import * as React from 'react';

const Beras = ({ title, titleId, ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 256 256"
		width="1em"
		height="1em"
		aria-labelledby={titleId}
		{...props}
	>
		{title ? <title id={titleId}>{title}</title> : null}
		<path
			d="M215.19 137.83c.13-.03.34-.12.37-.07.81.98 2.09 1.17 3.09 1.82.11.07.23.21.34.22 1.86.02 2.65 1.63 3.88 2.57.64.5 1.34.95 1.99 1.41 1.35.96 2.41 2.16 3.56 3.29.19.19.36.38.45.66.3.95.77 1.77 1.68 2.32.58.35 1.11.82.98 1.63-.01.09 0 .24.06.29.96.88 1.19 2.15 1.77 3.23.32.58.58 1.12.62 1.78.03.47.23.91.51 1.31.58.82.65 1.78.72 2.75.1 1.46.06 2.99.5 4.35.46 1.43-.17 2.52-.59 3.66-.7 1.89-3.59 4.09-5.57 4.69-2.89.87-5.79.6-8.72.42-2.25-.14-4.37-.97-6.6-1.2-1.72-.18-3.3-.72-4.88-1.4-.88-.38-1.9-.17-2.86-.12-.19 0-.41.06-.48.31-.44 1.74-2.21 1.75-3.36 2.55-1.28.88-2.79.64-4.23.64-.84 0-1.44.5-2.09.91-1.16.72-2.23 1.62-3.68 1.74-.19.02-.46.05-.56.18-.98 1.19-2.41.89-3.67 1.12-.27.05-.51.13-.76.22-.64.23-1.27.28-1.97.14-1.86-.38-3.63-1.17-5.61-1.07-.72.04-1.39-.48-1.96-.98-1.5-1.32-1.8-1.3-3.16.09-.45.46-.93.95-1.49 1.21-.63.3-.99.6-.98 1.34 0 .53-.48.61-.9.61-2 .02-3.7.8-5.37 1.83-.73.45-1.74.67-2.57.74-1.62.14-3.18.69-4.84.51-1.64-.19-3.31-.48-4.94-.34-1.68.14-3.16-.73-4.8-.61-.55.04-1.14-.04-1.62-.45-.19-.16-.55-.29-.75-.22-1.58.58-3.42.41-4.76 1.67-.14.13-.33.31-.5.31-.88.02-1.47.51-2.08 1.08-.92.86-2.19.69-3.29.74-1.2.05-2.22.35-3.19.98-.29.19-.6.32-.96.29-1.84-.17-3.61.52-5.41.5-2.01-.03-4.01.37-6.09-.35-1.25-.43-2.61-.81-3.93-1.17-.65-.17-1.12-.71-1.57-1.08-.9-.75-1.86-1.37-2.86-1.95-1.18-.68-1.96-1.76-2.6-2.92-.54-.97-.93-2.03-1.74-2.82-.31-.3-.29-.67-.29-1.04 0-.24 0-.49-.32-.55-.22-.04-.4.03-.52.23-.75 1.24-2.03 1.84-3.18 2.6-.16.11-.37.15-.56.19-1.01.2-2.02.23-2.78 1.21-.39.5-1.34.49-2.02.74-1.5.55-2.98 1.14-4.4 1.86-.06.03-.13.05-.19.06-2.77.44-5.55.75-8.38.65-1.53-.05-2.97-.56-4.48-.72-.94-.1-1.8-.93-2.72-1.39-1.05-.52-1.94-1.17-2.43-2.29-.12-.26-.49-.46-.84-.53-.89-.19-1.35-.85-1.65-1.63-.14-.36-.34-.67-.59-.94-1.12-1.19-1.12-.93-3.47-.88-2.43.06-4.93.35-7.33-.44-.15-.05-.29-.16-.42-.26A30.237 30.237 0 0 1 56.9 170c-.51-.59-1.25-1.28-1.11-2.19.24-1.62-.48-2.78-1.55-3.86-1.48-1.5-2.28-3.37-2.89-5.35-.14-.47-.13-1.02.06-1.38.67-1.25.42-2.57.47-3.88-.12-.26-.22-.51.16-.66.41.3.25.78.38 1.17.02.1.03.21.04.31.28 1.34.08 2.71 0 4.04-.08 1.52.75 2.38 1.5 3.4 1.21 1.67 2.67 3.23 2.5 5.53.04.64.39 1.11.79 1.6 1.1 1.38 2.24 2.7 3.52 3.93 1.07 1.03 2.42 1.11 3.74 1.23.53.05 1.06 0 1.61.1 1.47.29 2.92-.09 4.35-.29 1-.14 1.65.1 2.2.85.35.46.66.94.92 1.46.33.66.71 1.32 1.51 1.57.26.08.51.24.64.49.88 1.68 2.56 2.22 4.1 2.98 1.37.67 2.73 1.17 4.31.82.68-.15 1.42-.03 2.1.25.52.22 1.07.16 1.6-.02 1.63-.28 3.23-.77 4.92-.55.39.05.72-.12 1.06-.28.82-.39 1.56-.95 2.48-1.11.07-.01.17-.03.18-.08.49-1.4 2.15-.97 2.95-1.89.23-.26.63-.22.97-.23 1.44-.05 2.72-.52 3.82-1.44.58-.48 1.22-.86 1.82-1.3.83-.6 1.6-.37 2.17.58.04.71.44 1.28.83 1.83.47.67.96 1.31 1.28 2.07.03.06.05.14.11.17 2.1 1.46 3.57 3.74 6.07 4.67.73.19 1.26.83 2.03.91.72.42 1.57.39 2.31.62 2.21.69 4.45.28 6.66.44.98.07 1.88-.2 2.78-.53.38-.09.77-.09 1.15-.07.34.02.69.13 1-.04 1.51-.81 3.29-.87 4.78-1.58 1.81-.86 3.83-1.18 5.52-2.28 1.18-.77 2.66-.74 3.87-1.47.36-.22.81-.08 1.19.09 3.3 1.54 6.79 1.93 10.41 1.9 2.65-.02 5.19-.43 7.7-1.21.94-.12 1.62-.91 2.46-1.11 1.24-.29 2.19-.98 3.25-1.56.44-.24.78-.51 1.03-.93.52-.87 1.19-1.56 2.27-1.7.6-.08.92-.69 1.49-.84.67-.14 1.13.35 1.53.68 1.21 1.01 2.66 1.37 4.12 1.61 1.77.29 3.56.51 5.36.25.77-.11 1.54-.12 2.33-.08 1.18.06 2.23-.58 3.22-1.13 1.27-.72 2.63-1.27 3.86-2.06.54-.35 1.22-.38 1.88-.36 2.94.07 5.28-.97 6.85-3.56.46-.76 1.91-1 2.84-.48.89.5 1.76.94 2.86.89.74-.03 1.41.45 2.07.8.7.37 1.43.63 2.24.6 1.69-.07 3.22.82 4.9.82.72.34 1.43.69 2.26.41.1 0 .2 0 .3.02.27.06.54.09.81.01 1.31-.4 2.71-.05 4-.46 1.49-.47 3.26-.4 4.19-2.03.15-.26.39-.46.67-.62 1.14-.62 1.57-1.71 1.8-2.89.41-2.1.17-4.13-.28-6.23-.35-1.66-.72-3.28-1.4-4.82-.38-.86-.59-1.78-1.04-2.61-.43-.71-.81-1.45-1.2-2.18-.2-.39-.37-.74-.82-.97-.61-.3-1.06-.86-1.34-1.47-.6-1.31-1.55-2.48-2.55-3.36-1.52-1.34-3.04-2.79-4.89-3.73-.97-.53-2.03-.91-2.73-1.85a.53.53 0 0 0-.45-.2c-1.39.16-2.05-.78-2.7-1.75-.07-.22-.05-.42.12-.6Z"
			style={{
				fill: '#f9f7f4',
			}}
		/>
		<path
			d="M48.35 176.53c.17.3.24.67.61.82.41.34.96.51 1.22 1.02 1.07 1.23 2.11 2.47 1.63 4.28-.21.16-.25.42-.41.61v.61c-.13.61-.5 1.11-.82 1.63-1.48 2.22-3.57 3.71-6 4.67-.9.35-1.93.61-2.82.94-1.15.42-2.47.18-3.48.99-.18.14-.52.12-.78.12-1.9 0-3.8-.02-5.7.02-.74.01-1.32-.41-2.04-.5-.99-.13-2-.08-3-.49-1.36-.57-2.7-1.17-3.82-2.1-1.13-.93-1.53-2.32-1.75-3.73-.05-.3-.03-.58-.23-.86-1.34-1.89-1.34-3.79-.15-5.8.6-1.01.92-2.18 2-2.85.1-.07.19-.06.27.04.07.16.05.31-.02.46-1.14 1.02-1.59 2.48-2.02 3.81-.46 1.42-.71 3.09.67 4.37.12.11.19.28.25.44.05.15.07.31.08.47.05 1.77 1.12 2.89 2.52 3.69 2.81 1.6 5.86 2.13 9.09 2.12 1.39 0 2.78-.08 4.16-.19 2.1-.18 4.06-.96 6.06-1.6 2.35-.75 4.26-2.08 5.76-3.99 1.88-2.41 1.96-5.01-.55-7.07-.76-.62-1.44-1.35-2.37-1.74-.22-.15-.41-.33-.53-.57-.05-.15-.04-.3.03-.44.81 0 1.39.56 2.1.82Z"
			style={{
				fill: '#f4f2f0',
			}}
		/>
		<path
			d="M90.87 116.01c.05-.16.05-.41.15-.47 1.17-.68 2.08-1.65 3.08-2.53.41-.37 1.04.22 1.59-.19 1.03-.77 2.49-.43 3.54-1.24.25-.19.64-.05.96.15.31.19.68.31 1.04.38.41.08.6-.22.75-.55.16-.34-.04-.48-.28-.65-.25-.17-.51-.36-.67-.61-.33-.47-.05-1.12.5-1.15 1.14-.06 2.21.13 2.99 1.08.33.41.64.55 1.1.18.58-.46 1.52-.04 2-.78.09-.14.36-.26.34-.35-.23-1.12.63-1.91.99-2.79.66-1.62 1.3-3.38 2.92-4.45.98-.65 1.22-1.89 2.04-2.68.16-.16.25-.49.51-.43 1.39.31 2.19-.75 3.2-1.34.46-.27.95-.5 1.43-.75.22.25.06.52.05.78-.78.74-1.85 1.01-2.69 1.65-2.81 1.55-4.94 3.74-6.32 6.65-.42.87-.63 1.83-.69 2.74-.07 1.1-.7 1.46-1.54 1.72-.67.21-1.41.26-1.99.72-.52.25-1.01.57-1.58.7-1.43.89-3 1-4.64 1.09-1.14.06-2.34.22-3.46.63-1.65.27-2.86 1.4-4.26 2.16-.33.18-.57.63-1.05.33Z"
			style={{
				fill: '#fdfcf6',
			}}
		/>
		<path
			d="M175.79 116.62c1.16.04 2.24-.14 3.36-.54 1.16-.41 2.49-.18 3.7.04 1.51.27 3 .72 4.46 1.19 1.35.44 2.69.91 3.65 2.1.45.56 1.13.94 1.63 1.47.74.77 1.21 1.7 1.33 2.77.12 1.03.89 1.62 1.68 1.66 1.62.07 2.88.91 4.26 1.51.07.1.06.19-.03.27-.72.21-1.27-.37-1.93-.43-1.14-.42-2.33-.67-3.51-.97-1.26-.32-1.44-.54-1.46-1.8-.02-1.22-.57-2.12-1.45-2.88-1.28-1.37-2.59-2.64-4.56-3-.85-.15-1.56-.79-2.45-.93-2.57-.41-5.13-.14-7.69.07-.42.03-.82.13-1.03-.37l.03-.16Z"
			style={{
				fill: '#f8f5f0',
			}}
		/>
		<path
			d="M171.5 112.75c.34.57.97.79 1.43 1.22.93.8 2 1.47 2.57 2.63 0 .1-.04.19-.1.27-.09.05-.18.07-.28.07-.29-.06-.45-.28-.62-.49a16.63 16.63 0 0 0-5.88-4.43c-.47-.21-.89-.49-1.33-.75-.77-.45-1.62-.65-2.49-.82-.63-.28-1.3-.47-1.9-.83-.54-.32-.92-.79-1.29-1.28-.86-1.18-1.78-2.35-2.94-3.21-1.18-.88-2.38-1.76-3.56-2.65-1.33-.63-2.38-1.79-3.91-2.03-1.26-.67-2.69-.88-3.98-1.48-.21-.4-.43-.81.09-1.16.47.58 1.14.68 1.83.89 1.51.46 3.03.99 4.39 1.86 1.91.77 3.35 2.24 5.03 3.36 1.36.91 2.44 2.13 3.43 3.43 1.01 1.33 2.2 2.26 3.94 2.62 2.06.42 3.84 1.59 5.57 2.78Z"
			style={{
				fill: '#e8e4cf',
			}}
		/>
		<path
			d="M171.5 112.75c-1-.22-1.72-.98-2.65-1.39-1.24-.54-2.44-1.14-3.77-1.4-1.93-.38-2.85-1.95-3.95-3.28-.91-1.1-1.97-2.01-3.13-2.85-1.47-1.06-2.88-2.22-4.46-3.12-.05-.05-.07-.1-.06-.15 0-.06.02-.08.04-.08.09-.05.16-.04.23.03.21.3.53.17.82.2.56.38 1.16.73 1.63 1.22 1.31.98 2.77 1.68 4.01 2.86 1.35 1.28 2.21 2.92 3.64 4.08.41.33.8.64 1.35.6.99-.06 1.87.43 2.65.83 1.15.6 2.25 1.31 3.4 1.92.2.1.25.31.26.52Z"
			style={{
				fill: '#faf6f0',
			}}
		/>
		<path
			d="M90.87 116.01c1.29-.77 2.59-1.54 3.87-2.32.39-.24.78-.37 1.23-.33-.04.87-1.04.57-1.34 1.12-1.41.98-3.04 1.69-4.03 3.21-.41.52-.95.93-1.28 1.52-.62.56-.55 1.4-.64 2.09-.14 1-.48 2.03-.2 3.06.17.6-.14.96-.51 1.34-.26.27-.53.52-.84.74-.43.22-.75.81-1.36.4.25-.92 1.89-.87 1.61-2-.23-.94-.19-1.84-.18-2.77 0-.48-.21-1.04.4-1.35.75-1.68 1.66-3.25 3.27-4.28v-.41Z"
			style={{
				fill: '#faf7f2',
			}}
		/>
		<path
			d="M68 134.36c.22-.92.57-1.73 1.68-1.84.38-.04.58-.31.77-.6.51-.77 1.14-1.27 2.16-1.26.99.01 1.9-.53 2.74-.91 1.63-.73 3.26-.56 4.85-.42 1.44.13 2.72.13 3.93-.69-.17 1.25-.77 1.74-1.95 1.61-3.21-.35-6.34-.12-9.38 1.09-1.14.46-1.94 1.34-2.93 1.98-.66.22-1.09.82-1.74 1.07-.05-.02-.09-.03-.14-.05Z"
			style={{
				fill: '#fcfaf4',
			}}
		/>
		<path
			d="M48.35 176.53c-.82.08-1.35-.58-2.04-.81-.47.13-.76-.21-1.08-.44-.99-.71-1.93-1.48-2.94-2.15-1.75-1.15-3.78-1.39-5.75-1.82-.32-.07-.78.07-.84-.47.68-.45 1.36-.44 2.04-.01 1.47.53 3.04.55 4.53 1.07 1.71.59 2.74 1.91 3.96 3.05.47.44.85 1.05 1.64.99.43-.03.49.27.48.6Z"
			style={{
				fill: '#faf8f3',
			}}
		/>
		<path
			d="M52.08 152.71c-.24.15-.2.39-.2.61-.93-1.58 0-2.81.82-4.02.26-.38.65-.65.69-1.18.01-.18.15-.48.28-.52 1.52-.36 1.9-2.28 3.58-2.51.67-.09 1.23-.87 1.88-1.28.24-.15.45-.49.8-.36.81.31 1.58-.08 2.36-.12.01.05.03.1.04.15-.05.22-.19.36-.37.48-.6.46-1.39.3-2.02.6-1.58.76-3.16 1.53-4.51 2.69-1.12.84-2 1.88-2.59 3.15-.42.72-.35 1.6-.75 2.32Z"
			style={{
				fill: '#fdfaf4',
			}}
		/>
		<path
			d="M37.74 170.82c-.68.09-1.39-.2-2.04.19-1.32.19-2.66.14-3.96.46-1.6.39-3.21.75-4.68 1.53-.17.04-.33.02-.49-.06-.1-.08-.12-.18-.05-.29l.2-.41c.16-.25.36-.46.61-.61.89.01 1.74-.03 2.4-.77.16-.19.47-.31.75-.19.99.41 1.87-.11 2.76-.35.65-.17 1.28-.1 1.91-.1.59 0 1.15-.03 1.61-.45.37-.34.7-.29 1.07.02.51.41.08.7-.09 1.03Z"
			style={{
				fill: '#fcfbf4',
			}}
		/>
		<path
			d="M142.93 86.64c2.14.89 4.06 2.17 5.91 3.54.11.08.3.16.31.25.14 1.31.97 2.45.77 3.86-.13.93-.62 1.6-1.06 2.34-.1.07-.19.06-.28-.03a.63.63 0 0 1-.1-.3c0-.42.24-.77.35-1.15.49-1.82.11-3.65-1.51-4.97a21.033 21.033 0 0 0-4.62-2.88c-.29-.13-.88-.1-.7-.74.33-.21.64-.12.93.08Z"
			style={{
				fill: '#fdfaf1',
			}}
		/>
		<path
			d="M69.63 133.34c1.13-1.25 2.5-2.11 4.1-2.63 2.81-.92 5.67-1.07 8.58-.67 1.07.15 1.41-.67 1.82-1.39l.41-.41c.34-.53.58-1.16 1.23-1.43.57.11.81-.41 1.22-.61.07.08.11.17.11.27-.12.56-.65.75-1.01 1.08-.53.48-.94 1.05-1.37 1.61-.22.22-.36.49-.53.75-.44.68-1.05.87-1.84.78-2.06-.24-4.13-.15-6.19-.02-1.99.52-3.95 1.1-5.57 2.46-.23.19-.49.36-.83.3-.04-.03-.09-.06-.13-.09Z"
			style={{
				fill: '#f5f2e9',
			}}
		/>
		<path
			d="M199.88 127.02v-.21c.77.16 1.35.74 2.12.9.19.04.45.31.46.48.06 1.06.93 1.79 1.06 2.82.15 1.18 1.26 1.14 2.03 1.49.54.24 1.16.29 1.67.63l-.11.11c-1.3.34-2.45-.29-3.62-.62-.56-.16-.74-.9-.84-1.44-.27-1.49-1.25-2.43-2.27-3.38-.24-.22-.6-.36-.5-.79Z"
			style={{
				fill: '#fdfaf4',
			}}
		/>
		<path
			d="M64.53 140.89c.05-.12.17-.27.14-.37-.17-.49-.5-.9-.2-1.5.87-1.73 1.42-3.67 3.33-4.64.05-.03.13 0 .2-.01.29.55-.13.86-.46 1.08-1.56 1.05-1.71 2.73-2 4.33-.1.52-.14 1.01-.72 1.21-.11 0-.2-.03-.29-.1Z"
			style={{
				fill: '#fbf8f4',
			}}
		/>
		<path
			d="M148.64 96.63h.2c.03.43-.08 1.14.11 1.23.6.27 1.12.7 1.8.84.78.16 1.59.29 2.27.78.37.26.7.53.72 1.03h-.2c-1.14-.48-2.29-.94-3.43-1.42-.38-.16-.73-.34-1.16-.32-.49.02-1-.06-1.2-.57-.19-.47.16-.83.44-1.17.13-.16.26-.32.46-.39Z"
			style={{
				fill: '#fdfbf4',
			}}
		/>
		<path
			d="M119.04 97.45c-.23-.2.07-.41 0-.61.87-.33 1.74-.67 2.61-1.01.27-.11.45-.31.44-.62 0-.32.11-.58.3-.84.45-.6 1.01-1.12 1.13-1.94.07-.47.58-.62 1.03-.69.02.05.03.1.05.15-.44 1.35-1.22 2.55-1.83 3.82-.13.28-.36.51-.65.62-1.02.39-1.93 1.09-3.09 1.12Z"
			style={{
				fill: '#fbf8f2',
			}}
		/>
		<path
			d="M215.19 137.83v.61c-.49.27-.64-.19-.88-.42-.83-.82-1.6-1.71-2.67-2.24-.77-.41-1.48-.91-2.26-1.3-.53-.34-1.14-.52-1.68-.82-.21-.12-.54-.15-.48-.52 1.31-.22 2.12.77 3.17 1.23 1.55.68 2.79 1.73 4.06 2.79.26.21.49.45.74.67ZM142.93 86.64h-1.02s-.08-.03-.12-.04c-.33-.26-.71-.35-1.12-.31-.36 0-.72 0-1.07-.08-1.66-.23-3.31-.19-4.97 0-.4.08-.8.11-1.2.01a.63.63 0 0 1-.28-.2c2.26-.84 4.56-.84 6.87-.32.69.16 1.4.05 2.09.29.38.13.66.3.85.64Z"
			style={{
				fill: '#fdfaf4',
			}}
		/>
		<path
			d="M124.55 91.74c0-.24.03-.44.24-.63 1.35-1.21 2.67-2.44 4-3.67.26-.24.57-.17.87-.19.13-.11.26-.13.41-.04-.02.72-.71.86-1.13 1.14-1.11.74-2 1.7-2.95 2.6-.4.38-.77.86-1.43.79Z"
			style={{
				fill: '#fbf8f2',
			}}
		/>
		<path
			d="M26.51 172.65v.2c-.05.29-.27.46-.46.65-.07.06-.14.11-.22.17-.41.29-.83.57-1.16.95-.06.07-.12.13-.19.19-.3.18-.53.48-.91.54-.04-.02-.08-.03-.12-.05-.34-.59-.61-1.14.48-1.13.24 0 .27-.26.41-.4.59-.62 1.32-1.01 2.18-1.12Z"
			style={{
				fill: '#fcf9f4',
			}}
		/>
		<path
			d="M90.87 116.41c-.63.9-1.51 1.57-2.14 2.48-.41.59-.3 1.49-1.12 1.81.54-1.84 1.22-3.59 3.27-4.28Z"
			style={{
				fill: '#fdfcf6',
			}}
		/>
		<path
			d="m175.39 116.61-2.46-2.64c.76.14 1.22 1.03 2.11.83.11.66.41 1.25.76 1.82-.14.13-.27.12-.4 0Z"
			style={{
				fill: '#f8f5f0',
			}}
		/>
		<path
			d="M64.53 140.89h.21c.08.43-.43.58-.45.96-.24 1.44-.88 1.91-2 1.49.11-.28.35-.42.61-.5.46-.13.66-.37.62-.87-.06-.7.28-1.09 1.01-1.08Z"
			style={{
				fill: '#fdfaf4',
			}}
		/>
		<path
			d="M85.76 126.82c-.44.45-.64 1.1-1.23 1.43.07-.76.29-1.41 1.23-1.43Z"
			style={{
				fill: '#faf7f2',
			}}
		/>
		<path
			d="M156.19 101.93c-.65-.26-1.21-.65-1.63-1.22.72.17 1.37.44 1.63 1.22Z"
			style={{
				fill: '#fdfbf4',
			}}
		/>
		<path
			d="M130.07 87.25h-.41c.38-.64 1.01-.62 1.63-.61l.03.15c-.32.41-.68.73-1.25.47Z"
			style={{
				fill: '#fdfaf4',
			}}
		/>
		<path
			d="M47.18 171.27c.09-.64.56-1.08.82-1.63.06.71-.28 1.22-.82 1.63Z"
			style={{
				fill: '#faf8f3',
			}}
		/>
		<path
			d="M131.29 86.64c.25-.53.69-.67 1.23-.61.09.51-.32.59-.64.75-.22.05-.42.03-.58-.14Z"
			style={{
				fill: '#fdfaf4',
			}}
		/>
		<path
			d="M46.77 164.13c-.42-.33-.97-.5-1.22-1.02.58.13 1.12.32 1.22 1.02Z"
			style={{
				fill: '#faf8f3',
			}}
		/>
		<path
			d="m131.9 86.64.61-.61h.82c-.29.64-.74.92-1.43.61Z"
			style={{
				fill: '#fdfaf1',
			}}
		/>
		<path
			d="M27.33 171.63c-.13.28-.34.48-.61.61.02-.39.22-.59.61-.61ZM23.04 175.92h-.21c.02-.39.22-.59.61-.61.12.18 0 .31-.09.44-.09.09-.19.16-.32.17Z"
			style={{
				fill: '#fcf9f4',
			}}
		/>
		<path
			d="M48 169.03c0-.3 0-.59.41-.61 0 .29-.14.5-.41.61Z"
			style={{
				fill: '#faf8f3',
			}}
		/>
		<path
			d="M221.11 142.11c1.24.55 2.16 1.56 3.26 2.28 1.59 1.05 2.61 2.57 3.78 3.97.59.69.79 1.78 1.64 2.19.58.28.84.58.92 1.15-.66.09-1.01-.68-1.7-.56-.19.73.09 1.27.74 1.64.41.23.52.58.45 1.03-.13.81.04 1.62-.03 2.43-.03.35-.06.85.44.88.51.03.75-.36.84-.84.09-.47-.17-1.04.41-1.36 1.01.8.61 1.81.35 2.76-.15.58-.34 1.06.24 1.54.33.27-.2 1.12-.8 1.34-.19.07-.4.05-.6.07-.38.04-.63.25-.71.62-.09.43.22.6.56.71.28.1.62.09.71.47-.1.98.01 1.95-.03 2.93-.02.46.11.96-.35 1.3-.07.05-.13.05-.12.06q.01 1.03-.91 1.15c-.44.02-.88.04-1.32-.01-.69-.08-1.16-.61-.85-1.19.94-1.73.14-3.54.4-5.29.13-.91-.09-1.83.07-2.74.12-.68-.19-.94-.82-.96-1.19-.05-2.36.1-3.55.1-.59 0-.84-.19-1.03-.71-.43-1.13-.69-2.24-.23-3.44.27-.72.06-1.41-.59-1.9-.24-.43-.39-.86.19-1.16.96-.09 1.67-.37 1.71-1.56.02-.53.55-.98.8-1.5.31-.64.13-1.02-.33-1.5-1-1.05-2.08-1.99-3.16-2.96-.25-.22-.64-.46-.36-.93Z"
			style={{
				fill: '#f5f1ea',
			}}
		/>
		<path
			d="M220.5 173.31c-2.99-.43-6.02-.6-8.82-1.96-.85-.41-2-.05-2.79-.71-.65-.54-1.36-.54-2.12-.59-.49-.03-.77.15-.99.54-1.55 2.74-4 3.8-7.04 3.75-.86-.02-1.6.22-2.37.67-1.79 1.03-3.67 1.92-5.53 2.8-.87.41-1.82-.05-2.77.1-2.67.43-5.33.07-7.92-.57-1.12-.28-2.12-.96-3-1.73-.23-.2-.46-.26-.74-.26a.213.213 0 0 1 0-.28c.21-.18.44-.27.71-.16 1.45 1.21 3.3 1.33 5 1.87.45.14.6-.17.63-.56.04-.59.44-.83.96-.87 1.18-.1 2.37-.11 3.56-.02.47.04.75.29.83.75.13.72.65.87 1.28.9.4.01.74.04.69-.56-.05-.59.45-.81.9-.95.79-.24 1.53-.54 2.08-1.2.31-.37.78-.44 1.22-.4 1.52.15 3-.32 4.47-.13.05-.08 0-.04-.08-.08-.36-.16-1.05.3-1.07-.39 0-.61.63-.74 1.14-.78.91-.08 1.83 0 2.75.05.96.06 1.8-.23 2.36-1.08.68-.79 1.17-1.73 1.93-2.47.55-.54 1.14-.82 1.91-.74 1.01.1 2.13-.12 2.69 1.1.08.17.35.36.5.28.81-.42 1.92 0 2.56-.93.27-.39.72-.49 1.18-.48.88.03 1.76-.03 2.65 0 1.27.04 1.34.08 1.43 1.4.05.5.08 1 .12 1.51.1 1.12.5 1.48 1.61 1.66.94.16 1.93.14 2.82.58.02.21.05.43-.28.37h-.2c-.79.11-1.53-.1-2.25-.41Z"
			style={{
				fill: '#f5f3ec',
			}}
		/>
		<path
			d="M118.43 185.55c-.88.24-1.29-.72-2.04-.82-.22-.18-.52-.3-.55-.65.43-.53 1.45-.44 1.89.16.12.16.13.38.31.55.3-.13.1-.49.33-.66.19-.14.54-.3.36-.63-.16-.3-.5-.3-.81-.29-.24 0-.47.08-.7.07-.58-.04-.95-.27-.89-.95.05-.57.07-1.14.14-1.71.05-.24.02-.47.03-.71.08-1.23.48-1.68 1.71-1.66.87.02 1.74 0 2.63.12.79.11 1.78.04 2.68-.04.85-.08 1.7.04 2.54.13.32.03.75.27.48.53-.62.59.01.59.27.78.9.65 1.88.91 2.98.65.2-.05.41-.05.61-.03.62.06 1.28.1 1.41.88.1.58-.65 1.32-1.4 1.36-.95.06-1.9-.02-2.85.11 1.01-.12 2.01.05 3.01.09.38.02.75.02 1.09.22.51.3.69.65.19 1.12-.82.44-1.72.33-2.58.32-2.06 0-4.13-.08-6.19.02-1.22.06-1.25.11-.79 1.31.07.17.12.32-.07.43-1.26-.21-2.6-.07-3.77-.74Z"
			style={{
				fill: '#f5f2ea',
			}}
		/>
		<path
			d="M108.02 175.96c-.46-.98-1.02-.99-1.9-.42-1.85 1.19-3.5 2.93-6.01 2.67-.07 0-.16-.03-.2 0-.74.71-1.67.97-2.65 1.12-.16.03-.25.23-.18.42.17.43-.15.62-.43.62-1.03.02-1.78.69-2.63 1.1-.56.27-1.05.38-1.72.26-1.31-.23-2.58.39-3.89.45-.2 0-.4.06-.6.09-.7.06-1.35 0-2.03-.33-.77-.37-1.66-.06-2.48-.01-.73.04-1.41-.12-2.09-.27-.36-.08-.6-.3-.65-.68.08-.62.64-.39.98-.54 1.66.13 3.32-.03 4.98.1.64.05 1.15-.14 1.65-.61.81-.77 2.44-.85 3.19-.07 1.03 1.07 2.13.79 3.28.47.25-.07.53-.12.74-.39-1.03-.36-2-.82-3.13-.54-.29.07-.63.04-.88-.15-.7-.52-1.35-1.11-2.31-1.17-.29-.02-.53-.34-.48-.69.05-.4.41-.43.71-.43 1.66 0 3.34-.2 4.97.26.93.27 1.61 0 2.12-.74.28-.41.57-.61 1.07-.61 1.07.01 2.03-.5 3.08-.66.83-.13.42-.92.47-1.45.21-.91.97-1.24 1.7-1.59.39-.17.87-.15 1.17-.54.21-.27.47-.53.86-.32.38.2.63.51.63.97 0 .48-.08.94-.4 1.32-.2.24-.38.53-.1.81.28.29.57.07.83-.08.62-.34 1.2-.79 1.98-.6.45.12.79.38 1.05.76-.07.51-.05 1.03-.25 1.52-.15.07-.28.06-.41-.06Z"
			style={{
				fill: '#f5f2eb',
			}}
		/>
		<path
			d="M221.11 142.11c.18.66.7 1.21 1.19 1.41 1.31.54 1.7 1.98 2.88 2.62.33.18.37.66.21 1.1-.34.89-1.06 1.56-1.12 2.65-.04.68-.95.93-1.73.78a.48.48 0 0 1-.14-.25c.23-.85-.1-1.53-.65-2.13-.34-.37-.44-.81-.49-1.3-.09-.89-.1-1.77-1.23-2.2-.58-.22-.91-.97-1.17-1.61-.18-.45-.46-.72-1.04-.6 1.34 1.17 2.17 2.58 2.55 4.25.05.21.17.36.32.51q.88.9-.04 1.92c-.85-.49-.88-1.46-1.25-2.21-.27-.54-.51-1.09-.86-1.58-.74-1.52-1.93-2.7-3-3.96-.39-.45-.75-.83-.55-1.52.13-.45-.23-.83-.5-1.17-.68-.85-1.35-1.7-2.25-2.34-.29-.21-.65-.42-.53-.89 1.25.5 2.03 1.56 2.94 2.46.16.16.25.4.53.39.15.08.37.13.43.25.46.99 1.22 1.36 2.28 1.19.09-.01.24.02.28.08.72 1.07 1.95 1.43 2.93 2.14Z"
			style={{
				fill: '#f5f2e6',
			}}
		/>
		<path
			d="M56.16 167.19c.22-1.4-.25-2.57-1.22-3.57-.05-.05-.11-.1-.12-.16-.31-1.41-1.61-2.11-2.29-3.26-.23-.38-.41-.76-.4-1.22.05-1.39.1-2.78.16-4.18.01-.23-.21-.45 0-.67.38-.05.36.26.43.48.14.6-.12 1.25.28 1.81.14.11.3.2.44.32.64.71.37 1.86 1.24 2.48.74.52.9 1.35.85 2.16-.04.81.29 1.52.43 2.27.14.74.5.85 1.14.46.45-.27.87-.68 1.48-.5.74.35.78 1.11 1.01 1.76.34 1.22.34 2.51.99 3.67.68 1.21.97 2.64 2.16 3.55.3.23.59.31.93.28 1.18-.13 2.36-.13 3.53.08 1.12.16 2.19-.29 3.31-.27 1.09.02 2.06.14 2.71 1.17.27.44.47.82.09 1.28-.36.09-.46-.21-.61-.42-.61-.84-1.22-1.29-2.45-.94-1.37.38-2.88.21-4.34.14-1.17-.05-2.34.06-3.5-.35-.87-.31-1.53-.84-2.21-1.38-.28-.22-.37-.56-.28-.92.18-.72-.15-1.16-.76-1.48-.54-.29-1.02-.66-1.58-.92-.71-.33-1.05-1.02-1.41-1.68Z"
			style={{
				fill: '#f6f3eb',
			}}
		/>
		<path
			d="M165.99 181.47c-2.19.81-4.42 1.37-6.79 1.29-1.38-.04-2.76-.09-4.14-.05-2.54.08-4.8-.88-7.08-1.77-.62-.24-1.16-.21-1.84 0-2.42.73-4.62 1.97-7 2.81-1.35.48-2.76 1.17-4.13 1.46-1.21.25-2.19 1.33-3.53.96-.04-.7.46-.93 1-1.02.74-.13 1.29-.36 1.59-1.16.3-.77.86-.76 1.8-.08.72.31 1.36.05 1.97-.29.32-.18.6-.4.96-.5 1.17-.63 2.5-.87 3.63-1.6.82.04 1.13-.88 1.86-1.01.59.24 1.13 0 1.66-.22.83-.36 1.67-.44 2.58-.25.82.18 1.65-.11 2.47-.2.56-.06 1.09-.1 1.39.51-.07.6.17.87.8.86 1.9-.04 3.8-.08 5.7 0 .41.02.83-.04 1.17-.29 1.02-.73 2.13-.84 3.3-.54.83.21 1.66.3 2.52.24.37-.03.75-.04 1.08.19 0 .7-.76.31-.98.68Z"
			style={{
				fill: '#f5f2ec',
			}}
		/>
		<path
			d="M222.95 173.72c.16-.09.2-.24.2-.41.57-.41 1.25-.34 1.86-.32.8.02 1.55-.16 2.33-.21.14 0 .31 0 .39-.09 1.26-1.46 3.3-1.81 4.58-3.23 1.24-1.37 1.96-2.9 1.35-4.8 0 0-.06 0-.1.01-.76 0-.48-.75-.8-1.07 0-.84-.69-1.01-1.25-1.32-.33-.26-.79.19-1.13-.23-.3-.37-.44-.74-.26-1.19.17-.43.6-.71.96-.56.81.33.83-.52 1.26-.72.15-.07.07-.16-.11-.23-.77-.33-.61-.99-.39-1.53.39-.97.59-1.91.07-2.88-.21-.41-.7-.82 0-1.22.58 1.43 1.12 2.87 1.75 4.27.5 1.12.46 2.35.78 3.47.41 1.42.53 2.82.54 4.26.01 1.56-.44 3-1.24 4.31-.42.69-1.44.7-1.82 1.51-.4.86-1.19 1.13-2.11 1.31-.93.17-1.83.79-2.76.69-1.4-.15-2.74.56-4.12.17Z"
			style={{
				fill: '#f5f3ed',
			}}
		/>
		<path
			d="M56.16 167.19c.85 1.21 2.19 1.76 3.39 2.5.62.38.93.88.61 1.57-.22.47.03.73.33.94 1.15.82 2.33 1.57 3.85 1.52 1.69-.05 3.38 0 5.06-.01.43 0 .84 0 1.26-.25.46-.28.97-.13 1.35.28.43.46.87.93 1.3 1.4.04.03.08.05.12.07.27.3.44.67.71.98.13.15.28.42.44.38 1.46-.34 1.4.95 1.85 1.68.04.06.06.12.09.18.5.86 1.19 1.4 2.22 1.53.7.09 1.27.58 1.9.88.36.93 1.29.67 1.98.87.33.1.85.12 1.17 0 1.45-.51 2.67.41 4 .55-.49.37-1.07.3-1.54.11-1.03-.43-2.03-.33-3.08-.17-1.39.21-2.52-.6-3.73-1.08-1.61-.64-2.99-1.5-4.04-3.01-.46-.66-1.62-.92-1.98-1.82-.27-.68-.68-1.25-1.1-1.8-.42-.55-.93-.65-1.73-.57-1.64.16-3.31.76-4.99.18-.23-.08-.45-.06-.69-.02-1.36.22-2.72-.09-3.74-.84-1.29-.95-2.57-2.04-3.37-3.5-.45-.82-1.48-1.22-1.59-2.26-.01-.1-.03-.2-.05-.3Z"
			style={{
				fill: '#f6f4ef',
			}}
		/>
		<path
			d="M231.93 153.73c-.34.41.16.82 0 1.22-.35.33-.21.77-.19 1.15.04.54-.16.89-.61 1.17-.76.47-1.19.26-1.24-.67-.03-.53.03-1.07 0-1.6-.05-.96.33-2.02-.96-2.61-.54-.25-.36-1.06-.02-1.43.25-.28.82-.15 1.18.21.19.19.41.35.62.52.59.57.76 1.39 1.22 2.04Z"
			style={{
				fill: '#f5f2e8',
			}}
		/>
		<path
			d="M165.99 181.47c.14-.53.77-.26 1.02-.61.48-1.31 1.42-2.1 2.74-2.47.83-.24 1.54-.63 2.05-1.39.5-.76 1.51-.68 2.21-1.15.38.05.69-.11.99-.31.43-.26.77-.86 1.4-.38v.2c-.61.54-1.27.98-2.12 1.09-.4.05-.74.34-.93.73-.58 1.21-1.75 1.73-2.78 2.44-.63.43-1.23.61-1.97.71-.79.11-1.21 1.09-2.11 1.09-.17 0-.34.04-.5.05Z"
			style={{
				fill: '#f5f3ed',
			}}
		/>
		<path
			d="M108.02 175.96h.41c.56 1 1.32 1.79 2.33 2.34.28.15.47.38.59.68.58 1.44 1.64 2.46 2.89 3.32.7.48 1.18 1.2 1.74 1.83l.41.61c-1.54-.65-2.87-1.59-3.95-2.86-.49-.58-1.03-1.03-1.74-1.29-.09-.03-.2-.09-.23-.17-.63-1.46-1.76-2.62-2.42-4.05-.05-.11-.02-.27-.03-.4Z"
			style={{
				fill: '#f4f5ee',
			}}
		/>
		<path
			d="m118.43 185.55 3.88.61c.62-.61 1.44-.35 2.12-.32 1.75.06 3.5-.06 5.25.03.23.05.45.1.6.3-.7.43-1.47.63-2.3.62-1.69-.02-3.37-.02-5.06 0-.52 0-1-.05-1.46-.33-.77-.46-1.73.1-2.5-.47-.18-.14-.42-.19-.53-.43Z"
			style={{
				fill: '#f5f5ee',
			}}
		/>
		<path
			d="M130.27 186.16h-.61c-.07-.16.02-.31.14-.31.84-.02 1.34-.56 1.81-1.15.83-.74 1.97-.93 2.82-1.66.38-.33.9-.31 1.29.09.27.29.57.63.06 1-1.03-.79-1.02-.75-1.54.39-.2.43-.71.84-1.27.82-.7-.03-1.15.26-1.48.83h-1.22Z"
			style={{
				fill: '#f5f2ea',
			}}
		/>
		<path
			d="M52.49 154.75c0-.22.04-.47-.2-.61v-.2c-.29-1.27-.07-2.49.41-3.67.55-1.31 1.35-2.4 2.65-3.06.02.05.05.09.07.14 0 .11-.04.2-.09.29-1.04 1.16-1.97 2.38-2.34 3.94-.16.66-.26 1.31-.09 1.99.1.39.11.8-.13 1.17-.09.08-.18.09-.27.02Z"
			style={{
				fill: '#f4f0e4',
			}}
		/>
		<path
			d="M52.69 150.27c-.27 1.21-.55 2.42-.41 3.67-.37-.36-.14-.82-.2-1.22-.08-.89.09-1.71.61-2.45Z"
			style={{
				fill: '#f6f3eb',
			}}
		/>
		<path
			d="m220.5 173.31 2.25.41c-.85.43-1.58.17-2.25-.41Z"
			style={{
				fill: '#f5f3ed',
			}}
		/>
		<path
			d="M46.72 176.52c2.2.97 3.98 2.48 4.56 4.82.34 1.38-.22 2.89-1.14 4.08-1.94 2.52-4.56 3.93-7.6 4.85-2.24.68-4.48 1.23-6.79 1.3-2.14.07-4.28.14-6.43-.4-1.61-.41-3.18-.78-4.63-1.6-1.59-.91-2.84-2.06-2.89-4.06.07-.07.15-.08.24-.04.29.36.7.52 1.13.64a27.574 27.574 0 0 1 1.41.82c.2.11.41.2.63.27.74.3 1.53.25 2.3.37.31.05.63.18.68.52.06.42-.33.43-.69.56 1.04.41 2.03.51 3.07.44 1.38-.09 2.74-.44 4.13-.34.67.05.73-.61 1.05-.97.86-.43 1.83-.34 2.73-.55.52-.12.95-.28 1.27-.71.07-.06.15-.11.23-.16.43-.24.87-.48 1.36-.61.21-.09.42-.18.64-.25 1.21-.38 2.13-1.15 2.86-2.15.05-.08.1-.15.16-.22.31-.29.45-.68.63-1.04.8-.95 1.11-2.12 1.5-3.26.13-.4-.06-.71-.16-1.06-.12-.4-.44-.77-.26-1.24Z"
			style={{
				fill: '#e1e1e0',
			}}
		/>
		<path
			d="M21.81 185.09c-1.82-1.88-1.56-3.94-.52-6.07.48-.97.61-2.15 1.74-2.7.03.04.07.07.1.11.06.14.07.28.03.43-.03.09-.08.18-.14.25-1.19 1.1-.95 2.13.16 3.11 1.05.92 1.83 2.08 2.9 2.97.54.45.3.77-.27.88-1 .18-1.94-.08-2.85-.46-.18-.08-.33-.24-.54-.26-.3-.03-.68-.15-.86.1-.22.32.17.51.35.73.17.2.29.42.24.69-.06.16-.14.27-.34.22Z"
			style={{
				fill: '#eee9ce',
			}}
		/>
		<path
			d="m21.81 185.09.21-.21c.95.19 1.91.48 2.71.95 1.38.81 2.79 1.13 4.35 1.03.23-.02.47 0 .71.04 1.29.28 2.58 0 3.87-.05.69-.02 1.39.04 2.08-.05.1-.02.2-.03.3-.04.93-.04 1.81-.27 2.66-.65 1.25-.58 2.58-.92 3.78-1.67 2.03-1.28 3.31-3.02 4-5.26.33-1.06-.19-1.9-.71-2.73-.19-.31-.57-.5-.5-.94.63-.28.75.33 1.06.61l.41.41c.27.74.94 1.42.68 2.25-.39 1.23-.58 2.59-1.7 3.47-.13.38-.38.7-.61 1.02-.8 1.09-1.94 1.76-3.06 2.45l-.61.21c-.53.08-1.03.22-1.43.61-1.07.7-2.27.98-3.53 1.02-1.18.04-2.34.18-3.5.37-.11.03-.22.05-.33.07-.6.07-1.22-.03-1.81.14-.22.04-.45.04-.67 0-1.17-.33-2.33-.69-3.56-.58-.43.01-.84-.07-1.24-.21-.29-.2-.65-.26-.94-.46-.35-.27-.77-.37-1.16-.55-.27-.48-1-.28-1.23-.82h-.2v-.41Z"
			style={{
				fill: '#e1dcd1',
			}}
		/>
		<path
			d="M46.32 176.12c-.38-.13-.55-.63-1.02-.61-.7.03-1.04-.58-1.56-.87-.59-.43-1.16-.89-1.78-1.29-2.45-1.43-5.18-1.67-7.92-1.82-.97-.05-1.9.46-2.88.54-2.18.17-3.92 1.3-5.57 2.6-.45.35-.85.76-1.3 1.12-.19.15-.37.3-.57.44-.21.11-.42.24-.67.11v-.41l.21-.2c.46-.28.8-.7 1.22-1.02.38-.52.97-.8 1.43-1.22.32-.24.63-.48 1.02-.61 2.76-1.4 5.65-2.22 8.78-1.85 3.25.23 6.24 1.14 8.75 3.33.58.51 1.24.92 1.87 1.37v.4Z"
			style={{
				fill: '#e9e7d6',
			}}
		/>
		<path
			d="M131.9 86.64c.57.02.97-.37 1.43-.61h1.22c1.7-.17 3.4-.17 5.1 0h1.22c.22.21.84.1.55.71-.33.19-.65.06-.99.01-3.16-.47-6.29-.53-9.27.85-2.66 1.23-4.81 3.12-6.6 5.43-.32.56-.53 1.17-.75 1.77-.38 1.06-.91 1.96-2.15 2.19-.31.06-.61.28-.92.41-1.08.57-2.23.98-3.23 1.7-.36.26-.77.58-1.3.44-.22-.25.01-.35.16-.48.74-.78 1.85-.95 2.65-1.63.53-.23 1.03-.55 1.59-.68 2.06-.5 2.49-2.36 3.29-3.89.2-.39.41-.77.64-1.15.61-.36 1.17-.79 1.63-1.33 1.1-1.29 2.53-2.17 3.88-3.16.47-.09.88-.28 1.22-.61h.61Z"
			style={{
				fill: '#f4f0e3',
			}}
		/>
		<path
			d="m116.38 99.08-.2.41c.09.57-.4.71-.72.96-1.29 1.03-2.59 2.03-3.64 3.31-.95 1.57-1.95 3.09-2.01 5.03-.02.69-.34 1.31-1.06 1.61-.22.1-.46.16-.69.24-.18.05-.36.08-.54.09-.35 0-.68.09-.99.25-.08.04-.17.06-.26.08-.19.02-.36 0-.5-.16.57-.65 1.43-.53 2.14-.81.66-.26 1.09-.5 1.19-1.43.31-2.89 1.78-5.23 3.91-7.19 1.03-.95 2-1.94 3.38-2.39Z"
			style={{
				fill: '#f3f0e3',
			}}
		/>
		<path
			d="M94.54 114.37c.18-.76 1.16-.39 1.43-1.02 1.3-.58 2.72-.67 4.1-.78 1.34-.11 2.68 0 3.79-.99.1-.09.32-.05.49-.07.07.07.09.15.06.25-.2.32-.42.62-.69.87-.09.05-.18.08-.27.11-.15.04-.3.05-.45.07-1.54.39-3.15.25-4.7.55-.68.13-1.31.31-1.88.68-.53.34-1.1.51-1.73.42-.04-.03-.09-.06-.13-.1Z"
			style={{
				fill: '#f5f2e4',
			}}
		/>
		<path
			d="M104.34 111.72v-.2l1.43-.61h.61c-.53.8-1.15 1.05-2.04.81Z"
			style={{
				fill: '#efe9d8',
			}}
		/>
		<path
			d="M175.39 116.61h.4c.18.37.45.37.84.32 2.69-.33 5.44-.74 8.06-.05 2.63.7 5.32 1.57 7.02 4.01-.72.15-1.13-.38-1.63-.72-1.68-1.13-3.44-2.09-5.41-2.64-.79-.22-1.56-.43-2.38-.27-.91.18-1.8-.25-2.71-.04-1.04.14-2.12-.02-3.11.43-.56-.02-1.09-.09-1.09-.84v-.21Z"
			style={{
				fill: '#f0ede0',
			}}
		/>
		<path
			d="m190.29 120.09 1.43.81c1.22.87 1.6 2.08 1.45 3.51-.07.68.5.77.91.9 1.31.4 2.68.6 3.97 1.1.15.25.73.15.54.67-.55.27-.95-.15-1.41-.29-.6-.25-1.18-.52-1.83-.63-.55-.16-1.14-.1-1.69-.28-.92-.29-1.47-.89-1.39-1.84.09-1.09-.23-1.81-1.28-2.23-.59-.23-.98-.7-1-1.4.02-.18.13-.29.3-.34Z"
			style={{
				fill: '#e7e4d4',
			}}
		/>
		<path
			d="m198.66 127.02-.61-.61c.61.2 1.22.41 1.84.61.2.43.65.58.98.85 1.29 1.02 1.88 2.43 2.31 3.93.15.52.46.8.99.83 1.04.05 1.98.7 3.06.52.69.52 1.64.55 2.25 1.22-.79.47-1.34-.42-2.06-.36-.37-.07-.72-.19-1.08-.29-.62-.18-1.25-.31-1.9-.31-1.29 0-1.62-.27-2.1-1.5-.1-2.41-1.69-3.7-3.58-4.76l-.09-.12Z"
			style={{
				fill: '#f4f0e2',
			}}
		/>
		<path
			d="M124.35 92.96c.98-1.68 2.52-2.83 4-4 1.8-1.42 3.87-2.36 6.18-2.61 1.99-.21 3.99-.29 5.97.13.33.07.65.17 1 .16.14-.13.27-.12.41 0 1.95.93 3.83 1.94 5.55 3.31 1.8 1.44 2.21 3.77 1.51 5.62-.11.28-.21.57-.32.85-.33.54-.5 1.23-1.22 1.43-.39.34-.14.68 0 1.02-.53.23-.55-.18-.64-.51-.02-.16 0-.33.03-.48.45-.97 1.34-1.67 1.62-2.77.3-1.19.46-2.31-.3-3.38-.34-.49-.69-.98-1.21-1.31a9.337 9.337 0 0 0-1.88-1.43c-1.28-.79-2.6-1.5-4.1-1.79-1.54-.15-3.03-.67-4.6-.48-2.07.33-4.17.57-5.96 1.8-.48.33-1.03.52-1.5.85-.41.37-.72.86-1.27 1.06-.3.11-.32.38-.29.66 0 .2-.08.37-.21.52-.1.1-.22.18-.37.21-.89.08-1.51.63-1.76 1.53-.08.29.09.72-.39.84-.59-.32-.34-.8-.23-1.24Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M147.01 98.26c0 .3 0 .59.41.61 1.35.33 2.69.66 3.88 1.43.16.12.33.22.23.47-.34.36-.82.53-1.21.85-.57.45-1.3.35-1.87-.13-.37-.31-.72-.47-1.19-.32-.24-.06-.42-.23-.54-.43-.37-.62-.86-.7-1.46-.38-.5.22-1.03.24-1.56.24-.54-.06-1.18.07-1.42-.65.18-.26.47-.3.72-.22.94.3 1.79-.13 2.67-.3.33-.06.53-.23.68-.53.14-.28.21-.67.67-.63Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M155.18 102.34c.1 0 .24-.03.3.02 2.13 1.82 4.64 3.22 6.23 5.66.34.53.82.97 1.23 1.46l-.1.1c-1.35.13-2.16-.33-2.45-1.51-.22-.9-.84-1.24-1.65-1.45-1.05-.28-1.13-.48-.66-1.51-.84-.41-1.84-.41-2.57-1.15-.46-.47-.71-.89-.44-1.52.04-.03.07-.07.11-.1Z"
			style={{
				fill: '#e0d9bc',
			}}
		/>
		<path
			d="M167.42 111.11c2.97 1.38 5.69 3.11 7.76 5.71.09.3.57.43.36.85-.42.18-.62-.14-.82-.4-.79-1.01-1.74-1.87-2.67-2.76-.41-.38-.85-.72-1.35-.99-.42-.14-.53.17-.63.46-.15.42-.42.76-.69 1.1-.32.4-.64.82-1.23.68-.59-.13-.75-.61-.85-1.12-.09-1.13.71-1.46 1.69-1.67-.36-.6-.97-.68-1.41-.97-.23-.4-1.02-.28-.92-.98.27-.1.52-.06.76.08Z"
			style={{
				fill: '#d0c298',
			}}
		/>
		<path
			d="M175.59 117.64c-.11-.29-.44-.46-.41-.81h.2c.22.41.53.66 1.02.61.07.07.14.15.22.22 1.27 2.05 2.29 4.21 2.84 6.58.03.11.05.21.06.33.02.97.11 1.95-.04 2.92-.08.27-.16.54-.29.79-.46.63-1.16.77-1.87.83-.54.05-1.07.08-1.6.2-.5.03-1.01.13-1.48-.15-.03-.81.74-.59 1.13-.86.6-.15 1.21-.06 1.82-.11 1.17-.09 1.57-.5 1.59-1.66.07-3.12-1.28-5.76-2.9-8.29-.09-.14-.21-.26-.28-.42 0-.05-.02-.1-.03-.16Z"
			style={{
				fill: '#e0d5b6',
			}}
		/>
		<path
			d="M147.42 97.86c.41-.48.82-.95 1.22-1.43v.21c0 .3-.21.48-.37.69-.6.78-.43 1.21.54 1.34 1.73.23 3.27.95 4.73 1.85v.21c-1.28-.54-2.56-1.06-3.82-1.62-.39-.17-.78-.2-1.18-.23-.61-.05-1.16-.22-1.12-1.01Z"
			style={{
				fill: '#f6f1e2',
			}}
		/>
		<path
			d="m151.5 100.71-.2-.41c1.6.1 2.64 1.26 3.88 2.04-.22.2-.48.23-.76.15-.51-.46-1.24-.43-1.81-.77-.25-.46-1.14-.24-1.11-1.01Z"
			style={{
				fill: '#dddbbd',
			}}
		/>
		<path
			d="M167.42 111.11h-.81c-.64.06-1.13-.38-1.73-.47a.38.38 0 0 1-.17-.22l.06-.13c.97 0 1.86.25 2.65.82Z"
			style={{
				fill: '#e0d9bc',
			}}
		/>
		<path
			d="M162.93 109.48c.63.24 1.3.36 1.84.82-.34.31-.68.09-1.03.01-.09-.03-.17-.06-.25-.1-.23-.13-.48-.24-.62-.49-.03-.09 0-.17.06-.23Z"
			style={{
				fill: '#e0d9bc',
			}}
		/>
		<path
			d="M86.99 126.41v-.21c.35-.32.7-.63 1.05-.95.1-.09.28-.25.25-.3-.49-.95-.03-1.9.01-2.84.05-1.07.05-2.21.93-3.05.06.86.2 1.69.95 2.26 1.09 2.49 3.25 3.55 5.71 3.46 1.64-.06 3.37-.34 4.99-.78.56-.15 1.1-.45 1.71-.52.17-.02.37-.07.46-.19.8-1.03 2.13-1.12 3.13-1.79.36-.29.76-.38 1.05.04.31.44.09.83-.27 1.15-.13.11-.26.22-.41.29-1.33.65-2.53 1.5-3.72 2.38-.81.56-1.79.74-2.63 1.23-.55.23-1.16.28-1.73.44-1.88.23-3.76.34-5.66.28-1.06-.03-2.11-.16-3.02-.73-.75-.47-1.46-.67-2.25-.15-.17.11-.39.12-.57-.03Z"
			style={{
				fill: '#f6f2e3',
			}}
		/>
		<path
			d="M90.46 117.64c.04-.61.53-1.03.91-1.25 1.07-.65 1.95-1.61 3.18-2.01.46.6 1.02.62 1.62.26 1.21-.74 2.61-.66 3.93-.91.17-.03.35-.01.51.04.56.19 1.29.21 1.45.94.15.72-.44.99-.95 1.38-1.56 1.2-3.32 2.1-5 3.06-1.34.77-3.01 1.38-4.73.88a.53.53 0 0 1-.21-.21c-.3-.96.16-1.7.73-2.39.38-.46.85-.83 1.19-1.34-.7.31-1.36.65-1.83 1.26-.18.24-.43.44-.79.3Z"
			style={{
				fill: '#f5f2e4',
			}}
		/>
		<path
			d="M90.46 117.64c.86-.56 1.43-1.51 2.49-1.8.21-.06.42-.36.62-.13.24.27-.14.36-.26.53-.52.74-1.34 1.23-1.76 2.07-.23.44-.29.89-.26 1.37-.19.09-.3-.03-.45-.12-.22-.14-.25-.7-.65-.42-.35.25-.4.69-.18 1.1.17.32.48.6.16 1-.04.03-.08.06-.12.08-1.03-.47-1.2-1.26-.82-2.24.15-.7.73-1.02 1.23-1.43Z"
			style={{
				fill: '#f1eddf',
			}}
		/>
		<path
			d="M64.12 141.7c-.04-.46.41-.54.61-.81.39-.22.65-.59.56-1-.17-.8.3-1.42.43-2.13.22-1.2.89-2.06 1.89-2.72.23-.15.39-.38.39-.68.59-.26.82-1.11 1.63-1.02.12.2.03.38-.05.56-.73 1.02-1.74 1.76-2.7 2.55-.14.11-.29.24-.28.4.1 1.23-.73 2.27-.69 3.51.03.78-.63 1.19-1.8 1.34Z"
			style={{
				fill: '#f5f2e9',
			}}
		/>
		<path
			d="M64.12 141.7c.14-.09.27-.24.42-.28 1.03-.22 1.28-.93 1.21-1.85-.03-.45.03-.86.34-1.24.23-.29.36-.65.21-1.05-.18-.51.08-.83.48-1.09-.11 1.34.58 2.34 1.39 3.29.42.92 1.24 1.56 1.74 2.43-.53.73-1.34.56-2.02.49-1.37-.14-1.36-.2-1.52.99-.27.12-.47.02-.67-.16-.34-.31-.25-1.07-.81-1.06-.51 0-.36.73-.67 1.03-.07.07-.12.16-.2.23-.15.14-.32.24-.52.29-.55 0-1.03.46-1.61.27-.09-.08-.1-.17-.01-.26l.41-.41c1.26.18 1.63-.63 1.83-1.63Z"
			style={{
				fill: '#f4f3e3',
			}}
		/>
		<path
			d="M61.88 143.74v.2c-.15.73-.8.82-1.34 1.02-.31.11-.67.07-.99.18-1 .55-2 1.11-2.98 1.69-.36.21-.74.49-1.21.37.36-.9 1.25-1.18 1.98-1.56 1.25-.65 2.39-1.62 3.92-1.61.21 0 .42-.19.64-.29Z"
			style={{
				fill: '#f4f0e4',
			}}
		/>
		<path
			d="M26.92 172.86c-.3.26-.58.57-1.02.61.13-.28.34-.48.61-.61h.41Z"
			style={{
				fill: '#f4f2f0',
			}}
		/>
		<path
			d="M86.99 126.41c1.14-.82 2.2-.66 3.33.1.67.46 1.53.47 2.34.51 2 .1 3.98-.11 5.97-.21.05.1.05.19-.02.28-.1.09-.21.18-.34.19-.95.08-1.67.55-2.25 1.27-.38.18-.79.12-1.19.16-.52.05-1.01.17-1.16.78-.03.09-.07.17-.14.24-1.11.1-.64-.73-.73-1.24-.29-.16-.51.06-.75.14-.09.04-.19.07-.29.1-1.36.32-2.69-.05-4.03-.17-.68-.06-1.22-.02-1.4.77-.13.22-.32.22-.53.17-.35-.18-.76-.07-1.11-.26a.335.335 0 0 1 .06-.4c.42-1.12 1.56-1.58 2.25-2.44Z"
			style={{
				fill: '#ecead4',
			}}
		/>
		<path
			d="M84.74 128.85v.41c.14.33-.14.49-.27.72-.2.25-.31.57-.52.82-.17.19-.39.28-.64.32-.54.07-1.08.15-1.55-.23-.57-.23-1.1-.28-1.52.29-.27.36-.7.41-1.1.35-.63-.1-1.01.13-1.23.7-.99.18-1.76-.63-2.72-.59-.4-.3-.45-.6.05-.81.24-.1.51-.14.71-.35.2-.25.48-.21.75-.2 1.98.09 3.97-.19 5.94.18.57.11 1.06-.14 1.33-.7.18-.37.36-.73.76-.91Z"
			style={{
				fill: '#eeeada',
			}}
		/>
		<path
			d="M75.96 130.49c-.01.29-.19.39-.46.41-.39.03-.55.22-.35.61-.31.51-.85.62-1.35.81-1.17.22-1.9 1.16-2.85 1.73-.19.18-.41.28-.67.24-.34-.08-.68-.17-.84-.54l.2-.41c.7-.13 1.14-.68 1.68-1.05 1.4-.99 3.03-1.38 4.65-1.8Z"
			style={{
				fill: '#efebe0',
			}}
		/>
		<path
			d="M207.43 133.75c.76-.08 1.28.68 2.04.61.86.21 1.5.81 2.25 1.22.88 1.02 2.07 1.73 2.82 2.9.4.61 1.03 1.09.6 1.97-.17.34.26.5.45.72.96 1.18 1.93 2.35 2.9 3.53.17.2.18.43.18.67.11.13.11.27.04.42-.67-.14-.76-.83-1.15-1.23-.27-.29-.49-.63-.73-.94-.22-.26-.37-.58-.64-.79-1.13-.86-1.85-1.93-1.79-3.41-1.27-2.01-2.97-3.54-5.17-4.49-.62-.28-1.29-.45-1.81-.92-.06-.09-.05-.18.02-.27Z"
			style={{
				fill: '#ebe6d2',
			}}
		/>
		<path
			d="M139.66 86.03h-5.1c1.7-.34 3.4-.37 5.1 0ZM141.9 86.64h-.41l-.61-.61c.45.03.91.03 1.02.61Z"
			style={{
				fill: '#fdfaf1',
			}}
		/>
		<path
			d="M25.9 173.47c-.32.59-.92.86-1.43 1.22.22-.7.82-.97 1.43-1.22ZM24.47 174.69c-.24.54-.64.89-1.22 1.02l.2-.41c.38-.14.54-.63 1.02-.61Z"
			style={{
				fill: '#f4f2f0',
			}}
		/>
		<path
			d="M222.34 151.7c.73.18 1.23 1.37.8 2.12-.74 1.3.04 2.4.33 3.58.06.24.22.17.39.16 1.3-.06 2.6-.12 3.9-.15.94-.02.99.32.98 1.26-.03 1.93-.25 3.87.05 5.78.1.64-.07 1.19-.26 1.68-.5 1.29-.44 1.47.97 1.48h.61c.12.13.15.3.17.47.32 2.43.05 2.74-2.42 2.66-.67-.02-1.17.03-1.28.9-.1.84-.87.85-1.52.88-.71.04-1.56.11-1.78-.78-.22-.87-.7-1.02-1.47-.98-.54.03-1.09.02-1.62-.11-.56-.13-1.13-.29-1.42-.88-.13-.57-.22-1.14-.22-1.72.21-.42.56-.7.91-.99 3.74-2.53 3.98-6.95 2.89-10.73-.15-1.79-.9-3.45-1.17-5.21.18-.37.38-.21.59-.02.21.19.26.53.58.61Z"
			style={{
				fill: '#f5f2e8',
			}}
		/>
		<path
			d="M218.87 169.64c.93 1.14 2.24.79 3.43.83.65.02 1.12-.06 1.09.84-.02.67.42.93 1.12.96 1.37.07 1.6-.04 1.85-1.26.08-.39.28-.57.7-.55.74.03 1.48 0 2.22.01.62.02.81-.28.84-.87.04-.67-.28-1.33-.01-1.99 1.44.16 1.13-.97 1.2-1.72.08-.8.02-1.62-.04-2.42-.03-.43.1-.79.26-1.16.85-.02 1.57.1 1.43 1.22.21.24.07.51.08.78 0 .42.24.41.54.24l.58-.35c-.45 1.05.2 1.97-.13 2.98a5.96 5.96 0 0 1-2.16 3.02c-.51.37-.83 1.09-1.53 1.13-1.07.05-1.51.9-2.18 1.5-.63.57-1.6.37-2.39.43-.85.07-1.73.16-2.6.07-1.19.16-2.32-.24-3.47-.39-.91-.12-1.12-1.12-1.19-1.98-.04-.43-.02-.87-.03-1.3.14-.13.27-.12.41 0Z"
			style={{
				fill: '#f4f3ea',
			}}
		/>
		<path
			d="M222.34 151.7c-.05.25-.15.53-.37.14-.19-.34-.38-.68-.65-.96l-.11-.11c-.17-.38-.2-.8-.31-1.19-.03-.2 0-.4.03-.6.05-.4.38-.55.69-.63.36-.1.48.24.66.48.38.51.06 1.11.26 1.64v.2c-.58.24-.09.69-.2 1.02Z"
			style={{
				fill: '#f8f0ec',
			}}
		/>
		<path
			d="M218.87 169.64h-.41c.03-.94-.23-1.32-1.35-1.19-.82.09-1.73.16-2.6-.01-.25-.05-.6 0-.66.17-.43 1.45-1.9.66-2.71 1.3-.57.45-.99-.21-1.11-.52-.42-1.1-1.4-.77-2.13-.9-1.34-.24-2.09.65-2.75 1.66-.32.49-.64 1.03-1.19 1.34-.63.62-1.74.43-2.22-.47-.26-.48-.52-.44-.99-.5-2.08-.28-4.2.29-6.25-.35-.19-.06-.41-.05-.61 0-1.97.45-3.94.43-5.91 0-.13-.03-.28-.07-.4-.02-1.34.55-2.75.19-4.13.28-1.37.09-2.76-.25-4.15.04-.16.03-.34 0-.51.03-.23.05-.53.07-.51.38.02.3.32.3.55.32.27.03.54.01.81.06.5.08.8.35.82.88.03.53-.28.81-.75.95-.1.03-.2.06-.3.05-.9-.06-1.37.3-1.44 1.26-.03.5-.25 1.09-.98.55l-.61.2c-.67-.24-.87.6-1.43.61-.25.17-.56.06-.82.2-.48.26-.92.6-1.49.67-.19.02-.46.13-.52.28-.54 1.26-1.75 1.57-2.85 1.92-.97.31-1.47.96-1.89 1.77-.09.18-.22.23-.39.26-1.37 0-2.74.07-4.09-.31-.95-.27-1.86-.09-2.64.58-.38.33-.86.34-1.34.34-1.94-.01-3.87 0-5.81 0-1.16 0-1.23-.12-.81-1.22.36-.79 1.12-.63 1.77-.72.1 0 .19 0 .28.01.84.26 1.65.28 2.41-.28.4-.29.88-.35 1.36-.35 2.53-.01 5.07 0 7.6-.07.46-.01.93.04 1.5-.24-.85-.45-1.65-.49-2.44-.39-.91.12-1.67-.08-2.31-.75-.3-.32-.69-.53-1.08-.75-.79-.45-.79-.95-.15-1.6.52-.53 1.37-.8 1.48-1.69 1.66-.7 3.08-1.89 5.02-2.06.97-.09 1.69-1.08 2.15-1.97.33-.63.73-.89 1.35-1.2 2.34-1.15 4.76-.34 7.11-.31 1.03.02 2.19.29 3.04-.16.88-.46 1.88-.49 2.7-1.04.19-.08.38-.1.58-.01.42.85 1.67 1.07 2.55.46.27-.19.5-.43.72-.69 1.56-.96 3.18-.83 4.35.54.56.66 1.17.31 1.74.45.71.18 1.27.13 1.53-.69.08-.26.32-.51.6-.49 1.18.09 1.79-.85 2.68-1.42-.39-.35-.79-.18-1.16-.1-.93.21-1.85.41-2.81.19-.71-.16-1.13.3-1.6.69-.37.31-.69.83-1.3.48-.53-.3-.58-.84-.48-1.34.15-.69-.06-1.02-.76-1.08-.16-.01-.32-.12-.27-.34.41-.42.95-.35 1.42-.26 1.3.25 2.6.18 3.9.16.11 0 .22 0 .33-.01.42-.03.82-.19 1.25-.17 1.07-.23 2.19-.26 3.14-.9.2-.13.43-.17.67-.2.77-.12 1.45-.34 1.81-1.16.15-.34.4-.73.92-.6.17.46-.01.99.31 1.44.15.21.04.45-.24.56-.25.1-.62.29-.37.55.3.32.72.68 1.24.54.37-.1.36-.44.31-.76-.08-.54-.51-.97-.48-1.54.46-.4.63.12.91.29.06.07.12.14.17.21.12.19.27.34.45.48.07.06.13.12.19.19.53.7 1.26 1.17 1.97 1.66.11.11.18.22.08.37-.41.27-.78.08-1.14-.12-.53-.29-1.18-.4-1.4.2-.22.61.34 1.13.91 1.26.76.17 1.51.34 2.24.63.57.23 1.15.45 1.53.95.47.6 1.12.37 1.7.4.6.03 1.22.09 1.79-.21.43-.19.86.22 1.3.02a.57.57 0 0 1 .26 0c.35.21.75.26 1.15.31.1.02.19.04.28.07.52.14 1.12-.12 1.59.31l.2 1.63Z"
			style={{
				fill: '#f5f3e8',
			}}
		/>
		<path
			d="M177.02 174.94c.83.22.81-.46.79-.89-.04-.94.42-1.2 1.24-1.16.23.01.48 0 .71-.06.37-.09.57-.33.53-.75-.04-.42-.27-.6-.67-.61-.41 0-.82 0-1.22-.02-.31-.02-.5-.2-.53-.51-.03-.35.11-.67.47-.66 1.31.02 2.59-.54 3.94-.12.91.28 1.85-.19 2.79-.07.72.1 1.42.2 2.13-.21.32-.18.88-.17 1.27.11.25.18.48.21.76.16 1.49-.28 3.03.45 4.52-.28.34-.17.88-.16 1.27.12.21.15.41.17.66.17 1.29-.02 2.59 0 3.88-.03.59-.02 1.19.33 1.79-.13.15-.12.42.24.5.6.18.84 1.34 1.27 2.12.87-.09.66-1.33 1.46-2.17 1.35-.94-.13-1.88-.12-2.83-.13-.52 0-.99.09-1.36.71.58-.03 1.09-.17 1.48.23-.2.21-.45.29-.73.28-1.44-.02-2.86.38-4.31.21-.39-.05-.77.03-.98.4-.43.76-1.19.86-1.91 1.12-.33.12-1.42.08-.68 1.03.13.17.09.3-.07.42-.63.51-2.42-.07-2.55-.88-.08-.52-.26-.7-.76-.68-1.05.03-2.09-.01-3.14.02-.55.01-1.1.03-.95.91.09.55-.36.79-.85.62-1.46-.5-3.01-.69-4.42-1.34-.37-.17-.51-.52-.73-.81ZM200.84 173.92c-.1-.06-.22-.1-.24-.16-.04-.16.09-.23.22-.21.07 0 .17.1.18.16 0 .06-.09.13-.16.2Z"
			style={{
				fill: '#f5f1ea',
			}}
		/>
		<path
			d="M135.78 184.12c.03-1.04-.55-1.48-1.28-.84-.85.75-2.03.86-2.81 1.65-.14-.27-.19-.54 0-.82.59-.81-.18-1-.6-.98-1.01.06-1.98-.34-3.02-.1-.36.08-1.16.29-1.21-.66 1.16 0 2.31-.05 3.46.02.51.03.75-.2 1.01-.51.49-.58.32-.99-.38-1.18-.26-.07-.56-.13-.8-.05-1.58.51-2.85-.27-4.15-.93-.14-.07-.36-.12-.34-.33.04-.49.54-.29.86-.57-1.02-.3-2.02-.34-2.96-.26-.97.08-1.99-.42-2.92.21-.68-.85-1.58-.2-2.36-.3-1.17-.14-1.58.34-1.58 1.52 0 .23.13.46-.13.63-.43-.17-.43-.55-.45-.91-.03-.44-.13-.85-.38-1.21.04-.61-.04-1.21-.17-1.81a.58.58 0 0 1 .54-.07c.41.29.79.62 1.27.79.27.18.55.32.89.25.09 0 .19 0 .28.03.36.12.72.11 1.08-.02.85.15 1.71.04 2.57.14 1.09.16 2.17.12 3.26.03.11-.02.21-.02.32-.01 1.14.17 2.26.09 3.33-.38.92-.51 1.99-.55 2.98-.86 2.61-.81 5.21-1.59 7.46-3.22.1 0 .2.01.29.05.21.88-.27 1.55-.67 2.23-.29.49-.03 1.52.47 1.77.26.13.45.04.61-.18.22-.31.35-.65.4-1.03.06-.45.24-.82.62-1.11 1.25-.96 1.19-1.7-.16-2.41-.05-.03-.06-.11-.06-.18.38-.6.94-.52 1.44-.3 1.65.72 3.4 1.12 5.11 1.62 3.2.94 6.49 1.23 9.79.34.23-.06.46-.1.7-.03.39.2.27.74.67.97.47.28 1.01.73.75 1.29-.28.6-.88 1.03-1.63 1.06-.81.03-1.63-.01-2.44-.03-1.12-.03-2.24-.02-3.36-.03-.62 0-1.18.13-1.75.43-1.16.61-2.45.44-3.7.37-.82-.05-1.53-.13-1.96.8-.28.6-.93.61-1.52.62-.39 0-.79 0-.55.58.19.15.41.14.63.08.41.01.94-.37 1.13.34-.67.24-.9 1.27-1.84 1.02-1.31.35-2.53.9-3.67 1.63-.66.28-1.16.9-1.93.96-.39.03-.79.2-1.13-.14Z"
			style={{
				fill: '#f5f3e8',
			}}
		/>
		<path
			d="M115.77 178.41c.56.11.59.56.61.99.02.43-.04.86.21 1.25.19.53.02 1.07-.03 1.59-.08.84.33.95.95.78.38-.11.71-.12 1.08.03.25.1.54.13.62.45.09.39-.2.52-.47.68-.14.09-.51.13-.31.39.44.58-.18.53-.36.59-.49.15-.38-.28-.45-.55-.16-.6-.99-.84-1.63-.49-1.74-1.59-3.96-2.72-4.86-5.1-.14-.38-.45-.46-.72-.66-.86-.63-1.9-1.12-1.97-2.4-.2-.51-.23-1 .2-1.43.27-.52.86-.67 1.23-1.07 1.05.47 1.78 1.43 2.85 1.88.09.03.18.06.26.1.36.31.78.5 1.25.6.34.23.9.17.98.75-.34.32-.76.21-1.16.24-.36.03-.77-.04-.95.49.91.28 1.86.43 2.69.89Z"
			style={{
				fill: '#f5f3e8',
			}}
		/>
		<path
			d="M131.7 184.12c0 .27.2.54 0 .82-.27 1.08-1.32.89-2.04 1.22h-7.35c-.52-.32-.65-.83-.58-1.38.03-.27.1-.59.55-.58 2.38.05 4.76.1 7.14.1.76 0 1.52-.12 2.27-.19Z"
			style={{
				fill: '#f5f2e8',
			}}
		/>
		<path
			d="M73.31 175.15c.21-1.34-1.39-2.36-2.98-2.22-1.04.09-2.07.59-3.14.19.06-.28.33-.42.46-.65.5-.87.11-1.76-.84-1.91-1.62-.26-1.79-.57-1.25-2.22.53-.41 1.12-.11 1.68-.14.97-.06 1.95.05 2.92.1.18.12.15.24.03.41-.48.71-.41.93.35 1.22 1.27.48 2.01-.01 2.33-1.54.22-.17.46-.19.72-.12.09.04.17.1.23.18.06.41-.05.83.6.98.42.1.46.67.53 1.12.13.87.59 1.15 1.5 1 1.22.59 2.24 1.53 3.51 2.03.29.11.45.39.58.67.13.44.02.79-.35 1.06-.22.16-.46.31-.52.6-.08.38.05.71.45.77.36.05.54-.22.55-.57 0-.13-.02-.27-.05-.4-.21-.81.17-1.05.92-.95.1.02.19.06.28.1.29.17.57.37.92.4 1.53.14 2.97.58 4.35 1.25.32.15.67.19 1 .12 1.22-.26 2.44-.07 3.65-.08.14 0 .29.07.4.01 1.53-.82 3.34-.51 4.89-1.25.66-.32 1.29-.69 2.08-.68.47 0 .85-.37 1.19-.72.21-.21.45-.45.79-.19.51 1.4.34 1.7-1.02 1.84-1.05.1-1.99.71-3.12.63-.29-.02-.67 1.01-1.32 1.3-.29.13-.48.29-.82.16-1.76-.66-3.6-.41-5.41-.44-.23 0-.64-.15-.63.26 0 .32.36.62.64.51.86-.33 1.18.39 1.69.75.24.17.38.55.74.44 1.28-.37 2.43.17 3.63.41.2.04.41 0 .48.23.1.32-.14.37-.37.48-1.07.51-2.19.68-3.36.58-.29-.02-.5-.1-.67-.36-.63-.96-2.46-1.34-3.1-.46-.75 1.04-1.74.88-2.58.77-1.46-.2-2.92.21-4.36-.15-.6-.14-.84-.54-.79-1.12.06-.67-.26-.88-.88-.92-.61-.04-1.19-.13-1.8.04-.42.12-.87.05-1.27-.2-.33-.72.16-1.13.57-1.58.26-.29.75-.53.46-1-.27-.42-.77-.35-1.21-.3-.14.01-.26.08-.38.15q-1.58.84-2.86-.57Z"
			style={{
				fill: '#f6f2e9',
			}}
		/>
		<path
			d="M109.85 173.52c-.08.74-.8.7-1.23 1.02l-1.02-.61c-.26-.87-.74-1.64-1.08-2.48-.43-1.09-.37-1.82.46-2.55.69-.31 1.39-.1 2.09-.05.48.03.76.38.62.85-.35 1.19-.22 2.32.22 3.45.05.12-.04.26-.07.39Z"
			style={{
				fill: '#f8f1eb',
			}}
		/>
		<path
			d="M101.07 173.72c-.35 0-.61.2-.73.48-.23.54-1.01.82-1.16.77-.92-.34-1.49.37-2.15.63-.93.37-1.85.55-2.83.58-.17 0-.38-.03-.5.05-1.31.96-2.81.55-4.22.5-.6-.02-1.07.28-1.66.21-1.11-.13-1.99-.85-3.1-.99-.63-.08-1.24-.43-1.94-.39-.45.02-.86-.16-1.1-.6.29-.3.66-.26 1.02-.26 2.84.8 5.72 1.39 8.69 1.19 1.82-.12 3.62-.39 5.32-1.12 1.34-.08 2.38-.89 3.49-1.5.08-.05.16-.09.25-.14a4.81 4.81 0 0 0 1.69-1.38c.1-.11.22-.19.35-.24.28-.08.56-.17.85-.2.15 0 .3.04.41.14.02.74-.72.54-1.05.84-.56.46-1.28.74-1.63 1.43Z"
			style={{
				fill: '#f5efe2',
			}}
		/>
		<path
			d="M102.71 172.29c.25-.38.84-.34 1.02-.82.34-1.23 2.09-2.54 3.27-2.45-1.13 1.45-.18 2.66.52 3.84.24.4.01.71.09 1.05-.83-.17-1.41.37-2.02.75-.41.25-.72.35-1.04-.06-.31-.39-.23-.74.09-1.08.53-.56.71-1.17.22-1.85-.25-.35-.58-.42-.78 0-.29.63-.85.54-1.36.61Z"
			style={{
				fill: '#f5f2e7',
			}}
		/>
		<path
			d="M76.78 178.41c1.15.07 2.3-.27 3.47-.01.48.1.88.07.67.78-.17.58.1 1.09.55 1.48-.23.25-.57.03-.82.2-.77.21-1.22-.7-1.8-.63-.93.11-1.37-.56-2.01-.89-.36-.18-.51-.52-.47-.93.14-.11.27-.12.41 0Z"
			style={{
				fill: '#f3f4eb',
			}}
		/>
		<path
			d="M222.54 150.47c-.26-.22-.32-.52-.27-.82.09-.53-.03-1.08-.54-1.12-.74-.06-.6.63-.61 1.12-.25.09-.32-.1-.4-.27v-.14c0-.24-.03-.5.19-.66.55-.41.23-.76-.14-.92-.49-.21-.54-.6-.68-1.01-.48-1.37-.91-2.8-2.29-3.61-.18-.11-.38-.34-.41-.54-.03-.25.3-.27.46-.26.39.01.84-.06 1.07.38.22.41.23.96.63 1.25.38.28.34.97 1.22.87.49-.06.67 1.11.7 1.74.04.83.24 1.48.82 2.08.52.53.58 1.21.25 1.9Z"
			style={{
				fill: '#f5f1ea',
			}}
		/>
		<path
			d="M221.32 150.88c.03.26 0 .56.11.78.71 1.5.93 3.1 1.12 4.72.35 3.01.83 6.05-1.15 8.75-.31.14-.39-.06-.44-.3 0-.1 0-.21.04-.3.14-.31.27-.63.34-.97.06-.2.15-.38.28-.55.39-.7.49-1.45.46-2.24-.05-1.31.06-2.62-.06-3.93-.04-.1-.06-.21-.08-.31-.1-.51.01-1.05-.19-1.55-.3-.93-.29-1.94-.77-2.82-.12-.34-.1-.71-.26-1.03-.64-1.54-1.29-3.08-1.99-4.6-.11-.24-.28-.47-.06-.74v-.41c1.1.97 1.14 2.49 1.86 3.65.05.08.12.15.18.23.27.52.53 1.04.61 1.63Z"
			style={{
				fill: '#ede7d2',
			}}
		/>
		<path
			d="M65.55 168.42c-.17 1.2.04 2.06 1.57 1.95.24-.02.97-.1.88.34-.15.74.57 1.68-.46 2.21-.12.06-.24.12-.36.19-1.35 0-2.7-.1-4.06.05-.62.07-2.02-1.77-2-2.42 0-.13.03-.36 0-.36-.87-.21-.53-1.09-.88-1.56-.78-1.05-.6-2.3-.83-3.46.69.23 1.1.78 1.5 1.34-.01.07-.05.12-.07.18-.07.15-.46.16-.25.41.18.22.35.04.43-.16.07-.15.11-.31.27-.4.47 0 .81.32 1.19.53.74.41 1.45.88 2.37.8.28-.03.53.1.68.36Z"
			style={{
				fill: '#f5f2e7',
			}}
		/>
		<path
			d="M58.61 163.73c-.56-.05-.97.31-1.36.59-.31.23-.56.58-.94.35-.38-.24-.57-.64-.69-1.14-.27-1.08-.37-2.17-.44-3.27-.01-.23-.35-.47-.58-.66-.88-.73-.89-1.86-1.31-2.8.23-.48.6-.34.94-.18.3.14.59.32.93.39.86.41 1.69.87 2.56 1.26.31.14.61.31.76.64.03.44-.14.82-.31 1.21-.49.18-1.19 0-1.29.83-.09.81.27 1.51 1.04 1.87.18.08.39.11.55.23.19.2.32.4.13.67Z"
			style={{
				fill: '#f5f3e8',
			}}
		/>
		<path
			d="M58.2 160.06c-.34-.42.02-.7.21-1.02.69-.46 1.17 0 1.58.44.45.48.25 1.02-.06 1.49-.57.85-.79 1.71-.18 2.63.31.71.76 1.31 1.31 1.85.72.86 1.78 1.3 2.75 1.56 1.34.36 2.7.73 4.14.82 1.4.09 2.76-.15 4.14-.08.59.03 1.31-.09 1.63.66h-.82c-.88.22-1.77.23-2.65 0-1.57.2-3.13-.1-4.7 0-1.66.06-2.99-.73-4.29-1.63-.14.12-.27.11-.41 0-.48-.47-1.07-.83-1.43-1.43-.4-.48-.35-1.19-.82-1.63l-.2-.61c-.27-.32-.03-.64.03-.94.15-.73.23-1.45-.24-2.11Z"
			style={{
				fill: '#f7f1e4',
			}}
		/>
		<path
			d="M55.14 157.2c-.68.18-1.08-.91-1.84-.41-.17 0-.32-.04-.41-.2-.2-.52-.17-1.08-.26-1.61.51-.21.67.27.94.5.3.26.61.51.92.75.19.17.33.4.54.56.07.05.12.12.17.19.03.09 0 .16-.06.23Z"
			style={{
				fill: '#f4f0e4',
			}}
		/>
		<path
			d="M52.69 154.95c.09.54.43 1.05.2 1.63-.82-.46-.12-1.26-.41-1.84h.2c.05.04.06.09.05.13-.01.04-.03.07-.04.07Z"
			style={{
				fill: '#f5f3e8',
			}}
		/>
		<path
			d="M142.52 180.45c-.34-.02-.53-.24-.48-.53.07-.38.45-.57.78-.52 1 .13 1.6-.15 2.04-1.16.3-.7 1.19-.24 1.82-.25 1.32-.02 2.67.33 3.88-.55.42-.3.96-.26 1.46-.25 1.95.02 3.9 0 5.85.07.77.03 1.14-.55 1.46-.97.2-.26-.35-.81-.82-.99-.52-.21-.54-.54-.27-.96.48-.42 1.04-.25 1.58-.23.58.17 1.05 0 1.43-.45.47-.32.95-.57 1.48-.14.3.27.43.6-.02.77-.57.22-.86.74-1.31 1.08-.55.41-.49.98.14 1.15.44.11.7.35.98.64.67.72 1.43.99 2.45.78.68-.14 1.42.09 2.14.13.45.03.28.39.35.61.1.29-.1.33-.33.34-1.3.04-2.59.12-3.89.14-1.82.02-3.64-.01-5.46.02-.28 0-.61.02-.86.26-.86.84-1.8.68-3.57-.07-.26-.34.28-.34.71.1.03.03.04.11.07.07.47-.6 1.21-.25 1.77-.51.3-.14.74-.19.67-.62-.06-.39-.46-.31-.75-.34-1.52-.16-3.04.01-4.56 0-.21 0-.4.06-.58.17-.2.13-.44.26-.38.54.06.26.31.21.51.22.58.01 1.14.19 2.53.38.21.52-.49.46-1.03.88-.87-.57-1.77.06-2.66 0-.39-.03-.83.13-1.31-.01-1.03-.32-1.98.11-2.9.51-.42.19-.75.24-1.1-.09-.41-.39-.82-.18-1.22 0-.17-.16-.39-.2-.61-.2Z"
			style={{
				fill: '#f5f2eb',
			}}
		/>
		<path
			d="M138.84 183.31c.83-.89 1.89-1.36 3.05-1.65.21-.05.42-.26.62.02-1.08.86-2.45 1.08-3.67 1.63Z"
			style={{
				fill: '#f5f2ea',
			}}
		/>
		<path
			d="M233.57 164.54c-.14.2-.34.36-.58.26-.29-.12-.15-.37-.09-.6.05-.22.04-.46.06-.68.25.11.35.27.25.56-.11.3.07.44.36.46Z"
			style={{
				fill: '#f5f1ea',
			}}
		/>
		<path
			d="M76.78 178.41h-.41c-.1-.09-.24-.15-.29-.26-.31-.62-.27-1.42-1.45-1.35-.71.04-1.12-.9-1.32-1.65.32.2.68.26.92.68.34.6.93.43 1.35 0 .48-.49 1.02-.69 1.68-.53.35.08.76.11.91.53.17.47-.13.78-.45 1.03-.53.4-.97.84-.94 1.56Z"
			style={{
				fill: '#f5f2eb',
			}}
		/>
		<path
			d="M174.16 175.96c.21-.3.53-.17.82-.2-.23.22-.48.38-.82.2Z"
			style={{
				fill: '#f5f1ea',
			}}
		/>
		<path
			d="m55.35 147.21 4.08-2.24c.06.49.23.84.82.77.1-.01.21-.02.3.02 1.42.66 2.88.74 4.38.32.14.07.23.18.28.33-.01.28-.21.47-.43.51-1 .17-2 .75-3.03.11-1.31-.81-2.61-.41-3.91 0-.38.12-.7.37-.6.81.08.4.48.43.82.48.1.02.2 0 .3 0 1.32.04 1.7.65 1.1 1.79-.08.15-.13.32-.27.42-.26.09-.47-.01-.63-.19-.46-.48-.96-.46-1.56-.29-1.49.42-2.04-.11-1.7-1.59.06-.23.16-.45.33-.61.56-.54-.26-.26-.26-.45v-.2Z"
			style={{
				fill: '#eee9d7',
			}}
		/>
		<path
			d="m55.35 147.41.73-.25c.38.66-.52.77-.52 1.27-.41.46-.52 1.09-.93 1.56-.21.24-.12.51.11.71.21.22.68.16.66.62-.3.46-.71.63-1.21.39-.7-.33-.87.04-.82.61.06.74-.19 1.46-.08 2.19.16.27.34.53.6.73.41.3.81.59 1.2.91.27.22.63.43.47.89-.15.08-.28.06-.4-.05-.26-.15-.45-.36-.62-.61-.85-.17-1.17-1.02-1.83-1.43v-.2c.06-1.19-.34-2.36.11-3.57.56-1.48 1.28-2.79 2.54-3.77Z"
			style={{
				fill: '#e6e2cf',
			}}
		/>
		<path
			d="M30.18 187.95h.61c.59-.27 1.25.08 1.84-.2h.2c1.02-.03 2.04-.47 3.06 0-.13 1.07-.53 1.38-1.75 1.22-1.06-.14-2.26.14-3.37.36-1.21.25-2.32-.34-3.49-.24-.07 0-.19-.09-.22-.17-.07-.18.04-.33.16-.45.21-.24.62.02.87-.38-.91-.68-2.15-.06-3.01-.76-.05-.18-.01-.28.2-.2.38.24.8.21 1.22.2 1.24.12 2.47.29 3.67.61Z"
			style={{
				fill: '#e1e1dc',
			}}
		/>
		<path
			d="M48.28 180.33c1.01-.05.91.94 1.01 1.56.09.55-.63.91-1.04 1.01-.56.13-1.29.74-1.78.06-.47-.65.22-1.22.58-1.65.29-.34.38-1.05 1.22-.98Z"
			style={{
				fill: '#e0e1e4',
			}}
		/>
		<path
			d="M35.9 187.74h-3.06c.68-.32 1.44-.43 2.13-.37 1.76.15 3.38-.4 5.02-.85-.29.6-.7.9-1.43.95-.88.06-1.74.39-2.65.27ZM42.02 185.7c1.02-.82 2.04-1.63 3.06-2.45-.62 1.31-1.72 2.04-3.06 2.45ZM22.02 185.5c.39.3 1.1.12 1.23.81-.46-.2-1.17-.02-1.23-.81ZM39.98 186.52c.29-.65.85-.64 1.43-.61-.5.16-.87.61-1.43.61Z"
			style={{
				fill: '#e2e0d6',
			}}
		/>
		<path
			d="M23.24 186.32c.45.02.87.11 1.23.41.11.14.13.27 0 .41l-1.22-.81Z"
			style={{
				fill: '#e1e1dc',
			}}
		/>
		<path
			d="M45.09 183.26c.05-.44.34-.72.61-1.02.04.49-.2.81-.61 1.02ZM24.47 187.13v-.41l.82.41-.2.2-.61-.2Z"
			style={{
				fill: '#e2e0d6',
			}}
		/>
		<path
			d="M23.04 176.93v-.2c.18-.21.28-.54.67-.44.41.36.25.81.17 1.24-.06.33-.04.58.28.78.87.57 3.74.53 4.59-.08.34-.25.75-.33 1.15-.37 1.27-.11 2.24-.92 3.32-1.44.99-.48 1.03-1.56.3-2.42-.29-.34-.68-.56-.93-.94.12-.54.53-.38.88-.37 1.47.05 2.94.19 4.42.17 1.14.34 1.01.42.75 1.55-.34 1.5-1.31 1.63-2.48 1.52-.88-.08-1.34.25-1.87 1-.66.94-1.53 1.82-2.61 2.38-.24.12-.5.25-.76.27-1.14.06-2.03.46-2.7 1.47-.41.61-1.09.44-1.54-.3-.19-.31-.34-.65-.74-.49-.29.12-.42.35-.32.79.07.33-.07.84-.32 1.21-.2.05-.31-.07-.42-.21-.65-.85-1.36-1.65-2.13-2.4-.85-.82-.71-1.56.29-2.73Z"
			style={{
				fill: '#e0d9b8',
			}}
		/>
		<path
			d="M29.77 187.13c-2.93.43-5.31-1.01-7.76-2.25l-.21-.6c-.26-.22-.6-.53-.34-.83.3-.35.86-.3 1.23-.1 1.54.83 3.17.83 4.86.84 1.6.01 3.2-.18 4.8.02.19.49-.23.54-.5.65-.36.14-.75.24-1.14.27-.8.07-1.61.27-2.39-.13-.11-.06-.27-.05-.4-.02-.49.11-1.26.15-1.25.65.01.6.76.48 1.24.46.5-.03.94.1 1.32.41.18.2.59.21.53.62Z"
			style={{
				fill: '#e0d9b7',
			}}
		/>
		<path
			d="M32.43 184.28c-2.11.48-4.25.06-6.38.26-.95.09-1.97-.46-2.94-.76-.24-.08-.43-.29-.72-.32-.72-.07-1.06.08-.57.82-.46-.19-.95-.6-.62-1 .4-.46 1.14-.36 1.69-.04 1.06.62 2.15.78 3.42.46-1.42-1.24-2.62-2.59-3.8-3.95-.94-1.09-.71-1.98.53-2.82-.95 1.78-.88 1.87.85 3.35.59.51.79 1.39 1.4 1.95.39-.02.61.25.85.49.69.43 1.39.83 2.19 1.01 1.01.41 2.04.33 3.06.07.59-.15 1.17-.28 1.78-.16.1.03.19.07.27.14.06.08.08.17.06.28-.26.27-.6.22-.93.23-.05 0-.09-.01-.14-.02Z"
			style={{
				fill: '#e3dec0',
			}}
		/>
		<path
			d="M23.65 176.32c-.2.14-.41.27-.61.41v-.41c.2-.07.41-.14.61-.21.05.07.05.14 0 .21Z"
			style={{
				fill: '#e2dfc9',
			}}
		/>
		<path
			d="m29.77 187.13-.61-.41c.1-.24.3-.32.55-.32 1.72.08 3.47.19 5.17-.01 1.97-.23 3.88-.84 5.75-1.52.09-.05.18-.09.27-.13.92-.38 1.75-.9 2.46-1.6.15-.12.31-.22.48-.31 1.4-1.12 2.1-2.62 2.19-4.36.06-1.23-.73-2.12-1.64-2.88-.27-.13-.52-.27-.65-.57a.58.58 0 0 1 .02-.43c.03-.04.07-.07.1-.11.48.34.95.68 1.43 1.02.24.53.76.82 1.05 1.35 1.06 1.95.1 3.55-.88 5.07-1.56 2.44-4.04 3.59-6.71 4.39-.89.15-1.75.46-2.65.61h-.2c-.73.27-1.52-.08-2.25.2-1.29 0-2.59.45-3.88 0Z"
			style={{
				fill: '#d4ceb1',
			}}
		/>
		<path
			d="M30.18 187.95c-1.25-.03-2.47-.3-3.67-.61 1.27-.05 2.52-.01 3.67.61Z"
			style={{
				fill: '#e2e0d6',
			}}
		/>
		<path
			d="M36.11 186.93c.83-.43 1.69-.72 2.65-.61-.83.43-1.69.74-2.65.61ZM33.66 187.13c.72-.43 1.5-.1 2.25-.2-.72.43-1.5.1-2.25.2Z"
			style={{
				fill: '#e0d9b7',
			}}
		/>
		<path
			d="M32.63 187.74c-.57.41-1.23.11-1.84.2.57-.41 1.23-.11 1.84-.2Z"
			style={{
				fill: '#e2e0d6',
			}}
		/>
		<path
			d="M24.06 175.71c1.6-1.72 3.58-2.89 5.73-3.77.39-.16.8-.07 1.21-.1.08.33-.32.53-.23.87 0 .1-.03.19-.06.28-.05.09-.12.16-.2.21-1.8.04-3.24.79-4.4 2.16-.28.33-.69.54-1.11.71-.1.03-.2.05-.31.05-.28-.02-.53-.11-.63-.4Z"
			style={{
				fill: '#e2dfc9',
			}}
		/>
		<path
			d="M30.59 172.65c-.43-.56.22-.57.41-.82 2.28-.7 4.56-.68 6.9-.16 1.54.34 3.04.65 4.33 1.58-.15.17-.34.18-.55.15-.1-.02-.19-.05-.28-.09-1.07-.43-2.08-1.01-3.28-1.02-1.23-.14-2.47-.1-3.7-.32-.82-.15-1.69-.02-2.15.89-.6.26-1.11-.18-1.67-.22Z"
			style={{
				fill: '#dddcbe',
			}}
		/>
		<path
			d="m24.06 175.71.61.21c.26.35-.01.63-.14.93-.44 1.04-.21 1.41.95 1.44.84.02 1.68.06 2.52-.06.27-.04.54-.09.76.13-.02.39-.34.59-.62.56-1.2-.11-2.42.25-3.61-.17-.71-.25-1.26-.55-.85-1.45.14-.31.13-.66-.03-.98v-.21a.72.72 0 0 1 .41-.41Z"
			style={{
				fill: '#e3dec0',
			}}
		/>
		<path
			d="M41.62 173.26h.61l1.64 1.22h-.01c-.17.16-.36.23-.59.22-.72-.28-1.41-.61-1.65-1.44Z"
			style={{
				fill: '#d6ceac',
			}}
		/>
		<path
			d="M124.35 92.96c.04.44-.16.96.41 1.22a.7.7 0 0 0 .1.08c.18.3.27.64.49.92.13.2.21.41.21.64-.25.98-.87 1.67-1.71 2.2-.41.34-.21.7-.07 1.08.22.58.32 1.17-.2 1.67-1.34.31-1.97 1.65-3.14 2.2-.08.05-.16.1-.25.14-.73.24-1.07.9-1.57 1.4-.61.61-1.14 1.33-2.07 1.5-.28-.66.39-.89.61-1.33.14-.19.3-.35.49-.49.27-.17.46-.4.62-.67.05-.08.1-.15.16-.22 1.12-1.09 2.48-1.87 3.63-2.93.32-.29.9-.45.71-.96-.2-.51-.72-.12-1.09-.13-.13 0-.27.01-.41 0a.71.71 0 0 1-.39-.16c-.02-.8.88-.94 1.13-1.6-.23-.31-.55-.03-.81-.08-.2 0-.4-.05-.53-.22.45-.27.9-.54 1.44-.65.95-.2 1.12-1.07 1.44-1.79.27-.61.42-1.27.8-1.83Z"
			style={{
				fill: '#ede9cd',
			}}
		/>
		<path
			d="M120.67 97.24h.61c.1.36-.16.5-.4.6-1.22.5-2.21 1.41-3.44 1.9-.73.29-1.27.86-1.89 1.3.13.35.52.24.66.48.04.4-.24.58-.54.62-.89.11-1.4.74-2 1.3-.53.5-1.05 1.09-1.91 1.01-.34-.27-.23-.58-.09-.89 1.05-1.32 2.38-2.33 3.69-3.35.29-.22.64-.37.8-.73 1.32-.45 2.33-1.49 3.66-1.92.28-.09.55-.22.83-.33Z"
			style={{
				fill: '#e6e3ca',
			}}
		/>
		<path
			d="M111.69 103.56c.03.28-.09.6.21.82-.05.56-.2 1.1-.13 1.67-.01.41.03.83-.12 1.22-.52.61-.53-.43-1.06-.23.22 1.08.34 2.24-.68 3.09-.07.07-.16.13-.25.17-.34.11-.69.3-1.03-.01.66-.36.97-.98.98-1.66 0-1.99 1.09-3.5 2.09-5.07Z"
			style={{
				fill: '#e7e4d0',
			}}
		/>
		<path
			d="M104.34 111.72c.79 0 1.4-.44 2.04-.81.33-.17.7-.23 1.02-.41h.61c.05.08.06.17 0 .27-.4.39-.93.51-1.43.71-.66.3-1.34.56-2.01.97.42.24.84.21 1.21.36.43.25 1.01.26 1.27.78 0 .12-.04.2-.14.26-1.03.13-1.89-.4-2.82-.69-.24-.08-.47-.29-.38-.63.02-.41.29-.63.61-.82Z"
			style={{
				fill: '#e5e2c8',
			}}
		/>
		<path
			d="M108.02 110.7v-.21c.15-.23.39-.19.61-.2l1.02-.2c.09.24-.04.38-.2.51-.37.17-.77.14-1.16.19-.1 0-.19-.04-.27-.1Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M107.4 110.5c-.27.32-.62.42-1.02.41.27-.33.62-.42 1.02-.41ZM102.71 125.18c1.22-1.09 2.66-1.85 4.07-2.65.38-.22.56-.54.3-.91-.21-.29-.51-.32-.7.09-1 .31-2.01.56-3.08.54-.2 0-.53-.07-.22.37.19.27-.13.54-.48.61-.6.11-1.23.15-1.49.86-.08.22-.36.13-.55.16-1.42.22-2.91-.11-4.29.62-.34.18-1.05.25-1.15-.54.94-.7.94-.7.18-1.71-.38-.51-.32-.79.35-.87 1.22-.15 2.44-.06 3.66-.14.52-.04 1.01-.09 1.37-.56-.32-.25-.66-.08-.98-.09-.62-.03-1.17-.1-1.19-.91 0-.43-.31-.55-.68-.61-.36-.06-.77-.06-.89-.53 1.09-1.03 2.3-1.87 3.77-2.26.93-.25 1.16-1.06 1.49-1.79.16-.34-.08-.57-.38-.72-.36-.19-.76-.28-1.14-.43-.27-.1-.71-.08-.61-.49.08-.33.52-.3.8-.24.81.17 1.52-.1 2.23-.43h.41q-.08 1.5 1.57 1.18c.87-.17 1.92.39 2.34 1.22.65 1.31.71 2.7.52 4.1-.11.8-.13 1.5.31 2.23.57.94.28 1.66-.82 1.89-1.25.26-2.12 1.13-3.17 1.7-.5.27-.93.72-1.56.33Z"
			style={{
				fill: '#efe9d8',
			}}
		/>
		<path
			d="M102.71 125.18c1.06.07 1.83-.69 2.52-1.22.68-.52 1.36-.81 2.12-1.02.99-.28 1.21-.69.68-1.59-.48-.81-.54-1.56-.3-2.46.14-.52.41-1.19-.21-1.68-.06-.05-.04-.25 0-.37.28-1.14-.56-2.49-1.62-2.91-.55-.22-.9.14-1.29.22-.66.15-1.14 0-1.51-.44-.47-.55.43-.72.42-1.17h.2c.54.83 1.58.56 2.3 1 .27.16.64.15.97.22.39.08.6.38.83.66.96 1.23 1.55 2.55 1.54 4.2 0 1.04.11 2.07-.06 3.11-.15.93-.54 1.61-1.51 1.81-.58.12-.94.5-1.31.9-1.38.77-2.82 1.41-4.33 1.89-.34.11-.67.24-1.03.29-.26.02-.52.02-.76-.11l-.11-.11c.67-.69 1.71-.67 2.45-1.22Z"
			style={{
				fill: '#ede9d4',
			}}
		/>
		<path
			d="M103.12 112.54c-.8.89-1.94.49-2.93.74.69.23 1.38.39 2 .74.47.27.53.59.26 1.09-.53 1-1.09 1.81-2.39 2.01a3.3 3.3 0 0 0-2.11 1.29c-.23.31-.54.51-.96.46-.07.16-.14.33-.29.4-1.55.68-3.08 1.5-4.87 1.28-.36-.04-.64-.22-.56-.66 1.55.38 2.95-.41 4.39-.71 1.04-.22 1.76-1.41 2.85-1.79 1.13-.39 1.89-1.38 3.01-1.8.52-.19.38-.95-.1-1.26-1.05-.68-2.1-.13-3.15-.08-.93.05-1.71.5-2.53.86-.78.35-1.17.12-1.2-.73.75-.14 1.45-.39 2.13-.79 1.31-.76 2.85-.69 4.29-.77.74-.04 1.43-.29 2.16-.28Z"
			style={{
				fill: '#f1eddf',
			}}
		/>
		<path
			d="m190.29 120.09-.2.2c-.34.17-.54.4-.56.83-.01.29-.04.71-.56.61-.37-.26-.35-.71-.52-1.06-.08-.19-.11-.42-.31-.5-1.91-.83-3.79-1.87-6-1.32-.5.29-1.07.38-1.62.53-.8.21-.92.54-.42 1.16.08.1.11.24.14.37.01.15-.02.29-.1.41-.63.11-1.33.03-1.57-.55-.34-.83.05-1.68.53-2.37.51-.73 1.16-.13 1.56-.05-.64.03-.63-.73-.94-1.2-.02-.04-.04-.08-.06-.13.48-.5.95.09 1.44 0 2.23-.42 4.24.39 6.24 1.17 1.1.43 1.93 1.3 2.94 1.88Z"
			style={{
				fill: '#eae5d2',
			}}
		/>
		<path
			d="M176.41 117.64v-.2c1.03-.54 2.16-.4 3.26-.41-.36.86-1.06.95-1.86.84-.46-.14-.98.11-1.4-.23Z"
			style={{
				fill: '#eae5d2',
			}}
		/>
		<path
			d="M189.06 121.72c.27-.24.34-.57.28-.9-.12-.71.22-.73.74-.53.14.89.79 1.3 1.54 1.59.66.25.92.7.91 1.41 0 2.54.63 2.32 2.4 2.52.15.02.3.13.44.19l-.11.11c-.06.03-.12.08-.19.08-1.66-.07-2.78.88-3.67 2.09-.72.98-1.59 1.57-2.77 1.87-1.15.29-2.18.25-3.18-.39-.38-.03-.75-.13-1.08-.33-.5-.35-1.07-.27-1.63-.29-.62-.02-1.26.14-1.85-.22-.08-.11-.08-.21 0-.32.59-.37 1.25-.16 1.88-.22.21-.01.43 0 .64 0 .47.02.93.1 1.39.24.77.23 1.57-.04 2.19-.39.55-.31.32-1.1.25-1.71-.08-.66-.42-1.22-.69-1.79-.28-.58-.29-1.09 0-1.64.62-.24 1.26-.41 1.68-1.02.16-.24.5-.34.81-.35Z"
			style={{
				fill: '#e8e3cd',
			}}
		/>
		<path
			d="M202.54 131.71c.22 1.06.85 1.53 1.95 1.44.67-.06 1.33.04 1.93.39l-.12.12c-.77.29-1.56.16-2.34.1-1.53-.36-2.48-1.31-2.85-2.83-.29-1.19-1.23-1.82-2.08-2.53-.52-.39-.97-.9-1.66-1.03-.29-.2-.63-.36-.57-.8.15-.07.29-.08.43.04.51.03.89.49 1.43.41 2.07.92 3.39 2.46 3.88 4.69Z"
			style={{
				fill: '#e3dfc4',
			}}
		/>
		<path
			d="M197.23 126.61h-.41c-.29.25-.58.07-.86 0-.25-.14-.62-.18-.56-.61.7-.05 1.26.29 1.84.61Z"
			style={{
				fill: '#e8e3cd',
			}}
		/>
		<path
			d="M202.54 131.71c-.55-.59-.58-1.41-.96-2.08-.69-1.21-1.91-1.78-2.92-2.61 1.92.33 3.84 2.65 3.88 4.69Z"
			style={{
				fill: '#e7e4d4',
			}}
		/>
		<path
			d="M207.43 133.75v.2c-.5.27-.87.21-1.03-.4.34.06.68.13 1.02.2Z"
			style={{
				fill: '#e3dfc4',
			}}
		/>
		<path
			d="M141.09 87.04c1.54.21 2.86.92 4.09 1.83-.07.08-.15.13-.25.15-1.03-.18-1.85-.85-2.81-1.19-.3-.11-.61-.16-.92-.08-.51.87.26 1.43.69 1.75 1.5 1.13 1.69 2.65 1.67 4.31-.23.6-.41 1.23-.97 1.63-.55-.47-.19-.93.04-1.36.38-.71.23-1.23-.47-1.61-.36-.19-.72-.45-1.14-.2-.52.31-.35.98-.17 1.18.77.85.02 1.33-.33 1.92-.03.06-.08.11-.12.17-.1.11-.23.19-.37.24-.26.09-.6-.09-.8.08-.94.8-.98.11-1.13-.6-.17-.82-.17-1.62-.02-2.42.12-.62-.02-1.12-.57-1.51-.49-.34-.84-2.4-.52-2.9.32-.51.73-.09 1.11-.1-.1-.45-.52-.39-.8-.53-.28-.15-.58-.34-.51-.68.06-.29.4-.32.66-.4.2-.05.41-.11.6-.05.98.28 2.01.2 3.01.36Z"
			style={{
				fill: '#d8cc9f',
			}}
		/>
		<path
			d="m127 91.53.2-.41c.27-.83.98-1.11 1.72-1.27.47-.1.95-.16 1.31-.5.75-.71 1.7-.61 2.59-.63.79-.02 1.07.6.73 1.35-.39.87-1.15 1.39-1.79 2.03-.87.86-1.88 1.55-2.87 2.24-.23.16-.48.25-.76.14-.26-.17-.12-.35 0-.5.49-.57.84-1.2 1.1-1.9.07-.2.39-.35.19-.61-.21-.27-.53-.24-.83-.17-.42.1-.77.43-1.23.39a.483.483 0 0 1-.35-.18Z"
			style={{
				fill: '#edeaca',
			}}
		/>
		<path
			d="M141.09 87.04c-1.37.22-2.77-.31-4.17.06.2.58.64.52 1.04.58.32.05.54.27.64.59.06.22-.04.4-.23.51-.33.19-.48-.05-.65-.28-.1-.14-.25-.24-.44-.13-.18.11-.13.27-.12.44.04.4.03.81.05 1.21.02.45-.19.94.61 1.1.41.09.81.86.66 1.31-.41 1.22-.16 2.38.03 3.66.45-.44.96-.64 1.56-.5-.09.77-.66.97-1.29 1.01-.7.05-.78-.52-.88-1.02-.28-1.36-.45-2.74-1.03-4.02-.42-1.41-.78-2.84-1.04-4.29-.07-.37 0-.67.37-.86 1.68-.14 3.29.22 4.9.6Z"
			style={{
				fill: '#dacfa4',
			}}
		/>
		<path
			d="M127 91.53c.42.05.76-.11 1.13-.32.47-.27 1.02-.42 1.49.02.22.2.79.47.02.74-.45.15-.25.64-.44.94-.34.53-.64 1.09-1.17 1.48-.14.4-.48.51-.85.55a3.6 3.6 0 0 1-.92-.2c-.92-.75-.99-1.55-.21-2.35.23-.24.46-.48.75-.65l.21-.2Z"
			style={{
				fill: '#efebcf',
			}}
		/>
		<path
			d="M136.19 86.44c-.14.25-.24.52-.21.81.08.41-.28.3-.45.33-.75.16-1.14.79-1.67 1.23-.15.06-.31.07-.47.05-1.12-.1-2.21-.14-3.25.46-.47.27-1.03.68-1.51-.04 1.68-1.16 3.4-2.23 5.5-2.43.71-.07 1.3-.61 2.05-.42Z"
			style={{
				fill: '#e0dcb5',
			}}
		/>
		<path
			d="M128.63 89.29c.28.14.55.28.86.08 1.24-.83 2.65-.7 4.04-.69.74.6.8 1.16.25 1.97-.39.57-1.03.85-1.43 1.4-.05.08-.11.16-.17.23-.22.25-.46.48-.69.7-.07.07-.14.13-.21.18-.47.38-.93.78-1.51 1-.32.1-.56.31-.82.51-.08.06-.17.1-.26.14-.38.12-.7.37-1.07.5-.56.19-1.1.21-1.48-.38 0-.1.04-.18.14-.22.32-.13.6.22.92.09l.82-.41c.74.05 1.13-.56 1.63-.92 1.35-.97 2.68-1.97 3.62-3.39.18-.27.37-.53.19-.82-.19-.29-.51-.35-.89-.31-.93.1-1.76.27-2.58.88-.66.49-1.73.31-2.44.94-.12.11-.23.24-.34.35-.33-.35-.29-.73.14-.85.59-.16.86-.66 1.29-.99Z"
			style={{
				fill: '#e8e3c0',
			}}
		/>
		<path
			d="M126.39 94.8h-.2c-.41.19-.44.45-.17.8.23.29.55.51.64.89 0 .1-.04.18-.13.23-.68.08-.87-.47-1.15-.9l-.21-.61c-.17-.33-.22-.7-.41-1.02-.37-1.11.43-1.76 1.01-2.48.29-.35.69-.14 1.03.03 0 .39-.28.59-.52.82-.75.71-.72 1.32.11 2.04.07.04.09.09.07.13-.02.05-.04.07-.07.07Z"
			style={{
				fill: '#e8e2c2',
			}}
		/>
		<path
			d="M147.01 98.26c-1 2.16-2.87 1.84-4.69 1.63-1.11.5-3 .17-3.5-.61.37-.35.8-.23 1.22-.14.63.12 1.26.04 1.89.07.64-.04 1.25.24 1.89.21.94-.04 1.8-.23 2.32-1.12.08-.14.17-.25.29-.35.18-.11.35-.21.57-.1v.41Z"
			style={{
				fill: '#e2d6ad',
			}}
		/>
		<path
			d="m147 97.85-.41.2c-.22-.28-.05-.51.09-.75 1.52-1.33 1.48-3.1 1.35-4.88-.02-.27-.05-.53.09-.78.04-.04.08-.07.11-.11 1.4 1.35.55 4.31-.71 5.71-.18.2-.35.41-.53.61Z"
			style={{
				fill: '#c9c19c',
			}}
		/>
		<path
			d="M144.96 88.89h.22c.73.32 1.37.76 1.84 1.41-.04.03-.07.07-.11.1-1.03-.02-1.62-.6-1.95-1.52ZM147.02 90.3c.61.21.9.74 1.22 1.23l-.02.02c-.84.02-1.25-.39-1.22-1.23l.02-.02Z"
			style={{
				fill: '#c9c69d',
			}}
		/>
		<path
			d="M143.74 100.3c.56.05 1.1-.04 1.63-.21.06-.04.15-.07.19-.02.6.7 1.46 1.22 1.6 2.25.03.14.05.28.05.42.04.93.14 1.85.32 2.78.27 1.34-.07 2.71-.24 4.06.2 1.31-.39 2.31-1.2 3.26-.85.99-.79 1.11.43 1.43.13.04.23.13.32.23.21.48.2.99.21 1.5 0 .1-.01.2-.03.31-.26.8-.82.82-1.29.32-.75-.8-1.61-.67-2.5-.49-.43.09-.85.21-1.26-.06-.2-.34.1-.42.3-.48.53-.17.94-.5 1.33-.88.16-.4-.19-.26-.32-.27-.68-.05-1.36.04-2.03-.1-.17-.04-.33-.08-.5-.09-1.42-.11-1.7-.41-1.5-1.82.22-1.55.14-3.1.07-4.65-.06-1.31-.06-2.63-.01-3.94.02-.47-.04-.86-.37-1.2-.41-.96-.22-2.02-.49-3 .64-.23 1.09.22 1.55.49.68.4 1.33.64 2.09.3.54-.24 1.13.17 1.67-.14Z"
			style={{
				fill: '#e1dbc2',
			}}
		/>
		<path
			d="M162.93 109.48v.2c-.42.4-.9.2-1.34.07-.96-.27-1.88-.29-2.88-.1-1.46.28-2.94.47-4.36.91-.87.27-1.87.48-2.19 1.57-.09.32-.31.68-.05.96.3.34.62.02.91-.11.22-.09.43-.21.67-.11.21.21.06.38-.05.57-1.24.93-1.63.93-2.63-.06-.16-.6.25-1.07.34-1.61 1.04-1.66 2.52-2.57 4.5-2.61.21 0 .42-.01.53-.21.14-.25.03-.47-.15-.64-.62-.58-1.16-1.15-1.47-2-.24-.66-1.1-.24-1.65-.46-1.5-1.91-3.34-3.35-5.67-4.15-.2-.09-.34-.21-.31-.46l.08-.13c.42-.49.74-.51 1.21.03.66.77 1.41.69 1.98-.11.3-.42.8 0 1.1-.33.18.61 1.04.2 1.22.82-.09.26-.31.43-.48.64-.25.29-.31.62 0 .89.31.28.63.12.9-.12.35-.32.57-.9 1.22-.59h.82c0 1.18.59 1.92 1.77 2.13.31.06.56.25.86.28.58.06.52.41.33.74-.38.67-.03.79.54.86 1.16.15 1.81.75 2.05 1.98.22 1.12 1.34 1 2.21 1.15Z"
			style={{
				fill: '#e0d9b4',
			}}
		/>
		<path
			d="M143.74 100.3c-1.53.41-3.07 1.13-4.45-.37-.2-.22-.54-.27-.86-.24a.43.43 0 0 1-.28.11c-1.31-.23-2.63-.06-3.94-.03-.65.02-1.25.21-1.79.62-1.79 1.36-3.87 1.46-5.99 1.25-.91-.09-2.58-1.83-2.75-2.76-.11-.62.27-.82.77-.76.65.08 1.28-.05 1.92-.1.28-.02.66.12.8-.26.12-.31-.19-.47-.35-.68-.11-.13-.2-.27-.22-.45-.24-.52-.85-.74-1.02-1.32-.19-.66 0-.82.61-.52.5.48 1.03.58 1.62.14.3-.22.64-.38 1.03-.34.21.02-.38.42.15.3.12-.03.25.08.36.17.31.79-.09 1.36-.73 1.6-.53.2-.49.4-.37.81.15.47.15.93-.29 1.29-.18.15-.37.38-.15.6.2.2.44 0 .65-.09.28-.13.48-.37.75-.52.09-.04.18-.07.27-.09 1.29.28 2.54.19 3.85-.13 1.78-.43 3.55.1 5.29.56.09.04.16.11.22.19 1.08.65 2.29.53 3.47.61.38.47.91.41 1.43.41ZM147.01 102.34c-.48-.79-1-1.56-1.63-2.24 1.21-.73 1.39.38 1.84 1.02-.26.38.26.88-.2 1.22Z"
			style={{
				fill: '#e3ddbb',
			}}
		/>
		<path
			d="M167.42 114.58c.28.4.32 1.24 1.03.97.71-.26 1.22-.97 1.37-1.7.16-.79.46-.86 1.06-.5.04.64.63 1.02.79 1.6.28.51.58 1.02.91 1.51.82 1.85 1.36 3.78 1.2 5.81-.18 2.32-1.43 3.96-3.55 4.94-3.56.96-7.11.64-10.64-.16-1.25-.28-2.53-.45-3.78-.73-.41-.09-.72.07-1.02.33-.41.06-.65-.16-.72-.53-.08-.38.25-.5.5-.66.44-.29.93-.37 1.44-.34 1.63.29 3.18.86 4.81 1.18 2.41.47 4.83.49 7.26.42.68-.02 1.31-.31 1.91-.63.72-.24 1.26-.64 1.39-1.44.06-.35.34-.56.59-.8.5-.48.85-1.06.81-1.79-.03-.54-.36-.79-.88-.94-.61-.18-.47.28-.59.54-.07.16-.2.31-.36.33-1.58.25-2.65 1.3-3.75 2.32-.12.11-.31.11-.48.14-2.18.17-4.3-.09-6.36-.82-.28-.1-.57-.21-.88-.21-.22-.02-.43-.06-.63-.17a.96.96 0 0 1-.36-.68c.07-.66.4-.99 1.1-.83.1.02.2.02.31.01 2.84-.19 2.39-.14 2.32-2.38 0-.14-.02.03 0-.1.19-1.77.25-1.78-1.96-1.64-.52.03-1.08.31-1.52-.24-.14-.67.17-1.01.8-1.12.59.45 1.29.24 1.95.33 1.69.23 3.29-.14 4.87-.69.36-.13.29-.37.35-.63.09-.41-.03-1.04.73-.94.07.09.07.17-.01.25Z"
			style={{
				fill: '#cdc18f',
			}}
		/>
		<path
			d="M167.42 114.58v-.2c-1.04-1.82-2.71-1.51-4.35-1.31-.1.01-.2 0-.29-.05-.21-.44.27-1.09-.44-1.37-.33-.24-.72-.37-1.08-.55-.21-.11-.43-.25-.38-.53.05-.27.3-.46.52-.38 1.54.51 3.42-.23 4.67 1.33.4.5.99.5 1.57.43.28-.02.57 0 .77.19.32.3 1.04.26 1 .82-.05.6-.71.43-1.09.47-.79.07-.54.83-.88 1.17Z"
			style={{
				fill: '#cdc292',
			}}
		/>
		<path
			d="M167.63 111.93c-.66.52-1.42.36-1.92-.48-.17-.29-.35-.48-.67-.55-1.2-.27-2.46-.19-3.65-.53-.09-.03-.29.06-.33.15-.11.2.07.31.23.36.45.14.9.29 1.24.65-.22.22-.5.22-.75.11-1.45-.63-2.89-.35-4.32.05-.16.05-.33.06-.5.04a.938.938 0 0 1-.28-.1c.06-.53.11-1.04-.71-.94-.18.02-.51-.06-.35-.43 2.63-.76 5.27-.99 7.94-.17.35.3.83.24 1.22.41.69-.03 1.29.21 1.84.62.27.36.97.18 1.02.81Z"
			style={{
				fill: '#cdc397',
			}}
		/>
		<path
			d="M172.32 116.41c-.35-.43-.67-.88-.82-1.43-.19-.61.17-.65.62-.61 1.08.76 1.94 1.75 2.78 2.74.2.23.31.53.68.52 1.4 1.86 2.41 3.9 2.89 6.18.05.43.08.86-.11 1.27-.51.29-.57-.24-.81-.44-.39-1-.1-2.14-.67-3.13-.5-.87-.77-1.87-1.35-2.7-.13-.18-.29-.35-.46-.5-.39-.56-.88-1.01-1.41-1.42-.2-.27-.41-.53-.77-.6-.2-.03-.39.06-.57.11Z"
			style={{
				fill: '#b7a978',
			}}
		/>
		<path
			d="M172.12 114.37c-.26.15-.61.21-.62.61-.05-.6-1.22-.78-.61-1.63.41.34.97.5 1.23 1.02Z"
			style={{
				fill: '#baad83',
			}}
		/>
		<path
			d="M180.9 128.85h2.6c.42 0 .79.07 1.08.41-.3.34-.7.11-1.04.16-.25.86.62 1.38.61 2.17 0 .16.28.12.45.14.35.03.68.07.8.47.08.6.28 1.16.51 1.73.43 1.1.27 2.26.02 3.36-.14.62-.75.92-1.43.86-.47-.1-.48-.73-.95-.84-.69-.16-1.25.06-1.7.59-.51.3-1.1.3-1.64.48-.77.25-1.5.49-2.16 1.04-.82.69-1.99.52-2.96.9-.55.05-1.11-.04-1.65.12-.2.05-.4.05-.6.01-.49-.25-1.31.11-1.45-.8-.02-.13-.24-.06-.37-.06-.66.02-1.42.31-1.74-.62-1.4-.23-1.71-1.52-2.35-2.46-.22-.33-.36-.81-.02-1.13.34-.33.71 0 1.02.16 1.58.8 3.23 1.2 5.01.84 1.11-.22 2.2.27 3.33.02.83-.18 1.34-.73 1.61-1.37.25-.6.09-1.3-.51-1.84-.42-.37-.79-.83-.97-1.41-.21-.67-.78-.9-1.39-1.04-.18-.1-.3-.25-.31-.46.15-.61.68-.89 1.13-1.23.33-.2.7-.23 1.08-.2.81.07 1.52-.18 2.19-.61.71-.1 1.26.31 1.84.61Z"
			style={{
				fill: '#e1dcc2',
			}}
		/>
		<path
			d="M175.79 129.06c-.17.55-.72.79-1.02 1.22-.32.15-.58-.09-.87-.13-.58-.08-.99.1-1.22.65-.98.52-1.73 1.37-2.72 1.88-.87.26-.84 1.31-1.56 1.74-.34.21-.54.44-1.01.42-.7-.02-1.34.35-1.98.65-.15.04-.28.03-.42-.05-.14-.75.51-.93.94-1.23.48-.34.62-.66.23-1.14-.3-.76.13-.96.77-1.01 1.61.18 3.02-.14 4.08-1.49.32-.41.91-.44 1.29-.79.14-.14.3-.24.49-.28.45-.04.85-.21 1.24-.41.04 0 .09 0 .13-.01h1.63Z"
			style={{
				fill: '#e3dec2',
			}}
		/>
		<path
			d="M172.93 129.67c-.17 0-.32.03-.41.2-.8.33-1.59.67-2.24 1.27-2.11 1.69-4.37.97-6.64.42-1.61-.39-3.06-1.23-4.64-1.69-.68-.32-1.18-.91-1.84-1.25-.56-.2-1.02-.58-1.51-.89-.5-.39-1.14-.57-1.62-1.01-.47-.43-.63-.88 0-1.31.2-.13.37-.29.53-.46.67-.71.95-.69 1.67.09.02.2-.15.25-.26.34-.39.02-.77.01-1.16.21-.72.35-.78.63-.06 1.01.74-.19 1.25.3 1.8.64.34.21.63.49.99.67 3.14 1.89 6.51 3.09 10.17 3.49.51.06.96-.09 1.3-.43 1.55-1.56 3.57-2.15 5.59-2.75.29-.02.56-.02.78.22l-1.23.61c-.38.27-.87.31-1.23.61Z"
			style={{
				fill: '#cec29a',
			}}
		/>
		<path
			d="M175.39 128.45h-.83c.17-.71.84-.35 1.23-.59.43-.11.88-.08 1.32-.09.98-.03 1.43-.43 1.44-1.42.01-.87-.12-1.74-.31-2.6-.14-1.59-.97-2.91-1.65-4.29-.31-.62-.67-1.22-1-1.83.68.31.92.98 1.23 1.56 1.26 2.29 2.35 4.64 2.24 7.35-.05 1.3-.53 1.83-1.85 1.89-.61.03-1.22 0-1.83.01Z"
			style={{
				fill: '#d0c298',
			}}
		/>
		<path
			d="M176.41 117.64c.48.13.95-.34 1.43 0 .69.48.86 1.07.63 1.92-.16.59-.03 1.28.43 1.78.75.82.74 1.75.47 2.73-.04.03-.07.07-.11.1-.59-2.34-1.79-4.4-2.86-6.53Z"
			style={{
				fill: '#e9e2c9',
			}}
		/>
		<path
			d="M179.26 127.63v-3.26c.83.21.68.98.86 1.55-.07.67.44 1.57-.73 1.8l-.13-.09Z"
			style={{
				fill: '#eae2c6',
			}}
		/>
		<path
			d="M179.88 126c-.06-.6-.18-1.18-.61-1.63v-.2c.36-.24.58 0 .73.26.19.36.43.67.71.97.25.27.37.59.04.88-.43.38-.65.05-.86-.28Z"
			style={{
				fill: '#e9e2c9',
			}}
		/>
		<path
			d="M180.9 128.85c-.71.1-1.24-.35-1.84-.61 0-.22-.04-.46.2-.61.5.41 1.14.6 1.63 1.02v.2Z"
			style={{
				fill: '#eae2c6',
			}}
		/>
		<path
			d="M154.36 102.34c-.35.1-.69.18-.87.56-.23.48-.69.64-1.17.6-.38-.03-.49-.44-.57-.75-.15-.54.31-.76.63-1.04.1-.09.23-.13.35-.19.47.41 1.38-.03 1.63.82Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M164.77 110.5c-.44-.03-.96.16-1.22-.41l1.22.21v.2ZM163.54 110.09c-1.82-.32-3.66-.31-5.49-.18-.83.06-1.65.38-2.47.58-.52.39-1.25.27-1.75.71-1.19.35-1.24.41-1.24 1.45.54-.09.93-.57 1.48-.57.24-.03.47-.1.7-.16.44-.06.86-.31 1.32-.12.1.05.15.14.15.25-.64.83-1.65.65-2.5.89-.1.02-.21.02-.3.06-.53.27-1.04.97-1.65.22-.37-.46.26-1.98.9-2.28 1.78-.85 3.73-1.04 5.61-1.52 1.64-.42 3.09.19 4.63.26l.61.41Z"
			style={{
				fill: '#d6cea4',
			}}
		/>
		<path
			d="M95.15 124.37c.27.62 1.08.45 1.2.32.89-.91 1.98-.33 2.96-.51.72-.14 1.58.3 2.01-.78.13-.33.79-.47 1.29-.4.34.04.44-.15.27-.39-.31-.46-.34-.5.23-.57 1.08-.14 2.18-.22 3.27-.32-.66.29-1.25.74-2 .85-.3.04-.58.18-.67.54-.08.31-.31.42-.59.48-1.56.33-3.01 1.13-4.67 1-.3-.02-.6 0-.89.13-1.41.65-2.73.33-4.15-.13-1.46-.48-2.42-1.35-3.18-2.59-.13-.22-.17-.44-.17-.67.33-.12.52.11.66.33 1.06 1.59 2.64 2.34 4.44 2.73Z"
			style={{
				fill: '#f1eddf',
			}}
		/>
		<path
			d="M98.62 127.02v-.2c.5-.3 1.08-.3 1.63-.41.09.26-.05.42-.23.57-.46.25-.92.44-1.4.04Z"
			style={{
				fill: '#ede9d4',
			}}
		/>
		<path
			d="M95.15 124.37c-.87.39-1.54-.14-2.24-.51-1.16-.61-2.15-1.44-2.87-2.55.12-.35.01-.63-.23-.89-.22-.23-.31-.48-.19-.81.14-.38.24-.87.63-.97.49-.14.42.48.66.72.11.12.24.22.36.33v.2c.8.71 1.85.58 2.6.25 1.03-.46 2.18-.62 3.12-1.27.17.26.5.34.71.32.84-.09 1.23.17 1.06 1.05-.07.4.22.46.5.46.44 0 .88 0 1.31-.07.26-.04.48-.1.6.17.12.28-.12.43-.29.58-.79.68-1.77.51-2.7.54-.98.04-1.98-.04-3.05.2.49.54 1.31.86 1.01 1.74-.16.48-.58.5-1 .52Z"
			style={{
				fill: '#eeead8',
			}}
		/>
		<path
			d="m69.43 133.75.82.41c.29.72-.24 1.2-.55 1.73-.23.41-.55.77-.78 1.18-.32.56-.42.96.45.93.24 0 .47.03.67.19.04.06.07.16.04.18-.84.41-.89 1.15-.81 1.95-.66.26-.81-.47-1.26-.64-.23-.32-.41-.7-.71-.95-.86-.72-.85-1.57-.52-2.52.96-.73 1.91-1.48 2.65-2.45Z"
			style={{
				fill: '#edebdc',
			}}
		/>
		<path
			d="m63.51 143.54.4-.21c.14-.09.27-.18.36-.33.15-.23.15-.64.59-.5.38.12.66.33.57.79-.71.6-1.68.63-2.41 1.15 1.2.76 2.04.89 3.42.52 0-.48-.7-.67-.52-1.22.11-.11.25-.13.4-.11.38.17.7.46 1.08.63.23.22.42.47.72.62 1.44.38 2.93.55 4.35 1 .35.11.8 0 1.06-.41.17-.26.39-.47.74-.41.56.28.82.97 1.49 1.12.38.67.04 1.03-.56 1.2-.56.16-1.18.22-1.69-.07-1.01-.6-2.14-.49-3.23-.68-.48-.09-.7.13-.78.55-.06.3-.19.59-.17.89.11 1.28-.41 2.21-1.51 2.86-.2.12-.35.31-.56.43-.24.13-.49.22-.75.3-1.58.61-2.72-.55-4.02-1.03-.21-.08-.33-.33-.25-.6.28-.23.58-.12.86-.01.54.21 1.1.35 1.65.53 1.88.61 3.35-.36 3.59-2.35.22-1.84-.07-2.16-1.99-2.16-.57 0-1.15-.08-1.72.02-.53.11-1.07.18-1.61.22-.84.06-1.25-.37-1.5-1.09-.27-.79.32-.98.84-1.26.36-.19.75-.27 1.13-.41Z"
			style={{
				fill: '#e6e1c6',
			}}
		/>
		<path
			d="M66.37 143.34c-.08-.18-.12-.39-.23-.54-.22-.28-.05-.5.06-.74.16-.36.44-.22.69-.14.99.32 1.97.47 2.95 0 1.08.1 2.14.38 3.23.24.1-.03.2-.05.31-.06.34-.04.68-.05 1.01-.03.41.02.9.02.97.53.07.51-.36.8-.79.91-.59.14-1.15.4-1.74.52-1.76.35-3.52.69-5.31.15-.44-.05-.8-.28-1.13-.56-.09-.08-.09-.18-.02-.27Z"
			style={{
				fill: '#f6f1e5',
			}}
		/>
		<path
			d="M63.51 143.54c-.39.19-.77.39-1.16.58-.41.19-.86.38-.6.95.22.49.32 1.12 1.17.96.59-.11 1.21-.04 1.82-.05.65-.21 1.32-.06 1.98-.09.2 0 .3.11.27.32-.69.4-1.37.33-2.06-.03-.75.11-1.43.59-2.21.48-1.11-.16-2.1-.77-3.29-.78-.67 0-.05-.6-.01-.93.83-.3 1.8-.28 2.45-1.02.56-.08 1.02-.54 1.63-.41Z"
			style={{
				fill: '#ebe7d4',
			}}
		/>
		<path
			d="M73.11 142.31c-1.13.19-2.24.2-3.27-.41-.83-.57-1.35-1.4-1.84-2.24.53-.05.75.54 1.22.61.1.02.22.03.28.1.85.95 1.77 1.72 3.17 1.57.19-.02.36.16.43.37Z"
			style={{
				fill: '#f3eedd',
			}}
		/>
		<path
			d="M65.35 143.33c-.23-.63-.47-1.14-1-.18-.06.11-.29.12-.44.18.13-.27.3-.53.38-.81.09-.35.05-.8.56-.78.41.01.61.34.71.72.06.22.13.44.19.66 0 .19-.05.35-.23.45-.15-.02-.25-.07-.18-.25Z"
			style={{
				fill: '#e6e6ce',
			}}
		/>
		<path
			d="M65.55 143.53c0-.17.04-.32.2-.4l.61.21v.2c.05.05.07.09.05.14-.02.05-.04.07-.05.07h-.41c-.22.1-.33-.03-.41-.21Z"
			style={{
				fill: '#e9e4cd',
			}}
		/>
		<path
			d="M93.52 129.47c-.08-.79.51-.91 1.05-1 .45-.08.93-.02 1.4-.02 1.26-.89 2.69-1.25 4.21-1.39.53-.05.95-.5 1.51-.49.34.8-.37 1.28-.61 1.9-.09.24-.35.41-.49.64-.16.26-.17.54.07.74.25.22.43-.02.6-.18.32-.29.68-.42 1.11-.43.72 0 1.17-.27 1.08-1.1-.04-.35.02-.71.53-.64.15.05.26.15.34.27.22.58.6.96 1.23 1.07.23.04.5.12.62.32.57.98 1.58 1.03 2.52 1.24.36.08.72.18 1.06.34 1.14.51 1.33.93.97 2.13-.19.41-.45.71-.96.57a.224.224 0 0 1-.13-.14c-.12-.38.55-.78.04-1.09-.55-.34-1.05-.77-1.84-.71-.89.07-1.81-.13-2.68-.39-.53-.15-.85-.14-1.06.51-.38 1.13-1.84 1.95-2.85 1.71.04.24.11.55.3.58 1.53.31 1.29 1.67 1.64 2.68-.9.19-3-1.33-2.99-2.23 0-.8-.17-1.46-.91-1.88a.952.952 0 0 1-.19-.21c-.32-.7-.79-1.14-1.64-1.06-.41.04-.76-.26-1.17-.27-1.13-.11-1.83-.98-2.74-1.49Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="m84.33 129.87.41-.61c.34-.23.68-.23 1.02 0 1.58 1.67 3.49 2.81 5.68 3.49.81.25 1.66.32 2.46.6.35.12.7.25 1.06.34.73.18 1.24.97 1.1 1.66-.09.45-.47.49-.79.44-1.67-.25-2.76.81-3.93 1.7-.37 0-.48-.27-.44-.55.22-1.46-.52-2.28-1.78-2.78-.19-.07-.36-.18-.53-.29-.74-.64-1.44-1.26-1.98-2.13-.45-.72-1.21-1.48-2.32-1.32-.08-.19-.08-.38.05-.55Z"
			style={{
				fill: '#e6e2c4',
			}}
		/>
		<path
			d="M92.09 128.45c.27-.27.58-.54.97-.29.4.25.05.51-.06.77-.2.48.07.69.52.75 1.73.91 3.49 1.76 5.24 2.63.32.16.64.46.47.91-.15.39-.5.57-.9.55-1.57-.11-3.16-.08-4.68-.57-.75-.24-1.52-.35-2.29-.44-.48-.06-.86-.2-.95-.74.08-.28.27-.41.56-.42.37.05.69.29 1.06.34.35-.07.66.04.97.2.24.12.47.06.61-.19.12-.21.03-.4-.14-.54-.96-.75-1.07-1.89-1.36-2.95Z"
			style={{
				fill: '#f4efd7',
			}}
		/>
		<path
			d="M90.46 131.91c.13.15.25.44.39.44 1.61.07 3.08.86 4.7.9.8.02 1.6.13 2.39.24.46.06 1.01.12 1.12-.38.1-.47-.43-.63-.83-.84-1.59-.82-3.34-1.38-4.7-2.61v-.2c.57.1 1.05.34 1.5.72.37.32.8.61 1.36.5.33.22.66.49 1.08.51.82.04 1.38.45 1.78 1.13.14.09.29.18.39.32.24.34.7.62.46 1.13-.2.43-.67.37-1.05.47-1.81.49-3.42-.37-5.11-.7-1.8-.14-3.55-.68-5.06-1.54-1.15-.65-2.64-1.21-3.11-2.74l.41.2c1.08.28 1.9 1.02 2.78 1.61.45.31.89.58 1.41.73.03.04.07.07.1.11Z"
			style={{
				fill: '#eee9d1',
			}}
		/>
		<path
			d="m91.07 131.71-.61.2c-1.03-.27-1.06-1.35-1.63-2-.15-.18.08-.37.26-.46.62-.33 1.16-.85 1.96-.7.33.06.59-.12.83-.3h.2c.6.5.52 1.32.87 1.96.13.24.19.49.46.65.39.23.94.41.44 1.05-.39.5-.81.67-1.2.09-.22-.33-.42.13-.57-.08-.33-.15-.66-.33-1.02-.41Z"
			style={{
				fill: '#f5f0dc',
			}}
		/>
		<path
			d="M91.89 128.45c-.11.12-.24.35-.34.33-1.03-.14-1.69.67-2.71 1.03.84.53.97 1.49 1.62 2.11-.63.07-1.07-.14-1.59-.58-.71-.6-1.51-1.17-2.44-1.48-.19-.07-.24-.21-.27-.38.01-1.28.24-1.5 1.61-1.17 1 .24 2.03.04 3.02.33.32.09.72-.11 1.08-.18Z"
			style={{
				fill: '#f4f0d8',
			}}
		/>
		<path
			d="M92.03 127.9c-1.4.56-2.48.33-3.55-.1-.15-.06-.3-.16-.44-.25-.29-.19-.99-.09-.7-.7.21-.45.7-.78 1.27-.53 1.06.46 2.09.97 3.41 1.59Z"
			style={{
				fill: '#e4e2c8',
			}}
		/>
		<path
			d="M101.69 126.61c-1.06.88-2.43.77-3.67 1.07-.35.09-.58.17-.82.4-.34.32-.77.4-1.23.36.46-1.26 1.58-1.29 2.65-1.43.5.07.96-.09 1.43-.2.29-.25.71-.2 1.02-.41l1.02-.2.08.11c.02.09 0 .18-.03.26-.14.15-.29.21-.46.04Z"
			style={{
				fill: '#e7e2ca',
			}}
		/>
		<path
			d="M78.01 132.12c-.32-.63-.22-.93.58-.87.63.05 1.32.36 1.75-.61.15-.35 1.03-.31 1.55.05-.83.4-1.17 1.27-1.81 1.86-.28.25-.25.69-.21 1.06.03.26.06.6.42.59.45-.01.24-.36.25-.61.03-1.15 1.1-1.32 1.81-1.68.66-.34.89.52 1.23.94.28.35.37.81.3 1.26-.15 1.03.27 2.13-.58 3.08-.31.35-.11 1.05-.08 1.58.08 1.22-.43 1.78-1.68 1.8-.24-.17-.46-.38-.79-.28-1.02-.14-1.45-.57-1.52-1.52-.12-1.6-.51-3.17-.48-4.78-.02-.09-.03-.18-.04-.27.05-.39-.16-.65-.45-.87-.18-.21-.39-.42-.24-.74Z"
			style={{
				fill: '#eeead9',
			}}
		/>
		<path
			d="m78.01 132.12.41.61c.23.3.28.68.41 1.02.17.29.19.63.02.86-.93 1.29-1.94 2.52-3.61 2.87-.69.15-1.39.25-1.97.71-.69.15-1.39.32-2.09.4-.41.05-.81-.04-1.12-.35h-.1c-.55-.09-1.37.29-1.6-.22-.28-.62.4-1.24.76-1.75.48-.67.92-1.32 1.14-2.11l.61-.2c.3.14.43.41.52.71.5 1.68 2.31 2.59 3.96 2 1.28-.46 1.93-2.59 1.15-3.71-.42-.61-1-.57-1.63-.5-.41.05-.94.36-1.15-.33l1.43-.61c1.07-.34 1.86.63 2.86.61Z"
			style={{
				fill: '#f6f2e3',
			}}
		/>
		<path
			d="M81.48 140.48c1.6-.51 1.58-.36 1.48-2.69-.02-.55.02-.89.47-1.3.59-.54-.12-1.39.2-2.07.06-.13 0-.32 0-.49 0-.6-.79-2.03-1.07-1.9-.44.21-.83.51-1.29.71-.55.24-.64.64-.43 1.23.12.34-.29.56-.59.65-.33.09-.54-.2-.56-.45-.1-.8-.43-1.71.62-2.18.24-.11.2-.32.29-.49.28-.5.65-.87 1.28-.81.42.46.95.16 1.43.2.15.38.19.81.47 1.14 1.01 1.98 1.53 3.98.43 6.11-.17.33-.34.67-.41 1.04-.2 1.01-.73 1.71-1.78 2.01-.62.18-1.06.73-1.7.89-.22.04-.43.03-.62-.09-.23-.29.01-.47.2-.53.6-.22.87-.95 1.58-.98Z"
			style={{
				fill: '#eeead5',
			}}
		/>
		<path
			d="M83.52 131.91c-.34-.29-.47-.61-.2-1.02l.61-.21s.06.07.09.11c.07.41-.21.7-.38 1.03-.04.03-.07.06-.11.09Z"
			style={{
				fill: '#e7e2c8',
			}}
		/>
		<path
			d="M84.33 129.87v.61l-.05.12c-.1.1-.21.17-.35.08.03-.32.14-.61.41-.82Z"
			style={{
				fill: '#e7e2c8',
			}}
		/>
		<path
			d="M73.72 132.12c.36.36.74.18 1.13.06 1.54-.45 2.19.74 2.26 1.78.09 1.24-.43 2.27-1.4 2.8-.91.5-2 .33-3.09-.08-1.37-.52-1.4-1.68-1.77-2.73.84-.78 1.66-1.6 2.86-1.84Z"
			style={{
				fill: '#f7f3e8',
			}}
		/>
		<path
			d="M214.58 139.26c-.12 1.76 1.13 2.75 2.16 3.87.11.12.19.27.29.41-.07.07-.16.1-.25.1-.36-.05-.52-.38-.78-.56-.24-.14-.47-.51-.77-.15-.26.32-.33.74.04.99.77.53.71 1.52 1.25 2.17.13.16.07.39-.04.58-.88 1.14-.82 1.03-2.12.26-1.43-.85-2.65-2.15-4.46-2.28-.43-.03-.72-.32-.96-.68-.3-.45-.62-.89-1.02-1.27-.65-.62-1.08-.23-1.56.4-.85 1.11-.64 2.21-.53 3.38.02.23-.06.48-.33.57-.31-.07-.41-.35-.51-.58-.24-.54-.64-.37-1.03-.27-.35.09-.5.32-.45.68.06.44.31.66.77.62.36-.03.68.02.9.33.35 1.01-.03 2.04.1 3.06v1.05c.19.66.2 1.35.42 2 .67 1.52 1.77 2.62 3.22 3.4.24.13.65.05.58.52-.28.23-.64.28-.96.23-.5-.08-.81.14-1.17.43-.92.76-1.76.65-2.52-.31-.48-.61-1.16-1.05-1.47-1.79-.12-.6-.34-1.15-.61-1.7-.44-.91-.63-1.87-.74-2.9-.23-2.08 0-4.18-.35-6.24-.01-.71.62-1.09.86-1.68.41-.5.55-1.13.83-1.7.35-.94 1.47-.99 2.03-1.72.07-.09.25-.06.24-.32-.04-.74.3-1.3.97-1.64.13-.06.27-.09.42-.1.2-.01.44-.03.59.09 1.07.85 2.35.68 3.58.79.79.07 1.52.22 2.01.98.21.32.56.67.97.16.23-.36.06-.86.42-1.18Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M214.58 139.26c-.02.48.08.98-.21 1.42-.16.08-.27 0-.37-.12-.28-.55-.83-.93-1.04-1.53.06-1.48-1.04-2.03-2.09-2.62-.53-.2-.9-.65-1.4-.9-.23-.16-.48-.3-.66-.54-.02-.1 0-.19.06-.27.14-.05.28-.06.41.05 1.9.69 3.39 1.91 4.59 3.51.24.32.47.66.71.98Z"
			style={{
				fill: '#cfcbaa',
			}}
		/>
		<path
			d="M216.83 143.54h.21c.61.7 1.17 1.43 1.63 2.24.78 1.75 1.63 3.48 2.25 5.31.19.3.07.63.09.94-.57.19-.57-.34-.66-.6-.61-1.76-1.41-3.43-2.17-5.13-.35-.79-.98-1.38-1.34-2.15-.06-.2-.12-.4 0-.61Z"
			style={{
				fill: '#d8d2b1',
			}}
		/>
		<path
			d="M209.28 134.76h-.42c-.33.28-.64.13-.94-.04-.53-.29-1.09-.34-1.67-.28-.2.03-.36.18-.57.18-.55-.16-1.09-.3-1.65-.43-.36-.08-.74-.17-.72-.67.15-.09.3-.1.44.01h2.65c.27.31.63.42 1.03.4.61.27 1.23.54 1.84.81Z"
			style={{
				fill: '#d6d3b2',
			}}
		/>
		<path
			d="M221.11 165.15c.92-1.17 1.43-2.49 1.43-4v-4.77c.66 1.07.51 2.31.65 3.48.1.87-.45 1.75-.13 2.65.18.5-.33.69-.49 1.02-.7 1.48-1.5 2.92-3.1 3.66-.79.63-1.74.54-2.65.61-.35-.32-.88-.1-1.23-.41h-.2c-.82.04-1.61-.14-2.39-.37-.1-.04-.19-.1-.26-.18a.317.317 0 0 1-.03-.3c.22-.2.49-.19.76-.16.11.01.21.04.31.08 1.1.37 2.23.45 3.39.48 1.31.03 2.38-.34 3.23-1.34.18-.21.33-.54.72-.46Z"
			style={{
				fill: '#f5efe0',
			}}
		/>
		<path
			d="M216.83 167.81c.82-.49 1.79-.32 2.65-.61-.2.35-.47.62-.82.82-.61-.09-1.26.2-1.84-.2Z"
			style={{
				fill: '#f5f0e1',
			}}
		/>
		<path
			d="M221.32 150.88c-.21-.54-.58-1.02-.61-1.63l.41.41c.24.38.21.8.2 1.22Z"
			style={{
				fill: '#f5f2e6',
			}}
		/>
		<path
			d="M162.73 173.52c-.52 0-1.05-.06-1.43.41-.37.26-.77.41-1.22.41h-1.84c-2.06.66-4.18.67-6.3.61-1.75-.05-3.4-.56-5.07-1.04-.96-.28-1.88-.79-2.91-.79-.66 0-1.06-.56-1.68-.69-.49-.1-.85-.1-1.18.27-.23.54-.56.93-1.23.82h-.2c-.08-.09-.11-.19-.08-.31.56-.64 1.25-1.13 1.9-1.66.46-.37 1.02-.39 1.52-.03 2 1.45 4.41 1.77 6.7 2.25 3.25.68 6.58.4 9.82-.2 2.69-.5 5.3-1.44 7.64-2.95 1.22-.79 2.15-1.87 3.11-2.94.22-.17.46-.3.71-.4 1.02-.38 2.04-.35 3.08-.1 2.41.56 4.81.52 7.22-.05.94-.22 1.89-.48 2.88-.34-.03.45-.43.33-.67.47-.52.3-1.46-.2-1.59.83-.97-.13-1.93.61-2.82.23-.64-.28-1.23-.26-1.85-.3-1.21-.08-2.43.09-3.65-.16-.47-.1-1.12-.2-1.56.4-.11.15-.54.34-.92.28-.49-.08-.78.2-.81.68-.05.66-.51 1.03-.96 1.36-.25.18-.51.31-.63.61-.19.46-.48.66-1.03.53-1.06-.27-1.91.42-2.73.88-.72.4-1.46.65-2.21.94Z"
			style={{
				fill: '#f5f0df',
			}}
		/>
		<path
			d="M190.49 163.52c.24 0 .48.01.71 0 .59-.03.85.19.62.79-.14.36-.15.74-.09 1.1.1.63.57.79 1.03.32.79-.81 1.63-1.35 2.84-.99.77.23 1.5-.16 2.25-.31.34-.07.67-.12 1-.05.24.05.47.22.48.46 0 .25-.25.48-.46.47-.54-.02-.7.29-.88.71-.27.63-1.03.44-1.4.43-.7-.03-.85.33-.96.77-.1.39-.21.61-.65.59-.73-.04-1.44-.27-2.19-.03-.54.17-.41-.49-.64-.74-.84-.9-2.94-1.4-4.11-.46-.49-.29-.71-.71-.62-1.28.96-.37 1.7-1.05 2.45-1.72.07-.06.15-.11.23-.15.14-.04.28-.03.38.1Z"
			style={{
				fill: '#f5f2ea',
			}}
		/>
		<path
			d="M212.74 166.79h.2c.28.46.97.1 1.23.61-.25.67-.85.35-1.24.35-1.01 0-2.03.3-2.91-.79-.57-.7-1.73-1.08-2.75-1.05-.67.02-.99-.36-1.37-.69-.34-.29-.53-.92-.28-1.18.32-.33.82-.76 1.44-.41.43.25.83.61 1.4.49.08-.06.17-.07.26-.02 1.11 1.01 2.2 2.05 3.74 2.4.14.03.2.17.28.28Z"
			style={{
				fill: '#f6f2e9',
			}}
		/>
		<path
			d="M196.2 163.52h-.2c-.31-.19-.66-.1-.99-.09-1.15.03-2.29.02-3.41-.24-.58-.13-1.07-.02-1.52.34-.87.67-1.59 1.56-2.73 1.81-.06.08-.12.15-.2.21-.51.19-.9.82-1.58.46-.1-.31.14-.45.3-.64.35-.34.82-.44 1.25-.64.81-.31 1.45-.88 2.08-1.44.77-.68 1.62-1 2.62-.82 2.03.37 4.05.13 6.07-.11.73-.19 1.47-.37 2.12-.79.23-.13.47-.23.74-.27.22-.02.43.01.59.18-.5.82-1.34 1.13-2.2 1.32-.36.08-.72.13-1.05.28-.64.11-1.34-.05-1.88.45Z"
			style={{
				fill: '#e5ddc4',
			}}
		/>
		<path
			d="M185.59 165.97c.66.1 1.01-.62 1.63-.61.07.66-.49.75-.89.99-.34.14-.73.15-1.05.36-.16.08-.33.19-.52.08h-.61c-3.6.98-7.22 1.52-10.91.54-.85-.23-1.59.08-2.37.27.02-.77.35-1.08 1.27-1.01 1.13.09 2.27.17 3.34.63 1.66.32 3.28-.07 4.92-.2 1.5-.18 2.94-.64 4.4-.98.26-.06.5-.2.77-.06Z"
			style={{
				fill: '#f0e9d7',
			}}
		/>
		<path
			d="M204.78 160.87c.22.56.45 1.11.64 1.68.13.38.04.72-.29.99-.34.27-.66.06-.95-.06-.27-.11-.42-.45-.76-.47-.33-.02-.28-.23-.21-.43.14-.41.23-.91.99-.53-.29-.69-1-1.18-.24-1.79.13-.16.3-.17.48-.14.09.03.16.08.22.14.11.19.26.37.11.61Z"
			style={{
				fill: '#f6f2e9',
			}}
		/>
		<path
			d="M186.2 166.18c.4-.2.82-.37 1.02-.82.07-.07.14-.07.2 0l.61 1.22c-.55.81-2.14 1.44-2.96 1.17-.54-.18-.47-.55-.31-.96l.41-.21c.29-.26.81.05 1.02-.41Z"
			style={{
				fill: '#f8efe7',
			}}
		/>
		<path
			d="M208.66 164.14h-.2l-.21-.2c-.66-.64-1.52-1.05-2.04-1.83-.25-.16-.46-.36-.61-.61-.29-.45-.7-.8-1.02-1.22-.25-.45-.85.2-1.07-.34.52-.81 1.09-.53 1.67-.08.13.14.22.3.32.46.17.25.39.46.61.67.09.09.18.18.27.28.16.2.33.4.54.55.11.09.2.18.29.28 1.4 1.59 3.35 2.37 5.05 3.53.37.41 1.16.27 1.31.97h-.82a9.401 9.401 0 0 1-4.08-2.45Z"
			style={{
				fill: '#e7e2c9',
			}}
		/>
		<path
			d="M203.55 160.05c.36 0 .79-.4 1.02.2h-.61c-.67.05-.74.73-1.09 1.1-.12.13-.16.3-.37.38-1.66.63-3.28 1.38-5.07 1.58-.06-.53.49-.14.61-.41 1.17-.3 2.34-.58 3.27-1.43.68-.57 1.27-1.31 2.24-1.43Z"
			style={{
				fill: '#f1ebd7',
			}}
		/>
		<path
			d="M190.08 163.52c.37-.53.84-.69 1.48-.5 1.11.34 2.25.31 3.39.3.35 0 .75-.14 1.05.19-1.39 0-2.79.12-4.18-.17-.42-.09-.94-.2-1.34.18h-.41Z"
			style={{
				fill: '#f0e9d7',
			}}
		/>
		<path
			d="M206.21 162.1c.68.61 1.53 1.03 2.04 1.83-.79-.49-1.7-.85-2.04-1.83Z"
			style={{
				fill: '#f1ebd7',
			}}
		/>
		<path
			d="M214.17 167.4c-.32-.38-1.08.11-1.23-.61l2.45.61c-.41.63-.82-.1-1.23 0Z"
			style={{
				fill: '#f5f0e1',
			}}
		/>
		<path
			d="m198.04 162.91-.61.41c-.41.07-.82.13-1.23.2.44-.73 1.18-.55 1.84-.61Z"
			style={{
				fill: '#f0e9d7',
			}}
		/>
		<path
			d="M204.58 160.26c.55.23.86.67 1.02 1.22l-.82-.61-.2-.61Z"
			style={{
				fill: '#f1ebd7',
			}}
		/>
		<path
			d="M215.6 167.4c.44.04.96-.16 1.23.41-.44-.04-.96.16-1.23-.41Z"
			style={{
				fill: '#f5f0e1',
			}}
		/>
		<path
			d="M205.6 161.48c.28.13.48.34.61.61-.39-.02-.59-.22-.61-.61Z"
			style={{
				fill: '#f1ebd7',
			}}
		/>
		<path
			d="m139.86 173.52 1.23-.82c.4.03 1-.31 1.12.3.13.66.59 1.49-.28 1.99-.71.4-1.03.88-1.13 1.73-.05.5-.32 1.36-1.34 1.06-.58-.17-.15-.82-.72-1.07-.77-.33-.06-.79.18-1.08.51-.63.59-1.44.94-2.13Z"
			style={{
				fill: '#f5f2ec',
			}}
		/>
		<path
			d="M139.66 173.31v.21c-2.07 1.84-4.69 2.43-7.22 3.27-1.05.35-2.11.61-3.19.81-1.14.29-2.26.72-3.47.41h-.21c-1.16.16-2.31.16-3.47 0-.89.03-1.8.23-2.65-.2-.34.17-.68-.01-1.02 0-.33-.1-.72.08-1.02-.2-.52-.11-1.04-.21-1.23-.82.37-.28.77-.02 1.16-.08 2.42.27 4.84.59 7.28.6 2.65 0 5.26-.41 7.79-1.22.64-.21 1.32-.3 1.94-.58 1.74-.5 3.37-1.24 4.87-2.26.16-.05.31-.05.44.07Z"
			style={{
				fill: '#f0e9d5',
			}}
		/>
		<path
			d="M115.77 178.41c-.99.25-1.75-.77-2.76-.49-.3.08-.21-.29-.22-.44-.04-.37.14-.67.55-.69.61-.03 1.21-.01 1.82-.01.14-.13.27-.11.41 0 .64.47.67 1.02.2 1.63Z"
			style={{
				fill: '#f6f2ec',
			}}
		/>
		<path
			d="M115.57 176.78h-.41c-.27-.33-.79-.22-1.02-.61-.45-.11-.87-.3-1.22-.62h-.2c-.46-.24-1.03-.38-1.02-1.06.58-.25.87.41 1.36.42 1.12.52 2.23 1.05 3.44 1.37.32.08.74.2.71.7l-1.02-.2h-.61Z"
			style={{
				fill: '#eee7d5',
			}}
		/>
		<path
			d="M125.78 178.01c1.2.25 2.29-.5 3.47-.41-.23.78-.91.3-1.36.46-.68.24-1.41.32-2.11-.05ZM122.1 178h3.47c-1.16.32-2.31.33-3.47 0ZM117.41 177.6c.34.05.73-.14 1.02.2-.4.22-.77.32-1.02-.2ZM118.43 177.8c.34-.29.68-.03 1.02 0-.34.49-.68.21-1.02 0Z"
			style={{
				fill: '#f5f3e8',
			}}
		/>
		<path
			d="M142.52 180.45c.35-.37.46-.01.61.2-.22 0-.47.04-.61-.2Z"
			style={{
				fill: '#f5f2ec',
			}}
		/>
		<path
			d="M111.69 174.54c.21.47.69.67 1.02 1.02-.16-.02-.38.02-.49-.07-.8-.64-1.58-1.31-2.37-1.97-.6-1.23-.89-2.49-.39-3.83.16-.43-.01-.65-.46-.65h-2.01c-1.42.37-2.34 1.42-3.27 2.45h-.41c-.13-.47.3-.69.48-1.02.07-.07.15-.13.23-.19.66-.52 1.3-1.05 1.82-1.71.89-1.13.93-1.15 2.28-.65.16.06.32.09.49.14.1.03.19.06.29.1 1.61.54 1.6.53 1.2 2.14-.19.76-.28 1.53.08 2.28.22.49.48.94.94 1.24.24.21.51.39.57.74Z"
			style={{
				fill: '#f5efe0',
			}}
		/>
		<path
			d="M112.91 175.56c.41.21.82.41 1.22.62-.54.05-.98-.09-1.22-.62Z"
			style={{
				fill: '#f0e9d5',
			}}
		/>
		<path
			d="M73.72 168.42c-.97-.54-2-.41-3.05-.32-1.88.16-3.72-.02-5.59-.46-1.32-.31-2.47-.89-3.68-1.43-.42-.19-.57-.43-.55-.84.09-.08.2-.11.32-.1 1.48.84 3 1.54 4.69 1.88 1.67.34 3.29.64 5.02.45 1.25-.13 2.59-.36 3.71.58.74.91 1.19 2.01 2.1 2.84 1.45 1.33 3.23 2.08 4.86 3.1.4.25 1.02.2 1.14.83h-1.22c-.31-.26-.76-.27-1.02-.61-.38-.51-.95-.77-1.5-.97-1.01-.37-1.69-1.18-2.58-1.68-.5.33-.77 0-.93-.38-.45-1.04-1.07-1.97-1.73-2.88Z"
			style={{
				fill: '#f4efdf',
			}}
		/>
		<path
			d="M70.25 168.42a4.6 4.6 0 0 1 2.65 0c.18.99-.37 1.81-1.34 1.98-.7.12-1.78-.54-2.02-1.06-.36-.83.49-.6.7-.92Z"
			style={{
				fill: '#f7f2ec',
			}}
		/>
		<path
			d="M80.45 174.33c.49-.05.81.2 1.02.61-.67-.1-.88.19-.61.79.32.71-.06 1.08-.63 1.33-.55.24-.57-.34-.78-.58-.51-.59.02-1.08.38-1.23.51-.21.48-.58.62-.92Z"
			style={{
				fill: '#f5efe2',
			}}
		/>
		<path
			d="M73.72 168.42c.93.63 1.32 1.66 1.83 2.57.21.37.3.74.82.69-.2.42-.42.37-.81.16-.58-.32-.91-.73-.93-1.38-.02-.78-.14-.87-.87-.73-.35.07-.39-.27-.31-.46.12-.28.31-.52.26-.85Z"
			style={{
				fill: '#f5f2e7',
			}}
		/>
		<path
			d="M82.7 174.94c-1.48-.78-3.02-1.48-4.44-2.36-1.63-1.01-2.92-2.39-3.73-4.16-.11-.13-.1-.27-.05-.42.09-.05.18-.07.28-.05.51.24.65.76.87 1.21.23.46.52.87.92 1.2 2.66 2.18 5.63 3.76 8.97 4.63 1.98.32 3.95.61 5.97.5.55-.03 1.08-.07 1.6-.25.78-.39 1.63-.37 2.47-.39.09-.02.18-.02.26-.02.36.11.41-.34.68-.38a1.019 1.019 0 0 1 .77-.04c.08.04.14.1.18.18 0 .31-.35.19-.47.36-2.93 1.17-5.95 1.42-9.08 1.08-1.79-.19-3.49-.64-5.21-1.08Z"
			style={{
				fill: '#e2ddc5',
			}}
		/>
		<path
			d="m102.5 171.68-.21.2c-.6.49-1.2.99-1.84 1.43-.72.21-1.28.72-1.94 1.04-.36.17-.69.44-1.12.19-.13-.45.28-.52.51-.72.08-.05.16-.1.24-.14 1.77-.7 3.13-2.03 4.68-3.07.34-.23.54-.68 1.03-.72.1.01.19.04.27.1.15.24-.04.34-.19.46-.38.52-.79 1.01-1.43 1.22Z"
			style={{
				fill: '#e2ddc5',
			}}
		/>
		<path
			d="M97.4 174.54c.75-.02 1.33-.46 1.94-.83.35-.22.69-.43 1.12-.4-1.07.72-2.1 1.54-3.47 1.63l.41-.41ZM100.46 173.31c.5-.62 1.11-1.1 1.84-1.43-.46.67-1.04 1.18-1.84 1.43ZM102.5 171.68c.48-.41.95-.82 1.43-1.22.02.47-.47.64-.61 1.02-.25.14-.52.24-.82.2Z"
			style={{
				fill: '#eee9d2',
			}}
		/>
		<path
			d="M213.56 166.58c-.42-.37-1.06-.35-1.43-.81.38-.32.75-.1 1.11.03.48.17.98.07 1.47.1.16 0 .32 0 .48.02 1.06.15 2.09.41 3.18-.08.9-.41 1.4-1.11 1.93-1.86 1.38-1.95 1.08-4.16.96-6.31-.05-.81.03-1.62 0-2.42v-.46c0-.25.01-.49 0-.74.03-.4-.13-.75-.28-1.1-.03-.09-.05-.19-.06-.29a.7.7 0 0 1 .2-.55c.73.82.55 1.9.81 2.86.27.52-.08 1.11.2 1.63.06 2.25.47 4.53-.41 6.73-.16.09-.2.24-.2.41-.23.23-.27.55-.41.82-.77 1.55-1.98 2.39-3.75 2.46-1.29.05-2.54-.18-3.8-.42Z"
			style={{
				fill: '#e0d9bb',
			}}
		/>
		<path
			d="M213.56 166.58c.95-.12 1.87.12 2.8.22 2.07.22 3.54-.74 4.75-2.26v.61c-1.49 2.4-3.81 2.22-6.14 1.91-.48-.06-.94-.32-1.41-.48ZM221.72 163.32c.67-2.21.34-4.48.41-6.73.44 1.23.11 2.51.2 3.76.07 1.04.08 2.08-.61 2.96ZM222.13 156.59c-.41-.5-.12-1.09-.2-1.63.41.5.12 1.09.2 1.63Z"
			style={{
				fill: '#e7e2c9',
			}}
		/>
		<path
			d="M221.12 152.1v.62c-.45-.08-.37-.33-.21-.61v-1.02c.34.28.16.67.21 1.01Z"
			style={{
				fill: '#e1d8b3',
			}}
		/>
		<path
			d="M221.11 164.54c-.02-.35.04-.66.41-.82-.03.32-.14.61-.41.82Z"
			style={{
				fill: '#e7e2c9',
			}}
		/>
		<path
			d="M60.86 166.79h.41c-.16.3.34.86-.38.93-.39.04-.61-.12-.68-.54-.12-.72.59 0 .65-.39ZM58.2 160.06c.54.04.6.4.62.84.04.78-.17 1.5-.41 2.22-1.36-.1-2.18-1.29-1.73-2.52.28-.77.94-.59 1.53-.54Z"
			style={{
				fill: '#f6f3eb',
			}}
		/>
		<path
			d="M55.14 157h.41c.88-.06 1.55.43 2.26.84.52.31 1.07.56 1.62.83.17.08.33.17.5.25 1.14.79 1.26 1.8.25 2.7-.47.42-.57.87-.41 1.44.02.09.03.19.04.29 0 .15-.05.29-.18.39-.71-.82-.77-1.73-.13-2.61.3-.41.74-.84.44-1.34-.31-.52-.87-.82-1.54-.75-.96-.84-2.26-1.08-3.27-1.83v-.2Z"
			style={{
				fill: '#efe8d4',
			}}
		/>
		<path
			d="M59.63 163.73v-.41c.08-.07.16-.08.25-.03.47.57.76 1.25 1.22 1.82.04.09.02.18-.04.25h-.21c-.8-.25-.99-.95-1.22-1.63Z"
			style={{
				fill: '#efe9d1',
			}}
		/>
		<path
			d="M54.53 156.39c.28.13.48.33.62.61-.39-.02-.59-.22-.62-.61Z"
			style={{
				fill: '#efe8d4',
			}}
		/>
		<path
			d="M149.87 178.72c.16-.65.75-.97 1.33-.99 1.62-.05 3.25.04 4.88.07.42 0 .87-.01.9.56.03.53-.3.79-.79.87-.96.16-1.88.31-2.9.15-.89-.14-1.85-.19-2.77-.11-.45.04-.65-.03-.65-.55Z"
			style={{
				fill: '#f5f2ec',
			}}
		/>
		<path
			d="m160.07 174.33 1.22-.41c-.3.46-.7.62-1.22.41Z"
			style={{
				fill: '#f5f3e8',
			}}
		/>
		<path
			d="M59.22 150.47c-.12-.23-.14-.47.05-.66.27-.26.49-.53.19-.86-.26-.29-.55-.56-1.02-.37-.29.11-.61.09-.89-.08-.29-.18-.84-.19-.72-.7.09-.4.21-.86.73-1.01 1.57-.45 3.12-.86 4.65.16.42.28 2.32-.15 2.93-.56.5-.19 1-.16 1.47.04.5.21.56.74.06.88-1.65.49-3 1.49-4.39 2.44-.2.14-.45.12-.69.04-.42-.34-.06-.52.16-.69.27-.2.59-.34.8-.6.17-.21.58-.4.3-.73-.21-.25-.56-.16-.85-.05-.89.34-1.18 1-.9 2.09-.5.6-.99 1.2-1.89.66Z"
			style={{
				fill: '#f3ecdd',
			}}
		/>
		<path
			d="M61.47 149.65c.83.17 1.38-.46 1.83-.89.87-.83 1.92-1.15 2.98-1.54.21-.08.55-.02.56-.31.01-.32-.35-.4-.59-.45-.36-.08-.73-.05-1.1-.07l-.2-.2h2.04c.13-.13.29-.14.46-.09.47.32.91.66.62 1.34-.66.43-1.44.56-2.15.87-1.72.76-3.42 1.56-5.12 2.35-.09.07-.18.14-.28.2-.32.22-.68.3-1.06.29-1.65-.03-3.31.18-4.93-.27-.44-.42-.53-.77.03-1.22.4-.32.43-.99.99-1.23-.03.44-.49.96-.04 1.31.45.35 1.06.32 1.61.03.61-.32 1.14-.26 1.53.36.14.22.32.33.58.34.8.16 1.32-.33 1.84-.81.14-.11.27-.13.41 0Z"
			style={{
				fill: '#eee9d6',
			}}
		/>
		<path
			d="M62.29 150.06c.18.34.43.56.84.62.49.08.95.25 1.34.61.63.58 1.4.12 2.11.19.05.08.05.17 0 .25-.21.18-.51.18-.73.33-.11.08-.23.15-.35.22-.5.29-.95.19-1.43-.11-.66-.42-1.35-.74-2.1-.99-.69-.23-1.08.12-1.54.47-.5.4-.12.78-.03 1.18.13.61.41 1.26-.18 1.8-1.29.66-2.65.32-3.99.32-.23-.06-.41-.19-.57-.38-.83-1.01-1.53-1.02-2.34-.05-.06.08-.15.14-.22.2-.28-1.08.1-2.14.07-3.22 0-.29.48-.6.77-.27.51.58.94.26 1.41.03 1.32-.45 2.68-.12 4.03-.19.54-.03 1.01-.09 1.28-.62.54-.14.96-.78 1.63-.41Z"
			style={{
				fill: '#e0dcc3',
			}}
		/>
		<path
			d="M55.96 154.75c1.1 0 2.2.02 3.29-.02.35-.01.72-.11.99-.39 1.52-.75 2.97-1.66 4.68-1.94.25-.04.43-.18.62-.31l.21-.2c.3-.2.65-.1.98-.16.89-.17 1.2.1 1.37 1.09-.21.46-.57.56-1.02.43a.471.471 0 0 1-.23-.21c-.15-.44-.35-.75-.87-.42-1.29.82-2.79 1.2-4.15 1.89-2.06 1.55-4.54.55-6.77 1.08-.15.04-.27-.12-.4-.21.86.7 1.79 1.3 2.83 1.72.42.17.84.34.72.93-.15.09-.29.09-.43-.02-.75-.34-1.5-.68-2.24-1.02-.43-.75-1.28-1.02-1.84-1.63-.31-.88-.2-1.07.66-1.09.58-.01 1.11.15 1.59.47Z"
			style={{
				fill: '#d8d2b2',
			}}
		/>
		<path
			d="M55.96 154.75c-.49-.07-.97-.12-1.46-.21-.69-.13-.96.13-.79.82-.2-.21-.41-.41-.61-.62.13-.75.52-1.12 1.34-1.19.96-.08 1.24.51 1.52 1.19Z"
			style={{
				fill: '#dcdab9',
			}}
		/>
		<path
			d="M60.65 150.47c-.1.69-.57.83-1.17.82-1.38-.01-2.76 0-4.14 0-.17-.33-.64-.08-.82-.41 1.58 0 3.15-.01 4.73 0 .52 0 .99-.06 1.4-.42Z"
			style={{
				fill: '#e9e4ce',
			}}
		/>
		<path
			d="M31.61 179.18c.23-.42 1.12-.27.89-1.1-.04-.16.26-.21.46-.28.6-.21 1.1-.59 1.29-1.24.2-.7.63-.98 1.35-.86.2.03.41.01.61.01 1.75.01 2.01-.2 2.44-1.81.18-.68-.39-.64-.72-.84-.04-.32.19-.34.41-.39.84.15 1.12.74 1.21 1.49-.06.48 0 .94.24 1.37.27.47.24.95-.19 1.28-1.17.9-.85 2.13-.8 3.3-1.23.77-2.54 1.37-3.86 1.96-1.15.52-2.32.88-3.6.72-.45-.45-.16-.58.28-.68 1.65-.38 1.7-.54 1.17-2.13-.13-.4-.31-.43-.62-.46-.23-.02-.58.1-.56-.34Z"
			style={{
				fill: '#e1d8b6',
			}}
		/>
		<path
			d="M31.61 179.18c.08.05.16.16.24.15.42-.05 1-.27 1.13.25.21.81.71 1.66.15 2.51-.22.32-.66.03-.94.2-.31.19-.85-.26-.99.36-.44.61-1.1.43-1.69.45-.53.02-1.04 0-1.57.2-.75.29-1.4-.15-2.05-.45l-.61-.61c.03-.54.06-1.08.1-1.62.03-.39.21-.9.59-.75.28.11.97-.11.93.73-.03.5.77.97 1.07.4.78-1.53 2.24-1.46 3.54-1.81.03 0 .07 0 .1-.01Z"
			style={{
				fill: '#ded9b4',
			}}
		/>
		<path
			d="M28.76 178.36c-1.06.27-2.15.21-3.23.2-1.57-.01-1.95-.68-1.15-2.02.12-.2.3-.37.29-.63h.2c.3.28.42.63.3 1.01-.28.86.23 1.02.88 1.01 1.08-.03 2.14-.21 3.18-.5.58-.17 1.18-.26 1.77-.39.52-.16.93-.53 1.45-.71.68-.23 1.14-.77 1.01-1.46-.12-.64-.53-1.24-1.31-1.37-.58-.09-1.12-.26-1.57-.66v-.2c.61-.48 1.08.19 1.63.2.18-.02.31.07.41.2.95.43 1.69 1.06 1.61 2.19-.07 1.04-.94 1.29-1.73 1.79-1.2.77-2.48.98-3.77 1.32Z"
			style={{
				fill: '#ebe6c6',
			}}
		/>
		<path
			d="M32.64 173.06c-.17 0-.32-.04-.41-.2-.18-.39-.29-.58.32-.86 1.51-.7 2.95.11 4.41-.04.39-.04.8.05 1.2.08.34.2.47.46.2.81-.17 0-.32.04-.41.2-.84.13-1.68.02-2.52 0-.92-.03-1.86-.25-2.78 0Z"
			style={{
				fill: '#dfdab5',
			}}
		/>
		<path
			d="m29.57 186.52-.41.2c-.45-.36-.9-.43-1.5-.32-.52.1-1.33-.05-1.47-.57-.16-.61.6-.77 1.1-.96.55-.2 1.1-.33 1.64.06.56.41 1.1-.19 1.66-.05.29.31.84-.21 1.06.32-.2.4-.62.39-.96.45-.55.09-.93.34-1.13.86Z"
			style={{
				fill: '#ded5ab',
			}}
		/>
		<path
			d="M31.61 185.29c-.24-.39-.78-.02-1.02-.4.64-.13 1.32-.11 1.84-.61.31-.24.72.05 1.02-.2.63-.47 1.48-.5 2.09-1.02.4-.32.85-.55 1.36-.66.45.04.83-.5 1.31-.16.15.42-.11.65-.43.8-1.84.87-3.71 1.69-5.67 2.27-.16.05-.33.06-.49-.02Z"
			style={{
				fill: '#ddd1ae',
			}}
		/>
		<path
			d="M36.92 182.64c-.47.09-.88.28-1.23.61-.77.13-1.4.77-2.25.61-1.45-.16-2.79.62-4.25.43-.41-.06-.78-.08-1.05-.43-.11-.67.3-.82.84-.81 1.25.03 2.47-.17 3.7-.37 1.06-.17 2.02-.56 2.93-1.01 1.16-.58 2.43-.94 3.5-1.72.3-.22.58-.04.75.27 0 .9-.67 1.32-1.32 1.62-.55.25-1.06.56-1.61.79Z"
			style={{
				fill: '#eee5c4',
			}}
		/>
		<path
			d="M39.78 180.4c-.2-.4-.4-.37-.79-.15-1.77.99-3.62 1.84-5.57 2.43-1.39.42-2.8.73-4.27.58-.51-.05-.85.12-1.01.62-.89-.03-1.54-.59-2.25-1.02 1.8.61 3.54-.2 5.31-.2 2.15.02 3.99-.91 5.83-1.84.56-.29 1.15-.54 1.72-.81.25-.62.7-.47 1.08-.21.23.16.44.46-.06.62Z"
			style={{
				fill: '#e4ddbb',
			}}
		/>
		<path
			d="M33.45 183.87c.78-.08 1.42-.71 2.25-.61-.68.47-1.4.8-2.24.82v-.2ZM33.45 184.07c-.29.34-.68.15-1.02.2.29-.34.68-.15 1.02-.2Z"
			style={{
				fill: '#e0d9b7',
			}}
		/>
		<path
			d="M41.62 173.26c.51.46 1 .93 1.63 1.23.19.16.45.2.61.41.11.27.32.41.61.41.15.27.38.47.56.72 1.34 1.92 1.3 3.68-.11 5.6-.35.48-.54 1.07-1.06 1.43l-.41.2c-.75.64-1.72.95-2.45 1.63-1.33.79-2.88.51-4.3.86-.49.12-.75-.24-.87-.65-.14-.48.22-.65.58-.78.19-.07.39-.08.59-.08.67.27.98.04 1.28-.64.47-1.08 1.05-2.09 2.56-2.07.58 0 1.19-.48 1.1-1.32-.05-.44.16-.86.2-1.3.05-.48.08-.96-.34-1.31-.05-.04-.09-.13-.14-.14-.57-.16.64-.78-.25-.9-.45-.06-.73-.47-.99-.83-.32-.71-.43-1.48-.78-2.18.12-.67.56-.77 1.12-.57.28.1.58.14.85.29Z"
			style={{
				fill: '#d1c899',
			}}
		/>
		<path
			d="M37.13 184.48c-.41-.01-.85-.03-1.12.34-.14.19.12.35.21.52.12.22.27.26.5.18 1.39-.5 2.91-.03 4.29-.63-.88.87-2.12.77-3.18 1.17-2.51.95-5.18.67-7.81.65-.15 0-.3-.13-.45-.19-.32-.54-.02-.85.45-.98.51-.14 1.06-.17 1.59-.24 1.97-.78 3.98-1.46 5.89-2.4.32-.16.63-.24.64-.66-.07-.2.04-.26.21-.27.2.03.37.12.47.32-.31.93-.86 1.68-1.7 2.2Z"
			style={{
				fill: '#d2c89f',
			}}
		/>
		<path
			d="M43.86 183.05c.33-.56.59-1.18.99-1.68 1.13-1.42 1.25-3.42.25-4.93-.24-.36-.58-.67-.64-1.14 2.49 2.04 2.19 4.08.66 6.44-.31.48-.46 1.26-1.27 1.31Z"
			style={{
				fill: '#d2caa5',
			}}
		/>
		<path
			d="M41 184.89c.1-.34.23-.55.63-.71.62-.25 1.17-.68 1.82-.92-.62.83-1.49 1.31-2.45 1.63Z"
			style={{
				fill: '#d2c89f',
			}}
		/>
		<path
			d="M43.86 174.9c-.29 0-.5-.14-.61-.41h.61v.41Z"
			style={{
				fill: '#d2caa5',
			}}
		/>
		<path
			d="M31.2 177.34c-1.67.14-3.25.83-4.94.87-.38 0-.74-.04-1.09-.13-.42-.12-.7-.47-.41-.83.38-.47.08-.89.11-1.33 1.27-.61 2-1.89 3.31-2.53.86-.42 1.62-.18 2.41-.33.59-.05 1.07.38 1.64.41.33.02.62.16.63.53.02.38-.23.61-.57.76-.22.1-.46.1-.7.1-.48 0-.94-.08-1.41-.18-.35-.07-.88-.16-.91.32-.03.4.49.34.82.35h.1c.61.05 1.25.06 1.58.71.32.64-.41.84-.58 1.28Z"
			style={{
				fill: '#eeeacf',
			}}
		/>
		<path
			d="M31.2 177.34s0-.07.01-.1c.66-1.29.38-1.69-1.16-1.63-.03 0-.07-.01-.1 0-.51.16-.83-.16-1.13-.47-.12-.13-.06-.36.08-.45.37-.23.78-.51 1.22-.3.54.26 1.11.15 1.66.26.4.08.78-.11.88-.52.14-.54-.4-.46-.66-.54-.48-.16-.98-.25-1.42-.52v-.2c.9.41 2.05.14 2.75 1.17.65.96.46 2.1-.65 2.49-.55.2-1.04.46-1.49.82Z"
			style={{
				fill: '#ede9ca',
			}}
		/>
		<path
			d="M41.62 173.26c-.34.02-.66-.06-.99-.15-.46-.13-.8.02-.85.56.1.34.1.65-.23.87-.16-.02-.27-.06-.17-.26-.08-.66-.3-1.23-1.02-1.43.03-.3-.06-.56-.2-.81 1.27.08 2.41.53 3.47 1.22Z"
			style={{
				fill: '#d6ceac',
			}}
		/>
		<path
			d="M109.85 110.09c.02-.26-.1-.69.13-.76 1.09-.34.49-.98.36-1.56a1.84 1.84 0 0 1-.04-.7c.05-.28.23-.52.51-.57.44-.08.31.31.4.54.06.15.18.27.28.4.94.81 1.8.94 2.86.06.68-.56 1.68-.71 2.24-1.49.89-.69 1.77-1.39 2.45-2.32.28-.39.62-.82 1.2-.78.03.07.06.1.06.13q-.21 2.02 1.59 2.92c.36.18.76.32 1.02-.02.27-.36.1-.78-.19-1.11-.09-.1-.19-.21-.32-.25-.92-.28-1.52-.96-2.16-1.67 1.17-.61 1.72-2.15 3.29-2.2.4.92 1.11 1.67 1.35 2.7.62-.77 1.58-1.02 2.11-1.79.03-.05.12-.09.18-.08 1.2.25 2.38-.13 3.57-.14.09 0 .15.12.17.22-.65.53-1.44.75-2.22.73-1.04-.02-1.65.37-1.94 1.34-.19.35-.56.47-.88.65-.39.23-.72.48-.78.98-.09.66-.54 1.09-1.11 1.35-.46.21-.91.43-1.34.7-.29.19-.63.29-.95.06-.67-.48-.87 0-.92.51-.11 1.01-.27 2.03-.16 3.03.09.83.58 1.5 1.46 1.76.23.07.53.09.62.3.33.82.96 1.24 1.77 1.47.14.04.13.21.04.34-.28.2-.59.18-.9.17-.31-.03-.6-.13-.85-.31-.25-.21-.44-.49-.77-.6-.96-.27-2.02-.32-2.67-1.24-.44-.63-.93-1.21-1.47-1.76-.37-.38-.53-.91-.46-1.5.04-.35.08-.74-.11-1.08-.34-.07-.41.2-.51.39-.27.52-.73.69-1.27.65-1.32-.1-2.64.02-3.95.05-.34-.03-.56.18-.79.38-.27.22-.56.4-.9.1Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M117.81 104.38a.72.72 0 0 0-.41.41c-.45.3-.8.62-1 1.2-.34.98-2.74 1.41-3.49.7-.21-.2-.35-.46-.27-.73.27-.83.58-1.7 1.36-2.16.91-.54 1.63-1.28 2.46-1.91.35-.4.83-.43 1.31-.43.58 0 1.21-.03 1.5.61.27.59-.39.78-.61 1.16-.06.12-.16.22-.23.33-.19.28-.43.53-.61.82Z"
			style={{
				fill: '#f5f0dd',
			}}
		/>
		<path
			d="M130.88 101.53c-1.12-.14-2.21.55-3.35.13-.23-.09-.55.12-.68.36-.3.52-.59 1.01-1.3.94-.32-.03-.15.22-.17.33-.04.23-.02.53-.31.54-.15 0-.41-.22-.43-.36-.12-1.02-1.19-1.66-1.1-2.76.31-.58.32-1.18-.06-1.71s-.2-.85.26-1.14c.57-.28 1.19-.12 1.78-.15.77-.04 1.19-.24 1.08-1.07.27.21.53.42.8.62.31.21.11.51.12.75.02.36-.34.28-.54.26-.9-.09-1.78.35-2.7.06-.32-.1-.6.17-.43.57.3.68.63 1.3 1.33 1.73 2.5 1.54 4.85.94 7.12-.47.41-.26.81-.53 1.27-.56 1.55-.08 3.12-.47 4.66.1-.98.43-2.04.42-3.07.51-1.2.11-2.36.18-3.29 1.09-.24.24-.58.52-.99.24Z"
			style={{
				fill: '#e8e2c2',
			}}
		/>
		<path
			d="M116.59 102.14c-.86.55-1.51 1.35-2.42 1.88-.69.4-1.17 1.22-1.32 2.06-.1.54 1.11 1 1.82.65.72-.35 1.79-.27 1.87-1.5.02-.27.51-.4.86-.43-.18.47-.81.64-.81 1.22-.01.28-.1.6-.32.71-1.06.54-2 1.33-3.18 1.64-.81.21-1.32-.19-1.61-.92v-1.43c0-.9.47-1.47 1.24-1.88.48-.26.9-.62 1.25-1.03.59-.7 1.33-1.01 2.2-1.14.16 0 .3.06.42.18Z"
			style={{
				fill: '#f4f0d8',
			}}
		/>
		<path
			d="M116.18 101.53c-.17 0-.34.02-.51 0-.22-.03-.53.11-.61-.2-.07-.27.19-.42.36-.56.98-.75 2.06-1.34 3.16-1.9.93-.48 1.8-1.07 2.7-1.62.16-.04.32-.08.48-.13.25-.09.47-.06.62.16.18.27-.04.44-.2.59-.43.41-.87.81-1.31 1.21-.32.89-1.19 1.15-1.89 1.53-.85.47-1.87.61-2.81.91Z"
			style={{
				fill: '#e7e1c4',
			}}
		/>
		<path
			d="M116.59 102.14h-.41c.08-.58.48-1 .97-.97 1.81.1 2.84-1.22 4.13-2.08.27-.03.55-.02.8-.11.44-.15.88-.14 1.06.29.17.44-.13.91-.49 1.13-1.51.93-2.77 2.19-4.23 3.18 0-.25.19-.42.28-.62.12-.28.63-.4.38-.82-.24-.4-.65-.43-1.06-.39-.5.05-1.1-.23-1.44.4Z"
			style={{
				fill: '#f4edd7',
			}}
		/>
		<path
			d="M121.29 99.08c-.03.48-.39.67-.74.89-.45.29-.93.52-1.26.98-.38.54-.99.39-1.51.36-.73-.05-1.26.19-1.6.83-.71.03-1.28.32-1.78.84-.47.48-.98.94-1.55 1.3-.68.43-1.16.96-1.36 1.73.05-.57-.19-1.2.41-1.63.23-.13.49-.23.69-.4 1.14-.91 2.16-1.98 3.59-2.46.43-.31.82-.64 1.39-.71 1.32-.15 2.27-1.03 3.3-1.74h.41Z"
			style={{
				fill: '#eee7d0',
			}}
		/>
		<path
			d="M126.59 96.63c0 .25.14.43.3.61.4.45.09.61-.3.6-.95-.02-1.9.33-2.85.01.78-.49 1.33-1.16 1.63-2.04.47.18.64.81 1.22.82Z"
			style={{
				fill: '#efe9c8',
			}}
		/>
		<path
			d="M117.81 104.38c.02-.41.28-.64.61-.82-.02.41-.28.64-.61.82Z"
			style={{
				fill: '#f4edd7',
			}}
		/>
		<path
			d="M124.75 94.19c.33.26.42.62.41 1.02-.32-.26-.42-.62-.41-1.02Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M109.85 110.09c.46.05.76-.18 1-.55.18-.29.39-.35.64-.06.31 1.3 1.38 1.75 2.42 2.33 1.05.59.99.85-.07 1.5-.91.07-1.72-.32-2.57-.52-.84-.58-1.5-1.3-1.81-2.3l.2-.41h.2Z"
			style={{
				fill: '#eae1c3',
			}}
		/>
		<path
			d="M107.61 114.37c-.28-.13-.48-.34-.61-.61v-.2c.35-.26.67-.07.93.13.78.59 1.66 1.05 2.26 1.86.16.22.34.46.61.52 1.09.23 1.74 1.03 2.33 1.84.43.59.88.87 1.61.73.32-.07.68-.05.98.14.11.68-.51.64-.86.84-.26.15-.65.21-.58.58.32 1.68-.79 2.49-1.93 3.29-1.28.6-1.75.4-2.01-.93-.31-1.62-.56-3.25-.1-4.89.07-.26.04-.53-.18-.64-1.17-.56-1.52-1.86-2.45-2.64Z"
			style={{
				fill: '#e5e0c5',
			}}
		/>
		<path
			d="M115.77 118.86c-.54.03-1.08-.08-1.61.09-.43.14-.67-.12-.91-.43-.72-.92-1.35-1.83-2.64-2.26-.83-.28-1.34-1.42-2.22-1.94-.46-.27-.82-.7-1.4-.76-.39-.25-.92-.2-1.23-.61.21-.23.48-.22.75-.18 2.99.83 5.47 2.44 7.33 4.94.48.64 1.15.44 1.77.48.33.01.68 0 .96.21.07.1.1.21.08.33-.25.4-.55.38-.9.13Z"
			style={{
				fill: '#e4ddbb',
			}}
		/>
		<path
			d="M106.59 112.95h-.82c-.52.06-.98-.17-1.61-.31.65-.86 1.56-1.05 2.42-1.33.03.04.07.07.1.11.12.26.09.51-.06.75s-.17.65-.04.77ZM108.02 110.7h.2c.12-.09.2-.06.25.07-.54.79-.94.9-1.88.54.45-.28.92-.5 1.43-.62Z"
			style={{
				fill: '#dcd9b7',
			}}
		/>
		<path
			d="M108.43 110.7h-.21c.36-.37.82-.14 1.23-.2.66.63 1.02 1.55 1.84 2.04 1.52.72 3.1 1.2 4.79 1.34 1.2.1 2.42.08 3.58.45-.05.71-.58.63-1.04.6-.91-.04-1.82-.21-2.73-.28-1.45.05-2.78-.49-4.1-.95-.92-.31-1.74-.87-2.09-1.9-.2-.6-.84-.74-1.27-1.1Z"
			style={{
				fill: '#e3dab7',
			}}
		/>
		<path
			d="M107.61 114.37c.44 0 .76.31.88.61.34.87 1.08 1.32 1.76 1.82.4.3.57.6.23 1.01-.2.24-.23.49-.21.76.09 1.47 0 2.96.41 4.41.32 1.13 1.04.45 1.63.37-.24.43-.05.9-.12 1.35-1.53.65-2.99 1.46-4.52 2.11-.61.26-1.13.76-1.83.82-.15 0-.3-.03-.43-.11-.23-.59.16-1.14.52-1.27.99-.36 1.72-1.58 3.04-.93q-.49-1.61-1.99-.95c-.16.07-.31.13-.49.08-.04-.03-.08-.06-.11-.09.22-.71.78-1.03 1.44-1.09.48-.05.82-.29.93-.65.32-1.03.67-2.08.39-3.2-.06-.22-.13-.47-.1-.69.18-1.54-.31-2.85-1.32-3.99-.08-.09-.08-.25-.12-.38Z"
			style={{
				fill: '#e7e2ca',
			}}
		/>
		<path
			d="M102.09 126.2c1.43-.61 2.86-1.22 4.29-1.84.07.18.01.33-.09.47-.69.96-2.96 1.69-4.2 1.36Z"
			style={{
				fill: '#e7e2ca',
			}}
		/>
		<path
			d="M101.07 126.41c-.27.32-.62.42-1.02.41l.21-.41h.82Z"
			style={{
				fill: '#ecead4',
			}}
		/>
		<path
			d="M180.9 128.65c-.73-.05-1.3-.34-1.63-1.02 1.08-.22.52-1.05.61-1.63.26.05.43.53.77.14s-.05-.64-.25-.71c-.64-.22-.32-1.25-1.13-1.27.35-1.46-.59-2.58-1-3.85-.05-.16-.18-.35-.14-.46.35-.81.23-1.53-.3-2.22.76.23 1.29-.2 1.84-.61.16.03.46.09.46.1-.19 1.2.85.89 1.5 1.1-.34.47-.69.48-1.08.25-.89-.51-1.39-.19-1.59.76-.04.19-.18.37-.2.56-.08.58-.35 1.28.73 1.19.2-.02.32.35.59.32 1.52.42 3.17.47 4.44 1.6.3.26.67.23 1.05.11.35-.12.72-.19 1.04.13-.31 1.31.76 2.25.94 3.45.07.48.06.95-.03 1.38-.09.45-.33 1.03-1.05.73-.03-.01-.08-.03-.1-.02-.95.74-1.88-.05-2.82-.03.19-.78.9-1.02 1.45-1.42.33-.23.63-.51.99-.7.29-.15.56-.34.3-.7-.26-.37-.61-.31-.85 0-.86 1.07-2.28 1.12-3.31 1.86-.21.15-.52.15-.81.17.29.2.61.08.9.15.35.08.78.08.72.63h-2.04Z"
			style={{
				fill: '#e9e3cf',
			}}
		/>
		<path
			d="M180.08 120.9c-.86-1.25-.85-1.22.53-1.83.43-.19.95-.06 1.31-.42.35-.15.7-.17 1.04.02-.38.85.01 1.75-.17 2.62-.04.18.08.4-.15.53-.99.08-1.88-.13-2.56-.92Z"
			style={{
				fill: '#f4edda',
			}}
		/>
		<path
			d="M180.08 120.9c.88.27 1.62 1.02 2.65.82.61-.3 1.09.06 1.6.29 1.45.65 3.46.07 4.21-1.22.04-.03.07-.06.11-.09.32.27.15.73.41 1.02-.8.5-1.2 1.69-2.45 1.43-1.37.45-2.51.02-3.6-.85-.35-.28-.86-.42-1.35-.37-.65.07-1.19-.09-1.59-.62v-.41Z"
			style={{
				fill: '#eee9d5',
			}}
		/>
		<path
			d="M182.94 118.86c-.29-.34-.68-.15-1.02-.2 1.59-.34 3.14-.37 4.55.58.41.28.88.32 1.32.42.59.13.88.44.86 1.04-.96.11-1.86.05-2.6-.7-.61-.63-1.35-.98-2.28-.85-.29.04-.61-.03-.83-.29Z"
			style={{
				fill: '#eee9d5',
			}}
		/>
		<path
			d="m195.39 126 .61.41c.22.21.33.51.54.71.25.24.54.56.89.1.78-.03 1.18.53 1.63 1.02.04.17.17.3.22.46.09.31.52.67-.07.92-.52.22-1.18-.05-1.29-.53-.07-.28.05-.66-.44-.63-.52.03-1.37-.28-1.5.23-.28 1.13-1.29.92-1.92 1.36-1.45.06-2.91.01-4.34.28-.34.06-.66.15-.95.33-.29.17-.59.27-.93.25-.6-.11-1.22-.19-1.73-.55-.29-.21-.63-.43-.52-.89 1.49 1.22 2.98.38 4.45-.04.65-.19.81-.95 1.22-1.42 1.12-1.29 2.27-2.32 4.13-2.01Z"
			style={{
				fill: '#e2debc',
			}}
		/>
		<path
			d="M182.94 128.65c-.22-.48-.66-.42-1.06-.4-.45.02-.85-.11-1.28-.42 1.16.04 1.99-.75 3-1.08.64-.21 1.25-.5 1.66-1.11.18-.27.45-.59.84-.37.32.18.68.42.68.83 0 .37-.34.46-.63.65-.9.58-1.83 1.14-2.6 1.91h-.61Z"
			style={{
				fill: '#f2edd9',
			}}
		/>
		<path
			d="M191.64 125.68c-.02.91-.77 1.13-1.42 1.23-.68.1-.91-.57-.91-1.09 0-.73.47-1.27 1.14-1.52.38-.14 1.16.82 1.19 1.38Z"
			style={{
				fill: '#e8e2d1',
			}}
		/>
		<path
			d="M185.59 129.47c.47.91 1.39 1.01 2.25 1.22.07.11.05.2-.04.28-.8.37-1.44.03-2.04-.47-.4-.42-.83-.78-1.53-.59.11.55.46.91.81 1.27.25.26.59.49.4.94-.08.06-.17.06-.25 0-.14-.24-.44-.03-.52-.12-.25-.26-1.54.52-.78-.81.19-.33-.57-.78-.66-1.43-.13-.86.08-.75.66-.56.22.07.46.05.7.07.32.19.66.22 1.02.21Z"
			style={{
				fill: '#ddd8bb',
			}}
		/>
		<path
			d="M194.17 129.87c.32-.21.53-.65 1.01-.51.36.1.45-.12.4-.37-.18-.92.62-.76 1.03-.85.35-.08.76.17 1.18.05.26-.07.38.19.35.37-.2 1.14.6.81 1.16.9.07-.48-.66-.72-.23-1.21 1.13.6 2.02 1.39 2.3 2.72.28 1.33 1.21 2.08 2.4 2.58h-.41c-.22.24-.49.21-.76.13-.43-.13-.81-.05-1.13.26-.27.26-.59.25-.94.29-1.09.13-1.84-.12-2.51-1.17-.72-1.13-1.84-1.98-3.1-2.56-.3-.14-.64-.25-.75-.63ZM197.43 127.22c.09.2.64.54-.07.53-.81-.01-1.33-.46-1.36-1.34l.82.2.61.61Z"
			style={{
				fill: '#e4ddbc',
			}}
		/>
		<path
			d="M146.39 98.26c-.49 1.13-1.81 1.67-3.3 1.38-.33-.06-.66-.11-.98-.16-.89-.22-1.81-.17-2.7-.33-.33-.06-.71-.12-.8-.52-.1-.42.15-.73.49-.92 1.21-.68 2.34-1.47 3.43-2.31l.82-1.63c.42-2.04-.45-3.63-1.8-5.05-.33-.35-.85-.65-.45-1.27.35.04.74-.13 1.03.2-.05.13-.38.18-.1.4 1.7 1.49 2.46 3.33 2.15 5.59-.05.38-.23.7-.45 1.01-.16.22-.41.46-.33.72.32 1.02-.4 1.19-1.08 1.41-.49.44-.97.9-1.52 1.28-.47.32-.06.38.17.48.33.11.67.09 1.01.09.31 0 .62.01.92.11.57.34 1.07.36 1.67-.07.5-.35 1.18-.45 1.84-.38Z"
			style={{
				fill: '#cdc28f',
			}}
		/>
		<path
			d="M142.52 95.41c-.64 1.26-2 1.64-3.05 2.39-.31.22-.75.35-.68.75.08.46.57.52.98.53.8.02 1.6.05 2.34.42-1.1.1-2.18-.13-3.26-.2h-.2c-.07-.07-.14-.14-.21-.2-.37-.82.02-1.64.99-2.18.85-.47 1.87-.67 2.47-1.54.08-.18.21-.39-.06-.51-.33-.16-.47.15-.67.31-.27.19-.49.52-.89.25.26-.41.3-.98.97-1.11-.56-.28-.99-1.45-.74-1.89.43-.76 1.04-.57 1.64-.24 1.14.63 1.24.98.6 2.17-.18.34-.26.69-.23 1.07Z"
			style={{
				fill: '#d9caa2',
			}}
		/>
		<path
			d="M140.27 95.41c.35.03.53-.3.82-.41.3-.19.61-.47.98-.22.21.14.17.41.04.62-.49 1.08-1.64 1.18-2.52 1.66-.86.46-1.32 1.3-.95 2.01-1.01-.11-1.16-.3-.74-1.06.31-.55.27-1.05-.08-1.52-.59-.79-.93-1.62-.7-2.64.08-.36-.11-.73-.2-1.09-.11-.42-.27-.86.1-1.24.75.9.68 2.07 1.01 3.1.04.12-.03.3.03.4.24.43-.07 1.15.5 1.33.66.22 1.12-.3 1.53-.76l.2-.2Z"
			style={{
				fill: '#e2d6ad',
			}}
		/>
		<path
			d="M141.7 88.07c-.09-.08-.26-.21-.25-.25.14-.31.44-.09.66-.17 1.03.23 1.88.86 2.85 1.23.61.57 1.09 1.33 2.04 1.43.22.6.63 1 1.22 1.23.08.96.07 1.93.08 2.89.01 1.36-.59 2.21-1.49 3.01-.43-.56-.06-.93.3-1.31.55-.59.87-3.16.52-3.83-.24-.45-.73-.47-1.09-.69-1.18-.72-1.92-1.96-3.17-2.63-.55-.3-1.06-.7-1.66-.92Z"
			style={{
				fill: '#c7be8b',
			}}
		/>
		<path
			d="M141.09 87.46c-.05.46.26.7.54 1.01 1.4 1.49 2.39 3.14 1.7 5.31-.07-.8 0-1.65-.26-2.39-.18-.53-.57-1.13-1.13-1.43-.72-.38-.89-1.12-1.22-1.74-.14-.26-.15-.7.36-.76Z"
			style={{
				fill: '#d7cc97',
			}}
		/>
		<path
			d="M137 91.53c-.05 1.17.69 2.25.28 3.48-.15.45.48.85.76 1.27.59.87.51 1.6-.27 2.3.27.22.49.49.87.5v.2c-1.13.03-2.13-.66-3.28-.57-1.18.1-2.43-.24-3.49.53-.38.27-.62-.07-.93-.11-.5-.07-.96-.33-1.48-.26-.03-.41.33-.46.54-.41 1.23.33 2.27-.41 3.43-.5-1.47-.16-2.97.15-4.42-.3-.35.52.4.76.25 1.2-.21.43-.59.64-1.01.78-.29.1-.53.16-.78-.18-.27-.38-.03-.64.17-.77.64-.44.6-.95.26-1.51-.25-.41-.1-.69.31-.71.87-.04.98-.62 1.05-1.27-.27-.52.14-.69.46-.91.57-.4 1.2-.72 1.58-1.33.34-.2.61-.47.82-.82.79-.4 1.34-1.21 2.31-1.3.32-.03.16-.32.15-.48-.04-.62-.47-1.1-.63-1.69.3-1.01 1.15-1.25 2.04-1.43.43 1.41.82 2.82 1.02 4.28Z"
			style={{
				fill: '#e3dab4',
			}}
		/>
		<path
			d="M126.39 94.8v-.2c.3-.03.56.06.82.2-.27.37-.54-.08-.82 0Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M133.94 88.68c.8.66.97 1.55.88 2.63-.76-.71-1.14.13-1.63.4-.36.19-.65.46-1.09.44.02-.52.46-.68.81-.94 1.1-.82 1.26-1.53.62-2.53h.41ZM131.29 92.96c-.11.86-.89 1.11-1.47 1.5-.31.21-.54.37-.57.74-.04-.27-1 .08-.41-.61.29-.18.53-.42.82-.61l1.63-1.02Z"
			style={{
				fill: '#e2ddb9',
			}}
		/>
		<path
			d="M132.1 92.15c-.06.49-.33.76-.82.82.2-.35.47-.62.82-.82Z"
			style={{
				fill: '#e2ddb9',
			}}
		/>
		<path
			d="M129.66 93.98c-.18.33-.4.6-.82.61.18-.33.4-.6.82-.61Z"
			style={{
				fill: '#e3ddbb',
			}}
		/>
		<path
			d="M141.7 88.07c.73 0 1.26.37 1.89.76 1.25.79 2.02 2.28 3.34 2.7 1.4.45 1.08 1.3 1.07 2.15 0 .4.05.8.05 1.2-.01.57-.12 1.08-.67 1.38-.49.26-.61.69-.56 1.2l-.21.6-.21.21c-.71.49-1.65.37-2.35.97-.26.22-.87.17-1.12-.35.18-.27.57-.17.76-.42-.17-.92-1.04-1.23-1.58-1.82.1-.19.21-.4.44-.35.76.17.92-.02.49-.7-.2-.32.07-.58.24-.82.98-1.42.86-3.46-.16-4.92-.44-.63-.75-1.35-1.42-1.78Z"
			style={{
				fill: '#cbbe87',
			}}
		/>
		<path
			d="M130.88 101.53c.47-.05.82-.35 1.12-.64.54-.53 1.11-.8 1.87-.82 1.46-.04 2.89-.46 4.36-.38h.2c.54.46.59 1.13.51 1.7-.06.42.06.77.1 1.15.47.56-.15 1.07-.08 1.64.32 2.85.24 5.71.04 8.57-.07.94.32 1.3 1.3 1.32.33 0 .67-.1.99.09.84 0 1.67 0 2.51.02.25 0 .51.12.46.41-.04.24-.32.17-.51.19-.05-.01-.1-.03-.15-.04-1.43-.11-2.87.16-4.29-.12-.43-.07-.85-.15-1.16-.5-.27-.65-.54-1.3-.46-2.03.42-.79.42-1.63.26-2.47-.06-.33-.1-.68-.6-.79-.4-.09-.57-.49-.35-.9.73-1.37.95-2.83.84-4.36.21-.77.72-1.48.33-2.34-.26-.57-.55-.77-1.04-.24-.29.32-.65.49-1.07.52-2.49.18-4.68 1.25-6.84 2.37-.06.03-.12.09-.18.09-1.53 0-1.93 1.09-2.25 2.27-.1.36-.34.66-.61.92-.51.3-.64.8-.77 1.35-.36 1.41-.75 1.66-2.03 1.32.23.64.06 1.22-.08 1.81-.23.95.8 2.36 1.72 2.15.83-.18 1.36.11 1.96.48 1.07.32 2.15-.02 3.22.04.85.04 1.68.16 2.52.24.1.02.19.05.28.09.38.45 1.2.25 1.39.95-.28.26-.65.29-.95.17-1.18-.44-2.39-.24-3.59-.2-1.14.04-2.18-.46-3.29-.51-.67-.09-1.39.2-1.99-.29-.81-.33-1.89-.34-1.97-1.6 0-.09-.32-.16-.48-.24-.46-1.32-.94-2.63.06-3.92.09-.11.06-.25.05-.39-.06-.9.42-1.58 1.35-1.83.86-.23 1.54-.54 1.69-1.57.1-.72.97-.89 1.34-1.46.25-1.45.44-1.64 1.84-1.63.88 0 1.63-.43 2.44-.62Z"
			style={{
				fill: '#e9e3cc',
			}}
		/>
		<path
			d="M141.9 116.01c.5 0 .99-.11 1.48-.18.78-.11 1.66-.44 2.32.47.22.3.82 1.03 1.1-.09.59.15.41.57.35.95-.78.98-.82.99-1.48.08-.43-.59-.96-.23-1.46-.17-1.22.19-2.42-.23-3.64-.16-.61.03-1.22 0-1.81.14-1.45.75-2.41 1.79-2.17 3.58.02.17-.05.33-.16.47-.58.11-.73-.37-.92-.71-.26-.47-.57-.89-.98-1.24-.34-.75-.83-1.01-1.73-1.07-2.71-.18-5.4.11-8.1.23-.92.04-1.82-.09-2.71-.34.04-.5.04-.51.55-.57.76-.09 1.53-.11 2.41-.25-.73-.64-1.79-.98-1.48-2.18.09-.07.18-.09.29-.09 1.68.22 3.35.39 5.01.74 2.32.5 4.7.66 7.09.41.1 0 .21 0 .31.02.82.31 1.63.22 2.45-.02.2-.05.39-.06.59-.05.84.03 1.68-.1 2.52-.01.05 0 .1.02.15.03Z"
			style={{
				fill: '#dedabc',
			}}
		/>
		<path
			d="M147.01 117.23c-.05-.34.14-.73-.2-1.02v-.2c.05-.05.09-.11.09-.17q.12-1.48 1.58-1.87c.39-.26.73-.57 1.05-.91.69-.76 1.13-.67 1.56.3.82.77 1.63.57 2.45 0 .36-.24.67-.07.98.12.04.6-.69 1.45-1.16 1.24-.5-.22-.82.08-1.22.12-.37.06-.55-.49-.97-.31-.08.04-.16.07-.25.11-.88.8-1.13 1.81-.99 2.95.09.71 1.19 1.52 1.87 1.37.43-.1.63-.37.57-.82-.05-.34-.12-.67-.1-1.01.47-1.39 1.76-1.68 2.94-.65-.66.47-.78 1.44-1.78 1.7-.67.17-.62 1.8-.04 2.47.07.12.12.25.08.39-.12.46-2.28 2.08-2.74 2.01-.51-.08-1.02-.48-.93-.91.2-.96-.38-1.43-.88-2.01-.29-.33-.5-.72-.88-.97-.22-.09-.45-.19-.6-.39-.27-.48-.5-.96-.45-1.54Z"
			style={{
				fill: '#e4ddbb',
			}}
		/>
		<path
			d="M141.29 114.17c-.48 0-.95.02-1.43 0-.9-.04-1.3-.59-1.19-1.49.31-2.46.31-4.94.08-7.4-.09-.95-.09-1.85.29-2.73.33.2.63.4.58.86-.26 2.5.06 5 .05 7.51 0 .69-.22 1.33-.23 2.01 0 .75.21 1.22 1.09 1.06.25-.05.55-.07.75.19Z"
			style={{
				fill: '#e4dec7',
			}}
		/>
		<path
			d="M146.8 114.58s-.06-.03-.09-.04c-2.01-.32-2.04-.37-.65-2.05.74-.89 1.15-1.84.94-3.01.19-.18.26-.58.67-.4.06.08.09.17.11.26-.13 1.47-.37 2.91-1.46 4.18.61-.18 1.06-.15 1.46.14.11.77-.75.5-.98.91Z"
			style={{
				fill: '#ddd6bb',
			}}
		/>
		<path
			d="M147.62 109.28v-.21a1.63 1.63 0 0 1-.2-1.07c.29-1.79-.06-3.52-.41-5.26v-.41c.07-.41-.17-.87.2-1.22 0 .17.04.32.2.41.85 2.26 1.02 4.6.85 6.98-.03.35-.14.76-.64.77Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M147.01 102.75c.84 1.38.58 2.91.61 4.4.01.64 0 1.28 0 1.92l-.61.41c.12-1.45.64-2.86.13-4.36-.24-.71-.27-1.57-.13-2.36Z"
			style={{
				fill: '#e3ddbb',
			}}
		/>
		<path
			d="M146.8 114.58c-.05-.76.84-.34 1.02-.81.16-.17.35-.18.56-.11.2.11.26.3.26.51-1.14.08-1.68.77-1.84 1.83.1-.48-.2-.95 0-1.43Z"
			style={{
				fill: '#e1daba',
			}}
		/>
		<path
			d="M143.74 114.78c-.36.79-1.16.91-1.84 1.22-.79.22-1.61.03-2.41.11a.41.41 0 0 1-.28-.18c0-.13.04-.22.15-.28.38-.18.79-.15 1.19-.13.8.03 1.53-.14 2.18-.62.3-.22.62-.43 1-.13Z"
			style={{
				fill: '#e9e3cc',
			}}
		/>
		<path
			d="M148.44 113.76h-.61c-.54.02-1.12-.46-1.69.16.7-1.52 1.31-3.02 1.49-4.65.78-1.21.34-2.52.33-3.8 0-1.34-.59-2.6-.53-3.95.91-.06 1.72.44 2.33.91.87.66 1.74 1.35 2.59 2.05.44.36.73.76.79 1.32 0 .05 0 .1.01.15-.4.99-.79 1.98-.89 3.06-.6.93-1.43 1.69-1.99 2.65-.35.5-.43 1.15-.89 1.57-.27.25-.51.55-.94.52Z"
			style={{
				fill: '#d1ccaa',
			}}
		/>
		<path
			d="m154.56 113.56-1.02-.2.2-.41c.43-.49 1.07-.45 1.63-.59.32-.08.66-.06.82-.43 1.89-.52 3.78-.97 5.74-.34.79.25.99.63.56 1.34-.3.49-.7.91-1.14 1.28-1.01.55-1.68 1.62-2.87 1.92-.1 0-.19-.03-.28-.08-.2-.76-.66-1.33-1.3-1.76-.28-.19-.57-.35-.82-.58-.42-.43-.9-.34-1.4-.16h-.14Z"
			style={{
				fill: '#e5dcb5',
			}}
		/>
		<path
			d="M150.07 111.52c.61-.88 1.18-1.78 2.04-2.45.07-.07.15-.11.25-.13.97.25 1.83.12 2.59-.74-.87-.38-1.78.41-2.53-.24.04-.79.56-1.41.7-2.16.5.04.99-.51 1.55.09.18.2.42.13.43.59.03.78.78 1.19 1.33 1.66.3.26.43.49.29.86-.14.38-.41.51-.79.46-1.72-.23-2.89.75-4.02 1.83l-.42.42c-.04 0-.09.02-.13.02-.36.05-.59.38-.95.44-.4-.08-.21-.46-.34-.67Z"
			style={{
				fill: '#e1daba',
			}}
		/>
		<path
			d="m150.07 111.52.4.61c.35-.12.56-.57 1.02-.41.13.61-.33 1.07-.41 1.63-.48-.61-.92-.99-1.47 0-.19.35-.65.55-.98.82-.16-.09-.2-.24-.2-.41.89-.49 1.2-1.42 1.64-2.24Z"
			style={{
				fill: '#e5dcb5',
			}}
		/>
		<path
			d="M129.25 98.88c-.2-.26-.59-.36-.66-.74-.06-.29-.09-.63.1-.84.16-.16.43.02.65.12 1.1.49 2.28.09 3.41.24.49.07 1.32-.34 1.39.32.05.49-.84.09-1.22.32-1.09.67-2.33.25-3.46.57h-.2Z"
			style={{
				fill: '#ded5b0',
			}}
		/>
		<path
			d="M158.85 117.43c.9.18 1.79-.09 2.68-.16.86-.06 1.02.24 1 .94-.02.74-.09 1.49.02 2.22.16 1.1-.37 1.48-1.33 1.46-.65-.01-1.29.26-1.96.03-.51-.18-.39.41-.61.6-.75.21-1.15-.31-1.58-.76-.46-.53-.58-1.11.04-1.55.31-.22.11-.35.11-.54-.01-.69-.31-1.38-.07-2.08.51-.64 1.1-.56 1.71-.17Z"
			style={{
				fill: '#cfbf8f',
			}}
		/>
		<path
			d="M157.42 128.04c-.92-.4-1.63-1.2-2.65-1.44-.02-.63.2-.79.86-.65 2.43.52 4.86 1.13 7.33 1.39 2.12.22 4.3.37 6.43-.19.29-.08.6-.09.89-.14.43-.09.76-.41 1.2-.48.79.37 1.04 1.28 1.76 1.72-.04.31-.23.51-.51.55-1.26.17-2.37.69-3.46 1.31-.54-.53-.53-.98.18-1.35.3-.16.57-.36.62-.79-.76-.24-1.37.28-2 .46-.49.14-.23.66.17.93.18.13.48.2.39.51-.08.26-.33.3-.56.36-.79.21-1.47.35-2.26-.3-.72-.59-1.8-.73-2.4-1.59-.1-.14-.32-.1-.48-.06-1.24.27-2.31-.15-3.38-.72-.78-.41-1.66-.56-2.66-.72.24.4.62.63.59 1.05-.02.04-.04.09-.06.13Z"
			style={{
				fill: '#bbab75',
			}}
		/>
		<path
			d="M162.73 112.95c1.16-.56 2.38-.18 3.56-.15.81.02.79 1.01 1.13 1.58-.62.18-.63.83-.48 1.13.3.6-.16.52-.4.63-2 .85-4.1.85-6.21.71-.35-.02-.55-.11-.66-.42-.11-.49.21-.76.56-.97.29-.18.6-.33.68-.7.65-.55.99-1.43 1.82-1.79Z"
			style={{
				fill: '#cdc390',
			}}
		/>
		<path
			d="M166.81 124.16c.22-.02.36-.06.56-.27.89-.92 1.79-1.88 3.2-1.99.43-.03.62-.23.56-.73-.05-.47.07-.76.71-.37 1.59.97 1.68 2.09.15 3.33-.22.18-.4.37-.43.65-.07.8-.51 1.26-1.28 1.42-.2-1.32-.93-1.84-2.31-1.7-.41.04-.95.38-1.16-.34Z"
			style={{
				fill: '#cfc191',
			}}
		/>
		<path
			d="M166.81 124.16c.24.29.58.27.84.15.99-.47 1.75.09 2.51.54.57.34.33.87.12 1.35-.84.55-1.75.79-2.76.83-3.78.13-7.45-.37-11.03-1.58-.16-.05-.33-.04-.5-.06l.21-.21c.35-.32.76-.26 1.15-.13 2.25.79 4.59 1.2 6.95 1.38 1.57.12 3.17.05 4.73-.3.28-.06.67-.15.64-.53-.04-.42-.45-.32-.74-.34-.2-.02-.41-.02-.61 0-2.08.16-4.08-.35-6.11-.67-.72-.17-1.37-.53-2.1-.69-.35-.08-.72-.25-.65-.75 1.03.27 2.12.34 3.06.88.32.18.66.15.98.13 1.1-.09 2.2.21 3.3 0Z"
			style={{
				fill: '#d1c597',
			}}
		/>
		<path
			d="M171.51 126.61c-.36.27-.74.5-1.23.41 1.53-.98 2.76-2.18 3.16-4.06.28-1.29.03-2.55-.2-3.8-.17-.94-.61-1.84-.92-2.75.02-.41.32-.4.61-.4.65.7.92 1.64 1.37 2.45.42.77.1 1.79.05 2.69-.03.5-.17 1.01-.12 1.51.16 1.46-.69 2.5-1.5 3.54-.28.35-.67.71-1.22.41Z"
			style={{
				fill: '#baac75',
			}}
		/>
		<path
			d="M159.46 123.15c.66.9 1.89.55 2.66 1.22-.26.28-.59.26-.93.25a2.88 2.88 0 0 1-.91-.26c-.69-.24-1.31-.68-2.05-.78-.2-.04-.37-.12-.53-.24-1.23-.84-2.63-1.38-3.88-2.19a.685.685 0 0 1-.39-.44c-.98-.95-.82-1.94.38-2.53 1.53-.75 2.99-1.67 4.63-2.18 1.02-.42 1.66-1.39 2.65-1.84 0 .55-.43.82-.75 1.17-1.4 1.37-3.21 2.1-4.85 3.09-.31.09-.61.23-.91.37-.09.04-.18.06-.27.08-.93.36-1.04.78-.29 1.36.63.49 1.34.87 2 1.32.34.17.7.26 1.04.43.56.43 1.34.53 1.78 1.16h.61Z"
			style={{
				fill: '#dbd0a5',
			}}
		/>
		<path
			d="M154.36 118.66h.2c.27-.14.59-.18.82-.41 1.64-1 3.42-1.79 4.9-3.06.29-.1.42-.52.82-.41.03.34-.08.63-.42.71-.52.12-.75.53-1 .92-.59.08-.84.45-.82 1.02-.55.01-1.12-.14-1.63.2-.78.78-1.54 1.61-2.83 1.3-.09-.08-.1-.18-.03-.28Z"
			style={{
				fill: '#cfc395',
			}}
		/>
		<path
			d="M158.85 123.14c-.61-.35-1.31-.53-1.84-1.02-.14-.12-.35-.22-.19-.46.14-.07.28-.07.4.05.43.35.89.66 1.43.82l.21.61Z"
			style={{
				fill: '#d1c597',
			}}
		/>
		<path
			d="M161.09 114.78c-.28.11-.46.44-.82.41l.82-1.02c.39-.42.79-.83 1.15-1.27.5-.61.3-1-.45-1.19-1.59-.4-3.14-.05-4.7.15-.3.04-.6.04-.91.06-.06-.54.47-.19.61-.41.1 0 .21.02.3-.02 1.81-.67 3.61-.62 5.41.02.76.38.69.87.21 1.43-.55.61-1.09 1.22-1.64 1.84Z"
			style={{
				fill: '#d5ca9e',
			}}
		/>
		<path
			d="M153.74 111.11c.44-.72 1.16-.6 1.84-.61.23 0 .47-.01.7 0 .35.03.84-.17.98.27.16.48-.46.48-.67.74-.59.26-1.26.29-1.84.61l-.61.2c-.32-.34-1.2-.5-.41-1.22Z"
			style={{
				fill: '#cbc48f',
			}}
		/>
		<path
			d="M154.77 112.13c.52-.47 1.16-.61 1.84-.61h.21l-.61.41-1.43.21Z"
			style={{
				fill: '#d4cc9a',
			}}
		/>
		<path
			d="M171.51 126.61c1.27-.43 2.39-1.99 2.45-3.37.06-1.41.14-2.81.25-4.22.02-.3 0-.53-.21-.73-.68-.61-.78-1.5-1.07-2.29.35.2.81.28.82.82.41.55.78 1.12 1.43 1.43.27 0 .4.14.41.41.9 1.13.78 2.41.51 3.69-.11.54-.27 1.04-.02 1.58.14.3.02.59-.14.87-.2.35-.24.7.09 1.09.55-.42.1-2.13 1.59-1.31.45-.04.34.47.61.61.39.47.31.96.04 1.45-.57.65-1.24 1.07-2.16 1.1-.49.01-.99.15-1.44.4-.51.13-1 .55-1.55.11-1.06-.03-1.09-1.09-1.63-1.63Z"
			style={{
				fill: '#baab70',
			}}
		/>
		<path
			d="M177.63 124.57c-.57-.04-1.09-.06-1.06.79.01.35.1 1.03-.58.88-.49-.1-.63-.91-.5-1.06.57-.68.13-1.34.16-2 .03-.67.26-1.35.38-2.02.17-.92-.24-1.68-.44-2.5.89.66.97 1.78 1.49 2.66.58.98.55 2.14.55 3.25Z"
			style={{
				fill: '#baac75',
			}}
		/>
		<path
			d="M178.04 126.61c.39-.43.12-.95.2-1.43v-1.43c.36.69.52 1.44.59 2.2.14 1.46-.47 2.08-1.93 2.09h-1.11l-.03-.15c.41-.46 1.02-.19 1.5-.41.26-.09.6-.03.68-.42.01-.16-.01-.32.1-.45Z"
			style={{
				fill: '#b7aa79',
			}}
		/>
		<path
			d="M175.18 118.25c-.2.03-.19.43-.23.33-.26-.69-1.31-.83-1.2-1.76.68.27 1.16.74 1.43 1.43Z"
			style={{
				fill: '#baac75',
			}}
		/>
		<path
			d="M165.38 135.38c.38-.69 1.27-.81 1.75-.8 1.16.02 1.49-.63 1.88-1.44.15-.32.44-.61.87-.62.03.77-.39 1.34-.83 1.9-.65.85-.53.98.49 1.35 1.81.66 3.56.11 5.33-.11.72-.09 1.31-1.24 1.19-2.13-.13-.99-.53-1.89-1.12-2.7 0-.05.02-.1.03-.15.9-.28 1.32.33 1.65.96.35.65.7 1.25 1.27 1.77.49.45.39 1.28.22 1.86-.26.9-2.3 1.71-3.2 1.42-.63-.21-1.31-.19-1.91-.07-1.99.39-3.78-.12-5.52-1-.17-.08-.31-.36-.5-.18-.11.1-.12.41-.05.56.45 1 .98 1.96 1.86 2.67.39.31.58-.24.91-.18.24.33-.21.56-.06.92.68-.1 1.41.03 2.11-.37q-.14.8.97 1.21c-.68.49-1.46.22-2.19.25-1.4-.39-2.42-1.26-3.13-2.5-.4-.69-1.16-1.11-1.39-1.94-.11-.39-.56-.06-.8-.24-.19-.25.02-.35.17-.47Z"
			style={{
				fill: '#e3ddc7',
			}}
		/>
		<path
			d="M170.28 140.27h3.06c.59-.27 1.25.08 1.84-.2 1.11-.55 2.43-.37 3.47-1.45.58-.6 1.96-.77 3.06-.8.01.05.02.11.04.16-.1.42-.44.58-.79.72-1.96.84-3.89 1.76-6.02 2.13-1.35.24-2.71.06-4.05-.04-.27-.02-.63-.11-.61-.54Z"
			style={{
				fill: '#e5dfc9',
			}}
		/>
		<path
			d="M185.18 132.12h.2c1.23.78 1.84 3.52 1.32 4.81-.39.99-1.18 1.44-2.18 1.59-.21-.02-.26-.16-.25-.35l.08-.14c1.1-.15 1.49-.76 1.46-1.87-.03-1.02.03-2.02-.52-2.96-.17-.29-.09-.72-.12-1.08Z"
			style={{
				fill: '#ded9bb',
			}}
		/>
		<path
			d="M181.71 137.83c.33-.81.99-.85 1.74-.83.74.02.67.64.91 1.03-.3.41-.59.82-1.2.67-.31-.38.48-.79.03-1.07-.38-.24-.72.27-1.12.31-.14.01-.27 0-.37-.11Z"
			style={{
				fill: '#e5dfc9',
			}}
		/>
		<path
			d="M172.53 130.69c.46-.99 1.13-1.11 2.25-.41l.21.41c-.82.43-1.63.13-2.45 0ZM175.18 140.07c-.57.41-1.23.11-1.84.2.57-.41 1.23-.11 1.84-.2Z"
			style={{
				fill: '#e3ddc7',
			}}
		/>
		<path
			d="M167.01 132.32c-.62-.03-1.04.08-.61.82-.91 1.24-2.35 1.1-2.99-.28-.13-.28-.17-.66-.59-.54-.45.13-.92.29-1.08.83-.14.48.23.53.54.68 1.07.54 1.54 1.79 1.17 2.95-.1.33-.27.58-.63.56-1.1-.05-1.38.67-1.5 1.54-.05.4.01.89-.57.91-.53.02-.88-.28-1.07-.78-.43-1.13-1.14-1.49-2.32-1.2-.39.1-.53.31-.27.65.15.2.14.45.23.65.46 1.02.26 2-.33 3.17 1.28-.44 2.3-.48 3.34-.31.7.11 1.19-.06 1.56-.78.57-1.11 1.22-1.23 2.09-.44.63.58 1.32.97 2.16 1.13.24.05.58.06.46.49-2.04.86-3.22 2.4-3.62 4.57-.05.28.05.74-.51.66-.24-.65-.74-.8-1.37-.73-.51.06-.99.22-1.49.31-.72.13-1.4.16-1.98-.45-.33-.35-.79-.5-1.3-.5-1.12 0-1.93-.6-2.55-1.43-.52-.71-.32-1.56-.16-2.36.18-.87.25-1.73-.12-2.57-.13-.21-.3-.38-.52-.49-1-1.21-2.13-2.25-3.63-2.85-.94-.38-1.95-.57-2.86-1.03-.86-.5-1.81-.51-2.76-.48-.28 0-.56-.02-.84-.08-.48-.17-.98-.09-1.48-.12-.36-.02-.75.03-.96-.36.13-.38.46-.35.76-.37 3.57-.19 6.9.63 10.05 2.32.99.53 1.52 1.53 2.38 2.18.41.4.76.16 1.05-.14 1.24-1.31 2.8-2.09 4.45-2.73.41-.16.58-.43.77-.83.48-1 .5-2.15 1.17-3.11.56-.8 1.1-.89 1.95-.59 1.28.46 2.57.95 3.98.84.06.05.08.11.07.17-.01.06-.03.09-.04.09Z"
			style={{
				fill: '#e1d9b5',
			}}
		/>
		<path
			d="M166.61 142.31c-.79-.25-1.58-.47-2.32-.89-.3-.17-.23-.43-.46-.56-.8-.47-1.51-.4-1.75.46-.35 1.23-1.18 1-1.97.89-1.01-.13-1.99-.2-2.95.43-.31-.52-.31-1.03-.04-1.48.6-1.02.06-1.82-.47-2.6-.21-.3-.01-.42.08-.61.11-.22.13-.63.51-.47.45.19.86.02 1.29.02.79.01 1.36.32 1.35 1.25-.01.62.44.89.92.85.48-.04.21-.53.27-.83.15-.75.36-1.78 1.23-1.66 1.47.21 1.1-.95 1.03-1.39-.11-.75-.34-1.7-1.5-1.69-.27 0-.46-.25-.45-.58.01-.61 1-1.55 1.63-1.52.3.01.52.18.63.44.62 1.53 1.33 1.76 2.59.81.05-.04.13-.03.2-.05.57.36.51.68-.02 1.04-.51.34-1.1.61-1.41 1.21-.31 1.28-.68 2.54-.55 3.9.11 1.25.64 1.9 1.89 2.14 1 .19 1.95.54 2.98.64 2.97.3 5.85-.12 8.66-1.09.42-.14.84-.25 1.28-.31.23 0 .45.02.63.17.07.1.08.2.03.31-1.38.6-2.81 1.08-4.27 1.45-.1 0-.2.02-.3 0-1.24-.14-2.32.04-2.85 1.36a.49.49 0 0 1-.28.09c-.54-.27-1.14-.23-1.72-.31-.09-.02-.18-.06-.27-.11-.78-.54-1.68-.71-2.61-.73-.38-.1-.75-.22-.98-.57Z"
			style={{
				fill: '#e2d8b8',
			}}
		/>
		<path
			d="M172.53 130.69c.82-.43 1.63.06 2.45 0 1.36 1.11 1.72 3.21.82 4.69-.25.42-.57.67-1.07.61-.66-.07-1.28.1-1.9.28-1.42.41-2.74-.12-4.07-.45-.58-.14-.76-.71-.31-1.1.69-.62.95-1.46 1.42-2.19.91-.57 1.6-1.47 2.65-1.84Z"
			style={{
				fill: '#efe9d7',
			}}
		/>
		<path
			d="M179.26 140.88c-2.6 1.02-5.34 1.41-8.09 1.6-1.91.13-3.77-.51-5.63-.96-.32-.08-.51-.3-.74-.5-1.03-.89-.8-4.66.18-5.63h.41l-.2.41c.11.48.06.94-.14 1.39-.33.75-.29 1.56-.14 2.3.14.69.54 1.27 1.42 1.37.96.12 1.84.57 2.85.64 2.93.21 5.82.16 8.63-.8.44-.15.91-.31 1.39-.1.11.08.13.17.06.29Z"
			style={{
				fill: '#e5dfc4',
			}}
		/>
		<path
			d="M167.01 132.32v-.2c1.23-.02 2.41-.21 3.27-1.23.61-.65 1.39-.92 2.24-1.03-1 .59-1.84 1.4-2.76 2.09-.83.62-1.82.3-2.75.36Z"
			style={{
				fill: '#e2d8b8',
			}}
		/>
		<path
			d="M172.93 129.67c.21-.61.75-.54 1.23-.61-.27.48-.72.61-1.23.61Z"
			style={{
				fill: '#e0d5b6',
			}}
		/>
		<path
			d="M170.28 130.89c-.76 1.27-1.99 1.32-3.27 1.23-1.32.46-2.46-.25-3.64-.59-1.41-.4-2.32-.06-2.6 1.35-.17.86-.67 1.61-.71 2.49-.02.43-.38.44-.65.53-1.74.65-3.36 1.47-4.67 2.83-.3.31-.74.88-1.22.12.54-.44 1.13-.83 1.49-1.45.74-.94 1.85-1.23 2.88-1.66.96-.4 1.86-.71 1.82-2.06-.02-.65.46-1.26.7-1.9.16-.39.07-.62-.41-.47-.46.15-.92.26-1.4.22-.16 0-.31-.04-.46-.07-.6-.16-1.19-.13-1.77.11-.44.18-.9.27-1.36.03a.286.286 0 0 1-.13-.28c.1-.28.34-.4.6-.47 1.33-.51 2.73-.44 4.14-.48-.2-.34-.83-.17-.8-.72.44 0 .83.07 1.25.27 1.43.66 2.92 1.17 4.44 1.58 2 .53 3.96.81 5.73-.62Z"
			style={{
				fill: '#dcd2a9',
			}}
		/>
		<path
			d="M161.09 124.37h1.02c2.4.26 4.78.83 7.22.62.33-.03.62.07.7.44.09.39-.09.64-.44.81-.59.28-1.22.33-1.87.39-3.48.35-6.84-.17-10.13-1.23-.46-.15-.91-.27-1.39-.22-.54-.57-.93-.81-1.52.08-.78 1.18-.88 1.11.51 1.86.24.13.5.23.61.5a.42.42 0 0 1-.26.12c-.41-.03-.75-.26-1.12-.42-.36-.19-.7-.39-1.08-.55-.45-.19-.61-.61-.61-1.07 0-.47.22-.77.7-.85.49-.09.74-.58 1.21-.72.72-.27 1.37-.14 2.04.25.79.46 1.73.65 2.6.81 1.36.24 2.68.73 4.09.71 1.52-.03 3.03.36 4.55.03.38-.03.81.13 1.18-.33-.92-.29-1.82-.1-2.69-.14-.61-.03-1.24.22-1.84-.06-.35-.17-.72-.14-1.09-.14-.82-.22-1.78-.05-2.36-.88Z"
			style={{
				fill: '#ded2ad',
			}}
		/>
		<path
			d="m173.14 128.24 1.63-.21c.34-.24.68-.26 1.02 0-.32.42-.92-.01-1.23.41-1.43.59-2.98.9-4.27 1.83-.05.04-.14.05-.17.1-1.54 2.06-3.61 1.21-5.45.81-2.09-.46-4.07-1.36-6.02-2.28-.47-.22-.82-.57-1.23-.86.97-.25 1.78.3 2.54.66 1.81.86 3.67 1.55 5.59 2.08 1.36.38 2.61.29 3.7-.71.76-.79 1.66-1.22 2.77-1.32.37-.03.91.01 1.11-.51Z"
			style={{
				fill: '#b7aa79',
			}}
		/>
		<path
			d="M158.85 129.67c.49.3 1.11.37 1.67.94-1.74.13-3.39-.1-4.94.49.02-.64.6-.61.98-.79.66-.31 1.06-.7.62-1.46-.04-.09-.05-.18-.04-.28.03-.04.05-.08.08-.12.66.26 1.2.66 1.63 1.22Z"
			style={{
				fill: '#e2d7b0',
			}}
		/>
		<path
			d="M155.58 127.63h.21c.57.11.9.62 1.43.81h-.02c-.14.15-.31.2-.5.19a.76.76 0 0 1-.26-.06c-.27-.14-.48-.37-.73-.54a.769.769 0 0 1-.18-.18c-.03-.09-.01-.16.05-.23Z"
			style={{
				fill: '#e4dbb9',
			}}
		/>
		<path
			d="M153.74 111.11c-.5.62.42.76.41 1.22-.54-.07-.85.35-1.26.57-.17.09-.32.28-.54.13-.23-.16-.24-.37-.17-.63.21-.81.51-1.5 1.56-1.29Z"
			style={{
				fill: '#cbc498',
			}}
		/>
		<path
			d="M70.04 138.24c1.11.32 2.17-.3 3.27-.2.54-.43 1.21-.35 1.83-.48.56-.12.67.34.78.72.32 1.09.22 2.19.03 3.29-.16.46-.42.65-.97.63-.62-.01-1.26-.12-1.87.11-.19-.07-.39-.22-.56-.18-1.65.32-2.51-.72-3.32-1.86-.05-.16-.06-.33-.14-.47-.43-.71-.34-1.16.56-1.29.14-.02.26-.18.39-.28Z"
			style={{
				fill: '#eeead9',
			}}
		/>
		<path
			d="M67.19 151.29c1.48-.99 2.05-2.42 2.07-4.16 0-.67.4-.97 1.17-.76 1.08.28 2.26.03 3.28.76.39.28 1.06.17 1.58-.01.46-.17.66-.48.26-.92-.68-.55-.35-.89.24-1.19.9-.46 2.01-.49 2.79-1.19.43-.39.9-.54 1.45-.63.43-.07.69-.05.9.37.3.6.65.52.93-.03.24-.47.71-.85.54-1.48-.05-.17.04-.38.23-.39.82-.05.68-.69.78-1.2.35-.46.36-1.12.83-1.51.69.04 1.29.11 1.99-.36.88-.59 1.62-.01 2.1 1.31-.36 1-1.27 1.48-2.04 2.03-1.08.76-1.72 1.64-1.63 2.99 0 .1-.06.19-.13.27-3.21-.12-6.12.8-8.82 2.48-.85.53-1.63.51-2.47-.04-.8-.52-1.75-.48-2.66-.53-.35-.02-.58.18-.62.54-.04.34-.1.67-.13 1.01-.14 1.47-.98 2.38-2.53 2.75l-.12-.09Z"
			style={{
				fill: '#e4dec0',
			}}
		/>
		<path
			d="M62.29 150.06c-.63-.19-1.03.49-1.63.41.5-.8 1.46-.53 2.16-.94 1.62-.95 3.29-1.82 5.19-2.12.45-.74-.19-.93-.61-1.22h-.41c-.71-.44-1.5-.1-2.25-.2 1.09-.38 2.18-.3 3.25.04.45.15.86.5.82 1.05-.11 1.38-.32 2.7-1.6 3.61-.65.46-1.26.51-1.96.3-.99-.3-1.98-.61-2.96-.92Z"
			style={{
				fill: '#e9e4ce',
			}}
		/>
		<path
			d="M83.52 140.48c.15.7.33 1.41-.81 1.32-.04 0-.15.18-.13.2.45.63-.15.96-.39 1.39-.72 1.29-.66 1.24-1.62.14-.3-.34-1.13-.17-1.43.18-.85 1-2.11 1.05-3.17 1.48-.74.3-.6.53-.4 1-.65-.05-.95-.52-1.22-1.02-.25-.72.32-.84.77-.99.44-.14.92-.1 1.34-.33 1.11-.17 2.04-.79 3.05-1.24 1.39-.62 2.58-1.63 4.03-2.14Z"
			style={{
				fill: '#e5dec4',
			}}
		/>
		<path
			d="M76.58 143.95c-.27.34-.62.42-1.05.42-.54 0-1.08.11-1.19.8-.53 0-.53.62-.84.75-.48.21-1.02.35-1.62.16-.92-.3-1.77-.88-2.84-.66-.32.07-.84.03-1.03-.46l.11-.11c.25-.14.52-.18.79-.14 2 .25 3.88-.5 5.82-.73 1.01-.12 1.78-.79 2.68-1.18.38-.17.72-.39 1.15-.17.22.21.06.39-.11.47-.62.28-1.15.77-1.87.85Z"
			style={{
				fill: '#e9e4cd',
			}}
		/>
		<path
			d="m65.55 143.53.41.21c.13.32.34.57.63.76.19.13.4.31.29.58-.11.24-.36.27-.6.29-1.37.11-2.67-.05-3.88-.94.99-.42 1.88-1 2.95-1.1l.2.2Z"
			style={{
				fill: '#ded9ba',
			}}
		/>
		<path
			d="M66.37 143.74v-.21l1.02.41c.12.1.29.18.21.39-.06.07-.13.07-.21.02-.49.05-.81-.2-1.02-.61Z"
			style={{
				fill: '#ede7d4',
			}}
		/>
		<path
			d="M66.57 151.69v-.2c.15-.24.39-.2.61-.2.01.46-.2.58-.61.41Z"
			style={{
				fill: '#e4dec0',
			}}
		/>
		<path
			d="M67.39 144.35h.21l.14.03c.2.14.4.28.27.58-.39-.02-.59-.22-.61-.61Z"
			style={{
				fill: '#e9e4cd',
			}}
		/>
		<path
			d="m67.59 144.35-.21-.41c1.73.34 3.46.28 5.16-.16.73-.19 1.46-.36 2.17-.6.23-.08.53-.31.48-.59-.06-.33-.41-.28-.68-.28h-1.42c.6-.43 1.3-.16 1.95-.26.44-.06.55-.27.7-.56.27-.49.71-.46 1.16-.38.47.09.94.17 1.37-.13.09-.04.18-.08.28-.1.81-.14 1.51-.6 2.29-.82.48-.28.65-.09.61.41-.51.61-1.14 1.06-1.84 1.43-.86.59-1.95.65-2.83 1.23-1.93 1.27-4.25 1.16-6.39 1.68-.91.22-1.95.12-2.82-.46Z"
			style={{
				fill: '#f3eedd',
			}}
		/>
		<path
			d="M103.12 136.6c-.29-.35-.35-.79-.52-1.18-.18-.43.05-1.32-1.01-1.06-.18.04-.56-.73-.83-1.14-.03-.04.04-.2.11-.25.13-.09.22-.1.41.01.6.34 1.29.74 1.47-.45.05-.32.33-.39.61-.43.35-.04.52-.22.54-.6.03-.7.56-.96 1.26-.69.9.34 1.84.49 2.8.38.93-.11 1.52.57 2.14 1 .52.36-.33.73-.46 1.15-.51.62-1.32.61-1.97.93-.84.42-1.83.56-2.47 1.34-.16.19-.49.4-.28.68.21.26.52.05.74-.08 1.39-.84 2.95-1.2 4.47-1.66.32-.1.64-.25.97 0 .05.09.07.19.06.3-.73.93-1.9.86-2.88 1.21-.62.22-1.31.29-1.85.72q-1.64.99-.8 2.69c.11.21.27.43.26.65-.08 1.71.23 3.45-.32 5.12-.13.41-.25.95-.88.97-.16-.17-.2-.38-.2-.6.33-1.68.1-3.37.12-5.06 0-.84-.63-1.48-.88-2.25-.12-.6-.45-1.12-.64-1.69Z"
			style={{
				fill: '#e6e2c3',
			}}
		/>
		<path
			d="M103.12 136.6c.63.27.58.93.82 1.43-.31.24-.51 0-.68-.2-.28-.3-.6-.55-.98-.7-.44-.27-.89-.48-1.43-.48-1.04-.01-2.11.21-3.05-.48-.07-.06-.2-.07-.3-.05-1.3.24-2.64.3-3.87.86-1.06.36-1.75 1.35-2.82 1.68-.32.04-.63.06-.91-.13-.2-.39.15-.44.36-.51.39-.13.65-.44 1.02-.59.37-.39.27-1.44 1.32-.94.06.03.3-.43.52-.57.56-.34 1.13-.63 1.84-.36.25.09.95 0 .85-.14-.32-.46.26-1.34-.67-1.46-.44-.05-.86-.12-1.21-.42.7.08 1.48 0 2.09.29 1.15.54 2.27.07 3.39.1.51.02.79-.23.39-.77-.2-.27-.37-.56-.56-.84 1.18.27 1.23 1.22 1.18 2.12-.04.62.14.85.71.96.47.09.89.36 1.14.77.21.34.48.46.84.43Z"
			style={{
				fill: '#e7e2c8',
			}}
		/>
		<path
			d="M105.36 127.43h.41c.06.14 0 .26-.11.34-.88.61-.37.76.28.87.09.01.19.03.28.06.41.15.85.08 1.27.18.09.03.18.07.26.12 1.07.64 2.8.47 3.66-.39.24-.24.49-.36.82-.21.35.16.39.45.27.77-.32.89-.03 1.74.12 2.6.1.59.68.72.97 1.13.11.74-.27.92-.94.87-.87-.07-1.58-.45-2.19-1.04.52-.87.1-1.3-.68-1.69-.85-.43-1.82-.35-2.66-.75-.06-.03-.18.02-.19-.01-.59-1.21-2.49-.92-2.79-2.44.29-.5.66-.75 1.22-.41Z"
			style={{
				fill: '#eae5cc',
			}}
		/>
		<path
			d="M110.47 132.73c.8-.01 1.25.79 2.11.82.63.02.85-.06.95-.61.55-.16 1.08-.12 1.6.13.04.75-.71.38-.98.69-.9.73-1.92 1.02-3.07.81-1.91.51-3.85.95-5.56 2.01-.39.24-.67.27-.97-.08-.38-.43.14-.58.27-.83.54-1.02 1.69-1.2 2.59-1.59.69-.3 1.43-.68 2.23-.73.44.02.79-.08.82-.61Z"
			style={{
				fill: '#eee8cc',
			}}
		/>
		<path
			d="M105.36 127.43c-.47-.05-.83.23-1.22.41l-.2-.2c-.33-.31-.01-.63 0-.97-.59-.28-1.28.2-1.83-.26v-.2c1.6-.22 3.19-.45 4.29-1.84.63-.2 1.19-.56 1.83-.78.55-.19.66.04.76.43.02.09-.06.21-.04.29.26.85.49 1.65-.91 1.01-.07-.03-.23 0-.27.05-.64.87-2.08.82-2.4 2.06Z"
			style={{
				fill: '#e6e0c5',
			}}
		/>
		<path
			d="M102.1 126.41h2.34c-.05.45-.66.7-.5 1.22-.58.06-.25.56-.22.7.24 1.14-.6 1.1-1.25 1.13-.48.02-.84.13-1.16.49-.19.21-.34.76-.74.3-.31-.36-.74-.83-.21-1.31.72-.63.99-1.49 1.33-2.32.17 0 .32-.04.41-.2Z"
			style={{
				fill: '#e4e2c3',
			}}
		/>
		<path
			d="M99.24 132.32c-.55-.48-1.17-.83-1.89-1.01-.38-.1-.77-.22-.96-.62.51.05.95.31 1.53.29.67-.02 1.29.49 1.33 1.34Z"
			style={{
				fill: '#e7e2c8',
			}}
		/>
		<path
			d="M91.28 137.42c-.13.82-.92.72-1.43 1.02-.66.35-.72 1.37-1.63 1.43-.36-.73-.78-1.35-1.75-1.18-.09.02-.27-.03-.28 0-.43 1.11-1.17.58-1.84.36-.24-.82.31-1.46.48-2.18.49-.44.77-1 .9-1.65.16-.79.61-1.32 1.49-1.08.58.15.95-.24 1.41-.39.8.15 1.49.62 2.08 1.07.41.31.58 1.12.46 1.78-.05.3-.19.58.11.82Z"
			style={{
				fill: '#e4ddc2',
			}}
		/>
		<path
			d="M88.62 133.75c-.34.5-.61.92-1.41.62-.69-.25-1.15.17-1.3.98-.1.57-.06 1.37-.97 1.46-.54-.33-.31-.88-.28-1.29.1-1.35-.28-2.52-1.02-3.62-.05-.61.49-.93.68-1.42.65-.66.9-.11 1.49.24 1.29.76 1.56 2.32 2.79 3.02Z"
			style={{
				fill: '#e2dec0',
			}}
		/>
		<path
			d="M91.07 131.71c.49-.24.72.18 1.02.41-.4.01-.76-.08-1.02-.41Z"
			style={{
				fill: '#f4f0d8',
			}}
		/>
		<path
			d="M78.41 141.09c-.32.58-.85.46-1.32.33-.48-.14-.9-.17-1.34.08.02-.98.25-1.97-.02-2.94-.11-.4 0-1-.88-.65-.39.15-1.02.15-1.55.13.44-.89 1.35-.65 2.06-.79 1.13-.23 3.32-2.36 3.45-3.49.3.21.32.61.26.83-.36 1.47.48 2.81.39 4.26-.05.78.48 1.32 1.39 1.23-.69.48-1.33 1.04-2.25 1.02-.07-.14-.14-.13-.2 0ZM78.82 133.75c-.48-.2-.4-.63-.41-1.02.41.23.75.49.41 1.02Z"
			style={{
				fill: '#eeeada',
			}}
		/>
		<path
			d="M83.72 131.91c1.02.86 1.23 2.02 1.11 3.24-.06.58-.04 1.11.12 1.65.03.81-.44 1.49-.61 2.24-.35.43-.2 1.15-.82 1.43-1.71 1.22-3.48 2.33-5.46 3.04-.47.17-.82.94-1.48.42.68-.41 1.36-.82 2.04-1.22.34-.68 1.11-.5 1.63-.82.77-.34 1.37-.98 2.23-1.17.26-.06.59-.34.65-.59.45-1.63 1.66-3.06 1.4-4.89-.17-1.17-.46-2.3-1.02-3.35.07-.1.14-.1.2 0Z"
			style={{
				fill: '#e7e2c8',
			}}
		/>
		<path
			d="M80.25 141.91c-.44.48-1.09.54-1.63.82-.96-.09-1.65.59-2.39.98-.75.4-1.51.45-2.27.67-1.96.57-3.94.67-5.96.59l-.41-.61c.33.07.66.11.98.2.97.27 1.86.11 2.83-.16 1.31-.37 2.73-.29 4.01-.84.63-.27 1.32-.48 1.87-.86.73-.5 1.52-.67 2.35-.78h.61Z"
			style={{
				fill: '#ede7d4',
			}}
		/>
		<path
			d="M83.72 131.91h-.2c-.13-.49.4-.77.41-1.22l.41-.2c.01.57-.57.88-.61 1.43Z"
			style={{
				fill: '#e6e2c4',
			}}
		/>
		<path
			d="M205.6 153.94c-.16-.05-.57 0-.43-.18.49-.66-.17-1.11-.18-1.66.25-.41.32-.82 0-1.22-.1-1.02.19-2.04 0-3.06-.24-.46-.19-.78.41-.82.34-.57.24-1.13.02-1.72-.22-.59-.4-1.22.42-1.56.28-.12.38-.36.38-.66 0-.29-.42-.72.14-.83.57-.11 1.21-.37 1.72.21.35.41.81.78 1.01 1.26.28.67.83.79 1.36.82.65.04 1.21.22 1.67.64.92.86 2.23 1.14 3.08 2.1.23.26.6.43.65-.21.03-.32.28-.44.58-.46.08.07.14.15.18.24.13.83.12 1.69.5 2.47.06.14.08.29.04.44-.04.1-.11.15-.21.17-.61-.13-.8-.7-1.13-1.11-.83-1.05-1.88-1.82-3.06-2.42-.09-.03-.18-.06-.26-.11-.4-.19-.79-.93-1.16-.48-.4.48.25.96.63 1.28.86.73 1.68 1.47 2.23 2.46.12.66.85 1.04.84 1.76-1.16.08-1.42-.92-1.9-1.61-.52-.76-.94-1.6-1.96-1.81-.33-.36-.33.23-.55.19-.81-.48-.8-1.44-1.25-2.13-.18-.27-.2-.64-.48-.87-.35-.5-.56-1.08-.95-1.56-.31-.39-.6-.43-.87.02-.51.88-.98 1.73-.99 2.83-.02 2.3-.24 4.59-.06 6.89-.08.25-.15.51-.38.67Z"
			style={{
				fill: '#e4dbbc',
			}}
		/>
		<path
			d="M205.8 134.56c0-.17.04-.32.21-.41.81.19 1.05.8 1.13 1.52-.14.47-.5.74-.91.94-1.62.79-2.77 2.07-3.43 3.7-.53 1.31-1.03 2.62-2.02 3.92 1-.02 1.42-.5 1.6-1.11.42-1.41 1.11-2.66 1.92-3.87.36-.53.77-1.03 1.37-1.14 2.34-.44 4.69-.85 6.93.44.26.08.41.28.55.5.3.5.85.83 1.02 1.43-.29.22-.51.04-.72-.14-1.37-1.16-2.96-1.71-4.75-1.61-.57.03-1.11-.37-1.68-.09h-.41c-.4.18-.78.38-1.05.74-.71.95-1.55 1.81-2.01 2.93-.26.55-.32 1.2-.82 1.63-.31.43-.68.8-1.08 1.15-.18.09-.38.11-.58.13-.3.02-.61.08-.9-.01-.6-.19-.76-.66-.35-1.15.92-1.1 1.49-2.38 1.93-3.73.61-2.12 2.12-3.46 3.94-4.54.65-.39.17-.81.11-1.23Z"
			style={{
				fill: '#d8d0a7',
			}}
		/>
		<path
			d="M203.56 156.59c.57.49 1.15.98 1.6 1.59.47.64 1.2.93 1.73.37.78-.83 1.67-.71 2.6-.73.3-.32.69-.38 1.09-.41 1.24-.26 1.77-.05 2.04.82.21.68.01.95-.72.9-.78-.05-1.54-.04-2.32.25.28.39.85.29.97.77-.7.72-1.49.32-2.16.05-.92-.36-1.79-.69-2.8-.76-1.3-.08-1.84-1.11-2.21-2.23-.03-.24 0-.45.18-.63Z"
			style={{
				fill: '#e0d9b2',
			}}
		/>
		<path
			d="m210.7 157.61-1.22.2c-1.79-.29-2.54-1.93-3.79-2.93-.31-.25-.14-.62-.09-.95 0-.22-.04-.46.2-.61.08-.07.17-.07.26-.02.71.92 1.06 2.09 2 2.87.79.66 1.46.78 2.46.28.07-.07.15-.14.22-.21.47-.4.57-.88.57-1.52 0-1.84-.34-3.6-.77-5.37-.11-.45-.22-.93.15-1.34.06-.22-.27-.52 0-.64.31-.13.14.4.4.43.48.84 1.09 1.64.83 2.7-.02.09-.02.22.03.3.98 1.43.25 3.09.64 4.59.18.71-.01 1.16-.77 1.37-.47.13-.75.57-1.14.83Z"
			style={{
				fill: '#e3dcbc',
			}}
		/>
		<path
			d="M203.56 156.59v.61c-.11.06-.21.05-.3-.04-1.05-2.05-1.7-4.2-1.6-6.52.04-1.08-.32-2.14-.13-3.24.1-.58-.32-.55-.74-.39-.88.36-1.78.64-2.75.37-.1-.74.52-.66.92-.74 1.01-.2 1.91-.52 2.15-1.68h.61c.15.09.06.31.2.41.14 2.48.24 4.97.44 7.44.05.64.36 1.29.68 1.86.35.61.55 1.22.51 1.91Z"
			style={{
				fill: '#e0d5ae',
			}}
		/>
		<path
			d="M207.03 138.64c1.42-.27 2.81-.43 4.22.2 1.03.46 2.03.95 2.92 1.64l.2.2c-.39.5-.9.44-1.16 0-.64-1.09-1.66-1.18-2.71-1.18s-2.05-.01-2.89-.75c-.13-.11-.38-.08-.58-.11Z"
			style={{
				fill: '#e0d9b1',
			}}
		/>
		<path
			d="M217.03 149.86v-.41c-.34-.85-.44-1.76-.62-2.65v-.2c-.54-.77-.5-1.84-1.33-2.46-.75-.56-.25-1.29.07-1.67.37-.45.66.36 1.06.47.02.85.18 1.66.51 2.45.44 1.07.48 2.22.74 3.33.09.38.26.97-.42 1.15Z"
			style={{
				fill: '#dfd4af',
			}}
		/>
		<path
			d="M205.39 147c-.37.15-.43.47-.41.82-.21-.1-.41-.19-.67-.09-.63.24-.98-.06-1.06-.67-.08-.56.03-.95.7-1.19 1.2-.42 1.2.45 1.43 1.13Z"
			style={{
				fill: '#e0dab2',
			}}
		/>
		<path
			d="M203.56 142.31c.11-1.46 1.85-3.54 3.06-3.67-.49.48-.68 1.09-.91 1.72-.1.28-.27 1.33-1.21 1.09-.71-.18-.52.69-.95.86Z"
			style={{
				fill: '#e0d9b1',
			}}
		/>
		<path
			d="M217.03 149.86c.36-.56.21-1.14.06-1.73-.37-1.42-.71-2.84-1.1-4.25-.11-.39-.16-.7.22-.96l.61.61.2.41c-.3.55-.05 1.06.13 1.56.48 1.33.54 2.71.53 4.11 0 .24-.05.47-.24.65-.17.09-.31.02-.42-.11-.06-.1-.06-.2 0-.3Z"
			style={{
				fill: '#d5cca8',
			}}
		/>
		<path
			d="M204.99 150.88c.49.44.49 1.03 0 1.22v-1.22Z"
			style={{
				fill: '#e3dcbc',
			}}
		/>
		<path
			d="M201.92 145.37c-.16-.09-.2-.24-.2-.41.26-.42.6-.76 1.02-1.02 0 .64-.82.79-.82 1.43Z"
			style={{
				fill: '#e0d7af',
			}}
		/>
		<path
			d="M212.54 138.85c-1.67-1.12-3.53-.86-5.38-.77-2.55.12-3.25 2.07-4.03 3.96-.19.46-.33.95-.56 1.39-.44.84-1.07 1.38-2.21 1.02 1.34-1.71 1.79-3.84 2.89-5.6.65-1.04 1.58-2.1 2.96-2.45.14.61 1.75 1.37 1.85.97.16-.6.66-.87.88-1.36.1-.21.23-.41.41-.56.04-.02.08-.04.13-.06.63 0 .89.65 1.43.82.47.71.79 1.5 1.74 1.81.46.15.26.59-.11.84Z"
			style={{
				fill: '#d1c99e',
			}}
		/>
		<path
			d="M212.54 138.85c.15-.33.41-.61-.23-.79-.9-.24-1.35-.93-1.4-1.86 1.19.61 2.45 1.15 2.25 2.86l-.61-.2ZM207.03 135.58c-.31-.5-.43-1.13-1.02-1.43 1.04-.23 1.92.34 2.85.61v.2a.47.47 0 0 1-.25.33c-.54.03-1.06.17-1.59.28Z"
			style={{
				fill: '#cdc8a0',
			}}
		/>
		<path
			d="m208.66 135.18.21-.2c.29 0 .5.14.61.41-.34.19-.66.34-.81-.2Z"
			style={{
				fill: '#d1c99e',
			}}
		/>
		<path
			d="M217.24 150.27c.4-.66.29-1.43.14-2.07-.22-.93.05-1.95-.6-2.84-.22-.31-.48-1.05.24-1.41.21.8.93 1.27 1.28 2.01.97 2.01 1.74 4.1 2.6 6.15 0 .22-.03.46.2.61v.21c.17.33.23.7.41 1.02v.82c-.28.46-.65.83-1.23.74-.55-.09-.77-.58-.83-1.05-.2-1.5-1.57-2.34-2.05-3.67a.968.968 0 0 1-.19-.22c-.04-.1-.03-.19.03-.28Z"
			style={{
				fill: '#d0c99d',
			}}
		/>
		<path
			d="M205.8 134.56c.89.78.75.89-.15 1.56-1.26.92-2.86 1.6-3.2 3.43-.05.27-.35.49-.53.73-.07.07-.16.1-.26.08-.19-.1-.18-.25-.11-.42.11-.25.25-.48.32-.75.14-.52.15-1.13-.3-1.39-.45-.26-.72.33-1.04.61-.37.33-.5.8-.69 1.23-.22.52-.29 1.08-1 1.27-.36.1-.28.65-.38.99-.1.33 0 .67.03 1.01.07.71-.36 1.27-.78 1.68-.39.38-.75-.26-1.13-.42-.19-.08-.36-.19-.54-.28-1.15-.61-1.26-.94-.74-2.2.06-.07.13-.14.21-.19.53-.36.94-.87 1.49-1.21.18-.11.33-.29.34-.49.03-1.32.73-2.52.66-3.86-.05-1.02-.49-1.34-1.49-1.08-.33.09-.66.19-.92-.14.29-.63.9-.77 1.47-.96.76-.25.83-.43.21-.96-.72-.62-1.41-1.28-2.19-1.82-1.41-.98-2.99-.63-4.54-.54-.62.04-1.24.42-1.87.05.65-.63 1.52-.49 2.29-.58 1.06-.12 2.15-.03 3.22-.03 1.96.85 3.61 2.06 4.67 3.95.17.31.42.26.58.21.74-.24 1.6.24 2.27-.56.43-.52 1.09.2 1.67.08.37.64 1.07.4 1.61.57.33.11.6.21.84.45Z"
			style={{
				fill: '#e1dab4',
			}}
		/>
		<path
			d="M208.66 164.14c1.23 1.03 2.77 1.55 4.08 2.44v.21c-1.73-.31-3.09-1.2-4.08-2.65Z"
			style={{
				fill: '#f5f0e1',
			}}
		/>
		<path
			d="M139.66 173.31h-.4l-.05-.13c.83-.97 1.79-1.78 2.97-2.31.61-.09 1.08.18 1.53.57.45.39.91.79 1.56.78 1.86-.12 3.51.74 5.24 1.17.39.1.77.28 1.19.23 1.31.04 2.62.01 3.93.02 1.93-.17 3.84-.38 5.72-.98 1.18-.38 2.35-.75 3.48-1.26.75-.24 1.4-.72 2.17-.9.17 0 .31.04.43.16-.67.77-1.66 1.03-2.53 1.44-4.29 2.03-8.89 2.49-13.54 2.17-2.71-.19-5.4-.86-7.85-2.13-1.5-.77-1.46-.82-2.71.32-.34.31-.75.56-1.14.83Z"
			style={{
				fill: '#e3dcbe',
			}}
		/>
		<path
			d="M175.38 167.4c-1.01-.37-2.08-.4-3.13-.57-.54-.09-1.26-.1-1.36.77l-.61.21a.37.37 0 0 1 0-.38c.47-.7.13-.96-.54-1.2-.3-.11-1.08 0-.73-.8 2.02.29 3.89-.59 5.85-.75.22 0 .43 0 .65.02.16.02.3.07.43.16.15.59-.38.46-.65.61-.3.17-.85-.06-.93.42-.1.57.42.78.83 1.01.12.1.2.21.23.37-.01.05-.03.09-.04.14Z"
			style={{
				fill: '#e8e1c1',
			}}
		/>
		<path
			d="M168.85 165.56c.3.15.58.31.89.44q1.38.57.54 1.81c-.69 1.21-1.69 2.12-2.86 2.85h-.41c-.11-.37.16-.53.39-.72.88-.75 1.82-1.44 2.45-2.43.04-.08.09-.15.13-.22.14-.21.24-.42-.06-.58-.48-.23-.98-.4-1.46-.6-.31-.2-.61-.43-.86-.71-.03-.1-.01-.19.04-.27.48-.28.84-.05 1.16.3.02.05.03.09.05.14Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M187.43 165.36h-.2c.95-.62 1.9-1.23 2.86-1.84-.7.88-1.43 1.71-2.65 1.84Z"
			style={{
				fill: '#f0e9d7',
			}}
		/>
		<path
			d="M187.02 164.95c-.27.32-.79.23-1.02.61-1.62.85-3.42 1.06-5.17 1.43-.84.06-1.69.15-2.53 0-.43-.15-.6-.52-.47-.89.16-.46.58-.15.89-.14 1.04.05 2.07.13 3.1-.57-.94.14-1.75.19-2.4-.48.57-.72 1.54-.69 2.25-1.19.47-.33.99-.58 1.34-1.05.82-.61 1.67-1.18 2.29-2 .52-.25.5.41.83.48.17.07.32.16.45.29.28.34.64.6.95.92.29.3.55.62.33 1.08-.21.43-.53.71-1.03.7-.61-.01-1.22-.03-1.82.09-.28.06-.53.13-.66.41-.07.15-.14.33-.06.48.11.19.3.09.46.06.72-.14 1.39-.58 2.17-.35l.1.1Z"
			style={{
				fill: '#d3c89e',
			}}
		/>
		<path
			d="M203.35 157.2h.2c.24.44.44.9.72 1.31.14.21.41.45.64.46 1.77.09 3.3 1.12 5.05 1.28.2.02.41 0 .54-.2 1.52.32 2.97.02 4.42-.45.43-.14.69-.35.89-.73.24-.44.36-.94.64-1.37.42-.36.49-1.29 1.16-1.11.69.19 1.03.98 1.22 1.65.18.63.25 1.34-.14 1.97-.09.07-.19.07-.29 0-.33-.42-.08-.97-.34-1.4-.08-.12-.14-.24-.2-.37-.1-.21-.14-.45-.29-.69-.54.29-.45.86-.63 1.29-.73 1.69-2.17 2.23-3.84 2.27-1.51.04-3.03-.01-4.52-.26-.6-.34-1.18-.74-1.9-.85-.5-.13-1-.4-1.49.03-.54-.37-1.09-.78-1.63 0-.8.4-1.33 1.21-2.24 1.43h-.61c-.08-.32.19-.39.37-.52.42-.17.82-.36 1.14-.69.43-.57 1.02-.92 1.65-1.23-.28-.47-.6-.9-.68-1.44 0-.15.04-.29.16-.39Z"
			style={{
				fill: '#d9d0a7',
			}}
		/>
		<path
			d="M198.06 162.51c-1.88.44-3.78.58-5.69.29-1.21-.18-2.21-.07-3.16.82-.61.57-1.22 1.29-2.19 1.34-.2-.88.69-1.01 1.09-1.34.52-.43 1.09-.87 1.7-1.21 1.09-.32 2.2-.23 3.29-.09.81.11 1.59.16 2.39 0 .11-.03.23-.06.35-.07.65-.02 1.3-.08 1.94.05.12.04.21.11.29.21Z"
			style={{
				fill: '#d3c89e',
			}}
		/>
		<path
			d="m180.9 166.79 5.1-1.23-.41.41c-1.64.66-3.34 1.09-5.1 1.22-.68.22-1.38.04-2.07.1-.13-.02-.2-.1-.2-.23.51-.35 1.08-.09 1.62-.17.35-.05.73.1 1.06-.11Z"
			style={{
				fill: '#e2dab9',
			}}
		/>
		<path
			d="m201.11 161.08-.42.4-.61.21c-.73.24-1.39.71-2.2.65-.14-.53.33-.59.62-.73.6-.29 1.23-.53 1.89-.67.21-.05.41-.06.61.04l.11.11Z"
			style={{
				fill: '#cabe90',
			}}
		/>
		<path
			d="M197.84 162.3c.8 0 1.43-.66 2.25-.61-.55.59-1.31.66-2.04.82h-.22l-.07-.11.08-.1Z"
			style={{
				fill: '#d1c89b',
			}}
		/>
		<path
			d="M178.24 167.2h2.24c-1.69.28-3.38.69-5.11.2.92-.5 1.9-.26 2.86-.2Z"
			style={{
				fill: '#e8e1c1',
			}}
		/>
		<path
			d="M186.2 166.18c-.13.65-.66.32-1.02.41.23-.42.7-.22 1.02-.41Z"
			style={{
				fill: '#f5f0df',
			}}
		/>
		<path
			d="M214.79 166.17c-.93.17-1.78-.23-2.66-.41-1.66-1.02-3.46-1.84-4.87-3.25-.13-.13-.22-.25-.24-.42.08-.06.17-.09.27-.08 1.18.41 1.95 1.44 3.04 2 .96.5 1.8 1.22 2.92 1.39.69.11 1.97-.34 2.21-.94.25-.62.67-1.1 1-1.65.42-.69.79-1.39 1.14-2.11.17-.35.31-.77.85-.67.17.16.19.36.16.58-.66 1.51-1.32 3.03-2.31 4.37-.4.54-.97.84-1.52 1.17Z"
			style={{
				fill: '#d9d0a7',
			}}
		/>
		<path
			d="M207.23 162.1h-.21c-.07-.06-.13-.13-.2-.19-.26-.15-.33-.49-.61-.62l-.21-.2c-.14-.27-.35-.47-.61-.61-.17-.09-.2-.24-.21-.41.3-1.26.95-.19 1.43-.21.09.78.95 1.35.61 2.24Z"
			style={{
				fill: '#cfc9a3',
			}}
		/>
		<path
			d="M205.39 160.47c.39.02.6.22.61.61-.27-.14-.47-.34-.61-.61ZM206.21 161.28c.41 0 .47.35.61.62-.39-.02-.46-.36-.61-.62Z"
			style={{
				fill: '#d9d0a7',
			}}
		/>
		<path
			d="M117.2 176.98c-.27-.32-.66-.52-1.04-.57-1.19-.16-2.16-.87-3.25-1.27-.67-.68-1.73-.94-2.09-1.95-.04-.16-.1-.32-.17-.47-.13-.25-.21-.54-.02-.76.21-.25.5-.1.75-.02.06.02.13.04.19.07 1.44.73 2.94 1.13 4.57 1.39 1.88.31 3.73.48 5.61.39.27-.01.54-.08.76.14-.12 1.01-.99 1.16-1.72 1.42-.9.33-1.87.08-2.8.22-.22.03-.54-.08-.58.24-.03.28.28.35.5.41.63.16 1.27.17 1.91.15.75-.03 1.48.02 2.19.28l.76.15c1.78.29 3.55.02 5.32-.18.83-.09 1.65-.29 2.48-.4 1.04-.19 2.03-.6 3.06-.83.29-.06.56-.23.87-.1.1.08.12.17.06.28-.95.69-2.11.86-3.19 1.12-2.59.63-5.24 1.07-7.93.9-2.08-.13-4.16-.39-6.24-.59Z"
			style={{
				fill: '#dfd7b5',
			}}
		/>
		<path
			d="M134.56 175.56v-.21c.03-.15.13-.25.26-.33.13-.07.27-.12.41-.16 1.09-.46 2.22-.8 3.18-1.53.25-.19.54-.29.83-.04h.01c-1.32 1.27-2.93 1.94-4.7 2.26Z"
			style={{
				fill: '#e3dcbe',
			}}
		/>
		<path
			d="M111.08 173.31c.4.82 1.41 1.04 1.84 1.83-.53.04-.7-.65-1.23-.61a1.29 1.29 0 0 1-.61-.61c-.25-.21-.61-.36-.46-.8.24-.16.34.04.46.19Z"
			style={{
				fill: '#ece5c9',
			}}
		/>
		<path
			d="m103.93 170.46.2-.41c.07-.62.64-.84.98-1.25.35-.42.61-.71-.17-1.1-.93-.47-1.93-.64-2.87-.99-.59-.22-1.02-.51-1.23-1.1-.32-.6-.41-1.15.02-1.78.35-.52.05-1.23.34-1.83.21-.44.4-.68.9-.51.73.38 1.28.97 1.82 1.56.48.52.99 1.01 1.6 1.37.26.24.56.18.86.12 1.23-.24 2.4.09 3.56.44.21.06.39.15.4.39 0 .23-.13.38-.3.49-.4.26-.88.33-1.31.53-.27.12-.74.11-.55.64.21.43.79.55.92 1.05-.1.24-.26.27-.47.13-1.37-.62-2.26-.17-3.11 1.04-.31.44-.69 1.31-1.58 1.21Z"
			style={{
				fill: '#eee9d2',
			}}
		/>
		<path
			d="M108.63 168.21c.17 0 .32-.04.41-.2.23-.11.49-.11.72-.2.96-.44 1.9-.75 2.78.15.29.51.23.94-.28 1.3-.49.34-.72.97-1.31 1.21-.07.05-.14.09-.21.14-.23.15-.3.39-.36.63-.13.44.01.93-.22 1.36-.03.03-.07.06-.11.1-.66-.9-.46-1.91-.09-2.77.4-.93.27-1.3-.72-1.42-.21-.03-.48-.06-.62-.29ZM110.67 173.11c-.03.35.3.53.41.82-.67-.13-.83-.69-1.02-1.22.18-.13.31 0 .44.09.09.09.16.19.17.32Z"
			style={{
				fill: '#eee7d5',
			}}
		/>
		<path
			d="M61.06 165.36v-.2c.28-.2.51-.05.75.09 2.15 1.25 4.58 1.59 6.96 2.08 1.46.12 2.91-.08 4.36.01.54.04 1.19-.06 1.41.67v.41c-1.04-.93-2.34-.72-3.48-.55-1.21.18-2.39.1-3.52-.1-2.28-.41-4.61-.82-6.47-2.41Z"
			style={{
				fill: '#e8e2ca',
			}}
		/>
		<path
			d="M74.54 168.01c-1.28-.77-2.69-.33-4.04-.37-.62-.02-1.25 0-1.88-.04-.19-.14-.48-.13-.61-.38-.45-.91-.28-1.41.61-1.7.42-.14.86-.19 1.29-.3.1-.03.2-.06.3-.07.41-.04.82-.1 1.21.11.19.51-.23.53-.52.58-.4.07-.79.12-1.17.26-.09.03-.18.06-.28.08-.25.07-.63.08-.58.43.07.44.47.52.87.52.2 0 .4 0 .6-.01.74-.07 1.49-.11 2.22 0 2.91.45 5.28-1.09 7.78-2.14.59-.25 1.07-.72 1.74-.78.11.02.2.07.27.16.05.16 0 .31-.07.46-.1.19-.23.34-.41.45-1.07.43-2.1.96-3.15 1.43-.09.05-.18.09-.27.13-.16.05-.31.13-.46.22-.82.51-.87.72-.11 1.32 2.08 1.62 4.25 2.91 7.08 2.91 1.69 0 3.37.02 5.06-.04.74-.03 1.34-.49 2.08-.43.44 0 .88-.03 1.32.04.57.09.74.45.27.8-.65.5-.52.91-.17 1.53.73 1.26.34 2.02-1.06 2.25-.2.03-.4.07-.6.12-1.14.13-2.29.04-3.42-.07-1.03-.11-2.07-.15-3.1-.31-.84.18-1.45-.44-2.16-.67-2.56-.83-4.8-2.26-6.82-4.03-.34-.45-.67-.88-.63-1.51.04-.67-.62-.67-1-.94h-.2Z"
			style={{
				fill: '#d9d3af',
			}}
		/>
		<path
			d="M91.89 175.35c.14-.19.34-.19.54-.2 1.17-.08 1.69-.98.9-1.83-.92-.99-.6-1.46.37-1.95.04-.02.04-.12.09-.3h-1.7a.225.225 0 0 1 0-.27.86.86 0 0 1 .42-.16c.47-.03.96 0 1.37-.3.13-.06.27-.09.41-.1.31-.04.63.02.92-.15.07-.05.15-.1.22-.15l.11-.08c.55-.16.66-1.09 1.45-.83.08.11.1.23.08.37-.03.2-.31.43 0 .6.23.12.44-.05.65-.15.33-.16.64-.56 1.02-.08.05.77.2 1.49.55 2.2.21.43.47 1.06-.38 1.25-.17-.06-.26-.2-.33-.36-.46-1.1-1.06-1.24-2.03-.48-.11.08-.21.16-.35.17-.62-.96-.87-1.06-1.73-.65-.17.08-.44.13-.37.39.07.24.34.15.51.22.46.16 1.02-.37 1.4.21 0 .18-.06.33-.2.43-.73.57-.75 1.17-.07 1.79-.76.46-1.69-.09-2.45.41-.48.11-.95.35-1.43 0Z"
			style={{
				fill: '#ddd6b5',
			}}
		/>
		<path
			d="M96.18 172.5c.35-.25.37-.82 1.02-.84 1.36-.04 1.36-.09 1.64 1.45-.1.44-.54.55-.82.82-.43.17-.83.38-1.22.61h-.2c-.22.12-.5.14-.61.41h-.2c-.4-.08-.84-.16-.8-.7.03-.44.02-.95.58-1.15.2-.07.34-.2.43-.39.02-.11.09-.18.2-.2Z"
			style={{
				fill: '#d9d3b2',
			}}
		/>
		<path
			d="M91.89 175.35h1.43c-.21.26-.54.34-.81.35-2.41.16-4.81.11-7.15-.56 1.86 0 3.71 0 5.56.3.31.05.65-.06.98-.1Z"
			style={{
				fill: '#dad5b9',
			}}
		/>
		<path
			d="M74.74 168.01c.84-.02 1.55.09 1.23 1.22-.14.49.4.77.4 1.22-.95-.55-.98-1.7-1.63-2.45Z"
			style={{
				fill: '#dbd5bb',
			}}
		/>
		<path
			d="M96.79 174.53c.27-.47.72-.61 1.22-.61l-.61.61h-.61ZM95.97 174.94c.02-.41.32-.41.61-.4-.21.12-.26.49-.61.4ZM98.01 173.92c.2-.35.47-.62.82-.82.76-.29.43-.84.18-1.21-.48-.72-.56-1.45-.39-2.26.13-.61.71-.51.91-.31.93.95 2.19.85 3.31 1.2.02.04.04.09.07.13-.32.9-1.32 1.03-1.93 1.62-.79.77-1.84 1.35-2.97 1.64Z"
			style={{
				fill: '#dfd7b9',
			}}
		/>
		<path
			d="M101.07 165.56c.49 1.18 1.69 1.1 2.63 1.33.74.18 1.23.76 1.96.9.36.06.1.39.02.58-.3.76-1.04 1.12-1.55 1.68h-.21c-.1-.58.39-.88.61-1.3.08-.11.16-.21.24-.32.06-.66-.49-.26-.72-.41-.59-.11-1.09-.44-1.63-.67-1.29-.52-2.31-1.35-2.92-2.63-.15-.31-.33-.6-.16-.95.07-.08.15-.13.26-.14.54.09.6.58.77.96.17.37.43.67.69.98Z"
			style={{
				fill: '#e2ddbd',
			}}
		/>
		<path
			d="m104.75 168.83-.82 1.22c-.47 0-.51.69-1.02.61-.45-.57-.26-1.02.3-1.34.47-.27.89-.78 1.54-.5Z"
			style={{
				fill: '#dfd7b9',
			}}
		/>
		<path
			d="M221.52 155.16c-.08 1.43.14 2.85.14 4.27 0 1.1.3 2.5-.25 3.26-.73 1.02-1 2.42-2.24 3.07-1.21.64-2.45.86-3.78.42-.06-.02-.13 0-.2 0 .11-.7.53-.78 1.08-.51.47.23.9.26 1.34-.06.64-.47.7-.89.18-1.51-.71-.85-.72-.94.19-1.52.45-.28.5-.69.55-1.13-.03-.95.48-1.83.39-2.79 0-.1.08-.22.04-.3-.61-1.26.35-1.7 1.18-2.1.56-.27.67-1.06 1.38-1.09Z"
			style={{
				fill: '#e1d8b3',
			}}
		/>
		<path
			d="M221.52 155.16a4.81 4.81 0 0 1-2.26 1.87c-.2.08-.41.24-.31.45.68 1.4-.25 2.66-.29 4-.25-.23-.39-.48-.2-.82v-.61c.45-1.25.14-2.72-.71-3.44-.24-.2-.36-.08-.48.11-.19.31-.25.72-.65.88-.11-.93.3-1.63 1.13-1.95 1.05-.39 1.08-.49.45-1.45-.17-.25-.32-.51-.39-.81-.13-.98-.47-1.93-.38-2.93.38.17.49.54.6.89.1.33.19.75.48.86.83.31.84 1.06 1.04 1.7.51 1.61.49 1.62 1.95.83v.41Z"
			style={{
				fill: '#dfd5ae',
			}}
		/>
		<path
			d="m218.46 160.67.2.82c.16.66.07 1.18-.7 1.37-.7.17-.6.54-.18.9.51.44.99.85.49 1.58-.58.83-1.21.99-2.12.5-.5-.27-.74-.06-.95.35h-.41c.29-.75 1.1-.97 1.54-1.66.75-1.2 1.3-2.48 2-3.7.03-.06.09-.1.14-.14Z"
			style={{
				fill: '#e1d5ad',
			}}
		/>
		<path
			d="M221.52 153.94c-.32-.27-.42-.62-.4-1.02.32.27.42.62.4 1.02Z"
			style={{
				fill: '#e1d8b3',
			}}
		/>
		<path
			d="M57.8 158.02h.41c.06-.07.14-.1.23-.08.29.08.55.24.83.35.2.08.4.11.62.1l.27-.03c.47-.04.75-.38 1.06-.68.49-.48 1.05-.77 1.76-.66.09.13.13.27.13.43-.01.14-.03.27-.1.39-.24.43-.65.84-.23 1.38.41.53.96.74 1.61.68.85-.08 1.69-.19 2.52-.35 1.72-.34 3.46-.57 5.04-1.47.89-.51 1.58-1.12 2.04-2.02.81-.86 1.77-.51 2.7-.31.2.04.36.18.34.43-.52.28-1.03.59-.86 1.3.22.94-.26 1.39-1.12 1.71.24.24.4.52.57.79.28.43.5.83 1.16.75.42-.05.81.26.83.73.02.45-.34.52-.72.47-.81-.21-1.45.29-2.1.58-.97.44-1.99.63-2.98.95-1.29.42-2.6.43-3.89.64-1.44.24-2.67 0-3.67-1.19-.97-1.17-2.3-2.01-3-3.43-.36-.72-1.26-.31-1.82-.67-.6-.16-1.16-.41-1.63-.81Z"
			style={{
				fill: '#e0dab8',
			}}
		/>
		<path
			d="M59.43 158.83c1.15-.14 1.92.1 2.58 1.3.77 1.42 2.22 2.4 3.44 3.5.64.58 1.57.34 2.36.23.5-.07 1.01-.06 1.5-.15 1.66-.29 3.36-.46 4.88-1.25.69-.36 1.47-.48 2.14-.91.26-.17.61-.1.66.34-.54 1.05-1.46 1.69-2.49 2.2-.09.04-.19.08-.29.1-1.98.87-4.1 1.06-6.22 1.18-1.41.08-2.74-.44-4.04-.92-1.05-.38-2.14-.68-3.1-1.26-.39-.23-.7-.16-1.01.12h-.2v-.2c-.15-1.16.04-1.37 1.11-1.22.36.05.7.05.89-.3.18-.32 0-.6-.23-.82-.56-.54-.58-1.58-1.57-1.74-.17 0-.32-.04-.41-.2Z"
			style={{
				fill: '#ece7c8',
			}}
		/>
		<path
			d="M59.84 159.04c.62.11 2.19 1.74 2.22 2.31.03.56-.75 1.14-1.3.86-1.18-.6-1.05.24-1.12.91-.42-.62-.23-1.14.28-1.6.96-.86.93-1.66-.08-2.48Z"
			style={{
				fill: '#efe9d1',
			}}
		/>
		<path
			d="M59.83 163.32c0-.59-.03-1.02.83-.56 2.13 1.16 4.42 2.16 6.82 2.28 1.52.07 3.21.31 4.73-.52.63-.34 1.41-.4 2.12-.59-.03.62-.59.64-.99.84-1.04.52-2.19.45-3.3.59-3.13.96-5.93-.42-8.79-1.37-.06.35.09.46.21.56.6.5 3.2 1.43 3.98 1.3.98-.17 1.35.84 2.16.97.22.04.4.25.6.38l.41.41c-2.17-.52-4.39-.83-6.43-1.81-.39-.19-.62-.66-1.12-.63-.71-.41-.99-1.11-1.23-1.83Z"
			style={{
				fill: '#e2dcbb',
			}}
		/>
		<path
			d="M61.47 149.65h-.41c-1.03-.73-.27-1.24.24-1.76.58-.59 1.28-.74 1.99-.32.29.17 0 .48-.14.7-.41.64-1.15.88-1.67 1.38Z"
			style={{
				fill: '#f8f2e4',
			}}
		/>
		<path
			d="M67.39 146.19c.97.21 1.14.55.61 1.22.12-.57-.41-.81-.61-1.22Z"
			style={{
				fill: '#ebe7d4',
			}}
		/>
		<path
			d="M66.57 151.69c.29 0 .5-.14.61-.41 1.8-.59 2.65-1.84 2.5-3.71-.05-.65.24-.8.75-.77 1.13.06 2.25.04 3.26.77 1.06.76 1.94-.16 2.77-.61 1.75-.97 3.56-1.91 5.52-1.95.78-.02 1.77-.65 2.55.15l.12.12c.24.55.13 1.13.13 1.7-.02.18-.08.34-.18.48-.85.78-1.89.63-2.91.58-.11-.01-.21-.04-.32-.07-1.13-.17-2.25-.2-3.34.19-.18.08-.37.17-.54.27-.87.49-.87.62-.04 1.2.33.23.69.44.65.93a.33.33 0 0 1-.22.21c-.72-.08-1.27-.48-1.71-.99-.7-.81-.47-1.68.52-2.13.74-.34 1.52-.54 2.33-.63 1.12-.12 2.23-.21 3.32.18.29.1.6.13.9.05.53-.14.68-.52.65-1.01-.04-.58-.46-.44-.83-.45-1.78-.08-3.42.37-4.98 1.19-1.41.56-2.74 1.31-4.11 1.96-.69.33-1.13 1.05-1.84 1.4-.12.06-.23.18-.2.33.05.25.28.26.48.29.84.12 1.7-.02 2.54.09.46.06 1.15-.11 1.19.71-1.49.4-3.04.36-4.49.07-1.15-.22-2-.12-2.84.62-.2.17-.39.37-.65.48-.05 0-.11-.01-.16-.02-.22-1.51-1.4-.89-2.25-1.02.21-.3.54-.17.82-.21Z"
			style={{
				fill: '#ded9b8',
			}}
		/>
		<path
			d="M65.55 152.1c-.76.7-1.82.75-2.68 1.27-.77.47-1.68.85-2.62.97.28-.61 0-1.18-.18-1.73-.1-.3-.5-.6-.12-.86.5-.34.82-1.05 1.57-.9.98.19 1.93.51 2.7 1.17.45.38.88.18 1.33.08Z"
			style={{
				fill: '#e0ddbd',
			}}
		/>
		<path
			d="M60.04 158.63h-.2c-1.24-.99-1.17-2.24.24-3.07.63-.37.98-1.14 1.8-1.21.64-.6 1.52-.72 2.27-1.1.6-.3 1.24-.48 1.8-.9.59-.44 1.11-.38 1.04.57-.84.89-1.89 1.5-2.93 2.11-.48.28-.87.6-1.21 1.03-.81.98-1.7 1.89-2.79 2.57Z"
			style={{
				fill: '#d1cba5',
			}}
		/>
		<path
			d="M61.88 154.35c-.79.6-1.48 1.3-2.32 1.85-.45.29-.38 1.55.03 1.91.16.15.24.31.26.52-.23 0-.47.04-.61-.2-.22-.23-.55-.27-.82-.41h-.2c-.15-.7-.82-.62-1.27-.83-1.05-.48-1.88-1.28-2.84-1.89.04-.2.29-.3.35-.26.89.6 1.82-.01 2.73.1.93.12 1.89.02 2.84.02.34 0 .57-.2.77-.44.3-.35.68-.41 1.1-.38Z"
			style={{
				fill: '#d3caa7',
			}}
		/>
		<path
			d="M60.04 158.63c1.03-1.15 2.04-2.37 3.18-3.33 1.09-.92 2.38-1.79 3.76-2.38v.21c.14.36-.15.53-.33.74-1.28 1-2.6 1.98-3.75 3.13-1.14.22-1.68 1.48-2.86 1.63Z"
			style={{
				fill: '#dad4b0',
			}}
		/>
		<path
			d="m66.57 153.73.41-.61c.36.02.71-.01 1.02-.2-.1.8-.41.98-1.43.81Z"
			style={{
				fill: '#ded9b8',
			}}
		/>
		<path
			d="m39.37 174.28.2.2c.41-.05.53.21.6.53.28 1.33.57 2.65.51 4.02-.04.93-.28 1.73-1 2.35-.11.12-.23.23-.36.33-.29.21-.58.42-.98.32l-.2.2c-.45 0-.73.53-1.22.41.83-.9 2.26-1.05 2.86-2.24.05-.67-.18-.76-1.02-.41-.24-.03-.61-.13-.46-.37.4-.64.21-1.31.24-1.97.02-.43.33-.53.59-.73.51-.39.94-.79.31-1.47-.28-.3-.31-.76-.08-1.17Z"
			style={{
				fill: '#e2d9b1',
			}}
		/>
		<path
			d="m39.17 181.63.2-.2c1.68-1.25 1.41-3.02 1.25-4.76-.03-.32-.28-.63-.02-.95.51.58 1.18.76 1.97.66-.14.52-.73.34-.86.83.96.39.79 1.22.68 2.02-.07.48-.14.93-.12 1.44.02.66-.82 1.23-1.36 1.17-1.59-.18-1.9.98-2.38 1.97-.31.64-.64 1.04-1.39.68l1.63-2.24c-.09-.36.36-.35.41-.61Z"
			style={{
				fill: '#d1c89c',
			}}
		/>
		<path
			d="M43.24 179.7c.42-.44-.09-1.18.58-1.67.43-.31.12-.81-.22-1.11-.45-.4-.17-.69.13-.9.31-.22.54-.1.79.28.47.7 1.15 1.3.32 2.17-.05.05-.06.23-.02.28.62.73.24 1.18-.39 1.6-.23.16-.26.72-.61.53-.38-.2-.5-.69-.58-1.19Z"
			style={{
				fill: '#d1c996',
			}}
		/>
		<path
			d="M40.6 175.71c.61 1.61.64 3.18-.18 4.74-.25.47-.48.87-1.05.97 1.65-1.61 1-3.55.72-5.4-.08-.5.17-1.2-.51-1.54l.2-.81c.8.47.52 1.37.82 2.04ZM39.17 181.63c.04.32-.28.4-.41.61-.17 0-.32-.04-.41-.2.27-.14.54-.27.82-.41Z"
			style={{
				fill: '#dad1a6',
			}}
		/>
		<path
			d="m113.94 113.15.58-.65c-.75-.32-1.18-1.01-2.16-1.09-.84-.07-.66-1.22-.86-1.92 1.24-.33 2.5-.19 3.76-.18.64 0 1.22.13 1.38-.74.07-.39.43-.53.79-.46.4.07.22.4.22.66 0 1.13-.17 2.29 1.22 2.9.31.14.42.78.78 1.16.63.68 1.36.79 2.14.95.12.02.22.13.33.2-.23.26-.54.27-.84.28-2.28.05-4.53-.2-6.77-.62-.26-.05-.56-.1-.55-.47Z"
			style={{
				fill: '#e7e3c2',
			}}
		/>
		<path
			d="M126.59 103.77c-.02.47-.37.71-.7.95-.27.19-.5.43-.5.73 0 1.01-.6 1.33-1.46 1.38-.69.04-1.04.55-1.47.97-.09.09-.23.29-.21.31.9.95-.42 1.42-.47 2.18-.05.86.41 1.62.34 2.46 0 .07-.02.13-.02.2-1.05-.19-1.81-1.21-1.74-2.26.06-.9.04-1.8.13-2.69.12-1.11.39-1.21 1.34-.65.1.06.31.09.36.04.85-.86 2.6-.65 2.75-2.43.06-.76 1.02-.88 1.65-1.17Z"
			style={{
				fill: '#e6e3ca',
			}}
		/>
		<path
			d="M120.26 102.95c.17.02.44-.01.48.07.44.9 1.42 1.04 2.13 1.55.51.38.65 1.06.27 1.52-.34.41-.96.63-1.46.01-.08-.1-.2-.18-.32-.24-1.72-.8-1.9-1.27-1.09-2.92Z"
			style={{
				fill: '#e7e3c2',
			}}
		/>
		<path
			d="M136.19 116.21c-.55.18-1.12.21-1.7.21-2.68 0-5.31-.35-7.92-.96-.98-.23-2.03-.2-3.03-.47-.05-.05-.07-.09-.05-.14.02-.05.03-.07.05-.07h3.27c.87.48 1.84.69 2.81.68 1.95-.02 3.87.41 5.83.29.3-.02.72-.06.75.45Z"
			style={{
				fill: '#e1dbc2',
			}}
		/>
		<path
			d="M113.94 113.15c.23.3.57.14.85.22 2.4.63 4.86.67 7.32.6.39.02.59.22.61.61-.05.03-.1.07-.15.1-.97-.13-1.99.24-2.92-.3-1.76.03-3.54-.06-5.24-.47-1.08-.25-2.26-.53-3.13-1.37.88.21 1.73.57 2.65.61Z"
			style={{
				fill: '#e8dfbe',
			}}
		/>
		<path
			d="M123.53 114.78v.2c-.46.25-.77.18-.82-.41l.82.2Z"
			style={{
				fill: '#dedabc',
			}}
		/>
		<path
			d="M112.1 124.57c-.24-.46-.27-.88.2-1.22.05-.09.09-.21.17-.25 1.29-.71 1.8-1.78 1.55-3.22-.05-.27.05-.4.3-.4.58 0 .98-.37 1.45-.62.28-.03.6.09.82-.2.15-.15.34-.22.55-.23.56.14 1.03-.05 1.48-.37.76-.12 1.52-.14 2.28 0 .35.26.82.42.88.95.17.61-.09.98-.68 1.1-.33.07-.64.19-.95.31-.87.29-1.78.34-2.69.39-.45.02-.87.09-1.21.5.78.54 1.65.49 2.51.5.3 0 .6-.14.88.05.15.49-.28.59-.55.69-1.01.38-1.48 1.25-1.97 2.1-.28.48-.21.98.1 1.44.33.49.79.35 1.28.33 1.5-.07 2.37-1.22 3.48-1.95.89-.58 1.52-1.44 2.2-2.24.53-.62.36-.96-.44-1.2-.72-.22-1.39.29-2.09.07a.458.458 0 0 1-.01-.44c.82-.7 1.76-.45 2.69-.37.1.02.2.06.29.1.33.22.71.4.91.78.17.53-.02.96-.36 1.36-.23.19-.49.35-.54.69-.07.12-.15.22-.26.3-.42.34-.8.71-1.11 1.15-.32.48-.71.86-1.28 1.03-.68.11-.91.84-1.49 1.08-.21.12-.43.21-.67.26-.38.07-.78.03-1.15.16-.24.06-.48.08-.72.08-.38 0-.74-.12-1.11-.17a.764.764 0 0 1-.23-.17c-.72-1.28-.74-2.53.22-3.73-.63.46-.91.9-1.03 1.61-.12.67-.29 1.32-.98 1.66-.37-.28-.31-.68-.17-1.02.32-.79-.08-.88-.74-.99-.63-.1-1.18.3-1.79.12Z"
			style={{
				fill: '#eae5cb',
			}}
		/>
		<path
			d="M121.08 118.25h-2.65c-.27.56-.86.14-1.23.41h-.61v-.2c-.06-.19.05-.28.19-.35.39-.14.81-.06 1.2-.21.1-.03.21-.06.31-.07 1.04-.11 2.09.05 3.13-.12.18-.01.33.03.47.15.84.07 1.68.11 2.52.21 1.29.15 2.55-.15 3.81-.27 1.13-.12 2.25.21 3.4-.07.55-.14 1.26.16 1.94.09.82-.08.93.71 1.19 1.27-.08.67-.65.67-1.07.64-1.38-.08-1.52.59-1.4 1.74.12 1.18.18 2.37-.05 3.55-.04.2-.19.36-.23.56 1.13-.28 1.41-.1 1.5.96-.29.77-.91 1.44-.67 2.39.07.29-.23.56-.47.75-1.46 1.14-3.01 1.87-4.87.91a.388.388 0 0 0-.3-.04c.02.85-.26 1.2-1.17 1.15-1.44-.08-2.75.39-4.08.78-1.11.33-1.97.04-2.54-.96-.13-.24-.28-.47-.33-.74-.14-.72-.49-1.09-1.28-1.19-.95-.12-1.51-.77-1.59-1.61-.04-.43-.08-.92.59-.93.34.08.68.2 1.02 0h.82c.38-.26.86.13 1.22-.2l.61-.2c.24-.2.46-.07.67.05.39.28.8.05 1.02-.16.87-.84 2.05-1.33 2.75-2.38.61-.91.33-2.03.66-3.01.08-.24-.25-.35-.48-.42-.19-.04-.37-.09-.53-.21-.28-.24-.76.06-.98-.35-.4-.54-.04-1 .26-1.5-.96-.26-1.92.07-2.75-.39Z"
			style={{
				fill: '#e7e3c3',
			}}
		/>
		<path
			d="M108.43 110.7c.77-.12 1.39.35 1.51.92.23 1.1 1.07 1.53 1.86 1.81 1.28.45 2.57 1.02 3.98.94 1.03.23 1.99.72 3.11.61.74-.07 1.47-.03 2.21-.23 1.03-.28 2.49.91 2.49 1.97 0 .58-.4.75-1.29.57-.05-1.22-.32-1.4-1.62-1.1-.87.2-1.73.44-2.64.51.49.42 1.07.24 1.61.29.58.05.58.04.78.54-.97.39-2.03.2-3.03.48-.59.17-1.21.32-1.82.45-1.43.39-1.92-.76-2.69-1.55-1.67-1.73-3.6-3.08-5.95-3.76-.12-.04-.23-.13-.34-.19-.25-.22-1-.29-.23-.8.3-.2.21-.53.23-.83.68 0 1.37.02 1.84-.61Z"
			style={{
				fill: '#dfd5ae',
			}}
		/>
		<path
			d="M122.31 117.23c.35-.06.77.17 1.02-.25.26-.44-.19-.67-.34-.97-.51-1.03-1.2-1.18-2.39-.9-1.61.39-3.33.25-4.82-.73.93.1 1.88.14 2.8.31.46.08.78.02 1.08-.31 1.02.05 2.06-.14 3.06.21.15.37.47.43.82.41.09.95.67 1.48 1.52 1.79.21.08.5.17.4.48-.07.25-.34.14-.53.18-1 .22-2.05 0-3.03.4h-.41c-1.14.28-2.33-.08-3.47.2-.38.25-.85-.06-1.22.2l-.21.2h-1.02c1.53-.84 3.19-1.02 4.9-1.02.58-.36 1.19-.49 1.84-.2Z"
			style={{
				fill: '#dfd7b5',
			}}
		/>
		<path
			d="M112.1 124.57c.71-.55 1.54-.36 2.32-.32.46.02.98.23.55.9-.25.39-.23.83-.22 1.26.57 1.07 1.41 1.97 1.89 3.1-.07.14-.19.25-.34.3-1.36-.3-1.7-1.4-1.98-2.53-.15-.59-.1-1.22-.51-1.73-.17-.15-.3-.49-.54-.39-.82.33-1.79.22-2.52.72-1.07.73-2.21 1.29-3.41 1.74-.64.24-1.11.62-1.37 1.24-.23-.02-.49 0-.7-.08-.26-.09-.47-.3-.49-.6-.02-.34.3-.3.49-.41.17-.1.33-.22.5-.34 1.36-.69 2.83-1.15 4.09-2.03.68-.48 1.56-.37 2.24-.82Z"
			style={{
				fill: '#eee8d4',
			}}
		/>
		<path
			d="M182.94 118.86c.5 0 1 .02 1.49 0 .8-.03 1.37.49 1.84.95.52.52 1.03.7 1.72.66.22-.01.44.14.66.22-.08.96-.83 1.48-1.65 1.67-1.55.36-2.89-.2-4.27-.65-.28-.42-.38-.86-.14-1.33.15-.3.17-.57-.08-.83-.72-.76-.05-.67.43-.69Z"
			style={{
				fill: '#f5f0de',
			}}
		/>
		<path
			d="M188.65 130.49c.9-.14 1.8-.26 2.69-.41 2.32-.4 4.11.58 5.69 2.15.24.24.53.42.79.63.27.23.25.55.2.85-.07.37-.33.32-.62.28-.74-.09-1.2.53-1.8.78l-.09.12c-.94.64-1.9 1.25-2.71 2.07-.35.35-.72.83-1.35.64a.583.583 0 0 1-.06-.43c1.39-1.47 2.8-2.93 4.81-3.57.25-.08.58-.12.65-.42.08-.38-.28-.51-.52-.67-.54-.35-1.01-.79-1.53-1.17-1.46-1.05-3.03-.71-4.59-.46-.5.08-.98.27-1.5.26-.21 0-.41 0-.61-.07-.1-.04-.18-.1-.25-.18v-.2c.3.03.56-.07.81-.21Z"
			style={{
				fill: '#d5cda8',
			}}
		/>
		<path
			d="M187.84 130.89h.21c-.08.54.43.79.57 1.23.78 1.03.62 2.18.6 3.38-.02 1.44-.5 2.53-1.61 3.39-.28.22-.36.48-.09.77.25.27.36.57.18.92-.86.73-1.87 1.21-2.94 1.52-.37.11-.76.14-.95.5-.52 1.01-1.46 1.16-2.43 1.16-1.3 0-2.57.11-3.81.54-.65.23-1.35.14-2.03.1-.92-.05-1.79.3-2.71.26a.406.406 0 0 1-.16-.23c.27-.39.61-.67.68-1.25.08-.65.9-.56 1.43-.72.26-.08.56.08.8-.13.95-.3 1.89-.6 2.84-.9.47-.15.93-.37 1.45-.32.92-.47 1.92-.27 2.88-.28 1.46-.02 1.69-.23 1.54-1.62.21-.49.51-.81 1.1-.92.94-.16 1.48-.91 1.56-1.86.18-2-.83-3.56-1.84-5.13-.02-.03-.05-.04-.08-.06-.33-.29-.6-.66-.32-1.06.34-.48.72-.03 1.07.12.59.52 1.27.7 2.04.61Z"
			style={{
				fill: '#d1cbaa',
			}}
		/>
		<path
			d="M185.8 130.28c-.32.11-.73-.34-.93 0-.21.36.23.61.43.91 1.15 1.7 2.2 3.42 1.94 5.63-.12.97-.87 1.58-1.52 1.66-.69.08-.92.5-1.35.79-.33.32-.7.46-1.15.3.09-.59.13-.63 1.15-1.11.56-.41 1.36-.36 1.79-1.05.88-1.42.45-2.77-.14-4.12-.18-.4-.42-.77-.63-1.15-.19-.8-1.09-1.08-1.35-1.83-.07-.21-.34-.37-.13-.62.17-.21.4-.19.65-.11.47.15 1.02.15 1.25.73Z"
			style={{
				fill: '#d5d0b2',
			}}
		/>
		<path
			d="M142.11 96.63c1.03.09 1.34 1.07 1.98 1.63.18.16-.03.47-.27.54-.28.07-.59.06-.89.08h-1.02c-.3-.25-.71.03-1.02-.2-.27-.05-.67.14-.76-.27-.09-.38.29-.42.53-.59.52-.35.97-.79 1.45-1.19Z"
			style={{
				fill: '#c5bf86',
			}}
		/>
		<path
			d="M140.88 98.67c.34.05.73-.14 1.02.2-.34-.05-.73.14-1.02-.2Z"
			style={{
				fill: '#cbbe87',
			}}
		/>
		<path
			d="M142.11 95.41c.01-1.02-.64-.38-1.02-.41.2-.42.49-.63.95-.39.41.22.34.5.08.8Z"
			style={{
				fill: '#dacfa4',
			}}
		/>
		<path
			d="m137.82 112.13.41 1.84c-.18.19-.43.29-.64.2-1.04-.47-2.2-.47-3.26-.82-.84-.28-1.82-.25-2.48-1-.93-.62-1.27-.58-1.89.29-.38.53-.59.38-.83-.12-.33-.67-.62-.68-1.06-.11-.21.28-.32.59-.36.93-.07.59-.39.99-.92 1.24-.53-.48-1.01-.74-1.86-.51-.44.12-1.31-.48-1.71-1.11-.33-.52-.51-1.05-.11-1.65.38-.58-.08-1.24.05-1.87 1.41.58 1.84.38 2.03-1.13.08-.61.28-1 .78-1.28.28.32.06.64-.03.95-.34 1.24.47 2.39 1.77 2.56.9.12 1.74.02 2.52-.46.31-.19.64-.39 1.03-.35.61.18 1.12.64 1.8.62.21 0 .43.14.46.34.15.93.89 1.04 1.57 1 .96-.06 1.76.6 2.71.44Z"
			style={{
				fill: '#e8e5cf',
			}}
		/>
		<path
			d="M137.82 112.13c-.41.32-.79.74-1.26.01-.24-.38-.72-.13-1.04-.11-.84.06-1.5-.54-2.35-.5.14-.51.64-1.19-.56-.98-.47.08-.9-.41-1.33-.68-.11-.51.27-.77.62-.92 1.1-.46 1.89-1.25 2.57-2.18.14-.2.36-.3.55-.43.88-.59 1.64-1.28 2.16-2.22.17-.31.36-.68.84-.57.04.57.04 1.14.1 1.72.09.94-.42 1.79-.86 2.59-.31.56-.24.78.38.74.16-.01.16-.03.26.12.54.81.52 2.64-.08 3.4Z"
			style={{
				fill: '#eae4d0',
			}}
		/>
		<path
			d="M138.03 103.57c-.86.74-1.24 1.89-2.22 2.54-.99.66-1.74 1.58-2.57 2.43-.55.57-1.57.5-1.95 1.35-.35.03-.63.23-.92.4-1.41.82-2.87.71-4.05-.21-.78-.6-1.11-1.24-.59-2.17.14-.26.17-.58.26-.87.73-.66.73-1.68 1.18-2.48.12-.22.06-.55.44-.57 1.58-.08 2.77-1.15 4.19-1.63 1.26-.43 2.47-1.02 3.85-1.04.42 0 .92.06 1.2-.37.28-.43.64-.89 1.11-.56.41.29.65.88.63 1.47-.03.62-.24 1.18-.55 1.71Z"
			style={{
				fill: '#eee9d6',
			}}
		/>
		<path
			d="M126.8 114.58c.33-.49.74-.9.71-1.61-.02-.35.43-.73.67-1.09.18-.27.43-.22.72-.18.49.07.46.42.46.75 0 .18-.03.36.2.38.15 0 .21-.13.25-.27.29-1.01 1.18-1.19 2.09-.42-.09.11-.2.19-.34.19-.5 0-.97.07-1.03.68-.07.67.56.61.94.83.46.26 1.14.23 1.25.95-1.96-.41-3.95.01-5.92-.2Z"
			style={{
				fill: '#eae4d1',
			}}
		/>
		<path
			d="M132.72 114.78c-.46-.41-1.01-.62-1.59-.82-.44-.15-1.06-.16-.92-.89.13-.69.47-1.16 1.29-.95.13.03.27 0 .4 0 1.21.68 2.46 1.26 3.9 1.1.33-.04.49.15.71.28.53.31 1.08.54 1.72.45.28.28.66.32 1.02.41.56.26 1.19.19 1.76.38.26.09.59.1.55.47-.04.36-.36.38-.63.35-.58-.05-1.14-.02-1.68.23-.22.2-.46.22-.73.11-.03-1.23-.05-1.27-1.4-1.28-1.12 0-2.12-.36-3.08-.87-.75-.4-1.54-.61-2.47-.76.15.59.57.69.91.84.84.35 1.69.68 2.54 1.02.26.1.71.14.48.64-1.01.29-1.71-.52-2.58-.72h-.2Z"
			style={{
				fill: '#eee9d7',
			}}
		/>
		<path
			d="M136.19 116.21c-.33-.35-.76-.17-1.15-.2-2.56-.23-5.15-.18-7.67-.81-.27-.07-.54-.06-.57-.42 1.5.55 3.11.76 4.61.51 1.1-.18 1.94.61 2.94.3 1.08-.2 2.12.05 3.17.23.19.03.38.16.29.43-.55.24-1.09.07-1.63-.04Z"
			style={{
				fill: '#e6e1ca',
			}}
		/>
		<path
			d="M139.25 115.8c.58-.67 1.4-.45 2.29-.48-.71-.75-1.77-.22-2.29-.95 1.2-.01 2.4.33 3.61.02.3-.08.79-.18.88.39-.14.01-.33-.03-.4.04-1.16 1.19-2.65.97-4.09.98ZM137.82 116.21c-1.13-.35-2.31-.43-3.47-.61-.43-.35-1.15-.2-1.43-.82.96-.13 1.67.84 2.65.61 1.04-.46 1.92.14 2.86.41h.82v.2l-.11.08c-.37-.01-.72.09-1.07.17-.09.03-.17.01-.25-.05Z"
			style={{
				fill: '#eee9d1',
			}}
		/>
		<path
			d="M133.33 126.61c.02-.59.01-1.09-.87-.9-.32.07-.65-.08-.49-.72.28-1.1.22-2.28.05-3.42-.25-1.7 0-2.04 1.64-2.1.42-.01.81-.07 1.1-.41.9.4.84 1.56 1.63 2.04.45.28.59.77.62 1.22.09 1.4.28 2.82-.31 4.19-.39.9-.32 1.92-.63 2.85-.69.91-1.19 2.01-2.32 2.52-.21.04-.41.02-.59-.1.02-.69.67-.91 1.04-1.33.52-.58 1.07-1.11 1.11-1.95-.14-1.05-.74-1.55-2-1.65-.06-.09-.05-.17.02-.25Z"
			style={{
				fill: '#e9e2c2',
			}}
		/>
		<path
			d="M138.43 116.82c1.3-.32 2.61-.29 3.91-.08.68.11 1.35.04 2.02.08.63.07 1.43-.22 1.53.84.07.75-.59 1.67-1.44 1.84-1.26.27-2.56.28-3.81.63-.16.05-.34.02-.46.2 0 .34.41.54.35.91-.39.38-.67 0-.98-.14-.21-.15-.38-.34-.47-.59.02-.66-.61-.76-.95-1.12-.19-.9-.28-1.78.31-2.59Z"
			style={{
				fill: '#d1ccab',
			}}
		/>
		<path
			d="M140.48 121.31c-.05-.08-.11-.17-.16-.25-.19-.29-.71-.45-.54-.88.17-.42.66-.19.99-.3 1.23-.4 2.53-.32 3.76-.62.69-.17 1.08-.8 1.21-1.47.07-.37-.15-.72-.63-.74-.26-.01-.55.06-.74-.21.74-.26 1.47-.52 1.64.65.05.35.25.38.47.15.16-.16.26-.39.54-.39.37.4.34.98.61 1.43-.1.11-.21.19-.35.23-.1.03-.2.04-.3.03-.3 0-.57-.45-.89-.03-.28.36-.28.72-.05 1.1-.51.41-1.01.78-1.31 1.43-.32.71-1.11.92-1.81.77-.59-.13-1.19-.17-1.78-.26-.32-.1-.59-.25-.67-.61Z"
			style={{
				fill: '#e2d9b9',
			}}
		/>
		<path
			d="M138.43 116.82c-.47.85 0 1.78-.2 2.65a6.695 6.695 0 0 0-.59 3.73c.13 1.09-.12 2.23-.42 3.31-.22.78-.62 1.5-.6 2.35 0 .32-.18.58-.51.69a.462.462 0 0 1-.32-.09c.29-2.21 1.31-4.3 1.04-6.61-.07-.62-.34-1.16-.43-1.76-.46-1.97.5-3.27 2.04-4.28Z"
			style={{
				fill: '#dfd8b6',
			}}
		/>
		<path
			d="M137.82 116.21h.2c.2-.14.41-.14.61 0-.82.38-1.63.5-2.45 0h1.63ZM139.25 116.01h2.65c-.86.38-1.77.18-2.65.2-.07-.05-.09-.09-.07-.14.02-.04.04-.07.07-.07Z"
			style={{
				fill: '#e1dbc2',
			}}
		/>
		<path
			d="M139.25 116.01v.2h-1.23c.36-.37.82-.14 1.23-.2Z"
			style={{
				fill: '#e6e1ca',
			}}
		/>
		<path
			d="M161.09 124.37c.8.25 1.59.58 2.45.61.3.25.72-.04 1.02.2.61.28 1.23-.09 1.84 0 .47.23.98.04 1.46.16.27.07.71-.31.81.22.08.43-.36.48-.63.64-1.94.47-3.88-.07-5.81-.08-1.23-.01-2.46-.53-3.67-.87-.95-.27-1.97-.36-2.81-.99-.36-.27-.77.19-1.18.1-.24-.29-.52-.53-.82-.75-.57-.39-1.01-.28-1.34.31-.11.21-.2.43-.34.62-.66.86-1.12.87-1.82.05-.09-.11-.2-.18-.32-.25-.54-.23-.83-.68-1.01-1.2-.19-.54-.51-.94-1.05-1.15-.14-.19-.05-.34.12-.41.99-.39.66-1.01.29-1.63-.22-.37-.62-.72-.03-1.11.57.53.91 1.24 1.51 1.76.28.24.68.69.31 1.23-.36.52.31.56.46.85.18.37.53.1.69-.04.52-.5 1.09-.91 1.76-1.21.29-.13.44-.42.39-.77.07-.08.14-.08.2 0 .09.16.24.2.41.2.36.73 1.49.71 1.64 1.66.9-.4 1.47.48 2.24.58.09.16.24.2.41.2.69.26 1.26.79 2.04.82l.82.2Z"
			style={{
				fill: '#e3dbb4',
			}}
		/>
		<path
			d="M156.19 113.56c.92.27 1.35 1.2 2.21 1.59.41.19-.29.52-.17.85-.93.63-1.89 1.15-3.06.61-1.3-.85-2.38-.6-2.65.61-.59-.51-.77-1.56-.41-2.45.36-.26.38-.14 1.32-.24.3-.03 1.02-.36 1.13-.98.54-.18 1.09-.42 1.63 0Z"
			style={{
				fill: '#e5dcbb',
			}}
		/>
		<path
			d="M148.23 118.86c-.17.28-.16.5.07.8 1.02 1.31.93 1.66-.48 2.26-.07.07-.16.11-.25.14-.24.03-.47-.02-.71 0-.49.05-.95.06-1.17-.53-.18-.51-.3-.98.26-1.35.12-.08.14-.23.2-.35.5-.26.76-.73 1.06-1.18h.41c.15.24.39.2.61.2Z"
			style={{
				fill: '#dfdbb2',
			}}
		/>
		<path
			d="M152.11 114.78c.02.84.12 1.66.41 2.45v.2c.04.71.57 1.64-.69 1.82-1.02.15-2.1-.88-2.18-1.89-.08-.97.23-1.78.71-2.58.18-.3.38-.46.73-.42.3.4.04.7-.2.99-.33.41-.48.89-.61 1.38-.18.68.3 1.37.99 1.46.34.04.51-.14.56-.44.06-.34.12-.71-.02-1-.36-.76-.53-1.57-.72-2.38.62-.55.7.24 1.02.41Z"
			style={{
				fill: '#eee8c8',
			}}
		/>
		<path
			d="M155.17 116.62c1.06-.03 2.11-.07 3.06-.61h.2c-1.3 1-2.88 1.51-4.3 2.31s-1.58 1.11-.6 2.38h-.2c-.71-.18-.95-.67-.66-1.3.29-.62.01-1.74 1.28-1.63.1 0 .34-.3.33-.46 0-.65.46-.63.88-.69Z"
			style={{
				fill: '#e3dbb3',
			}}
		/>
		<path
			d="M153.82 116.76c.04.07.11.14.11.21.01.12.04.29-.14.3-.06 0-.17-.11-.19-.19-.04-.14.04-.25.22-.32Z"
			style={{
				fill: '#e5dcbb',
			}}
		/>
		<path
			d="M152.32 109.07h-.2c-.07-1.21.28-2.3 1.02-3.26.05.82-.33 1.52-.61 2.24.07.37.08.72-.2 1.02Z"
			style={{
				fill: '#e0d9b4',
			}}
		/>
		<path
			d="M156.19 113.56h-1.63c.54-.61 1.09-.61 1.63 0Z"
			style={{
				fill: '#e4ddbb',
			}}
		/>
		<path
			d="M152.32 109.07c.05-.34-.14-.73.2-1.02.69-.1 1.38-.22 2.07-.28.28-.02.66-.02.74.36.07.32-.24.43-.47.59-.8.54-1.6.94-2.55.35Z"
			style={{
				fill: '#e1dabf',
			}}
		/>
		<path
			d="M151.5 111.72c-.37.07-.58.52-1.02.41.26-.33.44-.87 1.02-.41Z"
			style={{
				fill: '#e4ddbb',
			}}
		/>
		<path
			d="M157.22 121.72h-.41c-.11.13-.25.11-.4.07-.42-.81-1.27-.91-2.01-1.2-.78-.85-.79-1.34-.04-1.72 1.17.11 1.89-.84 2.86-1.22.07.6.16 1.2.2 1.8.02.36.18.71-.3 1.03-.47.32-.08.83.11 1.24Z"
			style={{
				fill: '#ccc28f',
			}}
		/>
		<path
			d="M169.26 130.08c-.31 1.26-1.47 1.29-2.28 1.16-1.93-.29-3.88-.6-5.63-1.66-.7-.42-1.48-.94-2.38-.92-.64.02-.89-.78-1.55-.63-.15-.61-.73-.83-1.33-1.32 1.51-.26 2.7.22 3.82.74.98.45 1.9.87 2.99.59.42-.11.86-.29.91.45.02.29.38.35.61.49.64.41 1.48.45 1.98 1.14.19.26.62.25.85.09.38-.26.78-.31 1.31-.12-.15-.57-.56-.44-.75-.65-.4-.44-.64-.95.06-1.21.66-.25 1.31-.61 2.06-.61.58 0 .75.16.34.68-.25.31-.36.67-.85.78-.73.15-.07.66-.16.99Z"
			style={{
				fill: '#b9ab73',
			}}
		/>
		<path
			d="M165.87 114.62c-.9-.28-1.68-.63-2.54-.29-.3.12-.75.15-.88-.24-.12-.36.27-.61.51-.79 1-.72 2.61-.05 2.91 1.31Z"
			style={{
				fill: '#cdc38b',
			}}
		/>
		<path
			d="M154.36 118.86c-.7.64-.2 1.13.2 1.63.55.29 1.25.37 1.48 1.1-.02.04-.04.08-.06.13-.71-.42-1.42-.83-2.12-1.27-.4-.26-.77-.61-.63-1.14.14-.53.61-.66 1.11-.65v.2Z"
			style={{
				fill: '#d0c99e',
			}}
		/>
		<path
			d="M157.83 123.14c-.34 0-.67.02-.95-.23-.4-.36-.81-.41-1.24-.01-.11.1-.29.21-.46.08-.2-.16-.02-.29.06-.43.24-.41-.13-.49-.35-.68-.33-.3-.92-.36-.94-.96l3.88 2.24ZM160.28 124.16c-.91.3-1.43-.38-2.04-.82.78.03 1.37.52 2.04.82Z"
			style={{
				fill: '#e3dbb3',
			}}
		/>
		<path
			d="M156.4 121.72h.41l.2.41c-.36-.09-.74-.13-1.02-.41.14-.13.27-.12.41 0ZM155.38 118.25c-.15.37-.47.43-.82.41.21-.26.49-.38.82-.41Z"
			style={{
				fill: '#d0c99e',
			}}
		/>
		<path
			d="M175.79 128.04h-1.02c.11-.66.71-.44 1.05-.48.85-.11 1.6-.33 2.22-.94l.2.41c-.16.35-.49.48-.82.61-.55.11-1.13.1-1.64.41Z"
			style={{
				fill: '#bbab75',
			}}
		/>
		<path
			d="m177.43 127.63.82-.61c-.03.53-.38.63-.82.61Z"
			style={{
				fill: '#b7a978',
			}}
		/>
		<path
			d="M179.26 140.68c-.96 0-1.8.49-2.71.68-2.25.46-4.5.58-6.79.48-1.37-.06-2.62-.53-3.92-.79-.86-.17-1.16-.98-1.27-1.76-.17-1.22.15-2.37.6-3.49.67-.39.84-.15 1.3.5.93 1.29 1.53 2.97 3.25 3.58.21.07.37.27.55.41 1.59.52 3.19.5 4.82.24 2.08-.33 3.91-1.36 5.85-2.07.35-.13.59-.31.76-.62.28-.11.59-.19.83-.35.37-.25.75-.43 1.08-.03.33.41-.09.66-.31.94-.06.08-.11.17-.16.26-.96 1.3-2.27 1.97-3.88 2.04Z"
			style={{
				fill: '#eee8d1',
			}}
		/>
		<path
			d="M179.26 140.68c1.44-.4 2.71-1.12 3.88-2.04.49-.04.78-.49 1.22-.61v.41c-.21.57-.87.61-1.22 1.02-.83 1.07-1.89 1.62-3.27 1.43h-.61v-.2Z"
			style={{
				fill: '#e1dcc2',
			}}
		/>
		<path
			d="M146.6 135.38c2.53.69 4.96 1.57 6.53 3.88.47.61.54 1.28.26 1.99-.33.83-.19 1.72-.31 2.58-.09.63.41 1.09.98 1.38.44.55 1 .87 1.71.99.76.13 1.55.21 2.17.78.31.28.72.08 1.08.15.35.06.75-.21 1.05.16-.88.81-1.9.34-2.87.3-.36-.02-.71-.21-1.07-.32-.34-.14-.7-.19-1.06-.27-.71-.2-1.2-.69-1.69-1.2-.57-.59-1.12-.84-1.69.01-.11.16-.29.27-.45.39-.34.11-.31.76-.85.57-.15-.23-.16-.48-.11-.74.06-.26.22-.46.43-.62.98-.82 1.09-1.08.42-2.13-.88-1.38-1.66-2.84-2.89-3.96-.1-.27-.22-.55-.09-.85.88-.46.97-1.09.24-1.65-.32-.09-.6-.31-.93-.3-.68 0-.93-.37-.94-.99.02-.04.04-.09.06-.13Z"
			style={{
				fill: '#e9e2c6',
			}}
		/>
		<path
			d="M133.12 131.71h.61c.05.64-.52.55-.86.74-.08.04-.17.08-.26.13-1.37.59-2.61 1.45-4.11 1.74-.09.04-.19.07-.28.1-1.44.24-2.71 1.12-4.22 1.08-.2 0-.42.07-.51.28-.1.26.07.45.23.63.22.23.52.31.82.36 1.62.29 3.24.26 4.86.05.71-.22 1.36-.59 2-.93.84-.45 1.71-.78 2.68-.76.43 0 .78-.16 1.12-.38 1.58-.62 3.26-.36 4.89-.56.13-.02.25.09.34.19.43.37.95.13 1.43.2.35.05.74-.12 1.03.2-.42.41-.96.28-1.45.27-2.21-.03-4.37.25-6.51.78-1.24.27-2.62.18-3.57 1.28-.22.14-.45.24-.7.3-1.36.18-2.63.76-4.06.72-1.2-.04-2.32-.37-3.44-.66-.56-.15-1.36.18-1.67-.65-.12-.92 1.04-2.5 1.89-2.42 1.33.12 2.53-.32 3.78-.61 1.3-.47 2.69-.66 3.91-1.36.09-.04.18-.07.27-.09.41-.09.73-.36 1.09-.54.21-.08.42-.22.65-.07Z"
			style={{
				fill: '#e6e0bf',
			}}
		/>
		<path
			d="M140.47 134.37c-1.75.32-3.58.05-5.3.61-.2.14-.43.22-.66.26-.73.13-1-.2-.78-.93.35-1.13.81-2.22 1.22-3.33.11-.24.21-.48.49-.58.1-.02.2 0 .3.04.18.14.21.33.2.54-.01.1-.03.19-.06.29-.2.83-.09 1.73-.72 2.47 1.6.2 3.09.67 4.58 0 1.35-.11 2.75-.32 4.05-.09 1.24.22 2.5.46 3.73.82 1.2.35 2.3.98 3.54 1.23.53.11.88.52 1.18.92.35.46.73.89 1.12 1.31.5.54.76.07 1.05-.25.1-.11.22-.18.37-.21.15-.01.29.03.4.14-.46.52-.78 1.23-1.63 1.23-.88-.47-1.24-1.49-2.12-1.99-2.89-1.65-5.97-2.58-9.33-2.5-.54.01-1.08 0-1.62 0Z"
			style={{
				fill: '#d4caa2',
			}}
		/>
		<path
			d="M160.07 147.21c-1.77.33-3.3-.7-4.98-.91-.46-.06-.84-.51-1.14-.92-.69-.47-.86-1.11-.85-1.93.02-1.28.37-2.51.44-3.78.96.73.62 1.9.38 2.59-.73 2.05.56 3.71 2.54 3.72.48 0 .91.14 1.19.46.65.74 1.38.65 2.21.42.51-.14 1.04-.26 1.59-.27.77-.02 1.18.22 1.08 1.04.17.18.18.37.07.58-.08.07-.17.09-.27.07-.08-.07-.16-.15-.17-.24-.04-.95-.56-1.08-1.35-.82-.19.06-.4.06-.6.02-.05 0-.09-.02-.14-.02Z"
			style={{
				fill: '#e1dcbc',
			}}
		/>
		<path
			d="M162.52 148.23v-.61c.29-.23.18-.56.21-.85.18-1.77 1.41-2.9 2.55-4.07.32-.33.83-.44 1.33-.38.34.14.68.27 1.02.41.85.37 1.86.26 2.65.82.56.37 1.28.02 1.84.41h.2c.16-.21.49-.18.61-.47.41-1 .67-1.11 1.84-.95-.23.27-.59.27-.89.4-.22.09-.52.15-.39.45.39.85-.28.84-.76.99-.65.17-1.31.04-1.97.03-1.24-.44-2.58-.53-3.77-1.19-.66-.37-1.21-.23-1.74.47-1 1.33-2.09 2.58-2.24 4.35-.02.27-.08.63-.51.65-.1-.15-.12-.29 0-.43Z"
			style={{
				fill: '#dad3ac',
			}}
		/>
		<path
			d="M134.76 135.58c2.68-.73 5.41-.9 8.17-.82h.82c.51.37 1.22-.24 1.68.36-.54.51-1.19.41-1.81.28-1.05-.21-2.07-.17-3.12.08-1.29.31-2.63-.02-3.93.33-.84.22-1.58.82-2.52.68-.23-.07-.35-.22-.35-.46.33-.23.79-.11 1.07-.45Z"
			style={{
				fill: '#e9e2c8',
			}}
		/>
		<path
			d="M153.54 139.66c.24 1.27-.22 2.49-.22 3.75 0 .75.15 1.4.63 1.96-.87-.36-1.17-.93-1.13-1.95.05-1.4.78-2.74.32-4.17.27 0 .4.14.41.41Z"
			style={{
				fill: '#e5dec0',
			}}
		/>
		<path
			d="M145.37 135.18c-.46-.49-1.18.08-1.63-.41.99 0 2.02-.14 2.86.61-.06.07-.12.12-.2.15-.08.02-.17.03-.26.04-.13 0-.26-.03-.38-.08-.16-.07-.31-.15-.39-.32Z"
			style={{
				fill: '#e9e2c6',
			}}
		/>
		<path
			d="M179.88 140.89c1.28-.03 2.24-.82 3.27-1.43l1.22-.2c.2.36.64.68.18 1.15-.4.41-.68.8-1.46.66-1.04-.18-2.14 0-3.22.02v-.2Z"
			style={{
				fill: '#d2cab0',
			}}
		/>
		<path
			d="M174.77 142.52c-.59.26-1.8-.4-1.55 1.14.08.47-.59.2-.9.29.39-1.93 1.9-1.64 3.27-1.63-.21.3-.54.17-.82.2ZM170.28 143.54c-.85-.38-1.92-.06-2.65-.82.99-.06 1.93.03 2.65.82ZM172.12 143.94c-.63-.05-1.33.18-1.84-.41.61.13 1.36-.33 1.84.41Z"
			style={{
				fill: '#ded7b4',
			}}
		/>
		<path
			d="m154.77 137.62-.2.2c-.39.19-.65.76-1.22.41-.45-.4-.85-.83-1.21-1.32-.42-.57-.94-.97-1.79-1.1-.88-.13-1.73-.67-2.62-.96-.78-.26-1.53-.47-2.34-.49-.2 0-.51.04-.59-.06-.73-1.02-1.77-.31-2.62-.4-.79-.08-1.67 0-2.52.05-.85.14-1.7.13-2.56.14-.35 0-.69-.07-.87-.41-.21-.39.09-.62.28-.89.42-.59.94-.94 1.71-.87.47.04.94.02 1.42-.06.52-.08 1.02.02 1.35.5.28.41.72.48 1.15.58.25.06.06-.19.14-.26 1.12-.49 2.22-1.08 3.5-.61-.23 1.73-.08 1.83 1.62 1.19.93-.35 1.88-.19 2.8.07.57.16.46.69.38 1.12-.11.56-.12.88.64.82.93-.07 1.44.62 1.86 1.35.99-.29 1.34-1.38 2.27-1.75.28-.11.15-.41 0-.62-.2-.29-.48-.47-.8-.6-.31-.13-.72-.2-.87-.5-.55-1.15-1.52-1.72-2.65-2.1 0-.11.04-.2.14-.26.72-.32 1.4.05 2.09.15.38.21.8.33 1.23.43.66.36 1.34.38 2.01.05.57-.28 1.15-.27 1.74-.11h.41s.05.05.08.06c.52.25 1.21-.36 1.6.23.35.53-.48.91-.39 1.48.03.18-.15.38-.16.58-.05.91.03 1.91-1.42 1.44-.12-.04-.25.1-.27.25-.09.56-.62.72-.98.71-1.21-.05-1.72.83-2.34 1.58Z"
			style={{
				fill: '#d1c898',
			}}
		/>
		<path
			d="M154.77 137.62c.25-1.12.79-1.55 1.89-1.73.42-.07 1.3.24 1.09-.84-.04-.22.4-.43.82-.28.8.29.61.17.9-.54.3-.73-.06-1.63.68-2.25.31-.25-.05-.43-.35-.47-.39-.05-.82.15-1.15-.2.52.04 1.01-.05 1.47-.32.19-.11.39-.1.57.05.21.18.22.41.11.64-.47 1.01-1.02 1.99-.95 3.17.02.37-.32.45-.62.57-1.03.43-2.06.86-3.07 1.36-.38.19-.8.4-.99.85h-.41Z"
			style={{
				fill: '#d1c99d',
			}}
		/>
		<path
			d="M157.22 128.65c.75.8.56 1.52-.49 1.84-.42.13-.83.27-1.14.6l-.61.2c-.08.07-.16.08-.24.01-.07-.21.04-.36.16-.51.13-.14.28-.24.43-.35.36-.88 1.29-1.16 1.89-1.8Z"
			style={{
				fill: '#e4dbb9',
			}}
		/>
		<path
			d="M158.23 131.3c-1.03-.24-1.92.54-2.94.41-.32-.04-.68.11-.94-.2.2-.17.41-.14.61 0 .65.07 1.23-.14 1.84-.34.43-.14.98-.24 1.42.14Z"
			style={{
				fill: '#d1c99d',
			}}
		/>
		<path
			d="M154.97 131.5h-.61c-.39 0-.81.07-1.02-.4.03-.04.07-.07.1-.11.13-.07.28-.1.43-.11.36 0 .68.11.91.41h.2v.2Z"
			style={{
				fill: '#d4cba3',
			}}
		/>
		<path
			d="M150.07 124.16c.07.01.16 0 .19.05.93 1.1 1.26 1.04 1.87-.42.24-.58.82-.84 1.19-.66.49.24 1.34.34 1.24 1.24-.45.25-.58 1.02-1.37.77-.2-.07-.27.33-.26.57.02.38.08.79.52.88.46.09.78.35 1.11.64-.6.45-1.35.3-1.83.04-1.11-.6-2.19-1.33-2.84-2.5-.03-.23.01-.43.18-.6Z"
			style={{
				fill: '#e5dbb9',
			}}
		/>
		<path
			d="M150.07 124.78c.74.93 1.69 1.63 2.66 2.26.46.3 1.21.14 1.83.19.34.14.68.28 1.02.41v.2c-1.22.46-3.25.05-4.08-.82-.71-.75-1.68-1.27-2.14-2.26a.543.543 0 0 1 .01-.31c.44-.33.49.16.69.33Z"
			style={{
				fill: '#ebe2c4',
			}}
		/>
		<path
			d="M168.04 126.2c.15-.24.53-.34.45-.77-.7.03-1.42.11-2.08-.25h2.42c.28 0 .68-.09.7.35.02.35-.29.53-.59.6-.29.07-.6.05-.9.07ZM164.56 125.18c-.34-.05-.74.14-1.02-.2.34.05.74-.14 1.02.2Z"
			style={{
				fill: '#e3dbb3',
			}}
		/>
		<path
			d="M157.22 128.65c-.03.16-.01.43-.1.47-.75.34-1.28.91-1.74 1.57a.696.696 0 0 1-.17-.25c-.13-.57.1-.98.56-1.28.31-.2.59-.43.84-.71h.6c0 .07.01.13.01.2Z"
			style={{
				fill: '#ebe2c4',
			}}
		/>
		<path
			d="M156.6 128.45c0 .36-.03.69-.46.8-.66.17-.82.64-.77 1.24-.46.31-.97.35-1.47.19-1.19-.37-2.45-.52-3.5-1.29-.19-.14-.4-.25-.62-.34-2.11-.85-3.17-2.97-2.61-5.23.18-.71.87-.9 1.5-.42.4.3.51.79.77 1.18.69 1.13 1.93 1.73 2.7 2.79.14.2.38.3.63.27.95-.11 1.86.2 2.8.21.27.2.51.46.82.61h.2Z"
			style={{
				fill: '#efe9d0',
			}}
		/>
		<path
			d="M156.4 128.44c-.49.08-.67-.24-.82-.61.41.01.63.29.82.61Z"
			style={{
				fill: '#ebe2c4',
			}}
		/>
		<path
			d="M88.21 139.87c.72-.27.66-1.44 1.63-1.43h1.02c-.13.63-.81.71-1.15 1.14-.27.34-.73.58-.82.99-.28 1.35-1.36 1.67-2.44 2.02-.08.04-.16.07-.23.1-.28.13-.4.4-.54.65-.06.11-.14.21-.21.31-.21.28-.29.61-.39.93-.08.21-.14.43-.29.61-.09.05-.17.04-.25-.03-.39-1.47.31-2.58 1.64-3.45.73-.48 1.56-1.02 2.03-1.85Z"
			style={{
				fill: '#e6e2c8',
			}}
		/>
		<path
			d="M78.41 141.09c-.07-.18-.2-.38.06-.51.06-.03.17.03.26.04l-.12.47h-.2Z"
			style={{
				fill: '#eeead9',
			}}
		/>
		<path
			d="M106.38 136.6c.24-.44.66-.52 1.1-.63 1.22-.32 2.51-.49 3.6-1.21.11-.11.24-.18.4-.19.88 0 1.77.01 2.65-.08 1.58-.16 2.69.48 3.48 1.78.2.32.42.57.77.77.93.54 1.46 1.46 1.36 2.45-.09.92-.4 1.94-1.58 2.25-.78.2-1.18.72-1.12 1.58.03.44-.08.88-.19 1.31-.05.15-.12.28-.25.38-.46.09-.91 0-1.36-.1-.78-.9-1.71-1.62-2.74-2.22-.11-.08.02.03-.09-.05q-.68-.52-1.38-.23c-.57-.04-1.09-.31-1.67-.37-.48-.05-1.12-1.34-1.04-1.99.03-.27.1-.53.06-.8-.05-.38.06-.75-.65-.73-.78.02-1.41-1.03-1.35-1.91Z"
			style={{
				fill: '#e3dcb5',
			}}
		/>
		<path
			d="M106.38 136.6c.39.84.54 1.87 1.94 1.69.29-.04.54 1.12.32 1.51-.37.66.2.89.28 1.32.12.63.33.8 1 .69.34-.06.77.32 1.15.5.14.26 0 .49-.08.73-.14.31-.19.63-.24.96-.18.99-.86 1.32-1.79.95.23.85.05 1.68-.26 2.5-.3.32-.63.61-.92.95-.76.87-1.55 1.68-2.9 1.55-.74-.07-1.33.68-2.12.59-1.09-.97-2.1-.74-3.13-.22-.67.34.45.68-.07.96-.98.66-2.05.37-3.05.18-.8-.16-.61-.82-.29-1.37.26-.27.6-.27.93-.31 2.44-.3 4.48-1.59 6.59-2.69.43-.22.41-.88.99-.9.75-.94 1.05-2 .83-3.19-.01-.07-.02-.14-.01-.2.35-1.72.04-3.3-.91-4.78-.21-.34-.21-.68.35-.82.48-.12.92-.39 1.37-.59Z"
			style={{
				fill: '#dfd9b8',
			}}
		/>
		<path
			d="M111.49 134.77h-.41v-.2c.94-.38 2.12-.07 2.86-1.02 1.13-.22 2.26-.39 3.35.17.71.36 1.4-.05 2.1-.03 2.29.25 4.58.33 6.87.02.33-.04.68-.03.94.26-1.19.46-2.38.85-3.69.64a.609.609 0 0 0-.3 0c-.42.07-1.56 1.75-1.52 2.22-.07.06-.15.1-.24.1-.14-.02-.26-.08-.38-.14-.34-.18-.67-.12-1 .02-.4.22-.27.54-.15.85.13.34.28.66.3 1.03 0 .15-.06.29-.18.38-.1.02-.25.03-.28-.05-.43-1-1.27-1.69-1.86-2.55-1.08-1.58-2.5-2.01-4.21-1.84-.73.07-1.48-.11-2.2.16Z"
			style={{
				fill: '#e8e1c1',
			}}
		/>
		<path
			d="M102.3 137.01c.85-.15.97.87 1.63 1.02 1.44 2.39 1.11 4.97.82 7.55-.17.26-.16.65-.56.73-.09 0-.18-.02-.26-.06-.18-.36.2-.63.16-.97-.01-.08-.02-.16-.04-.25-.06-.21-.21-.38-.2-.61.36-1.28-.22-2.5-.28-3.75-.06-1.32-.98-2.31-1.34-3.52.02-.04.04-.09.06-.13Z"
			style={{
				fill: '#e9e5ce',
			}}
		/>
		<path
			d="m104.14 146.19.61-.61v.61c-.28.78-.91 1.15-1.6 1.55-1.35.77-2.76 1.41-4.18 1.99-.78.32-1.72.24-2.59.35-.19.16-.38.17-.58.03a.24.24 0 0 1-.02-.29c1.29-.58 2.7-.79 4-1.38 1.02-.46 2.03-.91 2.95-1.55.48-.21.92-.49 1.41-.68Z"
			style={{
				fill: '#e6e1c7',
			}}
		/>
		<path
			d="M107.22 133.74c-.34 0-.74-.06-.57-.4.22-.43-.96-.86.09-1.23.68-.24 1.34-.19 2.01-.17.29 0 .52.22.61.49.1.32-.17.5-.4.64-.55.34-1.15.58-1.74.68Z"
			style={{
				fill: '#e4deba',
			}}
		/>
		<path
			d="M86.17 142.52c.65-.07 1.02-.86 1.78-.69.26.05.27-.26.32-.44.37-1.42 1.43-2.22 2.6-2.94.94-.46 1.58-1.39 2.65-1.63.21-.08.25.05.26.21-.75.88-1.76 1.44-2.7 2.08-1.22.83-2.11 1.88-2.38 3.38-.11.6-.16 1.16.55 1.44.68.27 1.33 1.14 2.07.08.32-.46.84-.53 1.36-.56.54-.03 1.08-.03 1.61-.18q1.64-.78 2.3.98c.09.25.21.46.11.83-.12.44.4.64.83.73.42.08.83.19.73.76-.1.56-.49.68-.98.62-.38-.05-.74-.06-1.06.19-1.41.39-2.87.54-4.29.43-2.15-.17-3.59-1.52-4.62-3.34-.18-.32-.31-.67-.58-.94-.23-.31-.5-.6-.55-1.01Z"
			style={{
				fill: '#e8e5cf',
			}}
		/>
		<path
			d="m93.72 137.01-.2-.2c.31-.32.62-.57 1.14-.44 1.02.25 1.89-.92 2.88-.47 1.29.59 2.63.43 3.96.55.32.03.65.21.8.56-1.08.64-.97 1.67-.83 2.68.17 1.27-.21 2.49-.2 3.75 0 .85-.96.72-1.43 1.1-.33.27-.75-.13-.98-.5-.29-.47-.08-.82.16-1.29.55-1.05.21-2.26.37-3.4.09-.62-.44-1.25-1.11-1.57-.98-.88-2.16-.74-3.33-.62-.43.04-.86.2-1.23-.16Z"
			style={{
				fill: '#e9e5ce',
			}}
		/>
		<path
			d="M105.98 128.85c.03-.94.6-1.52 1.98-1.81.85-.18 1.6-.59 2.2-1.11.96-.84 2.18-.57 3.21-1.03.25-.11.44.24.57.48.4.52.42 1.2.42 1.75 0 .8-.6.7-1.14.35-.05-.04-.1-.1-.16-.13-.74-.38-3.2.3-3.59 1.02-.43.78-1.05.97-1.86.68-.46-.19-.94-.21-1.43-.21h-.2Z"
			style={{
				fill: '#f4eddc',
			}}
		/>
		<path
			d="M107.61 129.06c.79-.11 1.62-.11 1.79-1.21.04-.27.41-.68.77-.51 1.09.51 1.9-1.02 2.96-.36.11.07.13.29.2.44.23.29.09.59 0 .87-.34 1-.11 2.02-.1 3.03 0 .58.48.78.93.95.52.2 1.08.12 1.61.2.39.06.88.1.58.74-.41.16-.81.19-1.19-.08-.55-.03-1.12.11-1.63-.2-1.12-.48-1.74-2.18-1.32-3.65.08-.28.35-.57-.13-.73-.43-.15-.5.17-.62.46-.19.51-.54.75-1.11.59-.49-.13-.99 0-1.48.06-.55.06-1.01-.06-1.27-.61Z"
			style={{
				fill: '#eee8d4',
			}}
		/>
		<path
			d="M106.18 128.85c.55-.44.98-.02 1.43.21-.47-.08-1 .19-1.43-.21Z"
			style={{
				fill: '#eee8d4',
			}}
		/>
		<path
			d="M115.16 133.14h1.22c.21-.04.42.02.62.07.75.25 1.65-.26 2.31.44.03.11 0 .22-.07.31-1.04.31-1.98.14-2.99-.29-.67-.28-1.54-.09-2.32-.12.31-.43.91.02 1.22-.41Z"
			style={{
				fill: '#eae5cc',
			}}
		/>
		<path
			d="M77.86 141.1c-.08.04-.17.11-.25.11-.11 0-.16-.12-.09-.21.05-.06.17-.07.27-.08.02 0 .04.1.08.18Z"
			style={{
				fill: '#eeead9',
			}}
		/>
		<path
			d="M218.05 153.53c.15.5.65.76.82 1.27.2.61-.13 1.09-.56 1.08-1.28-.04-1.42.87-1.69 1.73-.07.22-.1.47-.22.67-.42.72-.5 1.64-1.78 1.67-.91.02-1.8.64-2.82.54-.49-.05-.92-.12-1.31-.43-.45-.28-1.38.05-1.33-.72.03-.37.89-.41 1.43-.45.3-.02.62.01.9-.07.34-.09.77.43.97-.06.12-.31-.11-.69-.38-.98-.31-.34-.63-.51-1.04-.19-.11.08-.22.16-.34.02.19-.4.36-.92.8-.99 1.19-.17.94-.97.77-1.67-.16-.65-.19-1.25.03-1.88.14-.43.16-.87-.22-1.2-.31-.27-.44-.61-.36-.99.23-1.11-.56-2.01-.62-3.05.32-.71.59-.16.83.06.78.68 1.28 1.57 1.84 2.42.28.43.6.91 1.2.99.39-.07.4.28.53.48.34.54.54 1.15.9 1.68.61.9.65.9 1.23.02.15-.06.29-.05.41.06Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M206 153.33h-.2c-.33-2.09-.02-4.18-.05-6.26-.03-1.76.61-3.11 1.61-4.44.89.56 1.23 1.5 1.71 2.34.11.17.33.42.21.53-.72.68-.65 1.79-1.37 2.46-.37.34-.43.71-.26 1.19.24.66-.02 1.39.25 2.09.17.45.26.61.75.44.4-.14.9-.41 1.27-.15.48.34.87.83 1.38 1.17.23.16.07.44-.11.62-.37.37-.79.64-1.35.62-.2 0-.45 0-.47.28-.02.24.18.33.39.4.13.04-.03-.02.1.02q1.72.51.84 1.96c-1.53.55-2.68.08-3.24-1.38-.3-.79-1.15-1.12-1.45-1.88Z"
			style={{
				fill: '#eee9d0',
			}}
		/>
		<path
			d="M210.7 156.59c.01-.2-.05-.49.06-.59 1-.9.18-.93-.48-1.04-.3-.05-.61-.07-.89-.17-.32-.11-.5-.36-.37-.72.09-.26.25-.59.56-.45.81.36 1.16-.27 1.72-.7-.52-.34-1.08-.48-1.37-1.12-.16-.36-.96-.02-1.39.18-.66.32-.63.06-.86-.5-.36-.87.09-1.8-.42-2.62-.13-.21-.13-.62.19-.82.68-.44.94-1.12 1.02-1.86.06-.5.93-.56.6-1.21.57.65.72 1.52 1.12 2.25.15.28.13.67.51.8 0 1.01.16 1.99.53 2.95.45 1.16.11 2.42.34 3.59.19.99-.14 1.54-.87 2.02Z"
			style={{
				fill: '#eeeacd',
			}}
		/>
		<path
			d="M213.97 149.66c-.58-.93-1.29-1.73-2.2-2.35-.24-.16-.41-.45-.56-.7-.21-.34-.76-.7-.22-1.1.42-.32.91-.12 1.26.29.11.13.2.27.31.4-.06.5.12.85.48 1.24.78.84 1.53 1.7 2.32 2.28-.29-.74-1.22-1.31-1.35-2.35.95-.07 1.21.81 1.71 1.32.51.51.91 1.13 1.43 1.65.24.81.48 1.62.36 2.49-.04.31-.12.63-.46.73-.34.09-.56-.16-.77-.39-.07-.08-.14-.15-.17-.25-.35-1.31-1.31-2.22-2.11-3.24Z"
			style={{
				fill: '#efe7c9',
			}}
		/>
		<path
			d="M213.97 149.66c.81.79 1.85 1.38 2.07 2.66.08.47.41 1.13.94 1.03.47-.09.25-.77.24-1.18-.01-.63-.12-1.27-.19-1.9-.06-.05-.08-.09-.06-.14.02-.05.04-.07.06-.07l.21.21v.19c.45.98.76 1.98.41 3.07-.02.26.06.54-.16.76-.26.26-.43.56-.81.02-.66-.96-1.11-2.03-1.69-3.02-.39-.51-.87-.97-1.02-1.63Z"
			style={{
				fill: '#e9e0be',
			}}
		/>
		<path
			d="M213.97 147.41c.88.78 1.19 1.98 2.07 2.78-.09.14-.29.25-.41.13-1.1-1.01-2.19-2.04-3.25-3.09-.36-.36-.2-.74.16-1.05h.2c.49.33 1.16.48 1.23 1.22Z"
			style={{
				fill: '#f2e9cf',
			}}
		/>
		<path
			d="M213.97 147.41c-.23-.59-.92-.72-1.23-1.22 1.27.46 2.24 1.32 3.11 2.32.39.45.6 1.06 1.17 1.35V150.27c-1.02-.42-1.33-1.53-2.12-2.19-.3-.25-.49-.65-.95-.67Z"
			style={{
				fill: '#e7dfc3',
			}}
		/>
		<path
			d="M216.42 146.8c.28.87.64 1.71.61 2.65-.71-.77-.59-1.73-.61-2.65Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M201.72 140.27h.2c-.13 1.45-.99 2.59-1.71 3.78-.14.23-.64.27-.41.67.18.31.52.41.89.27.12-.04.27-.02.4-.03.21.74-.2 1.32-1.02 1.65-.67.27-1.45.11-2.04.6-.6.76-.56 1.06.26 1.57.28.18.66.28.63.69-.03.37-.4.39-.67.52-.48.23-.87.63-1.42.72-.45.03-.78.28-1 .63-.49.76-.91 1.57-2.08 1.89.91.5 1.55.91 1.94 1.61.18.32.27.6.06.94-.44.72-2.51 1.52-3.41 1.3a.299.299 0 0 1-.07-.27c.36-.34.86-.44 1.24-.73.46-.26 1.24-.36 1.24-.89 0-.59-.78-.62-1.27-.82-.83-.34-.95-1.09-.29-1.67.13-.11.28-.19.42-.28.27-.18.73-.24.67-.66-.05-.35-.55-.19-.76-.42a.343.343 0 0 1-.03-.28c.54-.44 1.11-.84 1.62-1.32.2-.18.44-.34.31-.66-.12-.28-.36-.36-.65-.38-.37-.03-.73 0-1.1-.08-1.35-.4-2.73-.72-4-1.37-.43-.2-.78-.49-.97-.94-.02-.1-.03-.2-.02-.3.02-.1.07-.18.14-.26.71-.03.94.77 1.55.9.74.25 1.58.27 2.24.66 1.05.63 2.01.07 2.91-.22.34-.11.76-.72 1.24-1 .52-.23.96-.64 1.58-.64.21 0 .42-.15.47-.34.33-1.23 1.59-1.94 1.79-3.24.03-.19.18-.36.3-.53.21-.29.47-.54.62-.87.06-.07.12-.13.18-.19Z"
			style={{
				fill: '#e0d7af',
			}}
		/>
		<path
			d="M208.66 135.18c.21.3.53.17.81.21-.27.49-.24 1.19-.96 1.38-.03 0-.05.05-.07.07-.66.84-1.07.95-2.18.56-.8-.28-.21-.66-.06-1 .35-.2.62-.47.82-.82.41-.69 1.06-.4 1.63-.41Z"
			style={{
				fill: '#d2c899',
			}}
		/>
		<path
			d="M206 153.33c.54.7 1.65.86 1.73 2.06.05.73 1.56 1.39 2.36 1.24.2-.04.4-.02.61-.03-.65.54-1.86.59-2.45.09a7.092 7.092 0 0 1-2.24-3.35Z"
			style={{
				fill: '#eeeacd',
			}}
		/>
		<path
			d="M196.82 150.47c.68-.1 1.09-.72 1.77-.89.41-.1.1-.46-.15-.49-.45-.06-.67-.3-.92-.65-.55-.77-.34-1.12.53-1.23.98.06 1.92-.02 2.8-.54.21-.13.56-.38.83-.08.21.23.22.53.21.86-.08 2.82-.18 5.65 1.04 8.31.21.46.42.93.42 1.45v.41c-.47.08-.56-.29-.69-.59-.89-1.97-1.41-4.02-1.42-6.19 0-1.44-.25-1.59-1.53-.96-.86.42-1.8.7-2.71 1.44.78.11 1.31-.17 1.87-.23.61-.06 1.13.13 1.29.73.18.66.56 1.42-.3 1.94-.11-1.63-1.14-1.82-2.48-1.61-.46.07-.93-.04-1.4-.13-.52-.29-.35-.61-.06-.96.24-.29.56-.45.89-.59Z"
			style={{
				fill: '#d4c89c',
			}}
		/>
		<path
			d="M219.61 150.41c-.07.26.17.62-.29.66-.33.03-.59-.02-.69-.41-.1-.39-.28-.76-.38-1.15-.07-.28-.44-.71.1-.82.42-.09.97-.02 1.11.57.09.39.1.79.15 1.14Z"
			style={{
				fill: '#cfca96',
			}}
		/>
		<path
			d="M217.64 153.53c.13-1.06-.14-2.06-.41-3.07h.2c.4.98.5 2.02.61 3.06h-.41Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M201.11 141.29c-.23 1.56-1.59 2.54-2.06 3.98-.06.17-.3.45-.37.43-.74-.25-1.19.52-1.86.48-.14.12-.28.11-.43.02.13-.82.87-.89 1.33-1.12-1.2.23-2.46.42-3.71-.33-.81-.49-.93-.64-.57-1.62.11-.18.26-.3.45-.38.7-.06.78-1.02 1.5-1.06-.48 1.18.07 1.83 1.16 2.19.06.02.13.06.19.06.42 0 .82.66.82.56 0-.69.93-.94.67-1.85-.2-.71-.4-1.87.99-2.15.47-.09.15-.84.51-1.27.23-.29.43-.79.74-1.1.34-.35.7-1.12 1.23-.73.54.39.69 1.18.4 1.9-.13.32-.26.64-.39.97v.2c-.2.27-.46.51-.61.82Z"
			style={{
				fill: '#e2d9b8',
			}}
		/>
		<path
			d="M195.59 134.77c.3 0 .59-.03.89-.13.3-.1.57-.64.85-.31.36.42.94.67.94 1.45 0 1.49-.53 2.87-.78 4.3-.11.63-1.24 1.09-1.91 1.62-.28-.57-.03-1.03.32-1.45.37-.44.7-.89.88-1.44.22-.64.5-1.26.83-1.85.22-.4.31-.88-.04-1.22-.36-.34-.76-.19-1.2.05-2.14 1.14-3.91 2.64-5.01 4.85-.14.28-.32.55-.67.54-.44-.02-.5-.39-.59-.72-.05-.2-.11-.39-.11-.6 0-.07.05-.18.08-.17 1 .29 1.09-.56 1.43-1.12.75-1.23 1.67-2.29 2.96-2.98.42-.23.62-.73 1.13-.82Z"
			style={{
				fill: '#e2d9b8',
			}}
		/>
		<path
			d="M197.02 138.85c-.12 1.04-1.25 1.53-1.38 2.56-.01.1-.03.2-.05.29h-.2c-.51.36-.59 1.24-1.43 1.22-.13-.5.31-.69.54-.99.31-.4.59-.81.76-1.29.51-.67.76-1.61 1.76-1.8Z"
			style={{
				fill: '#e7debd',
			}}
		/>
		<path
			d="M151.5 173.92c-1.54-.43-3.09-.84-4.62-1.3-.57-.17-1.14-.08-1.71-.12-.19-.19-.48-.26-.64-.5-.18-.28-.22-.57-.07-.87a.62.62 0 0 1 .78-.33c2.21.78 4.51-.18 6.73.39.83.21 1.66-.4 2.51-.04.1.06.15.15.14.26-.62.51-1.37.67-2.15.72-1.47.1-1.54.2-.96 1.49.04.09.03.2 0 .29Z"
			style={{
				fill: '#e0d7b2',
			}}
		/>
		<path
			d="M154.56 171.27c-2.24.38-4.49-.15-6.72.04-.85.07-1.63.24-2.43-.22-.19-.11-.6-.31-.79.11-.13.31-.07.61.22.81.18.12.31.26.32.48-.68-.02-1.2-.42-1.63-.87-.42-.43-.87-.59-1.43-.56-.11-.37.17-.46.41-.59.26-.07.39-.26.47-.5.04-.08.1-.14.17-.18.09 0 .17.02.25.07.07.06.14.12.2.18.37.27.83.14 1.22.31 2.01.72 4.09.35 6.14.44 2.89.26 5.4-.9 7.91-2.07.49-.14.89-.46 1.32-.7.59-.25 1.09-.66 1.63-.99.34-.2.66-.5 1.11-.28.11.22 0 .4-.12.57-2.26 2.07-4.96 3.29-7.89 4.06-.14.04-.26-.02-.37-.11Z"
			style={{
				fill: '#e2dab6',
			}}
		/>
		<path
			d="M151.5 173.92c-.2-.51-1.07-.74-.74-1.41.34-.7 1.09-.7 1.77-.62.74.09 1.3-.56 2.04-.42.33-.06.3.17.29.37-.5 1.12-1.68.56-2.54.96.29.59.75.67 1.28.62.74-.08 1.48-.05 2.18.24.07.09.06.17 0 .26h-4.29Z"
			style={{
				fill: '#d2cca1',
			}}
		/>
		<path
			d="M142.72 170.66c-.29 0-.5.14-.61.41-1.02.66-1.95 1.44-2.86 2.24-.56-.1-.82.4-1.22.62-.92.49-1.88.88-2.86 1.22-.21-.25-.08-.44.09-.63.07-.06.16-.11.25-.14.56-.05 1.03-.35 1.52-.6.76-.16 1.04-1.03 1.78-1.21.65-.19 1.11-.66 1.6-1.08.67-.67 1.66-1 2.05-1.98.11-.27.43-.27.69-.08.09.14.11.28-.01.42-.19.25-.03.67-.41.82Z"
			style={{
				fill: '#d4cba5',
			}}
		/>
		<path
			d="M155.79 173.92v-.2a.62.62 0 0 1 .22-.17c.5-.1.98-.25 1.46-.45.76-.1 1.54-.05 2.29-.28 1.38-.59 2.9-.76 4.24-1.48.27-.14.58-.13.87.02.04.04.08.08.11.12-.52.64-1.35.84-2.02 1.03-2.34.68-4.7 1.35-7.17 1.41Z"
			style={{
				fill: '#d2caa3',
			}}
		/>
		<path
			d="M167.42 170.05c-.14.2-.28.4-.42.61-.68.27-1.25.81-2.03.82a.259.259 0 0 1-.02-.28c.71-.57 1.39-1.18 2.36-1.25.04.03.07.07.11.1Z"
			style={{
				fill: '#d2caa3',
			}}
		/>
		<path
			d="M174.98 164.95c-.82.15-1.69.17-2.45.47-1.23.48-2.44.28-3.67.15-.25-.44-.74-.45-1.14-.62-1.32-1.57-1.77-3.3-1.03-5.27.11-.29.23-.6.58-.65.38-.06.68.2.8.52.46 1.18 1.55 1.84 2.25 2.83.19.27.46.49.62.79.33.62.87.78 1.54.74 1.08-.06 2.15-.33 3.24-.2.48.06 1.24 0 1.25.57 0 .45-.74.42-1.2.48-.27.03-.54.04-.77.2Z"
			style={{
				fill: '#f0e8cd',
			}}
		/>
		<path
			d="M174.98 164.95c.49-.55 1.27-.38 1.85-.71-1.41-.67-2.84-.13-4.25-.09-.9.03-1.53 0-1.96-1.01-.31-.73-1-1.33-1.6-1.91-.5-.48-1.08-.84-1.16-1.63-.02-.17-.33-.42-.51-.43-.32 0-.34.35-.43.6-.64 1.71-.26 3.26.75 4.71.09.13.12.31.18.46-.1.07-.2.08-.31.03-1.16-.91-1.53-2.12-1.44-3.56.07-1.02.16-2.01.83-2.85.68-.49 1.02.06 1.29.5.92 1.5 2.17 2.69 3.52 3.78.31.25.6.4 1 .4 2.1 0 4.22.21 6.19-.8.3-.15.65-.19.99-.22.5-.07 1-.12 1.5-.17.27-.03.56-.11.7.22.12.29-.17.4-.32.56-.4.42-.92.67-1.4.98-.09.05-.19.09-.29.12-.75.16-1.5.27-2.21.58-.72.32-1.51.4-2.3.43h-.61Z"
			style={{
				fill: '#eee6cb',
			}}
		/>
		<path
			d="M175.18 166.99c-.62.05-.95-.33-1.11-.84-.12-.38-.15-.81.5-.8.5 0 .99-.12 1.43-.4 1.45-.32 2.83-.92 4.29-1.22.19-.14.38-.18.6-.06.07.08.1.18.07.29-.59.7-1.51.69-2.28 1-.84.34-1.75.53-2.66.67-.76.12-1.1.45-.79 1.23-.02.05-.04.09-.06.14Z"
			style={{
				fill: '#e2dab9',
			}}
		/>
		<path
			d="M180.28 163.73c-1.4.49-2.75 1.18-4.29 1.22h-.41c1.57-.38 3.02-1.22 4.7-1.22Z"
			style={{
				fill: '#ece2c3',
			}}
		/>
		<path
			d="M178.24 167.2c-.93.43-1.91.1-2.86.2l-.21-.4c1.03-.11 2.07-.26 3.06.2Z"
			style={{
				fill: '#e2dab9',
			}}
		/>
		<path
			d="M168.45 165.97c.62 0 1.11.34 1.63.61.22.27.18.55 0 .82-.08.07-.17.07-.26.02-.79-.9-1.12-.96-2.13-.39-.59.29-1.19.4-1.84.16-.39-.14-.82-.1-1.15.17-.56.47-1.1.4-1.64-.01-.03-.1-.04-.2-.02-.3.39-.71.86-1.36 1.06-2.18.44-1.87-.05-3.52-1.01-5.13-.7-1.17-1.52-2.24-2.44-3.24-.18-.19-.48-.37-.35-.67.14-.33.51-.32.8-.3 1.61.16 3.01.85 4.33 1.74-.11.48-.54.42-.88.53-.61.21-.86.73-.46 1.15.39.4.62.86.83 1.39-.07-1.12 1.09-1.9.75-3.04 1 .11 1.32.56.99 1.45-.08.22-.2.43-.27.65-.1.24-.21.49-.27.75-.57 1.27-.22 2.52.1 3.77.05.7.14 1.39.38 2.1.6-.47 1.21-.56 1.83-.05Z"
			style={{
				fill: '#d1c89e',
			}}
		/>
		<path
			d="M168.45 165.97c-.56-.02-1.22-.57-1.55.45-.12.36-.44.07-.5-.23-.14-.68-.26-1.37-.4-2.05.84.01 1.1.8 1.63 1.22.41.02.64.29.82.61Z"
			style={{
				fill: '#d2c7a3',
			}}
		/>
		<path
			d="M169.87 167.4h.21c-.52 1.25-1.53 2.01-2.65 2.65-.19-.75.16-1.29.7-1.72.34-.27.68-.55 1.03-.8.23-.13.47-.18.72-.13Z"
			style={{
				fill: '#d2caa3',
			}}
		/>
		<path
			d="M167.63 165.36c-.77-.11-1-.93-1.63-1.22-.19-.99-.54-1.95-.42-2.98.05-.41.07-.81.42-1.09.33.34.24.78.19 1.15-.23 1.53.26 2.77 1.37 3.81.03.05.06.09.08.14v.2Z"
			style={{
				fill: '#d9d1aa',
			}}
		/>
		<path
			d="M167.63 164.95h.2c.44.03.91.03 1.02.61-.4-.17-.75-.46-1.22-.41-.06-.05-.08-.09-.06-.14.02-.04.04-.07.06-.07Z"
			style={{
				fill: '#e8e1c1',
			}}
		/>
		<path
			d="M170.08 167.4v-.82c.68.27.4.55 0 .82Z"
			style={{
				fill: '#d2caa3',
			}}
		/>
		<path
			d="M186 161.28c-.17.2-.36.22-.33-.08.03-.28-.04-.42-.28-.53-.21-.03-.38-.16-.56-.25-.37-.13-.65.13-.96.24-.83.29-1.36.07-1.74-.73-.19-.4-.27-.84-.28-1.28-.01-1.05-.03-2.1 0-3.15.03-1.01.4-1.9.91-2.76.5-.84.24-1.34-.75-1.36-1.42-.02-2.85-.15-4.26.1-.31.05-.61.07-.88-.11-.04-.8.68-.5 1.04-.72.42-.05.84-.11 1.26-.06.9 0 1.81.15 2.69-.26.44-.2.85-.02 1.2.31.39.37.8.72 1.21 1.07.89.75 1.21.71 1.83-.26.37-.57.76-1.05 1.54-.83.4.55-.11.82-.36 1.17-.27.55-.37 1.2-1.19 1.31-.37.05-.44.54-.61.86-.09.37-.04.8-.52.95-.46.28-.68 1.37-.36 1.81.15.21.42.35.43.65-.1.21-.35.29-.46.49-.49 1.2.48 1.61 1.17 2.18.21.39.64.73.26 1.24Z"
			style={{
				fill: '#d2c99a',
			}}
		/>
		<path
			d="m185.18 160.26.21.41c-.41 1.06-1.26 1.62-2.25 2.04-.54.78-1.34 1.1-2.25 1.22v-.2c.09-.56.61-.66.99-.87.41-.23.72-.5.89-.92-.77-.38-1.47-.84-2.15-1.37-.8-.62-1.15-2.07-1.01-3.08.16-1.24.75-2.34.85-3.58.11-1.26-.41-1.71-1.62-1.32-.72.23-1.47.27-2.21.33-.92.08-1.81.26-2.67.58-.28.11-.57.26-.86 0 .16-.82.88-.85 1.48-1.06 1.84-.46 3.68-.9 5.61-.84 1.75.06 2 .29 1.87 2.03 0 .1.02.2.04.3-.31 1.45-.37 2.92-.31 4.4.01.33-.03.68.09 1 .62 1.66.76 1.78 2.17 1.11.36-.17.72-.36 1.13-.2Z"
			style={{
				fill: '#e2d9b3',
			}}
		/>
		<path
			d="M189.67 162.71c-.74.92-2.03 1.19-2.66 2.24-.75 0-1.45.28-2.16.48-.34.1-1.02.19-.94-.03.16-.46-.11-1.3.69-1.36.57-.04 1.11-.32 1.73-.14.53.15 1.08.07 1.36-.55.26-.59-.32-.75-.58-1.03-.25-.27-.57-.46-.7-.83 1.15.25 2.31.47 3.27 1.22Z"
			style={{
				fill: '#d1c89b',
			}}
		/>
		<path
			d="M179.47 164.95c.84.48 1.87.08 2.81.47-1.39 1.03-2.83.92-4.29.67l.05.69c-.11.13-.25.18-.41.19-.42.01-.83.02-1.25 0-.11 0-.21-.03-.31-.07-.44-.21-.99-.34-.7-1.04 1.32-.5 2.65-1 4.1-.91Z"
			style={{
				fill: '#d0c99b',
			}}
		/>
		<path
			d="M179.47 164.95c-1.38.25-2.76.53-4.08 1.02-.31.85.5.59.82.81.48.17.95.17 1.43 0h3.27c-.47.39-1.02.12-1.53.2-.38.06-.8-.14-1.13.2-1.02-.04-2.06.14-3.06-.2-.65-1.02-.5-1.37.7-1.61 1.71-.34 3.41-.72 5.01-1.45.74-.42 1.6-.62 2.25-1.22-.42 1.21-1.7 1.25-2.57 1.84-.33.22-.8.09-1.11.4Z"
			style={{
				fill: '#d9d0a9',
			}}
		/>
		<path
			d="M189.67 162.71c-1.11-.35-2.24-.65-3.27-1.22l-.41-.21c.13-.49-.4-.77-.41-1.22a.46.46 0 0 1 .48.08c1.94 1.61 4.19 2.11 6.65 1.88.97.08 1.99-.13 2.87.49-.8.39-1.62.19-2.45.1-1.16-.12-2.33-.28-3.48.1Z"
			style={{
				fill: '#cabe90',
			}}
		/>
		<path
			d="M184.92 162.52c.03-.57.33-.7.78-.77.02.52-.28.68-.78.77Z"
			style={{
				fill: '#d1c89b',
			}}
		/>
		<path
			d="M207.23 162.1c-.1-.45-.21-.88-.51-1.26-.23-.29-.36-.63-.11-.99.74 0 1.37.21 1.84.82.39.5.91.54 1.52.61 1.51.18 3.04.09 4.54.26.76.09 1.17-.18 1.46-.79.35-.73.65-1.48 1.06-2.18.36-.96.37-.96 1.01-.36l.2.2c.18.7.13 1.29-.36 1.93-.57.75-1.09 1.58-1.27 2.55-.64 1.02-.96 2.26-2.36 2.69-.85.26-1.57.07-2.23-.28-1.71-.9-3.3-2.01-4.8-3.22Z"
			style={{
				fill: '#d2c79a',
			}}
		/>
		<path
			d="M199.88 153.73c.38-.56.24-1.17.11-1.75-.14-.66-.63-.8-1.26-.63-.55.15-1.09.37-1.68.34-.21 0-.44-.03-.5-.26-.06-.19.14-.28.27-.38 1.18-.85 2.53-1.39 3.87-1.88.67-.24.83.4.81.94-.05 1.39.08 2.77.43 4.1.32 1.18.63 2.39 1.41 3.39.23.48.64.96.62 1.43-.02.45-.75.53-1.1.86-.19.18-.36.38-.54.57-.17.13-.37.12-.57.09-.35-.35-.83-.44-1.24-.68-.61-.35-.62-.86-.33-1.4.25-.48.65-.46 1.02-.15.33.28.65.48 1.1.37.27-.07.5-.24.38-.49-.62-1.22-1.03-2.54-1.72-3.73-.05-.08-.16-.13-.36-.12-.43 1.93-.7 3.98-2.34 5.42-.19.13-.37.26-.55.4-.25.24-.68.22-.85.6-.05.09-.12.21-.21.21-1.33.04-2.54.92-3.93.6-.23-.05-.49-.09-.71-.02-1.08.31-2.06.06-3.02-.42-.74-.43-1.64-.7-1.77-1.75.14-.09.3-.11.46-.09 1.69.83 3.44 1.34 5.37 1.32 2.61-.02 5.66-1.95 6.18-4.67.14-.74.18-1.55.63-2.22Z"
			style={{
				fill: '#c5ba86',
			}}
		/>
		<path
			d="M217.23 158.63c-.42.9-.84 1.79-1.26 2.69-.2.41-.52.63-.98.57-1.3-.17-2.62-.09-3.9-.23-.62-.07-1.25-.08-1.87-.14-.55-.05-.81-.29-.76-.84 1.77.07 3.56.31 5.31.15 1.3-.12 2.52-.78 3.06-2.19.14-.12.27-.13.41 0Z"
			style={{
				fill: '#d1c89e',
			}}
		/>
		<path
			d="M216.62 162.91c-.34-.84.3-1.36.65-1.97.45-.79 1.24-1.45.98-2.52.41.5.12 1.09.2 1.63-.77.39-.75 1.28-1.18 1.89-.22.31-.38.68-.65.97ZM217.23 158.63h-.41c-.13-.7.36-1.07.76-1.54.33.36.37.76.47 1.14-.51-.34-.71-.06-.82.41Z"
			style={{
				fill: '#d3caa0',
			}}
		/>
		<path
			d="M201.72 160.47h.61c-.35.31-.69.65-1.22.62h-.01c-.06-.48.25-.58.62-.62Z"
			style={{
				fill: '#cabe90',
			}}
		/>
		<path
			d="M197.64 160.06a.72.72 0 0 1 .41-.41c.65.76 1.58 1.05 2.45 1.43-.86.47-1.9.54-2.66 1.22-.66.27-1.38-.08-2.04.2h-.2l-2.86-.21c-.92-.23-1.86-.13-2.79-.21-.98-.09-1.23-.45-.88-1.21 1.39 1.06 3.02.32 4.52.5.9.11 1.97-.56 3.04-.54v-.37c.3-.23.81.08 1.01-.41Z"
			style={{
				fill: '#c6b781',
			}}
		/>
		<path
			d="M195.8 162.5c.65-.41 1.36-.11 2.04-.2v.2h-2.04Z"
			style={{
				fill: '#cabe90',
			}}
		/>
		<path
			d="M200.5 161.08c-1.09 0-2.03-.27-2.45-1.43 1.29-.95 1.63-2.43 2-3.84.16-.59.41-1.23.18-2.01.93.35 1.37.79 1.54 1.69.14.78.64 1.5 1.01 2.22.2.4.45 1.03.08 1.12-.41.1-.99.67-1.48 0-.18-.25-.38-.64-.79-.5-.31.1-.24.44-.32.7-.15.54.36.56.59.8.25.26 1.01-.16.86.64-.21.2-.41.4-.62.61h-.61Z"
			style={{
				fill: '#c5b981',
			}}
		/>
		<path
			d="m122.51 176.98-.61-.2c-.33-.39-1.2-.24-1.14-.97.06-.69.77-.79 1.28-.98 1.16-.43 2.38-.7 3.58-1 1.47-.36 2.77-1.07 4.08-1.8 1.15-.64 2.26-1.35 3.38-2.05.59-.37 1.05-.85 1.52-1.34.32-.35.34-.71 0-1.08-.56-.6-.58-1.24-.19-1.96.46-.86.35-1.79.17-2.69-.2-.96-.46-1.91-.65-2.88-.06-.33-.22-.66-.02-.99.24-.12.41.02.57.17.8 2.23 1.38 4.49.69 6.87-.11.38-.03.65.29.87.34.24.61.53.67.97 0 .1 0 .2-.04.3-.53.95-1.18 1.78-2.19 2.28-.42.21-.75.56-1.04.95-.44.52-1.07.65-1.67.87-.48.17-.91.42-1.3.74-1.24.84-2.65 1.22-4.06 1.64-.51.16-1.04.27-1.54.46-.25.1-.49.21-.74.31-.4.16-.94-.02-1.24.33-.34.4.47.71.2 1.17Z"
			style={{
				fill: '#d8d1a7',
			}}
		/>
		<path
			d="m110.67 173.11-.2-.21c-.31-.45-.51-.94-.1-1.39.38-.42.88-.19 1.34-.05.94.28 1.66 1.01 2.67 1.19 5.31.96 10.52 1.09 15.48-1.5.09-.05.2-.06.3-.07.17 0 .33.03.47.13-.19.76-.93.97-1.48 1.26-1.09.57-2.23 1.09-3.43 1.42-.97 0-1.94.13-2.89.33a.5.5 0 0 1-.31-.1c-.44-.45-.88.04-1.33.02-1.7-.09-3.4-.35-5.07-.48-1.99-.16-3.57-1.05-5.35-1.7-.21.56.5.85.31 1.34l-.41-.2Z"
			style={{
				fill: '#e3dbba',
			}}
		/>
		<path
			d="M122.51 174.13h.2c1.01-.08 1.99-.45 3.02-.27.11.08.12.17.04.27-1.53.25-3.02.67-4.46 1.23-.55.21-.62.6-.02.92.24.12.49.23.6.5-1.06-.26-2.14-.15-3.21-.2-.24-.01-.48 0-.71-.05-.46-.12-1.09-.3-1.05-.78.05-.57.68-.4 1.15-.42 1.55-.07 3.18.06 4.42-1.19Z"
			style={{
				fill: '#ddd6af',
			}}
		/>
		<path
			d="M122.51 176.98c-.79-1.27-.79-1.26.8-1.67.29-.07.55-.25.83-.37.24.67-.34.63-.64.81.13.05.3-.11.45-.06 1.98.65 4.03.24 6.04.42.2.02.41.04.59.15.03.04.07.07.1.11-2.7.57-5.39 1.16-8.17.61Z"
			style={{
				fill: '#cec69e',
			}}
		/>
		<path
			d="m134.76 175.15-.21.2c-1.29.37-2.53.89-3.88 1.02-.23-.46.14-.57.43-.71.33-.16.7-.17 1.06-.2.79-.35 1.57-.85 2.49-.43.04.04.08.08.11.12Z"
			style={{
				fill: '#cec69e',
			}}
		/>
		<path
			d="m135.37 174.54-.21.61h-.4c-.16-.58.05-.78.62-.62Z"
			style={{
				fill: '#cec69e',
			}}
		/>
		<path
			d="M99.65 163.73h-.2a.552.552 0 0 1-.19-.26c-.13-.78-.12-1.55.06-2.32.21-.96-.02-1.57-.62-1.69-.79-.15-1.96.69-2.03 1.47-.03.38.02.74.13 1.11.37 1.2.3 2.47.61 3.69.38 1.52-.19 2.87-1.43 3.87-.16.13-.31.27-.41.45-.1.08-.19.07-.27-.03-.24-.71.12-1.26.55-1.75.31-.36.53-.72.49-1.18-.12-1.44.11-2.9-.28-4.33-.27-1-.54-2.05.08-3.06.07-.2.18-.37.32-.53.2-.23.44-.42.74-.52.59-.41 1.17-.67 1.97-.49.65.14 1.29-.34 1.9-.62 1-.46 1.26-.33 1.29.79.01.5.18 1 .04 1.51-.47.37-.48.74 0 1.12.93.73 1.77 1.56 2.63 2.36 1.07.98 2.39.44 3.6.48.49.01 1-.12 1.51-.13.46 0 .92 0 1.37-.11.75 0 1.33.14 1.03 1.11-.32.49-.53 1.02-.44 1.63-.04.16-.1.29-.27.35-1.19-.41-.63-1.28-.47-2.16-1.84.68-3.63-.13-5.41.24-.2.04-.4-.05-.57-.17-1.14-.48-1.7-1.63-2.64-2.34-.22-.16-.42-.34-.62-.52-.5-.35-1-.69-1.07-1.38-.03-.24 0-.63-.38-.57-.27.04-.22.37-.27.59-.27 1.13-.38 2.29-.72 3.41Z"
			style={{
				fill: '#e6e2c5',
			}}
		/>
		<path
			d="M99.65 163.73c-.3-1.34.55-2.55.46-3.87-.02-.28.18-.6.57-.6.37 0 .64.22.58.56-.15.84.51 1.27.84 1.87-.49.01-1.06.92-.86 1.49.12.37.25.56-.2.87-.6.41-.1 1 .05 1.51-.89-.29-.89-1.27-1.43-1.84Z"
			style={{
				fill: '#efe8cd',
			}}
		/>
		<path
			d="M105.36 164.54c1.97-.13 3.97.34 5.9-.36.19-.07.43-.08.55.12.15.25-.03.44-.19.62-.57.66-.45 1.21.28 1.66.41.34.52.83.66 1.3-.02.04-.03.08-.05.13-.19-.06-.38-.12-.56-.18-.52-.17-1.05-.69-1.52.14-.07.12-.5.04-.77.05-.03-.53.51-.65.72-1.01.12-.21.27-.41.12-.65-.16-.27-.41-.16-.63-.09-.66.21-1.37.35-1.85.93-.59-.34-.4-.64.09-.84.56-.23 1.15-.4 1.73-.61.2-.07.4-.19.32-.43-.06-.18-.29-.1-.44-.15-1.28-.41-2.57-.62-3.9-.25-.19.05-.35-.17-.44-.37Z"
			style={{
				fill: '#efe8cc',
			}}
		/>
		<path
			d="M108.01 167.19c0-.96.85-.81 1.38-1 .43-.16 1.01-.76 1.4-.06.37.67-.24 1.1-.68 1.51-.15.13-.31.25-.46.38-.2.13-.41.13-.61 0-.4-.2-.82-.37-1.02-.82Z"
			style={{
				fill: '#e5dec4',
			}}
		/>
		<path
			d="M130.27 171.27c-1.61.85-3.31 1.46-5.06 1.89-.91.22-1.86.29-2.8.34-.98.06-1.97-.02-2.95.02-2.07.08-4.05-.46-6.06-.83-.66-.12-.93-.85-1.64-.91-.44-.04-.85-.54-1.31-.12-.42.39 0 .82.02 1.24l-.41-.2c.09-.54-.21-1.13.2-1.63.17-.18.21-.45.41-.61 1.15-.31 1.86-.09 2.43.81.52.82 1.2 1.24 2.19 1.19.5-.03 1.01-.04 1.51.04.13.02.02-.18.02-.04-.6-.13-1.02-.44-1.09-1.1.39-.31.66.02.96.17.24.2.5.37.76.53.56.44 1.18.44 1.89.45 2.45.04 4.74-.75 7.1-1.15.96-.16 1.85-.64 2.77-.98.19-.07.36-.18.56-.24.49-.13 1.11-.35 1.36.22.27.64-.49.65-.84.91Z"
			style={{
				fill: '#ece5c9',
			}}
		/>
		<path
			d="M115.77 171.27c.13.61.9.7 1.08 1.38-1.41.04-2.97.49-3.82-1.02-.59-1.07-1.41-1.14-2.37-1.18.74-.34.93-1.26 1.72-1.58.25-.1.08-.57.11-.87.42-.12.67.17.81.45.42.89 1.15 1.47 1.89 2.05.16.22.33.44.51.64l.06.12ZM110.67 170.46c0 .29-.14.5-.41.61 0-.3 0-.59.41-.61Z"
			style={{
				fill: '#ede6ce',
			}}
		/>
		<path
			d="M70.25 167.39h-.61c-.39-.18-.87-.3-.91-.82-.03-.43.44-.44.7-.61h.2c1.21-.04 2.38-.5 3.6-.34.24.03.51.03.68-.14.51-.54 1.23-.69 1.84-1.05.57-.33 1.2-.57 1.4-1.32.09-.33.47-.46.76-.65 1.01-.65 1.99-1.32 2.05-2.71.02-.48.53-.63.68-.33.48.94 1.49 1.09 2.2 1.68.4-.54-.44-1.12-.01-1.68.42-.15.71.15.76.44.17 1.08.78.72 1.38.5.44.37.07.72-.12.95-.96 1.16-1.88 2.28-3.35 2.99-1.69.81-3.51 1.4-5.07 2.47-.6.41-1.27.46-2.01.47-1.39.03-2.82-.6-4.19.13Z"
			style={{
				fill: '#d3c899',
			}}
		/>
		<path
			d="M82.91 159.44c.03.76.59 1.51 0 2.39-.09-1.15-1.34-.76-1.77-1.48-.04-.06-.2-.04-.26-.1-.23-.22.05-.89-.56-.73-.13.04-.07.65-.18.98-.32.99-1.13 1.57-1.95 2.11-.25.17-.68.27-.74.49-.41 1.31-1.72 1.35-2.58 2.01-1.69 1.28-3.5.63-5.24.87.49-.57 1.34-.08 1.84-.61 1.05-.52 2.28-.61 3.24-1.35 1.52-.43 2.51-1.68 3.81-2.45.46-.27.39-.77.09-1.16-.46-.59-.43-1.18-.09-1.79.26-.46.19-.99.28-1.48.1-.5.3-.95.95-.73 1.39.49 2.74 1.16 4.29 1.02.2-.02.38.14.49.32.04.09.05.19.03.29-.99-.04-1.33.69-1.67 1.42Z"
			style={{
				fill: '#d3c89d',
			}}
		/>
		<path
			d="M82.29 164.54v-.2c-.04-.63.56-.78.88-1.11.97-1.01 2.07-1.91 2.21-3.47.03-.4.12-.79 0-1.18-.09-.55-.57-.76-.96-1.05-.34-.22-.74-.04-1.09-.19-.37-.23-.74-.47-1.12-.69-.5-1.21-.4-1.48.68-1.86.1-.03.2-.05.31-.06.24-.02.51-.04.68.12.77.75 1.51.42 2.29.01.77-.41 1.57-.54 2.41-.17.08.08.11.18.08.29-.63.37-1.39.37-2.02.74-1.24.48-1.37.74-.75 1.83.95 1.65.5 3.09-.53 4.49-.24.33-.51.62-.8.91-.42.37-.8.77-1.16 1.2-.07.06-.14.11-.23.16-.29.09-.53.38-.88.24Z"
			style={{
				fill: '#dfd7b3',
			}}
		/>
		<path
			d="M68.21 167.2c-.72-.23-1.57-.18-2-1.02-.13-.26-.43-.04-.64-.05-.68-.04-1.53.47-1.92-.58-.07-.19-.29-.06-.45-.05-1.2.1-2.14-.59-2.52-2 3.11 1.05 6.07 2.41 9.36 1.86-.33.36-.82.22-1.22.35-.94.32-1.09.59-.62 1.48Z"
			style={{
				fill: '#ded7b3',
			}}
		/>
		<path
			d="M85.56 158.42c.44 1.64-.34 2.88-1.35 4.02-.59.67-1.28 1.26-1.92 1.89-1.62.72-3.29 1.39-4.83 2.22-1.83.98-3.65.86-5.51.78-.58-.02-1.13.18-1.7.06.3-.64 1.07-.76 1.45-.62 1.03.4 2.1 0 3.11.37.59.21 1.15-.17 1.58-.53.97-.82 2.16-1.15 3.28-1.67 2.07-.96 4.12-1.98 5.26-4.15.06-.12.17-.22.02-.34-.41-.77-.21-1.64-.41-2.45.51-.3.71.18 1.02.41Z"
			style={{
				fill: '#d3c89d',
			}}
		/>
		<path
			d="M92.09 170.87v.2c-1.66.44-3.39.76-5.06.55-1.66-.2-3.36.18-4.98-.5-1.56-.66-3.02-1.43-4.33-2.49-1.05-.85-1.02-1.12.15-1.82.25-.15.48-.24.76-.23.01.03.04.07.03.09-.51 1.22-.49 1.25.66 2.1.6.44 1.27.75 1.91 1.12.8.23 1.6.48 2.38.8 2.19.23 4.38.36 6.58.3.64-.02 1.24-.72 1.91-.12Z"
			style={{
				fill: '#e1dabb',
			}}
		/>
		<path
			d="M81.07 170.05c-.98-.49-1.95-.99-2.75-1.79-.56-.57-.78-.93.07-1.36.1-.05.16-.21.23-.32 1.15-.34 2.14-1.02 3.26-1.43l.21-.4c.39-.12.7-.37 1.02-.62h.2l.09.1c.03.09.03.17.01.26-.05.17-.15.32-.25.47-.28.58-.96.63-1.38 1.03-.63.4-1.28.77-1.97 1.07-.14.18-.85.21-.15.61.71.4.9 1.23 1.45 1.76.17.16.15.44-.05.63Z"
			style={{
				fill: '#e9e2c8',
			}}
		/>
		<path
			d="M74.74 164.14c-.96.76-2.08 1.07-3.27 1.22h-1.43c.86-.33 1.83-.2 2.68-.64.53-.27 1.17-.33 1.61-.79h.2c.07-.08.15-.09.24-.03.05.09.04.17-.03.24Z"
			style={{
				fill: '#ded7b3',
			}}
		/>
		<path
			d="M81.88 165.15c-1.05.57-2.01 1.32-3.26 1.43 1.03-.62 2.07-1.19 3.26-1.43Z"
			style={{
				fill: '#e1dabb',
			}}
		/>
		<path
			d="M69.43 165.97c-1.02.63-.3 1.01.2 1.43-.59.05-1.05-.29-1.12-.78-.07-.51.44-.66.92-.65Z"
			style={{
				fill: '#d3c89d',
			}}
		/>
		<path
			d="M83.11 164.14c-.21.42-.53.66-1.02.62l.2-.21c.28-.11.46-.44.82-.41Z"
			style={{
				fill: '#e1dabb',
			}}
		/>
		<path
			d="M104.75 168.83c-.42.19-.85.34-1.24.56-.47.27-.79.66-.59 1.27-1.14-.2-2.41.06-3.28-1.07-.21-.28-.68-.27-1 .05-.46-.02-.63.46-1.01.58-.35.12-.73.23-1.01-.1-.32-.37.2-.47.28-.72.04-.12.07-.25.1-.38.02-.04.04-.08.06-.13.35-.31.28-.76.41-1.15a.46.46 0 0 1 .19-.2c.4-.03.33.78.71.51.43-.3.9-.61 1.22-1.05.18-.25-.11-.4-.22-.61-.33-.63-.78-1.28-.09-1.97.7.83 1.31 1.73 2.06 2.53.2.22.12.51-.05.75-.15.2-.46.38-.16.68.16.16.38.18.57.09.35-.16.21-.41.11-.68-.27-.77.13-.8.71-.61l1.63.61c.29.26 1.24-.16.82.81l-.2.2Z"
			style={{
				fill: '#dcd4b2',
			}}
		/>
		<path
			d="M97.6 167.6v.2c-.15.44-.17.93-.61 1.22-.67.07-.76.95-1.43 1.02 0-.5.41-.8.68-1.09 1.2-1.24 1-2.57.69-4.1-.26-1.33-.53-2.71-.54-4.08 0-.9 1.85-2.07 2.63-1.64.5.28.83.9.63 1.56-.27.93-.2 1.87-.21 2.82-.11.07-.21.06-.31-.03-.54-.65-.37-1.4-.27-2.14.07-.52.07-.97-.63-1-.66-.03-1.14.12-1.14.92 0 .45.1.87.25 1.29.49 1.39.54 2.84.53 4.3 0 .27-.06.54-.27.74ZM92.09 170.87c-1.67.54-3.4.49-5.1.37-1.22-.08-2.48 0-3.68-.37.7-.51 1.5-.26 2.26-.27 2.29-.03 4.57.16 6.83-.53.91-.28 1.97-.59 2.95-.02h.2l-.2.21c-.31.24-.72-.05-1.02.2h-.41c-.39.44-.98.18-1.43.41h-.41Z"
			style={{
				fill: '#e2ddbd',
			}}
		/>
		<path
			d="m96.18 172.5-.2.2c-.57.02-1.15 0-1.72.06-.39.04-.46-.26-.57-.47-.14-.27.14-.43.34-.53.33-.16.68-.29 1.03-.38.94-.22 1.18.3 1.12 1.11Z"
			style={{
				fill: '#ddd4ba',
			}}
		/>
		<path
			d="M92.5 170.86c.42-.33.98-.19 1.43-.41-.33.64-.94.33-1.43.41ZM94.34 170.46c.29-.34.68-.15 1.02-.2-.29.34-.68.15-1.02.2Z"
			style={{
				fill: '#e1dabb',
			}}
		/>
		<path
			d="M99.24 163.52h.2v.2c.28 1.37 1.11 2.32 2.3 2.99.26.15.51.32.77.48-.52 0-.94.03-.34.65.26.27.2.69-.15.86-.39.19-.89.27-1.2-.13-.18-.23-.49-.62.13-.85.39-.15.45-.51.13-.81-.75-.69-1.32-1.52-1.83-2.38-.29-.34-.29-.68 0-1.02ZM104.95 168.62c.16-.7-.58-.51-.82-.81q1.25.02.82.81Z"
			style={{
				fill: '#dfd7b9',
			}}
		/>
		<path
			d="M74.13 156.18c-.54 1.75-2.13 2.26-3.56 2.8-1.97.74-4.11.87-6.18 1.22-.82.14-1.44-.28-1.91-.9-.44-.59-.11-1.07.3-1.52.08-.09.08-.25.12-.38.81-1.34 2.14-2.14 3.33-3.07.16-.13.37-.17.55 0 .26.42-.06.64-.33.81-1.09.65-1.82 1.7-2.82 2.46-.44.34-.67.86-.25 1.42.89.25 1.76.5 2.67.09.18-.08.4-.13.6-.1 2.28.34 3.92-1.29 5.87-1.95.89-.3 1.05-1.31.57-2.13-.91-1.55-1.58-1.81-3.27-1.23-.39.13-.76.28-1.18.29-.66-.12-1.17.76-1.89.29 0-.14.02-.28.14-.36 1.31-.86 2.67-1.67 4.15-2.14.66-.21 1.47 0 2.2.01.56.16 1.13.05 1.7.09.47.03.9.12.37.68-.36.38-.37.84-.41 1.3-.05.5-.18.98-.42 1.43-.07.3-.11.62-.34.86Z"
			style={{
				fill: '#e9e1c4',
			}}
		/>
		<path
			d="M73.31 151.9c-1.93-.22-3.55.62-5.13 1.54-.48.28-1.15.27-1.4.91-1.19.51-2 1.5-2.98 2.27-.31.25-.6.53-.9.79V157c.83-1.53 2.35-2.29 3.67-3.26.51-.21 1.21-.09 1.43-.81.38-.83 1.46-.91 1.87-1.71.03-.05.27-.06.37 0 1.92.88 3.95.35 5.92.49.62-.32 1.37-.42 1.84-1.02v-.21c.24-.09.43.05.5.23.21.53.64.55 1.09.52.97-.05 1.88.13 2.78.49 1.05.42 1.72-.03 1.88-1.13.01-.1.01-.2.03-.3.21-1.62.77-1.86 2.12-.92.09.05.17.1.25.16.16.12.32.24.38.44-.01.1-.06.17-.15.23-.42.17-.75-.03-1.09-.24-.41-.25-.44 0-.4.33.06.9.05 1.77-.81 2.35-.41.19-.87.15-1.29.25-.88-.06-1.73-.27-2.56-.56-.42-.15-.86-.15-1.3-.13-1.12.39-1.2.54-.97 1.62.06.29.14.58.2.87.31 1.29.08 1.78-.92 1.89-.31.03-.71.14-.76-.39-.95-.41-1.91-.7-2.86 0v-1.02c.97-.5 1.91-.09 2.87.08.26.04.57.23.76-.02.22-.28.02-.59-.14-.84-.31-.48-.6-.98-.9-1.46-.38-.61-.98-.89-1.7-.92-.57-.02-1.14.12-1.7-.09Z"
			style={{
				fill: '#e3ddba',
			}}
		/>
		<path
			d="M76.98 156.18c.65.58 1.16-.02 1.62-.28.43-.24-.23-.52-.19-.85.02-.16 0-.34 0-.5.82.24.81.9.81 1.56-.76 1.56-.99 3.24-.96 4.94 0 .47-.1.73-.43 1.02-.67.57-1.39 1.07-2.1 1.59-.26.19-.58.51-1 .27h-.21c.99-.48 1.59-1.42 2.46-2.04.18-.15.62-.13.41-.54-.19-.36-.52-.53-.93-.41-.26.07-.71.24-.73.03-.08-.73-.69-1.16-.85-1.81 0-.04.07-.12.13-.14.97-.31 1.02-1 .89-1.87-.1-.73.3-1.12 1.09-.97Z"
			style={{
				fill: '#e1d9b5',
			}}
		/>
		<path
			d="M73.46 162.02c-1.16-.45-1.89.23-2.55.79-.63.52-1.25.71-2.02.66-.43-.03-.86.13-1.29.13-.37 0-1.01.24-.76-.61.05-.16-.04-.38-.25-.36-.82.06-.39-.5-.41-.82-.04-.57.37-.56.75-.54.58.03 1.12-.14 1.75.11.93.37 1.69-.39 2.48-.76.14-.07.22-.26.36-.33 1.45-.72 1.65-.6 1.79.99.02.2.08.39.15.73Z"
			style={{
				fill: '#dfdab5',
			}}
		/>
		<path
			d="M58.41 158.02c.35-.02.66.03.82.41-.32-.03-.61-.14-.82-.41Z"
			style={{
				fill: '#d8d2b2',
			}}
		/>
		<path
			d="M86.58 149.66c-.16-.06-.35-.08-.46-.18-.31-.29-.71-.64-1.05-.45-.4.22-.51.75-.54 1.25-.09 1.76-.91 2.27-2.51 1.6-.53-.22-1.07-.43-1.66-.38-.97.09-1.9.09-2.35-1.02-.18-.4-.56-.57-.91-.77-.88-.5-.88-.82-.02-1.31.24-.13.48-.25.73-.37 1.21-.27 2.43-.44 3.67-.2 1.05.12 2.13.38 3.06-.41v-.41c.1-.06.19-.05.27.01.17.76.41 1.45 1.25 1.77.31.12.63.41.52.87Z"
			style={{
				fill: '#e8e1c6',
			}}
		/>
		<path
			d="M78 150.68c-.23 1.03-1.01 1.07-1.84 1.02-.45-.37-.97-.41-1.52-.41-.78 0-1.56.05-2.33-.05-.31-.04-.86.04-.94-.4-.06-.32.36-.55.61-.76 1.81-1.45 3.86-2.46 6.02-3.27.3.24.75.1 1.02.41-.65.34-1.4.28-2.08.58-1.07.48-1.32 1.32-.41 2.07.42.35.97.55 1.47.81Z"
			style={{
				fill: '#d4cfaa',
			}}
		/>
		<path
			d="M79.03 147.21c-.32-.19-.96.42-1.02-.41 1.66-1.22 3.65-1.16 5.56-1.39.27-.03.71.15.64.34-.19.52.29 1.17-.34 1.58-.42.27-.92.45-1.35.24-1.14-.56-2.33-.28-3.5-.36Z"
			style={{
				fill: '#d3cda9',
			}}
		/>
		<path
			d="m81.48 147.82-3.67.2c1.2-.54 2.43-.58 3.67-.2ZM84.54 147.41c-.6.69-1.85.86-3.06.41 1.04.01 2.09.09 3.06-.41ZM84.74 147h-.2v-1.84h.2c.41.61.4 1.22 0 1.84Z"
			style={{
				fill: '#e4dec0',
			}}
		/>
		<path
			d="M133.33 126.61v.2c.01 1.11.35 2.29-.69 3.17-1.51 1.63-3.64 1.69-5.59 2.17-1.71.42-3.47.62-5.23.78-1.22.11-2.28-.01-3.1-1.05-.67-.84-1.49-1.55-2.13-2.42-.73-.95-1.67-1.77-1.84-3.06.44-.66.8-1.3.84-2.19.02-.4.58-1.04.97-1.52.13-.15.31-.14.45 0 .24.26.29.62.05.83-1.29 1.09-.63 2.29-.27 3.49-.68.45-.33.93-.14 1.49.25.74.89.79 1.38.8.81.01 1.11.41 1.19 1.06.14 1.02.84 1.58 1.62 2.08.21.14.44 0 .67-.08 1.45-.52 2.87-1.15 4.49-.95.2.03 1.43.27.76-.83-.08-.13-.05-.25.09-.34.22-.15.44-.16.66-.02 1.7 1.09 3.14.31 4.52-.66.34-.24.8-.48.49-1.23-.23-.55.3-1.25.79-1.74Z"
			style={{
				fill: '#e7e3c7',
			}}
		/>
		<path
			d="M121.69 121.1c.85-.4 1.7-.57 2.61-.16.68.31.77.74.27 1.25-1.05 1.07-2.02 2.19-3.28 3.09-.94.67-1.79 1.2-2.91 1.39-1.2.2-2.06-.71-1.6-1.84.43-1.05.98-2.08 2.2-2.48.25-.08.45-.28.68-.43.61-.46 1.41-.42 2.04-.82Z"
			style={{
				fill: '#f3edd6',
			}}
		/>
		<path
			d="M121.69 121.1c-.41.95-1.33.62-2.04.82-1.31.28-2.58.31-3.82-.56 1.18-1.39 2.89-.58 4.23-1.07.26-.15.57-.14.85-.22.58-.17.81.07.78.63v.41ZM125.16 120.49c.36.04.74.2.68.59-.27 1.65-.3 3.61-1.86 4.48-.83.46-1.32 1.41-2.36 1.55-.36.05-.5.04-.55-.3-.02-.6.27-1 .82-1.22l1.22-1.02c.8-.02.92-.71 1.22-1.22l.2-.2c.17-.18.18-.47.41-.61.23-.45.49-.89.41-1.43-.1-.19-.34-.34-.2-.61ZM121.08 118.25h2.45c.25 0 .52.07.63.27.13.24-.07.45-.29.57-.5.28-.13.65-.13.99-.95.1-1.56-.53-2.25-1.02.18-.43-.44-.46-.41-.82Z"
			style={{
				fill: '#e8e4c6',
			}}
		/>
		<path
			d="M121.49 119.07c.82.18 1.48.71 2.25 1.02.17.33.64.08.82.41-.96.01-1.93-.19-2.86.2-.35-.9-1.1-.24-1.63-.41.28-.35.68-.38 1.09-.43.54-.06.56-.39.34-.8ZM124.35 123.35c-.03 1.31-.23 1.51-1.22 1.22.21-.61.62-1.02 1.22-1.22ZM121.9 125.59l-.82 1.22-.61-.2c.51-.29.58-1.2 1.43-1.02Z"
			style={{
				fill: '#e7e3c8',
			}}
		/>
		<path
			d="M117.2 118.66c.33-.37.88-.09 1.23-.41-.17.84-.8.33-1.23.41Z"
			style={{
				fill: '#e8e4c6',
			}}
		/>
		<path
			d="m125.16 120.49.2.61c-.3-.17-.67-.24-.82-.61h.61ZM119.86 126.81c-.33.52-.81.15-1.22.2.36-.37.82-.14 1.22-.2ZM124.96 122.53c-.1.23.04.62-.41.61-.22-.44 0-.58.41-.61Z"
			style={{
				fill: '#e7e3c8',
			}}
		/>
		<path
			d="M117.81 127.02c-.34.3-.68.3-1.02 0 .34-.23.68.07 1.02 0Z"
			style={{
				fill: '#e7e3c7',
			}}
		/>
		<path
			d="M118.02 118.05c1.13-.44 2.32-.09 3.47-.2-1.13.44-2.32.09-3.47.2ZM116.79 118.25c.36-.37.82-.14 1.22-.2-.36.37-.82.14-1.22.2Z"
			style={{
				fill: '#dedabc',
			}}
		/>
		<path
			d="m122.31 117.23-1.84.2c-.55-.41-1.18-.12-1.76-.2-.33-.04-.67.07-.93-.26-.13-.16-.29-.28-.16-.52.1-.19.24-.17.42-.14 1.02.19 1.94-.27 2.89-.5.2-.05.37-.07.57-.04 1.25.19 1.37.4.8 1.45Z"
			style={{
				fill: '#dbd4ab',
			}}
		/>
		<path
			d="M116.59 129.47c1.1.5 1.68 1.54 2.44 2.38.7.78 1.52.97 2.44.86 2.33-.26 4.66-.55 6.95-1.15 1.46-.38 2.94-.63 4.1-1.69.63-.59 1.5-.82 2.12-1.44.22-.23.64-.45.94.02-.12 1.61-1.43 2.33-2.45 3.26l-.61.2c-.39.12-.71.36-1.02.61h-.2c-1.01.43-2.04.8-3.13.99-1.55.27-3.1.56-4.69.45-1.41-.09-2.83.09-4.22-.22-.43-.39-.95-.13-1.42-.2-.35-.05-.74.12-1.03-.2.48-.66 1.24-.34 2.03-.55a50.98 50.98 0 0 0-2.03-2.24c-.23-.24-.69-.4-.41-.88l.2-.2Z"
			style={{
				fill: '#f2ecd2',
			}}
		/>
		<path
			d="M116.38 129.67c.78.86 1.55 1.74 2.35 2.58.21.21.39.43.34.69-.08.37-.45.19-.68.19-.55-.01-1.08.06-1.6.22-.17 0-.32-.04-.41-.2-.04-.36-.28-.41-.58-.41-.37 0-.74.02-1.11 0-1.28-.09-1.73-.62-1.79-1.88-.06-1.17-.11-2.33.42-3.42.27-.07.55.35.81-.02.23-.33 0-.42-.19-.68-.24-.34.25-.88-.01-1.34.71.36.48 1.08.6 1.65.23 1.17.63 2.18 1.85 2.63Z"
			style={{
				fill: '#f5eeda',
			}}
		/>
		<path
			d="M188.65 130.89c1.08-.05 2.16-.27 3.19-.5 1.48-.32 2.48.43 3.55 1.06.51.3.95.75 1.46 1.09.22.14.52.26.45.6-.07.31-.26.5-.6.61-1.55.49-3.01 1.12-3.99 2.54-.27.39-.79.62-1.19.93-.11.13-.16.3-.27.43-.19.22-.42.38-.71.2-.23-.15-.26-.43-.15-.64.4-.81.19-1.6.13-2.45-.1-1.39-.89-2.21-1.83-3-.34-.29-.84-.54-.03-.86Z"
			style={{
				fill: '#ccc49a',
			}}
		/>
		<path
			d="M188.65 130.89c-.08.19-.52.3-.04.59 1.21.74 2.01 1.69 2.15 3.27.08.92.33 1.74-.21 2.57-.05.08-.02.28.04.37.09.12.24.05.35-.04.18-.15.37-.29.56-.44v.41c.12.51-.32.7-.57.99-.46.54-1.07.95-1.44 1.57-.04.08-.09.16-.14.24-.23.34-.42.71-.59 1.08-.08.12-.19.21-.33.26-.1 0-.18-.05-.24-.12-.14-.41.05-.83-.06-1.24.01-1.02.44-1.82 1.26-2.42.48-.35.73-.79.55-1.4-.21-.67.33-1.26.17-1.96-.1-.44-.1-.82-.55-1.09-.53-.32-.66-1-1.11-1.41-.39-.06-.34-.52-.69-.72-.54-.31.33-.23.28-.5h.61Z"
			style={{
				fill: '#d0c9a2',
			}}
		/>
		<path
			d="M189.27 140.27c.23-.84 1.02-1.2 1.52-1.82.23-.29.48-.55.73-.83 1.18-.68 1.99-1.82 3.18-2.49.3-.17.53-.41.9-.36-.66 1-1.92 1.28-2.65 2.22-.46.6-1.01 1.16-1.3 1.85-.32.75-.6 1.36-1.57 1.02-.15.39-.36.64-.82.41Z"
			style={{
				fill: '#e0d8b4',
			}}
		/>
		<path
			d="M172.73 144.56c1.4-.46 2.87-.31 4.3-.44 1.17-.11 2.29-.63 3.51-.62.53 0 1.06.02 1.6-.06.64-.09 1.03-.26 1.33-.85.23-.45.68-.62 1.28-.75 1.01-.22 1.93-.88 2.89-1.35.15-.12.3-.11.45 0-.3.95-.97 1.69-1.79 2.08-1.72.81-3.36 1.82-5.39 1.83-2.32 0-4.58.9-6.94.64-.43-.05-.9.09-1.23-.31 0-.05 0-.11.01-.16Z"
			style={{
				fill: '#d0c9a2',
			}}
		/>
		<path
			d="M188.04 140.48h-.41c-.01-.14.02-.35-.05-.39-1.09-.71-.39-1.13.19-1.71.63-.64 1.47-1.25 1.04-2.43-.12-.34.16-.82.24-1.23.19-.95-.29-1.75-.6-2.59.3.01.47.17.61.44.21.4.39.83.96.91.25.03.56.35.38.6-.46.65.64 1.55-.36 2.09 0 0 .17.28.2.43.09.48.15 1-.33 1.28-1.01.6-1.45 1.52-1.67 2.61-.07.06-.13.07-.2 0Z"
			style={{
				fill: '#d3cba5',
			}}
		/>
		<path
			d="M170.69 144.15c.68.06 1.39-.15 2.04.2v.2c-.68.27-1.33.09-1.98-.11-.1-.08-.12-.18-.06-.3Z"
			style={{
				fill: '#d0c9a2',
			}}
		/>
		<path
			d="M136.82 101.78c.23 0 .47.02.7 0 .29-.04.48.03.49.34 0 .3.08.67-.35.72-.7.07-.87.42-.8 1.1.04.39-.31.82-.64.99-1.34.72-1.95 2.19-3.21 3-1.49.96-2.97 1.93-4.75 2.23-1.22.21-1.92-.87-1.85-2.08.11-2.02 1.58-3.15 2.94-3.76 2.23-1.01 4.41-2.36 6.96-2.6.17-.02.34 0 .51 0v.05Z"
			style={{
				fill: '#f4eede',
			}}
		/>
		<path
			d="M138.43 115.8c-1.01.24-1.88-.46-2.86-.41-1.03-.42-2.06-.82-3.08-1.26-.4-.17-.78-.4-1.15-.64-.22-.15-.25-.37-.12-.62.15-.27.28-.25.56-.16.96.31 1.92.55 2.82 1.05.83.45 1.75.71 2.74.62.26-.02.55 0 .8.08.3.1.71.08.84.48.17.51-.37.57-.56.86Z"
			style={{
				fill: '#f4eedc',
			}}
		/>
		<path
			d="M135.57 128.45c-.43-.28-.9.11-.97.27-.45.9-1.42.73-2.09 1.16.87-.86.5-2.05.82-3.06 1.13-.3 1.97.31 2.24 1.63Z"
			style={{
				fill: '#e7e1c7',
			}}
		/>
		<path
			d="M135.57 130.49a.75.75 0 0 0-.41.41c-.3.67-.54 1.39-1.41 1.57-.37.08-.73.17-1.04-.14.25-.35.88-.08 1.02-.61.9-.55 1.34-1.51 2.04-2.24h.21c.16.46-.12.74-.41 1.02Z"
			style={{
				fill: '#dfd6b5',
			}}
		/>
		<path
			d="m135.57 130.49.41-1.02c.19-.09.37-.23.38-.45.09-1.79.95-3.42 1.05-5.22.06-1.03-.42-2.07.02-3.1.2-.46.24-1 .79-1.23.77-.09 1.12.25 1.02 1.02-.65.04-1.36.02-1.27.99.05.22.12.43.16.65 0 .54-.04 1.08.11 1.61.02.14.02.27.02.41 0 .41-.08.81-.05 1.22 0 .14-.03.27-.08.39-.23.33-.15.77-.36 1.11-.22.32-.39.68-.64.98-.24.2-.32.46-.3.77v.27c-.05.66-.47 1.1-.91 1.53-.05.01-.09.03-.14.04h-.21ZM140.48 121.31l.61.41c1.97.35 2.91 1.87 3.77 3.41.27.49.41.81 1.05.82.7 0 1.18.43 1.18 1.22-.06.09-.14.13-.25.14-.55-.22-1.04-.55-1.69-.51-.47.03-.79-.32-.96-.76-.59-1.54-1.83-2.52-3.09-3.46-.27-.2-.56-.37-.79-.62-.18-.2-.45-.28-.66-.44-.26-.2-.34-.41 0-.61.28.11.46.44.82.41Z"
			style={{
				fill: '#d4caa3',
			}}
		/>
		<path
			d="M139.66 120.9c-.22.76.66.43.82.82-.51.64-1.11.57-1.5-.02-.39-.6-.72-.43-1.16-.18-.51-.59.16-.78.39-1.09.36-.48.69-.03 1.04.07.08.19.21.33.41.41Z"
			style={{
				fill: '#d4caa2',
			}}
		/>
		<path
			d="M147.01 127.22c-.24-.75-.65-1.23-1.55-1.03-.28.06-.59.05-.7-.38-.48-2.02-1.96-3.16-3.68-4.09.65.05 1.28.02 1.95.26.49.17 1.47-.08 1.58-.79.14-.9.77-1.03 1.37-1.31.07-.05.14-.05.2 0 .03.39-.38.54-.47.85-.15.48.43 1.08.93 1.07.32 0 .65.08.97.12-.2.83-.48 1.63-.66 2.47-.16.75-.14 1.45.33 2.1.5 1.07 1.2 1.99 2.08 2.77a.43.43 0 0 1-.13.27c-1.1-.19-2.07-1.19-2.23-2.3Z"
			style={{
				fill: '#e1d8b5',
			}}
		/>
		<path
			d="M142.13 119.96c.38-.05.64.16.54.44-.15.45-.31 1.08-.91 1.06-.64-.03-1.42-.63-1.31-1.04.19-.76 1.18-.05 1.68-.45Z"
			style={{
				fill: '#eee4c6',
			}}
		/>
		<path
			d="M146.19 119.88h-.2c-.22-.03-.62.02-.54-.26.13-.46.41-.89.69-1.28.12-.16.39-.07.52.11.15.21.28.38.55.21-.15.57-.16 1.25-1.02 1.22Z"
			style={{
				fill: '#e4ddbb',
			}}
		/>
		<path
			d="M147.21 126.61c-.43-.24-.62-.65-.6-1.1.07-1.27.17-2.54 1.01-3.59h.2c.73-.11 1.01.38 1.23.94.21.54.39 1.1 1.02 1.3v.61l-.61-.41c-.55-.17-.53-.87-1-1.11-.22-.11-.19-.61-.56-.44-.3.13-.58.38-.58.76 0 .92-.47 1.84-.02 2.77.04.09 0 .19-.09.27Z"
			style={{
				fill: '#e7e0be',
			}}
		/>
		<path
			d="M151.09 114.37c.59 1.13 1.18 2.25 1.03 3.6-.04.34-.24.43-.5.54-.72.28-.94-.51-1.47-.67-.41-.12-.33-.56-.22-.88.26-.71.34-1.51 1.01-2.03.18-.14.15-.36.15-.56Z"
			style={{
				fill: '#f1ead0',
			}}
		/>
		<path
			d="M156.4 121.72h-.41c-.28-.64-.97-.79-1.43-1.22.83.09 1.57.3 1.84 1.22Z"
			style={{
				fill: '#d1c597',
			}}
		/>
		<path
			d="M173.18 141.11c-.82.5-1.48.72-2.15.56-.68-.16-1.34-.18-2.02-.17-1.21.02-2.13-.85-3.29-1.05-.56-.1-.89-1-.77-1.42.26-.88.17-1.73.23-2.6.02-.23.12-.38.36-.41.22-.02.5.03.52.22.11 1.01 1.22 1.26 1.55 2.13.93 2.46 3.14 2.57 5.57 2.74Z"
			style={{
				fill: '#f0ead6',
			}}
		/>
		<path
			d="m148.23 138.44.2.82c-.97.07-1.24.68-1.24 1.55-.02 2.26-1.25 3.92-2.77 5.43-.69.69-1.68.84-2.45 1.37-2.27.13-4.53.09-6.81-.02-1.55-.07-2.92-.48-4.26-1.16-.37-.19-.72-.38-.89-.79a.34.34 0 0 1 .08-.32c.15-.09.34-.15.48-.06 1.14.72 2.51.76 3.74 1.22 1.1.41 2.31.44 3.5.45 1.22.01 2.44.04 3.65-.02l.27-.12c.61-.89 1.72-1.05 2.48-1.71 1.34-1.76 1.5-4.02 2.5-5.93.22-.41.34-.9.89-1.03.27 0 .49.09.63.33Z"
			style={{
				fill: '#e5dec6',
			}}
		/>
		<path
			d="M142.11 147.41c.12-.25.3-.45.56-.56 2.64-1.1 3.93-3.16 4.26-5.92.03-.23.04-.47.08-.7.15-1.1.36-1.25 1.43-.98 1.4 1.11 2.13 2.71 3.08 4.15.61.93.24 1.64-.63 2.17-.11-.1-.13-.23-.09-.37.45-1.41.2-2.22-1.03-3.21-.37-.44-.59-.98-1-1.39-.24-.24-.47-.54-.85-.46-.43.1-.34.53-.4.84-.18.82.16 1.7-.31 2.48-.87 1.6-2.18 2.8-3.65 3.82-.42.29-.9.86-1.45.13Z"
			style={{
				fill: '#e0dbbf',
			}}
		/>
		<path
			d="M155.99 147c1.07.24 2.13.55 3.24.41.29-.03.61.08.84-.21.23-.07.46 0 .7-.02q1.42-.18 1.46 1.29c-.23.49-.7.52-1.14.61-.83-.05-1.54.31-2.31.59-1.36.5-2.75.94-4.28.55-.92-.24-1.91-.47-2.9-.17-.27.08-.6.2-.8-.17-.02-.12.01-.23.08-.33.72-.54 1.54-.63 2.4-.52 1 .13 1.99.35 3 .33.76.07 1.46-.01 2.06-.57.41-.38.98-.42 1.5-.55.44-.11.86-.08 1.26.12-.59-.4-1.24-.57-1.95-.48-.64-.01-1.29.04-1.93-.04-.5-.06-1.02-.13-1.27-.68 0-.06.02-.12.02-.17ZM151.09 145.99c.11-.08.23-.14.33-.23 1.17-1.09 1.21-1.14 2.28-.04.4.41.85.73 1.28 1.09l-.11.11c-.68.34-1.13-.21-1.68-.41-.23-.04-.52-.13-.61.16-.35 1.25-1.49 1.29-2.43 1.63-.22.08-.45.11-.69.14-.2.02-.4 0-.57-.12-.21-.39.14-.51.34-.54 1.09-.13 1.55-.87 1.86-1.79Z"
			style={{
				fill: '#eee8d1',
			}}
		/>
		<path
			d="M149.87 141.91c.97.15.93 1.11 1.37 1.69.64.83-.19 1.33-.35 1.98a.72.72 0 0 0-.41.41c-.11 1.38-1.23 1.63-2.25 1.99-.21.04-.41.04-.59-.07-.4-.59-.01-.74.47-.91 1.42-.48 2.1-1.55 2.33-2.98.05-.32-.06-.2-.26-.3-.84-.42-.53-1.15-.31-1.82Z"
			style={{
				fill: '#dfd9bc',
			}}
		/>
		<path
			d="m148.23 138.44-.61-.2c-.03-.77-.82-.79-1.21-1.21-.27-.52-.57-1.04-.22-1.64h.21c.11.13.21.28.25.44.11.51.25.92.93.69.28-.1.55.29.87.1.68 0 .96.25.67.95-.18.42.11 1.26-.87.89Z"
			style={{
				fill: '#e8e2cb',
			}}
		/>
		<path
			d="M151.09 145.99c.11 1.61-1.18 1.82-2.25 2.24-1.11.91-2.3 1.7-3.74 2-.27.06-.54.07-.77-.12-.07-.47.33-.55.6-.7 1.12-.62 2.28-1.16 3.47-1.62.7-.3 1.5-.39 2.06-.97.29-.2.19-.71.61-.82Z"
			style={{
				fill: '#e8e3c9',
			}}
		/>
		<path
			d="M148.44 136.6c-.81.49-1.65.24-1.86-.56-.06-.22-.12-.44-.19-.67h.2c.09 1.2 1.29.72 1.84 1.22Z"
			style={{
				fill: '#e9e2c8',
			}}
		/>
		<path
			d="M150.48 146.8c-.39.91-1.32.76-2.04 1.02-.07.08-.14.08-.21 0 .84-.51 1.93-.69 2.25-1.84v.82Z"
			style={{
				fill: '#e0dbbf',
			}}
		/>
		<path
			d="M154.97 146.8c.34.05.73-.14 1.02.2-.4.25-.8.44-1.02-.2Z"
			style={{
				fill: '#eee8d1',
			}}
		/>
		<path
			d="M120.06 139.05v-.41c.55-.1.87-.4.99-.96.06-.32.16-.65.44-.88h.2c.58.58 1.39.34 2.08.58 2.2.76 4.41.53 6.6-.17.09-.03.2 0 .3 0-.04.61-.59.59-.96.8-1.03.17-1.73.73-2.05 1.74-.06.19-.16.37-.28.54-.46.68-.81 1.35-.45 2.24.16.4.08.94-.05 1.4-.17.24-.36.45-.68.48-.51-.73-1.18-1.01-2.06-.78-1.22-.21-2.27.23-3.29.82-.3-.02-.49-.23-.69-.4-1.07-.85-1.31-.8-2.05.46-.07.08-.16.1-.27.08-.54-.85-.14-1.55.34-2.25.08-.07.16-.12.25-.16 1.69-.2 1.96-.54 1.75-2.2-.03-.27-.11-.53-.14-.79v-.14Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M132.72 132.32c1.19.16 1.87-.55 2.45-1.43-.09 1.16-.93 2.08-1.04 3.23-.03.3-.56.5-.21.88.31.33.63 0 .94-.02h.3c-.13.27-.35.43-.65.4-1.57-.15-2.82.68-4.12 1.36-.3.16-.6.31-.95.28-1.13.16-2.27.09-3.41.08-.58 0-1.25-.2-1.35-.85-.11-.71.56-.9 1.11-1.1.88-.32 1.81-.51 2.63-.99.77-.18 1.53-.18 2.25.16.32.15.51.1.58-.26.16-.85.85-1.26 1.46-1.73Z"
			style={{
				fill: '#ded6af',
			}}
		/>
		<path
			d="M129.65 137.83c.34-.21.75-.29 1.02-.61l.61-.21c.71-.59 1.42-1.19 2.45-1.02l.2.41c-.17.3-.24.66-.49.92-2.07.23-3.39 1.73-4.86 2.92-.71.57-.65 1.57-.59 2.69.58-.91 1.19-.79 1.96-.59.99.26 2.03.05 2.91-.53.43-.28.87-.52 1.35-.69.3-.15.58-.34.92-.4.15-.01.29.02.41.1.14.69-.45.81-.85 1.06-.28.17-.66.13-.92.39-.91.5-1.74 1.08-2.9 1.02-.65-.04-1.09.59-1.29 1.25-.08.25.03.55-.24.74-.25.12-.51.11-.77.03-.98-.28-1.37-1.05-1.59-1.94-.5-2.06.37-4.12 2.21-5.26.14-.09.29-.18.42-.28Z"
			style={{
				fill: '#ede9d3',
			}}
		/>
		<path
			d="M128.43 134.16c-.38.81-1.29.62-1.9.99-.27.17-.65.16-.96.27-.33.12-.63.36-.71.68-.09.37.35.44.57.61.29.24.66.34 1.04.3.99-.1 1.99-.09 2.98 0-1.53.37-3.06.24-4.59.07-.67-.08-1.33-.09-1.66-.88-.24-.58.03-1 .45-.96 1.73.15 3.13-.98 4.78-1.07Z"
			style={{
				fill: '#e1d9b4',
			}}
		/>
		<path
			d="M119.24 133.75c1.66.08 3.31.03 4.97.13 1.45.09 2.92-.48 4.39-.6.97-.08 1.73-.75 2.69-.75-1.22.88-2.68 1.06-4.08 1.43-2.65.23-5.31.36-7.96 0v-.2Z"
			style={{
				fill: '#efe8cb',
			}}
		/>
		<path
			d="M132.72 132.32c-.5.7-1.26 1.23-1.35 2.2-.04.43-.44.27-.63.14-.71-.46-1.5-.51-2.3-.51 1.51-.43 2.82-1.32 4.29-1.84Z"
			style={{
				fill: '#dfd6b5',
			}}
		/>
		<path
			d="M133.74 135.99c-.93.07-1.66.62-2.45 1.02.49-.84 1.3-1.14 2.19-1.2.44-.03.85-.14 1.28-.22-.2.48-.63.4-1.02.41Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M131.49 132.52c.21-.42.53-.66 1.02-.61-.3.26-.59.57-1.02.61Z"
			style={{
				fill: '#efe8cb',
			}}
		/>
		<path
			d="M137.82 121.51c.63-.93.81-.95 1.23-.08.36.76.89.49 1.43.28.83.8 1.91 1.31 2.62 2.28.5.69 1.17 1.18 1.4 2.13.25 1.02 1.73-.07 2.18.94.03.06.08.1.13.16.35.31.48.72.48 1.17-.41.28-.64-.02-.8-.31-.41-.72-1-.83-1.73-.63-.6.16-1.16.23-1.31-.61-.05-.31-.32-.44-.62-.41-.39.04-.27.37-.34.61-.56 1.88.03 3.8-.18 5.69l.49.46c-.76-.24-1.76.18-2.17-.94-.13-.37-3.2-.2-3.45.18-.26.39-1.01.59-.78 1.15.24.57.89.21 1.36.24.63.05 1.27.09 1.9.13-.92.54-1.93.43-2.91.34-.41-.03-.75-.56-1.25-.1-.1.09-.53-.05-.66-.35-.13-.29.03-.46.26-.57.53-.25.34-.77.41-1.16.06-.36-.02-.73.34-.97.31.15.14.72.61.68.1 0 .16-.12.15-.23-.03-.57-.57-.3-.76-.45-.06-.25-.06-.46-.06-.66.26-.55 1.24-.74.82-1.63v-.2c.15-.26.19-.58.41-.82.17-.36.26-.77.61-1.02.36-.25.24-.69.41-1.02v-.41c.14-.41.18-.82 0-1.22v-.41c.09-.54.09-1.09 0-1.63-.24-.15-.2-.39-.2-.61Z"
			style={{
				fill: '#d2c79a',
			}}
		/>
		<path
			d="M153.34 138.24c.5.13.77-.4 1.22-.41-.33.36-.53 1.12-1.22.41Z"
			style={{
				fill: '#d1c99d',
			}}
		/>
		<path
			d="M162.52 148.23v.41c.53.43 1.15.34 1.75.34.83-.01 1.62.08 2.3.61.07.1.07.2 0 .31-.19.17-.42.25-.66.2-1.02-.19-2.06-.23-3.09-.37-.66-.09-1.08-.44-.63-1.19 0-.11.04-.22.12-.3h.2Z"
			style={{
				fill: '#e1d9b5',
			}}
		/>
		<path
			d="M162.32 148.23v.2c-.07.09-.13.09-.2 0 .15-.94-.12-1.46-1.18-1.11-.33.11-.59.04-.87-.11.41-.34.95-.32 1.41-.37 1.14-.12.75.8.84 1.39Z"
			style={{
				fill: '#e9e2c6',
			}}
		/>
		<path
			d="M166.6 149.66c-1.08-.39-2.2-.47-3.33-.41-.42.02-.72-.13-.75-.61.06-.08.17-.16.17-.24.1-2.11 1.36-3.64 2.56-5.21.4-.53.97-.64 1.44-.38 1.26.7 2.7.78 3.99 1.34v.2c-.07.09-.16.15-.26.19-.59.15-1.15.05-1.65-.27-.33-.21-.69-.25-1.06-.28-.2-.03-.39-.12-.57-.21-.86-.41-.86-.41-.93.5-.01.14 0 .32-.12.35-1.08.26-1.22 1.55-2.25 1.97-.71.29-.32 1.25-.28 1.87.04.51.67.28 1.04.3.44.03.88-.15 1.32-.04.52.14 1.08.23 1.08.96-.14.07-.28.08-.4-.04Z"
			style={{
				fill: '#d0c89d',
			}}
		/>
		<path
			d="M133.53 137.22c-.34-.51.05-.65.41-.82 1.17-.25 2.24-.83 3.43-1.04.72-.13 1.39.1 2.1 0 1.13-.16 2.26-.58 3.41-.36.84.16 1.65.24 2.49.17.17 0 .32.04.41.2-.41.28-1.07.26-1.09 1.04 0 .23-.52.23-.82.24-.78.02-1.56-.04-2.33.02-.76.06-1.55.05-2.09.79-.34.46-.74.43-.98-.17-.34-.86-1.02-.99-1.83-.84-.67.13-1.31.32-1.9.66-.38.22-.77.46-1.2.09Z"
			style={{
				fill: '#ebe3d0',
			}}
		/>
		<path
			d="M133.53 137.22c1.17-.04 2.04-.96 3.21-1.08.72-.08 1.19.31 1.79.46.62.16-.26 1.01.49.99.5-.01.22-.78.69-.87.59-.12 1.18-.26 1.78-.3.81-.05 1.62-.01 2.43-.01.43 0 .77.14.68-.66-.08-.68.78-.2 1.18-.36h.41c.07.56.18 1.11.41 1.63.11.12.13.25.05.4-.08.06-.18.07-.27.04-.45-.51-.87-.64-1.63-.43-.74.21-1.58.21-2.37.32-1.1.14-2.09.47-3.1.86-1.55.6-1.96.33-2.25-1.21-.73-.25-1.35.04-1.9.46-.63.48-1.31.74-2.08.63-1.36-.2-2.94 1.72-2.87 3.23.03.52.32.72.8.69.59-.03 1.11-.26 1.6-.6.56-.39 1.16-.56 1.78-.12-1.1.51-2.07 1.33-3.37 1.37-.41.02-.8.09-1.19-.08-.52-.23-1.08-.6-1.31.35-.04.17-.24.34-.49.25-.2-.07-.34-.19-.37-.43-.19-1.22.5-2.69 1.59-3.31.61-.34.96-.95 1.5-1.34.83-.6 1.77-.92 2.82-.89Z"
			style={{
				fill: '#efe9d7',
			}}
		/>
		<path
			d="M142.31 132.73c-.17-.03-.35-.04-.34-.28.08-1.08.21-2.14-.05-3.24-.22-.94.48-1.82.33-2.82-.05-.31.57-.3.74-.22.29.14.95.06.78.67-.18.6.25.61.5.49 1.24-.57 2.08-.18 2.67.97.04.07.17.1.26.14.85.68 1.79 1.2 2.75 1.69.53.27.37.64-.16.88.53.37.85-.31 1.28-.11v.2c0 .99-.74 1.58-1.68 1.35-.58-.14-1.07-.46-1.37-.97-.44-.74-.8-.5-1.22 0-.27.32-.37.96-1.04.64-1.24-.24-2.31.42-3.47.61Z"
			style={{
				fill: '#d2c798',
			}}
		/>
		<path
			d="M145.78 132.12c.85-.02.77-.97 1.33-1.34.5-.33.7-.33.89.18.1.27.25.47.44.67 1.06 1.1 1.99.92 2.64-.52.96.05 1.89.09 2.31 1.25.19.53.61.93 1.25 1.07.5.11.91.46 1.11.97.14.36.25.75-.36.8-.1 0-.24 0-.29.06-.59.73-1.49 1.15-1.95 2.05a56.8 56.8 0 0 0-.65-1.13c-.3-.49-.73-.73-1.32-.64-.76.11-1.19-.09-.89-.95.32-.91-.03-1.13-.95-1.16-.88-.02-1.7-.31-2.45.52-.24.27-1.04.04-1.33-.29-.4-.46-.33-1.07.2-1.52Z"
			style={{
				fill: '#d1c893',
			}}
		/>
		<path
			d="m151.09 130.89-.56.44c-.27.21-.57.24-.85.05-.13-.09-.31-.27-.3-.38.06-.4.5-.24.81-.42-.93-.87-2.44-.84-2.98-2.13l-.41-1.22h.2c.55.94 1.21 1.79 2.24 2.25.19-.02.36.04.52.12.27.19.58.26.9.32.73.21 1.44.47 2.16.71.23.08.55.09.51.47-.76.08-1.48-.32-2.24-.2Z"
			style={{
				fill: '#d4cba3',
			}}
		/>
		<path
			d="M147.21 126.61c-.61-1.18-.06-2.35.08-3.52.04-.37.43-.77.82-.81.41-.04.23.47.38.7.3.47.64.92.97 1.38v.2c-.49-.03-.5-.5-.71-.78-.24-.33-.55-.51-.96-.43-.5.1-.28.52-.38.81-.45 1.42.35 2.52.89 3.7.42.92 1.44.74 2.13 1.18 1.49.96 3.15 1.45 4.95 1.42v.2l-.41.2c-.05 0-.11 0-.16.01-2.01-.03-3.82-.71-5.56-1.65-.83-.77-1.78-1.44-2.04-2.65Z"
			style={{
				fill: '#ede5c7',
			}}
		/>
		<path
			d="m154.77 131.3-1.02-.2c.32-.6.8-.22 1.22-.2l-.2.4Z"
			style={{
				fill: '#e2d7b0',
			}}
		/>
		<path
			d="M154.97 130.89c-.41.07-.87-.16-1.22.2h-.41c-.95-.34-1.91-.68-2.86-1.02-.26-.16-.59-.19-.82-.41-.17 0-.32-.04-.41-.2v-.21c1.38.28 2.6 1 3.97 1.32.58.14 1.23-.14 1.74.31Z"
			style={{
				fill: '#e4dbb9',
			}}
		/>
		<path
			d="M84.74 147v-1.84c0-.22-.04-.47.2-.61.19-.32.24-.69.41-1.02l.2-.2c.23-.25.29-.63.61-.81.37.15.44.52.61.82-.07.08-.15.14-.24.19-.99.54-.96 1.56-1.1 2.47-.08.5.06 1.01.01 1.52-.02.17-.02.41.12.47.99.41 1.69 1.46 2.87 1.39 2.13-.11 4.26.12 6.4-.06 1.82-.15 3.46-.87 5.07-1.65 1.4-.68 2.83-1.31 3.96-2.43.12-.12.3-.16.47-.08.09.43-.22.7-.41 1.02-.26.37-.71.51-1.02.82-2.15 1.54-4.56 2.42-7.15 2.86-.39.39-.95.18-1.39.39-.33.08-.64.2-.97.26-1.64-.13-3.29-.25-4.94-.2-.69.02-1.28-.36-1.88-.65-.18-.34-.43-.67-.78-.78-.98-.3-1.19-.98-1.06-1.87Z"
			style={{
				fill: '#efead5',
			}}
		/>
		<path
			d="M85.35 143.54c.01.4-.08.76-.41 1.02-.01-.4.08-.75.41-1.02ZM86.17 142.52c-.17.3-.24.67-.61.81.07-.37.13-.75.61-.81Z"
			style={{
				fill: '#e8e5cf',
			}}
		/>
		<path
			d="m110.87 142.93.2-.61c.59-.7 1.01-.27 1.43.2.49.67 1.35.89 1.85 1.54.7.9 1.08 1.97 1.37 3.03.27.99.56 1.94 1.04 2.84.31.57.51 1.18.54 1.83.01.11 0 .21-.02.31-.06.15-.17.26-.32.33-.1.03-.2.03-.3 0-.36-.19-.52-.54-.57-.91-.26-2.02-1.39-3.77-1.83-5.74-.1-.43-.45-.66-.88-.75-.7-.14-1.25-.49-1.66-1.27 0 .04-.11.25 0 .17.26.58.04.88-.56.98-.71-.55-.43-1.26-.31-1.95Z"
			style={{
				fill: '#e4ddbc',
			}}
		/>
		<path
			d="M111.49 134.77c1.52-.44 3.09-.42 4.59-.13.7.13 1.3.82 1.86 1.46.82.93 1.46 1.95 2.13 2.96.29.85.02 1.64-.23 2.43-.21.66-.91.58-1.4.83-.96.58-.79 1.63-1.04 2.51-.35.17-.58-.04-.8-.26.07-.36.25-.75.18-1.08-.24-1.22.52-1.68 1.44-2.07 1.14-.48 1.68-2 1.01-3.06-.3-.47-.56-.98-1.23-1.24-.52-.21-.88-.93-1.22-1.47-.44-.69-1.06-.87-1.81-.87h-3.47Z"
			style={{
				fill: '#e7e1bc',
			}}
		/>
		<path
			d="m116.59 144.56.82.2c.23-.11.43.01.63.11 1.07.88 2.36.9 3.64.87 1.05-.02 2.09-.08 3.13.04.44.05.91 0 1.27-.25.6-.41 1.25-.47 1.93-.42.42.14.91.05 1.26.41.05.11.03.22-.03.31-.64.39-1.38.11-2.05.34-.39.09-.78.12-1.08.47-.59.69-1.12.75-1.92.25-.25-.15-.44-.25-.74-.19-1.65.34-3.26.32-4.8-.46-.21-.11-.45-.14-.68-.21a1.11 1.11 0 0 1-.48-.28c-.23-.34-.67-.45-.9-.79v-.41Z"
			style={{
				fill: '#e1dab9',
			}}
		/>
		<path
			d="M117.2 151.9c-.81-2.22-1.61-4.44-2.45-6.65-.26-.68-.6-1.36-1.34-1.67-.48-.2-.7-.62-.9-1.06 1.07.53 2.12 1.08 2.65 2.24.49.74.78 1.55.94 2.42.02.09.03.19.04.28.07.6.42 1.04.78 1.48.76.92.86 1.91.28 2.95Z"
			style={{
				fill: '#e2dcbb',
			}}
		/>
		<path
			d="M115.98 147.21c-.25-.82-.73-1.57-.82-2.45.48.01.98-.08 1.43.2.42.07.81.2 1.02.61-.87.22-1.24.93-1.63 1.63Z"
			style={{
				fill: '#e0d8b4',
			}}
		/>
		<path
			d="M88.62 154.96v-.2l.09-.12c.66-.42 1.44-.46 2.16-.69.88-.21 1.75-.51 2.68-.5.22 0 .52 0 .59-.29.07-.3-.15-.5-.38-.66-.34-.25-.76-.26-1.15-.35-1.64-.37-3.35-.52-4.89-1.27-.35-.17-.79-.28-.74-.82.59-.29 1.06.21 1.6.22 1.41.19 2.81.46 4.13.98.94.37.73-.67 1.16-.89.56-.22 1.17-.09 1.73-.29.05 0 .1-.01.15-.02h.61c-.31 1.21-.31 1.19.94 1.23.79.02 1.58.22 2.33-.21.99-.37 2.06-.29 3.06-.61 1.03-.4 2.01-.87 3.19-.88.67 0 1.19-.78 1.67-1.32.31-.35.52-.8 1.06-.86.16.04.27.14.31.3-.22 1.21-1.6 2.45-2.78 2.47-.8.01-1.55.19-2.13.79-.37.39-.83.52-1.36.58-1.17.12-2.3.56-3.5.38-.06 0-.15 0-.2.04-1.06.89-2.32.42-3.56.51.04.53.26 1.1-.29 1.48-1.64.58-3.41.52-5.06 1.04-.47.15-.97.38-1.44-.05Z"
			style={{
				fill: '#e3ddbb',
			}}
		/>
		<path
			d="m108.83 147.62-.2-.2c.07-.7.15-1.4.2-2.1.02-.27.04-.41.4-.38.92.07 1.37-.34 1.27-1.31-.03-.26.14-.51.37-.68l.2 1.83c.15.96-.74 1.4-1.08 2.11-.3.39-.54.86-1.16.75Z"
			style={{
				fill: '#e1dbbc',
			}}
		/>
		<path
			d="M102.71 150.47c-.9.81-2 .59-3.06.61-.09-.35-.69-.01-.65-.46.04-.38.44-.42.71-.6.78-.52 1.54-.42 2.37-.27.48.09.65.27.63.71Z"
			style={{
				fill: '#ded9b4',
			}}
		/>
		<path
			d="M121.49 136.81c.02.48-.27.89-.34 1.34-.11.8-.51.82-1.09.5-.18-.43-.37-.85-.53-1.29-.19-.49-.04-.78.53-.75.41-.15.82-.15 1.22 0l.2.2Z"
			style={{
				fill: '#eee7cc',
			}}
		/>
		<path
			d="M121.28 136.6h-1.22c.41-.31.82-.31 1.22 0Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M98.42 137.62c1.08.5 1.66 1.73 1.13 2.71-.35.66.1 1.21.04 1.82-.03.36-.01.59-.32.75-.64.33-.45.77-.15 1.17.31.42.58.34 1.08.05 1.56-.89.64-2.4 1.03-3.57.13-.4-.09-.91-.1-1.37-.02-.93-.21-1.97 1.16-2.17.12.78.92 1.17 1.07 1.96.19.96.73 1.85.59 2.87-.05.35-.03.75.13.98.47.67.24 1.19-.16 1.74-1.32.39-2.4 1.33-3.77 1.6-.44.09-.75.42-1.09.71-.88.76-1.86.82-2.9.34.26-.6.75-.32 1.13-.24.49.1.7-.08.77-.52.09-.56-.4-.35-.62-.4-.94-.22-.8-.21-.92-1.18-.08-.64-.41-1.32-.67-1.96-.12-.29-.42-.01-.61.08-.33.15-.5.57-.93.55.05-.95.79-1.26 1.51-1.36 1.17-.16 1.73-1.14 2.59-1.71.42-.28.53-.98.3-1.6-.15-.4-.42-.78-.31-1.25Z"
			style={{
				fill: '#eae4d0',
			}}
		/>
		<path
			d="M104.34 145.17c-1.68 1.72-3.89 2.59-6.01 3.56-2.28 1.04-4.74 1.03-7.2.91-.84-.04-1.68-.05-2.51.03-.81.07-1.43-.27-2.02-.73-.29-.23-.53-.52-.95-.53-.26-.01-.47-.19-.47-.45.03-1.5-.26-3.05.75-4.39.2-.26.34-.41.64-.23.16.16.18.35.1.56q-.87.83-.78 3.78c.73-.31 1.2.11 1.72.53.39.31.77.85 1.41.48.2-.11.44-.24.44-.51 0-.29-.23-.43-.46-.46-1.13-.13-1.53-1-1.93-1.86-.19-.4-.34-.84.19-1.14.39.19.54.59.79.9 1.44 1.85 3.18 2.69 5.62 2.28 1.34-.23 2.72-.49 4.1-.51.27 0 .55.03.78-.16 1.19-.97 2.76-1.25 3.98-2.2.52-.41 1.19-.5 1.8-.06v.2Z"
			style={{
				fill: '#f3eedb',
			}}
		/>
		<path
			d="M104.34 144.97c-1.02-.41-1.69.31-2.48.71-1.64.84-3.15 1.83-5.13 2.04-1.57.17-3.16.37-4.75.51-.92.08-1.55-.51-2.31-.86-1.26-.58-1.72-1.68-2.47-2.61-.52-.04-.51-.47-.61-.82v-.61h.2c.79.6 1.09 1.57 1.69 2.32.99 1.25 2.26 1.86 3.7 1.91 1.32.04 2.69-.03 4-.36 1.18-.02 2.32.19 3.25-1.07.45-.61 1.78-.38 2.53-.97.6-.48 1.25-.64 1.98-.61.19.08.33.21.41.41Z"
			style={{
				fill: '#ece8d6',
			}}
		/>
		<path
			d="M102.91 147c.2-.45.62-.62 1.02-.82h.2c-.3.43-.72.69-1.23.82Z"
			style={{
				fill: '#eae4d0',
			}}
		/>
		<path
			d="M94.34 150.06c.43-.39.95-.13 1.43-.2v.2c-.48.24-.95.32-1.43 0Z"
			style={{
				fill: '#e8e1c6',
			}}
		/>
		<path
			d="M98.42 137.62c.58.9 1.09 1.95.33 2.83-.65.75-1.39 1.61-2.45 1.84-.85.18-1.51.51-1.96 1.25-.54 0-1.05.18-1.61.12-.66-.08-1.12.36-1.55.79-.19.19-.29.47-.61.49-.86.07-2.28-1.47-2.15-2.34.25-1.65 1.16-2.82 2.54-3.71.94-.6 1.84-1.25 2.76-1.88l2.47-.18c.86-.06 1.62.15 2.23.79Z"
			style={{
				fill: '#eeead7',
			}}
		/>
		<path
			d="M167.63 143.74c.61-.12 1.09.17 1.58.47.39.24.85.11 1.28.14.73.33 1.39.79 2.31.54 1.23-.33 2.48.58 3.7.13 1.52-.56 3.11-.46 4.65-.76 1.24-.24 1.68.06 2.38 1.56.77 1.65 2.06 1.87 3.38.65.55-.51 1.21-.77 1.94-.28.2.34.47.62.82.82-.02.54-.46.44-.75.42-1-.08-1.87.25-2.69.75-.63.39-1.29.56-2.04.43-.75-.13-1.48.08-2.21.22-.5.09-1.01.24-1.44-.19-.43-.4-.98-.42-1.52-.47-.89-.09-1.75-.24-2.33-1.03-.23-.31-.51-.3-.81-.18-.62.25-1.1.04-1.58-.35-.58-.48-1.25-.62-1.99-.46-.91.19-1.75.16-2.31-.76-.17-.28-.48-.35-.79-.39-.59-.27-1.21-.47-1.67-.97-.02-.11 0-.2.09-.28Z"
			style={{
				fill: '#cdc497',
			}}
		/>
		<path
			d="M180.69 148.43c.43.49.93.19 1.39.11.82-.15 1.63-.36 2.48-.14.42.11.8-.02 1.16-.24 1.08-.65 2.18-1.23 3.52-.96.17.03.33-.05.44-.2 1.36.48 2.72.95 4.08 1.43.12.13.12.26.04.41-.08.06-.18.09-.28.09-.7 0-1.32-.29-1.97-.52-.9-.09-1.29.29-1.65 1.62-.12.09-.26.1-.37.01-.6-.5-1.01-.26-1.36.31-.11.18-.24.42-.54.32-.73.1-1.17.48-1.46 1.2-.26.63-.88.9-1.52.46-.63-.44-1.2-.98-1.77-1.5-.27-.25-.59-.51-.88-.31-.94.65-1.97.23-2.95.36-.21-.34-.61-.6-.52-1.06.23-1.11 0-1.54 1.45-1.35.22.03.47.08.7-.04Z"
			style={{
				fill: '#d1c897',
			}}
		/>
		<path
			d="M188.86 146.19c-.85 0-1.57.07-2.13.93-.49.76-2.76.32-3.16-.51-.23-.47-.58-.97-.7-1.39-.23-.85-.65-.83-1.31-.76-1.25.13-2.53.09-3.75.36-.67.15-1.35.67-2.02.59-1.34-.15-2.63-.8-4.03-.17-.08.03-1.02-.32-1.27-.89h.2c.69 0 1.38-.04 2.04.2 1.41.39 2.87.37 4.25.1 1.58-.31 3.18-.43 4.77-.68.94-.15 1.95-.04 2.64-.93.11-.15.34-.27.53-.28 1.55-.09 2.18-1.4 3.13-2.3h.2c.47.41-.01.82 0 1.22 0 .05 0 .09-.01.14-.54.89-.43 1.83-.22 2.77.32.43.68.84.85 1.37v.2Z"
			style={{
				fill: '#cbc39a',
			}}
		/>
		<path
			d="M184.77 154.75c.66-.13.32-.66.41-1.02.14-.12.28-.11.43-.03.22.64-.25 1.43.52 1.95 1.21.81 2.48 1.39 3.97 1.35.74-.02 1.48-.01 2.22-.01 1.17.17 2.03-.58 2.97-1.06.42-.21.61-.56.16-1.05-.45-.5-.78-1.09-1.56-1.16-.53-.05-.58-.47-.17-.63 1.06-.41 1.5-1.37 2.13-2.16.24-.3.54-.51.96-.45-.26.48-1.32.51-.82 1.43.4.93.42 2.02 1.31 2.76.2.16-.05.78-.4 1.06-.63.52-1.16 1.16-1.81 1.63-1.01.73-2.28.88-3.46.93-.63.03-1.33.04-1.99-.03-.82-.09-1.51-.24-2.21-.81-.61-.5-1.58-.48-2.27-1.01-.67-.52-.81-.97-.4-1.67Z"
			style={{
				fill: '#d8cea2',
			}}
		/>
		<path
			d="m188.45 141.7.2-.21c.22-.2.11-.83.71-.56.09.14.11.3.1.47-.22.61-.35 1.24-.46 1.87-.28 1.69.68 2.78 2.35 2.86 1.28.06 2.47-.47 3.73-.43.23 0 .47.01.92-.04-1.08-.06-1.84-.44-2.53-.91-.77-.52-.72-1.23.08-1.63.26.37-.58.86.06 1.11.73.28 1.34.95 2.19.82.7-.11 1.38-.07 2.35-.06-.76.46-1.31.74-1.74 1.19-1.98.79-3.99 1.3-6.12.61-.68-.06-.88-.78-1.43-1.02-.37-.3-.58-.69-.67-1.15-.03-.76-.03-1.52 0-2.28 0-.25.1-.46.26-.65Z"
			style={{
				fill: '#e7debd',
			}}
		/>
		<path
			d="M192.33 157c-2.31.73-5.16.08-6.71-1.47-.49-.49-.27-1.19-.03-1.8.4-.7 1.13-.87 1.8-.99.95-.17 1.92-.44 2.91-.16.46.13.86-.07 1.21-.38.31-.26.59-.56.96-.75.09-.05.19-.08.3-.1.17-.01.31.02.42.16-.24.86-.79 1.44-1.6 1.8-.49.15-.98.17-1.5.11-1.2-.14-2.35.01-3.42.66-.69.42-.78.73-.15 1.29.74.66 1.59 1.14 2.63 1.15h2.13c.37 0 .75-.05 1.04.27v.2Z"
			style={{
				fill: '#e2d9b1',
			}}
		/>
		<path
			d="M192.33 156.79c-1.05 0-2.11-.01-3.16 0-1.25.02-2.2-.61-3.03-1.42-.61-.59-.42-1.06.29-1.48 1.29-.77 2.65-.91 4.1-.68.38.06.8-.06 1.2-.09l.06.13c-.01.1-.05.18-.12.26-.19.17-.42.23-.67.25-.41.04-.81-.06-1.21-.13-.68-.12-1.33-.06-1.67.64-.32.65-.99.27-1.41.53-.04.3.14.46.31.52 1.74.54 3.43 1.45 5.35.86.36-.11.7-.28 1.08-.09l.1.1c-.27.47-.72.6-1.23.61Z"
			style={{
				fill: '#e8debb',
			}}
		/>
		<path
			d="m191.72 153.12 1.43-1.63c0-.34.17-.34.41-.2.38.13.94-.31 1.13.3.12.39-.11.7-.53.84-.19.06-.37.17-.55.27-.14.08-.3.17-.41.29-.41.43-.23.8.17 1.1.1.07.26.05.39.08.65.16 1.5.5 1.42 1.07-.07.52-.93.87-1.63.93-.17-.19-.12-.4.03-.54.6-.55.47-.82-.31-.84-.59-.02-.97-.26-1-.88-.02-.39-.33-.56-.56-.8Z"
			style={{
				fill: '#e8debb',
			}}
		/>
		<path
			d="M190.29 146.8c1.72.21 3.39.1 5.02-.54.33-.13.73-.06 1.1-.08h.41c-.41.46-.91 1.25-.96 1.62-.37-.6-.78-.51-1.22-.17-.26.2-.53.4-.92.27-1.14-.38-2.28-.74-3.43-1.11Z"
			style={{
				fill: '#e0d8b4',
			}}
		/>
		<path
			d="M193.76 148.83v-.4c.69.11 1.63-.37 1.97.59.32.9-.8.95-1.13 1.5-.21.35-.62.52-1.04.57-.07.08-.15.09-.24.02.17-.68.8-.95 1.24-1.39.52-.51.15-.58-.29-.64-.19-.03-.38-.07-.51-.24Z"
			style={{
				fill: '#d6cc9f',
			}}
		/>
		<path
			d="M188.45 141.7v.61c-.17.82-.17 1.63 0 2.45.14.34.27.68.41 1.02v.21c-.46-.31-.68-.82-1.02-1.22-.15-1.06-.31-2.12.41-3.06h.2Z"
			style={{
				fill: '#d5ceab',
			}}
		/>
		<path
			d="M201.11 141.29c-.08-.48.25-.66.61-.82-.01.41-.28.64-.61.82Z"
			style={{
				fill: '#e1dab4',
			}}
		/>
		<path
			d="M193.35 151.08h.21v.2c-.17 0-.32.04-.41.2h-.41a.307.307 0 0 1-.02-.28c.18-.2.37-.35.63-.13Z"
			style={{
				fill: '#d9cfa1',
			}}
		/>
		<path
			d="M184.77 154.75c-.3.75.09 1.17.68 1.57.88.59 2.08.48 2.81 1.44.37.48 1.09.16 1.63.22 1.58.15 3.22.09 4.66-.56.93-.42 1.67-1.31 2.39-2.08.17-.18.54-.81-.13-1.1-.77-.34-1.12-.83-.65-1.67.13-.23-.06-.45-.15-.67 1.02-.13 2.05.13 3.08-.11.36-.08.77.23.79.74.01.4 0 .81 0 1.21-.11 2.32-.76 4.42-2.72 5.83a7.14 7.14 0 0 1-3.3 1.31c-1.93.23-3.74-.3-5.55-.86-.26-.08-.45-.38-.68-.57-.14-.13-.1-.29-.08-.46.12-.94-.06-1.15-.97-1.16-.57-.01-1.14-.02-1.61-.41-1.06-.51-.66-1.51-.74-2.33-.02-.24.17-.52.54-.32Z"
			style={{
				fill: '#d7cd9c',
			}}
		/>
		<path
			d="M193.55 143.13c-.63.75-.56 1.07.23 1.55.83.51 1.76.72 2.8.81-.44.61-.94.46-1.39.49-.44 0 .68-.29-.06-.28-.79 0-1.51-.36-2.13-.82-.66-.48-.83-1.34-.3-1.85.83-.81 1.65-1.64 2.55-2.39.05.01.1.03.15.04-.03 1.03-.96 1.49-1.43 2.24l-.41.2Z"
			style={{
				fill: '#e9e2c3',
			}}
		/>
		<path
			d="M189.27 141.29v-.41c-.16-.2-.13-.41 0-.61.36.03.53-.29.82-.41.44.26.05 1.12.6 1.12.61 0 .5-.78.79-1.18 1.19-1.65 2.55-3.13 4.44-4.01.37-.17.58-.59 1.03-.61.91-.03 1.45.94.94 1.82-.35.59-.59 1.21-.86 1.83-.69.48-1.03 1.27-1.63 1.84-.4-.5-.08-.87.21-1.26.54-.73.97-1.54 1.43-2.33.13-.22.32-.51.15-.76-.21-.29-.51-.05-.73.05-2.06.88-3.73 2.14-4.53 4.35-.22.6-.26 1.48-1.23 1.53a.582.582 0 0 1-.25-.12c-.2-.53-.63-.76-1.16-.84Z"
			style={{
				fill: '#e9e2c3',
			}}
		/>
		<path
			d="M163.13 167.19v.21c0 .49-.39.64-.74.81-.77.45-1.46 1.02-2.26 1.41-.31.2-.72.3-.89.64-.47.93-1.3 1.24-2.23 1.29-.76.04-1.46.45-2.24.34 0-.17-.04-.32-.2-.41v-.2c2.99-.83 5.76-2.09 8.17-4.08.14-.11.27-.12.41 0Z"
			style={{
				fill: '#d4c99f',
			}}
		/>
		<path
			d="M143.34 170.05v-.2l.06-.15c.22-.42.4-.86.57-1.3.32-.81 1.05-1.06 1.58-.42 1.29 1.55 2.94 1.72 4.77 1.61 2.54-.15 5.06-.36 7.42-1.44.52-.24 1.09-.37 1.63-.56.36-.08.61-.35.91-.53.33-.16.68-.24.86.18.18.43-.27.47-.47.65-.12.11-.27.2-.39.32-.41.2-.66.73-1.22.61-1.05.27-1.96.86-2.99 1.2-1.58.53-3.16.81-4.84.87-2.59.09-5.1-.33-7.63-.7-.1-.01-.18-.09-.26-.15Z"
			style={{
				fill: '#f0e8ca',
			}}
		/>
		<path
			d="M163.13 167.19h-.41l.2-.41c-.07-.09-.07-.19 0-.29.85-1.13 1.14-2.39.82-3.76-.11-.49-.26-.97-.38-1.45-.06-.38-.31-.66-.53-.96-.05-.08-.09-.16-.13-.25-.45-.81-.88-1.63-1.62-2.23-.44-.51-.93-.99-1.27-1.57-.2-.34-.25-.71-.01-1.05.21-.3.54-.19.84-.19 1.9.03 3.61.75 5.33 1.45.56.23 1.06.61 1.19 1.28.01.1 0 .21-.02.31-.27.49-.23 1.19-.95 1.37 0-.23.05-.44.16-.66.44-.86.26-1.16-.77-1.37-.07.06-.14.06-.2 0-1.57-.74-3.05-1.75-5.15-1.61 1.61 1.3 2.56 2.87 3.54 4.4 1.34 2.09.99 4.97-.63 7Z"
			style={{
				fill: '#d9d1aa',
			}}
		/>
		<path
			d="M143.34 170.05c1.17.02 2.32.15 3.48.38 2.27.44 4.58.36 6.87.04 1.48-.21 2.87-.68 4.19-1.4.35-.19.76-.29 1.18-.23-2.47 1.41-5.05 2.41-7.96 2.24-1.11-.23-2.23-.08-3.34-.09-1.09-.02-2.13-.36-3.19-.52-.41-.14-1.02.33-1.22-.41Z"
			style={{
				fill: '#eae1c2',
			}}
		/>
		<path
			d="M162.93 166.58v.2c-1.04.19-1.65 1.17-2.65 1.43.01-.22.13-.35.32-.47.17-.11.54-.14.39-.47-.16-.37-.47-.04-.71-.08-.01-.04-.03-.09-.04-.13.43-.8 1.33-1.01 1.95-1.57.08-.06.17-.11.26-.15.47-.16.93-.32 1.08.4.02.43-.29.64-.59.85Z"
			style={{
				fill: '#eee5c1',
			}}
		/>
		<path
			d="M144.56 170.46c2.06.17 4.11.57 6.19.43.11 0 .23.12.34.18-1.28 0-2.56-.03-3.84.01-.96.03-1.83-.26-2.7-.62Z"
			style={{
				fill: '#e3dcbe',
			}}
		/>
		<path
			d="M143.13 169.84v-.55c.3-.4.04-1.2.89-1.19.12.72-.22 1.25-.68 1.74h-.21ZM142.72 170.66l.41-.82c-.04.32.14.75-.41.82Z"
			style={{
				fill: '#e0d9b3',
			}}
		/>
		<path
			d="M154.77 171.88c.86-.51 1.87-.53 2.8-.7.61-.12 1.01-.29 1.26-.81.26-.55.73-.76 1.25-.94.87-.28 1.65-.71 2.25-1.43.34-.11.57-.38.82-.61 1.48-.28 2.97-.54 4.49-.41.16.32.35.57.78.47.29-.07.61-.13.86.14-.63.8-1.71 1.27-1.84 2.44-.95.15-1.56.96-2.45 1.23-.53.24-.96 0-1.41-.24-.47-.25-.99-.4-.82.47.09.43-.21.61-.46.65-.94.14-1.86.61-2.79.29-.17-.1-.1.15-.08.01.33.1.71.16.45.65-.87.21-1.76.23-2.65.2-.39.21-.86.15-1.23.41h-.2c-.83.07-1.66-.2-2.49 0-.4.09-.69-.13-.99-.38-.2-.17-.31-.31-.28-.58.04-.4.35-.23.54-.29.72-.24 1.6.1 2.2-.58Z"
			style={{
				fill: '#d2c698',
			}}
		/>
		<path
			d="M129.86 172.91c.33-.7 1.07-.76 1.67-.97.46-.16.85-.35 1.19-.67.65-.42 1.26-.92 2.03-1.13.28-.08.61-.18.58-.6-.04-.57.39-.91.66-1.33.18-.18.1-.4.02-.57-.76-1.48-.7-3.06-.61-4.65.02-.38-.03-.74-.18-1.09-.46-1.03-.42-2.08-.22-3.16.21-1.13.33-1.25 1.56-1.08.18.09.31.23.41.39.19.34.34.67.78.81.41.13.69.49.8.94.14.64.26 1.24-.4 1.73-.37.27-.38.62.17.81 1.07.37 1.4 1.15 1.31 2.23-.08 1.03.31 2.06-.03 3.12-.22.66-.56 1.07-1.24.81-.75-.29-1.2-.08-1.41.63-.17.57.44 1.34 1.17 1.39.63.04 1.18.27 1.77.44.26.19.66.25.6.71-.49.43-.86 1.04-1.63 1.02-.71.24-1.44.32-2.17.46-.23.04-.51.12-.7 0-1.21-.81-2.32.1-3.47.17-.36.02-.53.28-.43.65.2.76-.22.72-.72.54-.45-.16-.92-.27-1.33-.5-.52-.29-.66-.67-.16-1.12Z"
			style={{
				fill: '#cfc697',
			}}
		/>
		<path
			d="M129.86 172.91c-.24.55-.09.87.51 1.03.52.14 1.01.35 1.65.58-.65-1-.27-1.34.71-1.55.88-.18 1.89.01 2.67-.83.32 1.59 1.4.62 2.1.62.41 0 .9 0 1.35-.07-.71.27-.88 1.33-1.84 1.22-.57.13-1.18.15-1.63.61-.39.02-.59.22-.62.61-.89-.09-1.73.02-2.45.61-1.28-.31-2.58-.13-3.87-.1-.53.01-.94.09-.98-.61-.02-.4-.29-.33-.59-.3-.37.04-.83.37-1.1-.21l4.08-1.63Z"
			style={{
				fill: '#d1c49a',
			}}
		/>
		<path
			d="m140.47 171.68-.61-.61c-.4-.45-.88-.72-1.49-.78-.42-.04-.83-.17-.8-.72.03-.54.39-.65.86-.61.53.05.9-.23 1.23-.61.42-.49.91-.92 1.41-1.32.33-.26.71-.46 1.08-.05.35.38.61.23.75-.16.29-.85.85-1.45 1.58-1.92.5.38.35.84.1 1.25-.61 1.04-1.03 2.15-1.44 3.28-.16.03-.45.04-.46.1-.23 1.24-1.44 1.45-2.19 2.14Z"
			style={{
				fill: '#cfc49c',
			}}
		/>
		<path
			d="M135.37 174.54c.27-.95.95-.78 1.63-.61-.44.49-.98.7-1.63.61Z"
			style={{
				fill: '#cec69e',
			}}
		/>
		<path
			d="M159.87 173.11c-.13-.65-.63-.57-1.21-.45.25-.49.61-.4.83-.35.9.21 1.73-.25 2.6-.26.23 0 .69-.09.36-.57-.19-.28-.23-.63.05-.83.35-.25.77-.11 1.1.11.43.28.81.62 1.37.52v.2c-.66-.17-1.2.21-1.71.48-1.08.57-2.36.47-3.39 1.15Z"
			style={{
				fill: '#d0c89f',
			}}
		/>
		<path
			d="M155.99 173.72c.32-.4.77-.43 1.23-.41-.28.53-.81.29-1.23.41Z"
			style={{
				fill: '#d2cca1',
			}}
		/>
		<path
			d="M173.14 153.53c1.47-.64 3.03-.88 4.62-.98.44-.03.85-.14 1.27-.31.92-.38 1.72.07 1.7 1.05-.02.88.15 1.88-.65 2.6-.17.15-.17.34-.08.56.2.47.23.88-.21 1.28-.23.22.29 2.31.63 2.44.95.35 1.44 1.62 2.7 1.32.12-.03.3 0 .25.19-.06.19-.26.19-.43.21-.97.15-1.98.04-2.86.61-1.23-.07-2.18.82-3.39.93-1.46.13-2.91.07-4.36.07-.74 0-1.1-.75-1.61-1.15-1.04-.81-1.93-1.79-2.61-2.95-.23-.4-.36-1.03-1.09-.77a.495.495 0 0 1 0-.61c.44-.3 1.07-.26 1.24.08.27.57.48-.06.66.09.26.13.39.38.52.61.32.6.85.74 1.37.44 1.02-.58 2.2-.57 3.27-.98 1.24-.47 2.06-1.34 2.94-2.19.19-.36.44-.68.66-1.02.46-.74.03-1.56-.83-1.67-1.57-.19-2.9.45-4.21 1.15-.29.16-.55.39-.89.47-.29.03-.61.21-.84-.07-.25-.3 0-.56.17-.79.2-.28.14-.65.33-.93.64-.27 1.16.19 1.73.31Z"
			style={{
				fill: '#e2d9b8',
			}}
		/>
		<path
			d="M167.01 158.02v.61c-.57 1.3-.86 2.63-.62 4.06.15.91.71 1.57 1.24 2.26v.2c-1.26-.78-1.67-1.96-1.64-3.37.01-.58 0-1.15 0-1.73 0-.22-.04-.47.2-.61.49-.35.53-.96.82-1.43Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M180.08 162.5c.86-.65 1.78-1.02 2.86-.61.06.63-.34.94-.84 1.12-.45.16-.86.37-1.2.71h-.61l1.9-1.53-2.11.31Z"
			style={{
				fill: '#ece2c3',
			}}
		/>
		<path
			d="M165.38 157.4h.2c.62.4.65.93.17 1.4-.4.4-.6.76-.41 1.33.1.31-.03.64-.41.68-.42.04-.32-.32-.38-.57-.09-.4-.11-.8-.64-1-.46-.17-.25-.71-.22-1.08.03-.36.35-.65.7-.63.35.02.66-.11.98-.14Z"
			style={{
				fill: '#d1cb9a',
			}}
		/>
		<path
			d="M169.26 167.6c-.38-.04-.73.11-1.09.17-.7.13-.88-.17-.54-.79.19-.65.71-.68 1.21-.57.5.11 1.13.19 1.03.97-.15.24-.39.2-.61.2Z"
			style={{
				fill: '#cfca98',
			}}
		/>
		<path
			d="M180.69 148.43c-.16.11-.31.28-.49.33-1.5.36-1.64.6-1.14 2.12-.34-.22-.68.07-1.02 0-.13-.59-.48-1.1-.6-1.7-.06-.32-.3-.44-.51-.24-.56.52-1.37.5-1.94 1.04-.51.48-1.3.34-1.94.16-.39-.11-.38-.52-.15-.85.23-.34.38-.7.01-.99-.38-.29-.69-.01-.98.25-.1.09.04.06-.08.06-1.19.02-1.74.88-2.32 1.71-.37.09-.59-.17-.75-.42-.38-.59-.78-.53-1.22-.11-.21.05-.4.04-.55-.13-.52-.62-1.15-.83-1.97-.64-.45.1-.95.03-1.42.02-.27 0-.55-.14-.45-.4.23-.59-.03-1.19.12-1.78.08-.31.01-.65.57-.6.49.05.85-.44.94-.81.17-.71.62-.89 1.22-.93-.09-.47-.45-.94-.08-1.28.44-.41.86.09 1.25.27.14.06.26.21.44.21v.2c-.09.2-.25.28-.45.37-.73.34-.79 1-.15 1.45.19.13.49.14.58.37.36.96.93.65 1.6.37.71-.29.86-.58.28-1.14-.16-.16-.35-.33-.23-.61.47-.07.84.18 1.02.54.39.79 1.08.81 1.73.65 1.04-.26 1.92-.13 2.69.65.15.15.52.35.61.28 1.02-.78 1.57.08 2.19.61.52.44 1.16.32 1.75.45.51.12 1.09-.02 1.46.5Z"
			style={{
				fill: '#d1c697',
			}}
		/>
		<path
			d="M169.46 150.27c.19-.38.6-.66.55-1.16 0-.09.04-.25.08-.26.92-.19 1.73-.75 2.62-.88.77-.12 1.01.6.46 1.33-.16.22-.28.36-.18.58.11.23.33.14.53.11.59-.07 1.1-.01 1.67-.52.47-.41 1.31-.58 1.93-.97.19-.12.55.02.52.12-.28.83.9 1.41.38 2.26-.41.14-.87.1-1.22.41-.92.84-2.09 1.03-3.25 1.28-.43 0-.86.11-1.29.02-.43-.09-.87-.18-.86-.77.9-.16 1.11-.7.9-1.53-.09-.35.02-.86-.55-.72-.43.11-.58.54-.5.98.07.38.53.66.28 1.12-.96-.07-1.46-.82-2.08-1.39Z"
			style={{
				fill: '#d1c897',
			}}
		/>
		<path
			d="M173.55 152.31c1.15-.14 2.18-.66 3.27-1.02 1.68-.27 3.37-.19 5.06-.21.41 0 .79.01 1.12.35.38.39.65.63.16 1.24-.79.98-1.14 2.18-1.03 3.48.09 1.14-.19 2.3.16 3.43.33 1.06.75 1.24 1.71.73.42-.22.78-.41 1.19-.04-.65.18-1.29.36-1.89.7-.47.26-.89.41-1.23-.41-.81-1.97-.75-3.92-.21-5.91.06-.22.05-.47.07-.7-.05-.39.15-.72.24-1.08.22-.96.19-1.09-.72-1.14-2.13-.13-4.25-.04-6.27.75-.19.07-.37.16-.58.14-.54-.06-1 .54-1.58.19-.22-.62.44-.25.55-.5Z"
			style={{
				fill: '#d8d0a5',
			}}
		/>
		<path
			d="M189.06 160.87c-.26.87.35.92.93 1.02.91.15 1.88-.06 2.74.41-1.88.19-3.67-.12-5.39-.88-.69-.31-1.14-.94-1.75-1.36-1.37-.57-1.66-1.15-1.22-2.45 1.01.2 1.78.89 2.68 1.31.17.08.27.3.18.53.54.56 1.04 1.19 1.84 1.43Z"
			style={{
				fill: '#c4ba86',
			}}
		/>
		<path
			d="M192.74 151.29v.2c-.28.13-.6.18-.83.37-1.35 1.13-2.73.86-4.13.12-.24-.13-.55-.07-.75-.28.15-.37.75-.47.61-1.02.08-.1.18-.2.25-.3q.86-1.21 1.99-.31s.09.02.14.03c.29.15.56.34.87.46.49.56 1.29.34 1.85.74Z"
			style={{
				fill: '#d5cd99',
			}}
		/>
		<path
			d="M187.02 151.69c.29.04.6-.34.86-.03.73.87 1.75.55 2.66.69.23.04.41.01.52-.18.38-.66 1.03-.65 1.67-.68-.35.31-.7.62-1.04.94-.36.33-.78.58-1.28.47-1.73-.39-3.31.04-4.83.84h-.41c.39-.43.5-1.13 1.38-1.06.43.04.07-.75.46-.98Z"
			style={{
				fill: '#d9cfa1',
			}}
		/>
		<path
			d="M187.23 159.44c-.78-.88-2.04-1.01-2.86-1.84.15-.24.39-.19.61-.2.69-.04 1.35.23 2.09.11.7-.11.98.94.57 1.92h-.41Z"
			style={{
				fill: '#d5cd96',
			}}
		/>
		<path
			d="M174.57 152.51c2.29-.97 4.7-1.12 7.14-1.02 1.12.04 1.25.23.76 1.17-.22.41-.2.93-.55 1.28-.25-.18-.16-.39-.1-.64.22-1.05-.05-1.34-1.1-1.41-2.11-.14-4.13.34-6.15.82-.07-.05-.09-.09-.07-.14.02-.04.04-.07.07-.07Z"
			style={{
				fill: '#dfd7af',
			}}
		/>
		<path
			d="M174.57 152.51v.2c-.55.15-1.09.3-1.43.82-.65.27-1.14-.07-1.63-.41l-.08-.12c-.02-.15.03-.27.17-.34.44.04.89.12 1.33.05.57.1 1.08-.19 1.63-.2Z"
			style={{
				fill: '#d8d3ab',
			}}
		/>
		<path
			d="M176.2 166.79c-.47-.07-1.27.18-.82-.81-.05.59.57.52.82.81ZM177.63 166.79c-.48.32-.95.32-1.43 0h1.43Z"
			style={{
				fill: '#d3c89e',
			}}
		/>
		<path
			d="M197.64 160.06c-.13.66-.66.32-1.02.41.26-.33.73-.15 1.02-.41Z"
			style={{
				fill: '#c4ba86',
			}}
		/>
		<path
			d="M125.78 174.13v-.2c-.07-.05-.09-.09-.07-.14.02-.05.05-.07.07-.07 1.69-.7 3.48-1.21 4.9-2.45.03-.04.06-.08.09-.11 1.12-.65 1.95-1.64 2.87-2.5.1-.09.08-.25.08-.39.2-1.17.18-2.36.32-3.54.13-1.08.2-2.18-.69-3.05-.2-.19-.3-.5-.22-.76.43-1.38-.39-2.47-.81-3.65-.14-.41-.24-.77-.03-1.17.05-.09.11-.18.18-.25.37-.34.78-.18 1.18-.11 1.45.58 2.98.95 4.37 1.69 1.94.62 3.57 1.76 5.06 3.11.13.3.5.54.26.94-.44.25-.71-.07-.96-.32-2.07-2.09-4.76-3.06-7.4-4.11a1.9 1.9 0 0 0-.39-.11c-.47-.1-1.03-.68-1.38-.23-.26.35.26.92.47 1.37.15.31.33.59.26.96.32 1.79 1.04 3.5 1.03 5.36 0 .52-.07 1-.38 1.44-.42.6-.33 1.18.27 1.59.52.36.54.71.13 1.15-.63.68-1.22 1.33-2.1 1.79-.87.46-1.7 1.05-2.56 1.59-1.44.9-2.97 1.59-4.55 2.17Z"
			style={{
				fill: '#ded5b1',
			}}
		/>
		<path
			d="M125.78 174.54c.34 0 .73.08 1.03-.04.71-.28 1.12-.33.93.65-.11.59.29.3.57.27 1.31-.13 2.61-.09 3.91.06.04 0 .07.17.1.27-.62.01-1.27-.08-1.63.61-2.7 0-5.41.03-8.22-.55.59-.47 1.51 0 1.69-.87.52-.23 1.07-.35 1.63-.41Z"
			style={{
				fill: '#cec598',
			}}
		/>
		<path
			d="M133.94 159.04c-.34-.65-.67-1.3-1.03-1.94-.14-.25-.28-.51-.1-.75.19-.26.48-.15.74-.06 3.27 1.22 6.65 2.24 9.17 4.88.17.18.36.31.62.31.05.01.1.02.16.03 2.01 1.49 2.27 4.34.6 6.42-.05.02-.09.05-.14.07-.37.42-.35 1.06-.82 1.43.1-1.21.54-2.3 1.18-3.31.26-.41.4-.77.05-1.17-.37-.95-.45-2.05-1.37-2.72-1.73-1.84-4.01-2.85-6.19-4.01l-.21-.41c-.9-.05-1.71-.58-2.62-.58-.16.76.86 1.23.38 2l-.41-.2Z"
			style={{
				fill: '#d4cba5',
			}}
		/>
		<path
			d="M134.35 159.24c0-.83-.87-1.36-.75-2.26 1.12-.18 2.02.48 3 .83-.93-.16-1.35.13-1.43 1.17-.09 1.12-.19 2.19.35 3.22.29.56.32 1.43.19 1.72-.64 1.39.28 2.45.47 3.65.04.23.04.48-.2.64-.07-.55-.33-.96-.86-1.14-.47-.16-.52-.48-.34-.87.67-1.42.45-2.88.2-4.33-.15-.89-.42-1.75-.63-2.63ZM135.98 168.21c-.07.56-.81.99-.37 1.68.01.02-.31.36-.5.39-.88.14-1.53.83-2.4.99.1-.13.17-.3.3-.39 1.05-.82 2.19-1.54 2.96-2.67Z"
			style={{
				fill: '#d0c89f',
			}}
		/>
		<path
			d="M130.27 171.27c.06-.43.95-.45.65-.85-.32-.43-.92-.1-1.39.09-3.07 1.28-6.27 2.04-9.6 2.19-.96.04-2.04.56-2.73-.61.04-.03.08-.07.12-.1.2-.09.4-.07.61-.03 2.12-.07 4.25.06 6.31-.62.13-.04-.03-.03.1-.03 1.98.01 3.64-1.14 5.52-1.48.61-.13 1.13-.47 1.69-.7.08-.05.17-.09.26-.13.24-.12.5-.21.7-.41.17-.17.36-.38.6-.17.27.23.11.5-.04.73-.63.89-1.42 1.6-2.38 2.13h-.41Z"
			style={{
				fill: '#e5dec0',
			}}
		/>
		<path
			d="M125.78 173.72v.2c-.71.02-1.43-.1-2.08.32-.34.22-.65-.12-.98-.11.96-.58 2.03-.36 3.06-.41Z"
			style={{
				fill: '#dfd7b5',
			}}
		/>
		<path
			d="M95.36 170.05c-1.26.08-2.51.06-3.73.55-.56.22-1.23.29-1.88.28-2.14-.04-4.29-.01-6.43-.01l-2.25-.82c-.27-.91-.81-1.65-1.59-2.14-.91-.57-.18-.79.16-1.12.68.77 1.49 1.11 2.5.67 1.38 0 2.75.36 4.14.08.88-.3 1.69.24 2.57.22 1.2-.02 2.33-.16 3.4-.7.35-.18.58-.44.47-.8-.23-.76.15-1.39.38-2.04.25-.69.66-1.32.62-2.11-.01-.24.12-.46.35-.58.71-.37 1.16-1.02 1.68-1.6.17-.18.32-.4.62-.29-.62 1.14-.22 2.27 0 3.43.31 1.57.21 3.18.19 4.78 0 .49-.68.43-.79.86-.11.46-.48.83-.42 1.34Z"
			style={{
				fill: '#eae4cd',
			}}
		/>
		<path
			d="M112.3 164.75c.31-.8-.11-1.03-.82-1.02.31-.77.18-1.23-.79-1.25-.48 0-.88-.27-1.18-.7-.55-.8-1.39-.86-2.26-.8-.2.01-.44.05-.45.31-.01.26.23.3.43.33a.9.9 0 0 0 .4 0c.91-.17 1.59.14 1.48 1.11-.1.85.88.6.93 1.19-.97.06-1.93.11-2.9.19-.98.08-1.84-.02-2.58-.82-.8-.87-1.73-1.63-2.61-2.42-.66-.59-.59-.94.32-1.03h.15c1.07.24 2.12.24 3.15-.17.28-.11.57-.21.88-.14.42.25.78.61 1.35.56.51-.05.82-.23.76-.8.4-.39.88-.47 1.41-.38.2.08.33.23.43.42.07.13-.03.46.34.19.58-.42 1.03-.27 1.17.48.12.66.72.78 1.18 1.01 1.42.7 2.22.53 3.28-.62.22-.23.44-.43.79-.36.24.93-.49 1.49-.93 2.1-.24.33-.6.71-1.07.86-.88-.36-1.47-.1-1.98.9-.2.4-.25.95-.91.88Z"
			style={{
				fill: '#e3daba',
			}}
		/>
		<path
			d="M102.3 159.85c-.19-.58-.23-1.18-.21-1.79.02-.63-.23-.87-.76-.39-.52.46-1.25.72-1.8.76-.8.07-1.6-.06-2.34.39-.18-.43.1-.78.24-1.14.48-1.21.42-1.54-.62-2.38-.52-.42-.89-.9-.88-1.6 1.37-.6 2.33.31 3.3.98.37.25.74.25 1.1.38.98.36 2.18.14 2.94 1.15.29.38.66-.22 1.03-.09.08.06.12.14.14.24-.06.53-.43.9-.76 1.26-.66.72-.83 1.46-.32 2.32-.4.45-.72-.08-1.07-.1Z"
			style={{
				fill: '#eae4cd',
			}}
		/>
		<path
			d="M110.06 163.93c-.98 0-1.27-.74-1.22-1.46.06-.76-.33-.63-.75-.62-.37 0-.74.03-1.12.04-.51.01-.48-.38-.51-.71-.04-.36.17-.43.5-.45 1.14-.05 2.27-.17 2.92 1.12.19.38.69.36 1.08.45.39.09.93-.12 1.12.45.18.53-.47.6-.58.98-.43.39-.95.12-1.43.2ZM112.3 164.75c.34-.18.52-.45.63-.83.22-.74.75-1.2 1.49-1.47.49-.18.69 0 .74.47.18.42-.14.7-.27 1.04-.07.12-.16.23-.25.34-.5.4-.33 1.02-.51 1.53-.34.16-.55-.13-.95-.31.6.82.49 1.44-.24 1.93-.75-.09-.72-.83-1.04-1.27-.28-.59-.02-1.04.41-1.43Z"
			style={{
				fill: '#e1dab9',
			}}
		/>
		<path
			d="M95.97 153.74c.26 1.04 1.29 1.47 1.85 2.29.36.52.39.82.04 1.32-.3.44-.45.98-.67 1.48l-.61.41s-.06-.08-.08-.11c-.03-.65.65-1.15.4-1.85-.05-.23-.13-.45-.21-.68a.405.405 0 0 1-.05-.09c-.62-1.64-2.08-1.74-3.5-1.9-.02-.71.58-.33.86-.43.42-.15.94.06 1.3-.36a.84.84 0 0 1 .24-.18c.16-.04.3-.02.43.09Z"
			style={{
				fill: '#ede9d4',
			}}
		/>
		<path
			d="M111.89 166.17c.5.27.59.89 1.02 1.22 1.07.78 1.74 1.95 2.76 2.8.4.33.9.63 1.03 1.22 0 .1-.04.19-.11.26l-.82-.41c-.25-.16-.46-.36-.61-.61-.85-.5-1.64-1.04-2-2.04-.09-.25-.43-.41-.66-.61-.32-.42-.53-.9-.61-1.43v-.41Z"
			style={{
				fill: '#e6dec3',
			}}
		/>
		<path
			d="M96.38 159.65a.72.72 0 0 0-.41.41c-.23.08-.45.49-.71.03-.03-.27.07-.48.23-.68.08-.07.16-.12.25-.16.28-.08.56-.24.84 0l-.21.41Z"
			style={{
				fill: '#ede9d4',
			}}
		/>
		<path
			d="M116.59 171.68v-.2c.45-.05.67.15.61.61-.29 0-.5-.14-.61-.41Z"
			style={{
				fill: '#e5dec0',
			}}
		/>
		<path
			d="M115.16 170.66c.28.13.48.34.61.61-.39-.02-.59-.22-.61-.61Z"
			style={{
				fill: '#ece5c9',
			}}
		/>
		<path
			d="M84.54 158.02c.64.73.38 1.61.41 2.45-.19.18-.35.43-.57.52-.29.12-.7.35-.73-.34-.03-.48-.21-.98-.74-1.2.04-.12.1-.25.1-.37.05-1.11.24-1.24 1.53-1.05Z"
			style={{
				fill: '#d2c999',
			}}
		/>
		<path
			d="M82.6 162.67c-.3.52-.79.8-1.25.95-.4.13-.88-.4-.78-.7.19-.58.11-1.5.94-1.61.96-.13.54 1.01 1.1 1.36Z"
			style={{
				fill: '#d4ca95',
			}}
		/>
		<path
			d="M74.74 163.93c1.29-.48 2.24-1.46 3.29-2.29.06-.05.11-.19.09-.26-.47-1.5.36-2.91.35-4.38 0-.27.36-.55.56-.82.08-.11.18-.29.29-.25.95.4 2.05.15 2.97.65.49-.05.81.2 1.02.61.38.27.85-.05 1.22.2.44.24.97.39 1.02 1.02l-1.02-.41c-.13-.27-.36-.45-.65-.4-1.5.28-2.76-.46-4.07-.96-.61-.23-.78.05-.77.5 0 .74-.11 1.41-.5 2.04-.26.42.03.67.27.98.61.81.52 1.33-.37 1.8-.79.42-1.43 1.03-2.13 1.55-.48.36-.98.58-1.57.62v-.2Z"
			style={{
				fill: '#ddd2aa',
			}}
		/>
		<path
			d="M86.99 150.07c.74.76 1.71 1.01 2.7 1.21 1.28.27 2.57.55 3.86.78.38.07.58.25.76.57.47.8.4 1.07-.55 1.07-1 0-1.92.34-2.89.44-.76.15-1.56.16-2.24.61-.97 0-1.89 0-2.78.57-.51.32-1.32.84-1.88-.17-.16-.29-.55-.17-.85-.19-.28-.42-.28-1.01-.88-1.24-.24-.09-.51-.39-.26-.74.21-.3.47-.5.84-.21.2.16.36.14.51-.06.36-.37.82-.14 1.23-.2.38-.09.74-.3 1.15-.3.28 0 .54-.05.61-.39a.65.65 0 0 0-.28-.7c-.4-.27-.67-.63-.86-1.06-.05-.18-.26-.36-.04-.53.2-.16.47-.12.64.05.35.34.73.56 1.23.48Z"
			style={{
				fill: '#d4cca9',
			}}
		/>
		<path
			d="M82.29 156.59c-1.12.09-2.17-.33-3.27-.41.05-.64-.18-1.17-.61-1.63-.16-.54-.51-1.11-.43-1.61.08-.53.69-.85 1.24-1.04.58.81 1.22 1.47 2.32 1.63.7.11 1.23.64 1.36 1.42-.94.27-.69.98-.61 1.63Z"
			style={{
				fill: '#ddd7ae',
			}}
		/>
		<path
			d="M84.33 162.91c.51-.66 1.04-1.3 1.45-2.05.62-1.14.47-2.21-.15-3.25-.74-1.25-.5-1.79.94-2.04.64-.27 1.3-.47 2-.48.22.35-.06.49-.29.62-.27.15-.58.19-.87.27-.44.12-1.04.09-1.07.72-.03.62.11 1.22.77 1.54.21.1.42.23.61.36.92.61.91.98-.06 1.57-.21.13-.36.31-.49.5-.71.85-1.59 1.55-2.29 2.41-.15.18-.32.36-.6.24-.09-.15-.07-.28.04-.41Z"
			style={{
				fill: '#eae3cd',
			}}
		/>
		<path
			d="M82.9 154.96c-.61-.64-1.07-1.34-2.2-1.36-.47 0-1.54-.65-1.47-1.7 1.45-.15 2.71.62 4.08.81-.3.53-.43.6-.56.38-.22-.39-.32-.31-.56-.06-.38.4.22.55.25.55.9.14.65.82.67 1.37h-.2Z"
			style={{
				fill: '#d5d0a9',
			}}
		/>
		<path
			d="m88.62 155.16-2.05.41c.58-.52 1.3-.62 2.04-.61 1.2.03 2.3-.5 3.46-.67 1.02-.16 2.09-.15 3.07-.55.14-.11.27-.13.41 0-.25.53-.69.63-1.23.62-.41 0-.86-.17-1.22.19-1.44.64-2.87 1.3-4.49.61Z"
			style={{
				fill: '#eae4cd',
			}}
		/>
		<path
			d="M84.33 162.91v.41c-.17.48-.26 1.06-1.02.82.11-.61.59-.9 1.02-1.23Z"
			style={{
				fill: '#e9e2c8',
			}}
		/>
		<path
			d="M84.54 157.4c-.41-.07-.87.17-1.22-.2.41.07.87-.17 1.22.2Z"
			style={{
				fill: '#ddd7ae',
			}}
		/>
		<path
			d="M83.32 164.14c.59.04.57-.68 1.02-.82.87-.9 1.65-1.89 2.65-2.65.27-.34.54-.69 1.06-.43.12.21.06.39-.11.55-.28.19-.55.38-.76.66-.58.76-.57.81.37 1.05.63.16.71.42.26.89-.16.17-.35.32-.58.4-.77-.54-1.4-.39-1.97.34-.18.23-.45.41-.73.55-.24.09-.49.1-.74.03-.2-.06-.35-.2-.47-.36v-.2Z"
			style={{
				fill: '#f2ebd9',
			}}
		/>
		<path
			d="M82.09 167.6c-1.19.6-2.03.32-2.45-.82.77-.15 1.37-.66 2.04-1.02.46-.03.94-.56 1.36.09.2.86-.24 1.38-.95 1.75Z"
			style={{
				fill: '#ece5d0',
			}}
		/>
		<path
			d="M82.9 165.77c-.41-.28-.82.37-1.22 0 .38-.47 1.16-.39 1.43-1.02.21.12.31.3.36.53-.02.35-.03.72-.56.49Z"
			style={{
				fill: '#eae3cd',
			}}
		/>
		<path
			d="M83.31 165.16c-.16-.09-.2-.24-.2-.41l.21-.41c.17 0 .32.04.41.21.39.16.68.35.17.72-.21.08-.41.05-.58-.11Z"
			style={{
				fill: '#ece5d0',
			}}
		/>
		<path
			d="M99.24 163.52v1.02c.11.65-.3 1.41.58 1.91.54.31.03.75-.25 1.05-.15.16-.44.17-.61.32-.94.87-.93.88-1.36-.22-.01-1.85.06-3.7-.74-5.45-.19-.43-.11-1-.06-1.5.08-.77.71-.57 1.19-.58 1.34-.02 1.46.1 1.14 1.37-.18.72-.1 1.4.1 2.09Z"
			style={{
				fill: '#dad4b1',
			}}
		/>
		<path
			d="m96.99 169.03.61-1.22c-.05.48.21 1.12-.61 1.22Z"
			style={{
				fill: '#ddd6b5',
			}}
		/>
		<path
			d="M68.61 153.73c.71.12 1.25-.41 1.92-.5 1.2-.16 1.94.08 2.54 1.11 1.03 1.75.67 2.63-1.33 3.28-.79.26-1.51.73-2.2 1.14-.71.42-1.37.46-2.1.47-.71.01-1.36.17-2.05.37-.72.2-1.54-.12-2.29-.37-.26-.82-.02-1.42.71-1.9.71-.47 1.23-1.21 2.28-1.11.36.03.93-.5.98-.93.12-.99.9-1.17 1.54-1.57Z"
			style={{
				fill: '#f1e9d0',
			}}
		/>
		<path
			d="M73.31 151.9h1.01c2.24 0 3.09.63 3.76 2.8.29.94.16 1.09-.76.89-1.05-.23-2.09-.53-3.19-.43.52-.39.52-1 .51-1.53 0-.65.05-1.18.83-1.43-.8-.25-1.53.15-2.16-.3Z"
			style={{
				fill: '#e8e2c0',
			}}
		/>
		<path
			d="M68.61 153.73c-.16.31-.39.54-.75.62-.25.05-.4.21-.46.47-.28 1.21-.74 1.57-2 1.62-.82.03-2.28 1.8-2.3 2.79-.48-.85-.14-1.5.55-1.99 1.07-.77 1.78-1.95 3.01-2.53.08-.04.08-.24.12-.37.66-.06 1.14-.68 1.84-.61Z"
			style={{
				fill: '#efe9c9',
			}}
		/>
		<path
			d="M88.62 150.47c-.54-.14-1.09-.27-1.63-.41l-.41-.41c2.27.68 4.65.16 6.94.61.07.1.07.21 0 .31-.44.44-1.03.64-1.57.43-1.08-.41-2.22-.39-3.33-.54Z"
			style={{
				fill: '#e8e1c6',
			}}
		/>
		<path
			d="M85.15 150.06c.37.32.73.65 1.11.96.32.27.49.45.27.97-.2.48-.37.55-.78.43-.41-.12-.78.46-1.21.08.67-.7.66-1.57.62-2.45Z"
			style={{
				fill: '#d5d0a9',
			}}
		/>
		<path
			d="M79.74 151.08c-.27-.18-.98.35-.99-.33-.01-.71.49-1.43 1.14-1.64.61-.19 1.19-.45 1.79-.66.45-.16.9-.29 1.39-.22.44.07.9.16 1.03.67.14.53-.3.64-.66.85-1.96 1.16-2.36 1.32-3.7 1.33Z"
			style={{
				fill: '#f3ebd8',
			}}
		/>
		<path
			d="M118.14 124.87c-.44-.58-.17-1.07.26-1.64.47-.63 1.08-.61 1.61-.43.62.21.38.75.15 1.18-.13.25.05.46.09.68.12.65-.27.93-.78 1.11-.51.19-.96.08-1.37-.31-.22-.21-.09-.35.04-.6Z"
			style={{
				fill: '#f5eddd',
			}}
		/>
		<path
			d="M189.27 140.27v.61c-.21.2-.41.41-.62.61-.04-.53.3-.87.62-1.22Z"
			style={{
				fill: '#e0d8b4',
			}}
		/>
		<path
			d="M136.6 128.85c.36.04.53.28.3.54-.34.39-.55.93-1.12 1.09.13-.61.9-.91.82-1.63ZM138.03 122.12c.32.54.32 1.09 0 1.63-.19-.54-.22-1.09 0-1.63ZM138.03 124.16c.16.41.59.82 0 1.22-.22-.41.09-.82 0-1.22ZM138.02 125.79c0 .4.24.88-.41 1.02.18-.32-.06-.81.41-1.02ZM137 127.83c.12.4-.22.57-.41.82.04-.32-.14-.75.41-.82Z"
			style={{
				fill: '#d4caa2',
			}}
		/>
		<path
			d="M146.6 137.42v-.41c.53.25 1.38.23 1.02 1.22-.99.98-1.42 2.3-1.67 3.55-.26 1.32-.95 2.31-1.6 3.39-.31.19-.55.51-.95.51-.9 0-1.29.55-1.5 1.32-2.63.18-5.27.39-7.67-1.11-.38-.24-.77-.25-1.17-.08-.66.27-1.28.18-1.83-.24-.42-.31-.86-.38-1.34-.24-.17 0-.32-.04-.44-.17-.26-1.27.66-2.26 1.9-2.13.94.1 1.58-.65 2.39-.93.42-.28.94-.27 1.36-.24 1.26.1 2.38-.32 3.51-.71.5-.17.88-.19.96.45.05.43.34.44.66.43 1.07-.04 1.77-.89 1.57-1.96-.06-.3-.14-.59-.03-.9.32-.51.84-.31 1.29-.35.74-.07 1.48-.1 2.22 0 1.22.17 1.52-.15 1.32-1.42Z"
			style={{
				fill: '#e9e3cf',
			}}
		/>
		<path
			d="M129.25 145.78v-.21c.27-.25.54-.2.82 0 1.5.88 2.99 1.59 4.84 1.7 2.41.15 4.8.03 7.2.13.56.35.96-.04 1.35-.33 1.4-1.04 2.71-2.18 3.55-3.75.68.64.37 1.27-.13 1.76-.81.78-1 2.01-2.06 2.61-.24.13-.32.6.06.87.2.14.41.26.39.55-.27.37-.59.65-1.09.6-.37-1.09-1.25-1.06-2.2-1.11-1.15-.06-2.28.2-3.42.07-.21-.02-.41.03-.59.12-.92.49-1.69.3-2.34-.49-.49-.59-1.04-.43-1.67-.18.29.38.99.46.64 1.11-1.09.22-2.19-.22-3.28.06-.19-.14-.19-.35-.17-.55.12-1.36-.43-2.25-1.78-2.6-.11-.1-.2-.21-.13-.37Z"
			style={{
				fill: '#dfd9bc',
			}}
		/>
		<path
			d="M129.86 145.17c.68.01 1.41-.21 1.91.51.08.11.43.16.57.08.99-.58 1.87-.33 2.76.24 2.11 1.34 4.5.93 6.8 1.01-.23.29-.55.2-.85.2-2.05 0-4.15.25-6.14-.26-1.44-.37-2.99-.55-4.28-1.44-.15-.1-.38-.09-.58-.13-.22.08-.25-.02-.2-.2ZM141.9 147c-.13-.97.31-1.46 1.27-1.42.47.02.69-.55 1.18-.42-.02.39-.33.55-.62.57-.88.06-1.32.71-1.83 1.26Z"
			style={{
				fill: '#e7e1ca',
			}}
		/>
		<path
			d="m129.86 145.17.2.2v.2h-.82c-.38-.24-.8-.21-1.22-.2-.07-.1-.06-.19.03-.27.2-.07.4-.07.59.06h1.22Z"
			style={{
				fill: '#e6e2c6',
			}}
		/>
		<path
			d="M145.17 149.04c-1.03-.74-.94-.98-.1-1.89.86-.94 1.7-1.96 2.07-3.24.07-.23-.06-.39-.12-.57.43-.89.03-1.87.31-2.77.09-.27-.04-.75.3-.78.36-.03.85-.03 1.11.35.4.57.98 1.04 1.13 1.78l.09 1.65c.47.09.28-.66.65-.44.29.17.15.52.11.87-.22 1.81-1.12 2.92-2.92 3.31-.25.05-.16.33-.18.52-.24.36-.52.67-.94.81-.39.07-.81.06-1.13.36-.12.08-.23.14-.38.06Z"
			style={{
				fill: '#ddd8b7',
			}}
		/>
		<path
			d="M150.89 149.86c1.09-.17 2.24-.43 3.24.04 1.21.56 2.29-.08 3.43-.05.41 0 .82-.12 1.14-.37.72-.55 1.52-.72 2.39-.63.07.2-.05.36-.2.41-1.11.3-2.06 1.08-3.26 1.1-.86.01-1.64.38-2.5.42-.81.04-1.6-.44-2.28-.25-.69.2-1.27.76-2.08.91-.97.17-1.72.73-2.44 1.49-1.2 1.28-1.78 2.95-2.99 4.2-.2.2-.18.5-.19.78-.02 1.02-.78 1.63-1.35 2.32-.31.38-.81.17-1.12-.06-.74-.57-1.64-.95-2.14-1.83-.32-.57-1.02-.45-1.55-.55-.36-.07-.71-.18-1.07-.26-1.02-.45-1.95-1.06-3.08-1.29-.62-.12-.56-.83-.65-1.35.05-.78.36-1.42 1.01-1.88.31-.22.51-.53.7-.85.18-.3.39-.6.74-.64 1.03-.12 1.92-.76 2.97-.74 1.22.04 2.44.03 3.62-.37.19-.07.41-.07.54.14-.49 1-1.48 1.07-2.39 1.16-.66.07-1.34.04-2.01.15-.72.05-1.31.46-1.94.75-.08.04-.16.08-.24.13-.39.22-.64.62-1.04.83-1.16.75-1.17 1.4.05 2.05.9.48 1.93.61 2.93.82.72.19 1.41.45 2.16.53 2.53.28 3.7-2.18 3.03-4.12-.29-.84-.04-1.16.61-1.48.82-.41 1.7-.66 2.57-.94.42-.14.84-.25 1.21-.49.72-.15 1.44-.2 2.16-.04Z"
			style={{
				fill: '#e3dcc2',
			}}
		/>
		<path
			d="M138.03 157.41c.46.3 1 .12 1.46.1 1.43-.05 1.48 1.53 2.49 1.91.18.07.3.29.47.38.6.33 1.19.63 1.63-.26.33-.66 1.13-1.13.76-2.05-.04-.09.04-.29.12-.36 1.27-1.08 1.73-2.72 2.8-3.96 1.08-1.25 2.21-2.13 3.9-2.14 1.1-1.73 2.68-.07 3.96-.55 1.27-.48 2.75-.17 3.91-1.01.48-.35 1.19-.05 1.56-.62.36-.09.74-.13 1.02-.41h.2c-.33.75.01 1.11.73 1.07 1.21-.05 2.36.38 3.55.35.02.05.03.11.05.16-.06.1-.14.17-.24.22-.6.19-1.19.02-1.79-.06-.56-.07-1.14-.13-1.68.15-.73 1.08-1.83.9-2.86.74-.66-.1-1.29-.12-1.9.09-1.26.43-2.59.52-3.86.91-1.73.53-3.21 1.42-4.5 2.67-.17.09-.35.1-.44-.08-.44-.84-.92-.57-1.27.02-.5.85-1.47 1.34-1.76 2.34-.2.68-.38 1.35-.65 2.01-.27.65-.67 1.19-1.08 1.71-.5.64-1.14.29-1.69-.08-1.5-1.23-3.09-2.32-4.9-3.06-.07-.05-.09-.09-.07-.14.02-.05.05-.07.07-.07Z"
			style={{
				fill: '#e1dcbc',
			}}
		/>
		<path
			d="M149.46 148.23c.66-.21 1.32-.43 1.99-.63.38-.11.78-.31.78-.69 0-.9.57-.74 1.11-.72.08.11.14.23.22.34.47.68.88 1.47 1.95 1.02.08-.04.2.02.3.03.48.06 1.11-.16 1.28.51.16.65-.12 1.19-.69 1.55-1.07.05-2.12-.13-3.17-.35-.84-.18-1.57.23-2.35.35-.91.4-1.87.13-2.8.22-.27.03-.55-.13-.56-.47 0-.34.18-.59.5-.68.49-.13 1-.2 1.42-.5Z"
			style={{
				fill: '#efe9d7',
			}}
		/>
		<path
			d="M149.46 148.23c-.22.43-.56.66-1.05.61-.41-.04-.72.18-.68.55.04.43.48.25.75.26.8.02 1.61 0 2.42 0v.2c-.72.38-1.5.13-2.24.2-1.04.4-2.17.52-3.16 1.03-.63.32-1.39.54-1.51 1.42-.43.28-.58-.2-.86-.32-.82-.2-1.61.05-2.42.13-.9-.19-1.64.28-2.44.54-.41.13-.8.38-1.27.3-.2-.31 0-.48.22-.64.75-.11 1.3-.7 2.04-.82.6-.33 1.26-.28 1.91-.27.99.02 1.86-.26 2.58-.95.1-.29.24-.53.61-.41 1.05-.19 2.1-.31 2.95-1.12.39-.37 1.02-.48 1.54-.72h.61ZM156.4 149.66c-.01-.37.4-.51.43-.89.04-.57.44-1.18-.74-.89-.5.13-1.13-.17-1.65.27-.05.04-.33-.11-.33-.12.2-.81-.98-1.04-.78-1.84.47.41.96.75 1.63.61.29.34.68.15 1.02.2.55.7 1.33.6 2.08.61h1.19c.05.65-.42.64-.86.69-.35.04-.83-.16-1.01.51.89-.1 1.59-1.04 2.48-.39-1.26.11-2.04 1.59-3.47 1.22Z"
			style={{
				fill: '#efe9d4',
			}}
		/>
		<path
			d="M159.87 148.43c-.72-.05-1.41.01-1.94.6-.2.22-.47.28-.74.14-.17-.09-.19-.28-.1-.44.13-.23.1-.51.5-.65.55-.2 1.34.42 1.68-.47.77-.05 1.54-.09 2 .82h-1.39Z"
			style={{
				fill: '#efe9d7',
			}}
		/>
		<path
			d="m144.35 150.06-.61.41c-1.33.45-2.67.79-4.08.41.02-.04.03-.09.05-.13.32-.36.75-.49 1.2-.46 1.1.08 2.12-.2 3.11-.64h.14c.44-.04.72-.35 1.02-.61l.2-.2c.38-.22.83-.24 1.22-.41l1.02-.61h.82c-1.25.95-2.83 1.31-4.08 2.24Z"
			style={{
				fill: '#e1dcc0',
			}}
		/>
		<path
			d="M128.02 145.17v.2c-.66 0-1.31-.07-1.9.47-.27.25-.85.33-1.25.25-1.41-.28-2.82-.04-4.23-.08-1.11-.03-2.03-.34-2.84-1.05-.11-.23.05-.32.2-.41.45-.3.66.15.96.31.87.46 1.47.31 1.9-.51.88-1.01 2.06-1.07 3.27-1.02.3.34.1.78.24 1.15.11.3.09.73.49.79.33.05.63-.2.88-.4.17-.14.18-.44.43-.52.21-.12.29-.44.61-.41.79.03.76.87 1.23 1.22Z"
			style={{
				fill: '#e7dfc5',
			}}
		/>
		<path
			d="M120.88 144.35c.5.82-.16.89-.68 1.01-.9.22-1.48-.47-2.18-.81-.09-.71.42-1.13.9-1.37.52-.26.97.12 1.29.62.15.23.44.37.67.54Z"
			style={{
				fill: '#ebe4cc',
			}}
		/>
		<path
			d="M128.02 145.17c-.64-.17-.65-.99-1.23-1.22-.58-1.87 0-3.5 1-5.07.44-.69 1.09-.97 1.85-1.05-.19.79-1.04.91-1.49 1.51-1.18 1.56-1.51 3.05-.6 4.84.27.53.79.59 1.08.99h-.61Z"
			style={{
				fill: '#e7e1ca',
			}}
		/>
		<path
			d="M126.18 144.35c.16.95-.73.96-1.22 1.27-.28.18-.51-.11-.64-.44-.24-.61-.27-1.22-.18-1.85.13.03.29.11.38.07 1.04-.52 1.36.2 1.66.95Z"
			style={{
				fill: '#ebe3ca',
			}}
		/>
		<path
			d="M118.43 142.31c1.58-.57 1.44-2 1.63-3.26.59.82.7 1.81.3 2.61-.28.57-1.12.93-1.93.65ZM118.02 144.56l-.2.41-.41-.2c-.35-1.06.04-2 1.02-2.45-.38.7-.87 1.39-.41 2.24Z"
			style={{
				fill: '#e8e1c1',
			}}
		/>
		<path
			d="M134.35 141.29c-.75-.03-1.44-.02-2.03.63-.25.27-.8.31-1.23.38-.98.14-1.26-.3-1.2-1.3.07-1.2.88-1.9 1.51-2.74.18-.24.49-.33.72-.32 1.4.06 2.59-.45 3.74-1.17.48-.3 1.04-.24 1.55.04-.76 1.07-.08 1.71.71 2.31.05.3-.12.45-.37.53-.34.1-.75-.01-.99.35-.42.49-1.09.53-1.59.88l-.82.41Z"
			style={{
				fill: '#f5f0df',
			}}
		/>
		<path
			d="M141.9 139.25c.04.23.1.46.13.69.09.55.34 1.08-.2 1.6-.67.64-1.42.9-2.32.75-.36-.06-.4-.24-.22-.58.23-.41 0-.65-.4-.43-1.63.91-3.4.83-5.17.82.53-.53 1.5-.41 1.84-1.22.44-.8 1.32-.89 2.04-1.16.62-.23 1.25-.45 1.88-.67.8-.29 1.67-.62 2.4.21Z"
			style={{
				fill: '#e7e4cf',
			}}
		/>
		<path
			d="M141.9 139.25c-.86-.36-1.75-.34-2.53.11-.88.51-1.9.53-2.79.95-.35.16-.83.12-1.01.58h-.41c.23-.69 1.06-.53 1.43-1.02.21-.47.72-.17 1.02-.41.27 0 .4-.14.41-.41 1.18-.94 2.62-.83 3.97-.86 1.24-.03 2.51-.11 3.75.15.77.16.47-.7.85-.92.83.36.33.9.12 1.33-.2.41-.41.71-1.08.49-1.21-.4-2.49-.23-3.74.02Z"
			style={{
				fill: '#efe9d7',
			}}
		/>
		<path
			d="M135.83 131.39c-.18-.43.2-.43.42-.47.49-.1.68.26.72.64a.64.64 0 0 1-.58.71c-.64.05-.41-.55-.55-.87Z"
			style={{
				fill: '#d1c898',
			}}
		/>
		<path
			d="M167.01 149.65h.61c.49-.05.9 0 .79.67-.67.13-1.24-.17-1.81-.46v-.2h.41Z"
			style={{
				fill: '#d8d3ab',
			}}
		/>
		<path
			d="M146.6 137.42c0 .31.02.62-.02.92-.05.36-.24.5-.65.39-1.77-.48-3.56-.25-5.35-.16-.89.05-1.7.31-2.55.49-1.41-.51-1.55-1.02-.61-2.24.03.02.08.04.08.06-.15 1.48.1 1.81 1.52 1.12 1.41-.69 2.96-.57 4.33-1.19.25-.11.45-.03.68.03.22.06.57.17.68.06.97-.97 1.4-.11 1.9.53Z"
			style={{
				fill: '#f3ecdc',
			}}
		/>
		<path
			d="M149.66 129.67c.32.03.61.14.82.41-.35.02-.66-.04-.82-.41Z"
			style={{
				fill: '#e1d8b5',
			}}
		/>
		<path
			d="M93.52 150.47v-.2c.25-.14.52-.24.82-.2h1.43c-.48.74-1.22.28-1.84.41-.14.11-.27.13-.41 0Z"
			style={{
				fill: '#e6e1c7',
			}}
		/>
		<path
			d="M102.3 159.85c.34-.14.68.37 1.02 0 .85-.4 1.79-.44 2.68-.69 2.14-.33 4.15-.93 5.83-2.4.46-.4.99-.72 1.5-1.05.37-.24.61-.57.52-1.02a.955.955 0 0 0-.8-.71c-2-.23-4-.39-5.78.87-.38.19-.84.2-1.18.5-.48.46-1.15.46-1.72.72-.44.07-1.08.55-.91-.51.08-.48-.34-.53-.67-.57-.9-.13-1.52-.75-2.21-1.24.7-1.53 1.04-1.73 2.7-1.62 1.06.07 2.13-.08 3.13.58.53.35 2.01-.57 2.12-1.22.08-.44.23-.84.44-1.23.14-.27.25-.53.11-.86-.38-.87-.36-1.64.62-2.13.17-.08.15-.29.16-.46.24-.78 1.02-1.24 1.22-2.04.69-.04.61-.6.63-1.41.62 1.08 1.4 1.35 2.25 1.54.41.09.48.51.62.86.59 1.49.74 3.14 1.68 4.51.4.59-.26 1.52.54 2.04.26.24.24.56.18.86-.08.46.12.75.43 1.06.94.94.9 1.09-.29 1.62-.12.05-.2.18-.3.28-1.05.33-1.88 1-2.69 1.7-.49.43-1.12.4-1.7.55-.79.22-1.44.97-2.38.67-.5.04-.99.13-1.43.41-.65.39-1.33.44-2.04.2-1.06.27-2.06.77-3.21.62-.41-.05-.79-.08-1.08-.42Z"
			style={{
				fill: '#e6e2c5',
			}}
		/>
		<path
			d="M116.79 155.98c.04-.28.07-.53.48-.48 1.07.14.62-.56.3-.76-1.01-.62-.88-1.51-.78-2.44h.2c1 .07 1.87-.07 2.61-.92.5-.58 1.39-.65 2.09-.98 1.29-.61 2.23-1.77 3.64-2.15.16-.04.31-.13.48-.17.33-.08.71-.17.95.14.22.28.01.57-.13.84-.24.24-.02.31.15.41l.24.09c.38.11.78.04 1.16.09.09 0 .18.02.27.03.46 0 .92-.07 1.38-.09.52.03.88-.65 1.46-.33 1.09-.6 2.18-.21 3.27 0 .05.09.04.18-.02.26-.09.05-.18.08-.28.09-.1 0-.19-.01-.28-.03-.59-.07-1.19-.16-1.76.09-.34.41-.64.82-1.31.59-.37-.12-.78.13-1.17.22-1.15.23-2.28.25-3.38-.21-1.18-.73-1.5-.7-2.55.26-.4.37-.49.72.04 1.05.32.2.62.4.88.68.61.66.6 1.09-.03 1.82-.19.16-.44.24-.58.51.42.01.49-.34.71-.51 1.09-.9 2.32-.66 3.54-.44.24.22.09.39-.05.57-1.53-.07-2.9.3-4.05 1.4-.3.29-.69.02-.98-.24-.56-.51-.47-.98.09-1.43.23-.19.51-.34.66-.62.13-.24.06-.47-.13-.64-.17-.15-.37-.18-.52.03-.73 1.04-1.78 1.6-2.93 2.04-.41.16-.76.43-1.1.71-.66.52-1.52.49-2.26.82-.16.07-.32-.04-.29-.28Z"
			style={{
				fill: '#e7e0c4',
			}}
		/>
		<path
			d="M117.2 151.9c.21-1.28.15-2.45-.95-3.39-.26-.23-.44-.67-.27-1.1 1.83.04 2.69 1.66 4.06 2.46.19.11.28.37.31.62-.03.36-.3.49-.57.64-.56.3-1.12.57-1.56 1.06-.31.35-.71.35-1.01-.09v-.2Z"
			style={{
				fill: '#dfd9b5',
			}}
		/>
		<path
			d="M117.2 152.1c.22.09.53.32.65.14.6-.89 1.66-1.12 2.41-1.78.23-.55.98-.29 1.25-.78 1.41-1.01 2.97-1.71 4.66-2.1.42-.01.85 0 1.02.46.2.53-.13.89-.5 1.21-.11.06-.21.05-.31-.02l.3-1c-1.31 0-2.37.57-3.23 1.36-.78.71-1.71 1.02-2.59 1.47-.64.33-1.3.48-1.77 1.18-.52.76-1.38.27-2.1.06l.2-.2Z"
			style={{
				fill: '#e2dcbb',
			}}
		/>
		<path
			d="M121.49 149.86c-.16.7-.81.41-1.22.61-.71-.98-2.02-1.28-2.67-2.41-.17-.29-1.21-.01-1.62-.65v-.2c.13-1.34.35-1.55 1.63-1.63.09.16.24.2.41.2.49 1.11 1.27 1.5 2.5 1.22.74-.16 1.54.11 2.29.23.73.12.87.81.35 1.36-.49.51-1.17.77-1.67 1.26Z"
			style={{
				fill: '#ddd7b0',
			}}
		/>
		<path
			d="M121.49 149.86c.23-.65.9-.88 1.35-1.29.29-.26.47-.48.4-.8-.1-.43-.52-.33-.85-.36-.91-.08-1.81-.29-2.72-.09-1.3.28-1.43-.67-1.65-1.54 1.29.65 2.69.82 4.09.98.03 0 .07.02.1.02.91-.25 1.78-.61 2.69.1.35.27.87.29 1.04-.45.09-.38.63-.45 1.06-.44-.4.93-.39.89.67 1.27.59.21 1.31-.15 1.79.45-.6.67-1.29.79-2.09.31-.39-.24-.74-.42-1.19-.19-1.69.39-3.17 1.27-4.7 2.04Z"
			style={{
				fill: '#e0d8b4',
			}}
		/>
		<path
			d="M129.45 147.62c-.88.03-1.75.03-2.57-.39-.22-.11-.57.05-.66-.32-.1-.39.21-.52.47-.68.11-.07.21-.16.31-.25.72-.38 1.5-.14 2.25-.2l.2.2c.12.12.12.25.01.39-.38.15-.78-.18-1.16.06-.17.1-.39.17-.35.42.03.19.22.23.38.27.32.08.66.03.98.15.09.05.15.12.18.21l-.05.13Z"
			style={{
				fill: '#dcd6b0',
			}}
		/>
		<path
			d="M109.85 146.8c.36.33.16.56-.17.68-.87.33-.83 1.11-.49 1.58.43.61.16 1.04-.06 1.45-.25.43-.41.83-.35 1.32 0 .07.03.14 0 .2-.14.47-2.28 1.25-2.66.9-.49-.45-1.02-.46-1.64-.52-.64-.06-1.29-.03-1.94-.14-.91-.16-1.38.8-1.89 1.46-.72.46-1.46.41-2.2.05-.96-.46-1.92-.54-2.9-.05h-.41c.28-.4.18-.75-.12-1.1-.12-.14-.09-.33.01-.48.12-.17.28-.17.43-.04.24.2.49.07.76.08 2.34.04 4.55-.9 6.87-.92.31 0 .46-.22.65-.42.71-.76 1.59-1.09 2.63-.89.23.04.43.02.57-.12.72-.67 1.54-1.25 1.86-2.24l1.02-.82Z"
			style={{
				fill: '#e6e2c2',
			}}
		/>
		<path
			d="M93.52 150.47h.41c-.4 1.31-.39 1.26-1.86.82-1.13-.34-2.29-.55-3.44-.82 1.02.1 2.06-.32 3.08.34.5.32 1.22-.12 1.82-.34Z"
			style={{
				fill: '#e6e1c2',
			}}
		/>
		<path
			d="M94.82 150.66c.3.05.68-.08.68.32 0 .37-.38.44-.67.49-.39.06-.61-.21-.6-.52.01-.42.42-.18.59-.28Z"
			style={{
				fill: '#dfd9b8',
			}}
		/>
		<path
			d="M88.62 154.75c.6-.76 1.45-.59 2.24-.61l-2.24.61Z"
			style={{
				fill: '#dfd7b3',
			}}
		/>
		<path
			d="M86.58 143.95c.43.11.32.61.61.82-.14 1.19.69 2.42 1.83 2.64.46.09.77.34.86.75.14.64-.68.48-.88.93-.15.32-.53.09-.77-.13-.37-.33-.88-.47-1.17-.93-.16-.25-.64-.4-.79-.22-.23.28-.36.32-.63.14-.29-.19-.06-.41-.06-.62.02-.67-.17-1.34-.02-2.01.13-.61.12-1.33 1.02-1.38Z"
			style={{
				fill: '#f4eede',
			}}
		/>
		<path
			d="M95.62 141.88c-1.11.42-2.31.84-3.48 1.34-.89.39-1.72.73-2.75.36-.54-.2-.69-.39-.47-.84.76-1.48 1.46-3 3.15-3.75.61-.27.97-.96 1.63-1.29 1.61-.81 3.05-.6 4.44.43.62.46.44 2.03-.24 2.42-.46.27-.95.54-1.25 1.01-.23.36-.51.54-1.04.31Z"
			style={{
				fill: '#f3efdf',
			}}
		/>
		<path
			d="M169.26 144.76c.1.13.19.29.31.4.3.26.73.45.63.94-.1.49-.52.56-.94.6-.4.04-.61.54-1.08.44-.29-.06-1.87-1.77-1.87-2.07 0-.91.68-.99 1.32-1.13l1.63.82Z"
			style={{
				fill: '#d2c894',
			}}
		/>
		<path
			d="M192.74 151.29c-.76.06-1.49.02-2.04-.61-.28-.19-.53-.43-.82-.61-.44-.85.34-1.25.69-1.78.21-.32.6-.4.94-.06-.03.22-.16.38-.33.49-1.02.69-.79.97.13 1.6.2.13.4.26.63.32 1.08.3 1.51-.7 2.23-1.11.26-.18-.06-.52.19-.69.35 0 .71 0 .78.45.06.33-.22.44-.43.61-.47.37-.92.78-1.37 1.18l-.61.2Z"
			style={{
				fill: '#cac28f',
			}}
		/>
		<path
			d="M191.92 150.88c-.1-.02-.22 0-.29-.06-2.06-1.42-1.95-1.21-.12-2.59l2.04.61s-.06.07-.1.1c-.06.03-.12.07-.19.08q-1.63.26-1.35 1.86ZM194.37 148.84c-.26.27.7.54 0 .82-.35-.19-.81-.28-.82-.81h.82Z"
			style={{
				fill: '#c3ba88',
			}}
		/>
		<path
			d="M188.25 141.7c-.49.97-.42 2.02-.41 3.06-.2-1.06-.71-2.17.41-3.06Z"
			style={{
				fill: '#d0c9a2',
			}}
		/>
		<path
			d="M189.27 141.29c.87-.42 1.17.01 1.22.81-.54.1-.74.47-.89.96-.3.92.03 1.76.59 2.34.55.57 1.46.34 2.22.27.41-.04.36-.31.18-.59-.25-.4-.56-.76-.85-1.13-.35-.44-.57-.92-.17-1.45-.38-.16-.95.3-1.08-.4 1.05.05 1-.92 1.19-1.47.91-2.58 2.97-3.82 5.29-4.77.51-.21.76.21.56.71-.42 1.06-1.02 2.02-1.7 2.92-.29.38-.49.71-.44 1.18-.79.84-1.55 1.7-2.47 2.43-.58.46-.34 1.33.42 1.73.71.37 1.43.74 2.31.78l-.46.37c-1.36-.06-2.64.52-4.02.43-1.5-.09-2.54-1-2.49-2.52.03-.88.08-1.8.59-2.6Z"
			style={{
				fill: '#f0e8cc',
			}}
		/>
		<path
			d="M188.45 144.76c-.33-.82-.33-1.63 0-2.45v2.45Z"
			style={{
				fill: '#e0d8b4',
			}}
		/>
		<path
			d="M191.72 153.12c.46-.02.84.12.8.65-.06.75.37.82.94.78.16-.01.34 0 .5.04.24.06.44.22.51.45.11.32-.21.38-.4.47-.29.15-.52.32-.52.67-1.26.32-2.54.47-3.85.38-.13 0-.35.07-.39.02-.63-.96-1.9-.47-2.65-1.17-.23-.22-.53-.36-.39-.72.14-.34.48-.42.77-.29.48.21.68.09.91-.39.4-.83 1.21-.77 1.95-.62.4.08.79.15 1.2.15.04.52-.65.92-.21 1.56.59-.46 1.07-.92.83-1.76v-.2Z"
			style={{
				fill: '#ece2c2',
			}}
		/>
		<path
			d="M191.72 153.33c.54.33.52.73.15 1.17-.24.28-.5.54-.74.82-.11.14-.22.26-.41.19-.19-.07-.2-.25-.21-.41-.07-.63-.02-1.21.61-1.56l.61-.2Z"
			style={{
				fill: '#f4eacb',
			}}
		/>
		<path
			d="M162.32 168.01c-.38 1.05-1.27 1.31-2.25 1.43l2.25-1.43Z"
			style={{
				fill: '#d1c89e',
			}}
		/>
		<path
			d="M143.34 169.85c.25-.6.71-1.12.61-1.84.26-.31.44-.71.9-.78.34 0 .63.13.91.32 1.04 1.45 2.48 1.66 4.18 1.65 2.83 0 5.53-.42 8.11-1.57.49-.22 1.02-.42 1.57-.12.11.08.12.18.05.29-2.01.54-3.87 1.52-5.98 1.77-1.95.24-3.9.34-5.86.24-.92-.05-1.53-.79-2.16-1.41-.88-.87-1.17-.79-1.55.36-.14.42-.2.96-.78 1.08Z"
			style={{
				fill: '#eae1c2',
			}}
		/>
		<path
			d="M159.66 167.81v-.2c0-.45.18-.61.61-.41-.13.28-.34.48-.61.61Z"
			style={{
				fill: '#eee5c1',
			}}
		/>
		<path
			d="m145.58 167.6-.82-.21c-.28-.74.08-.83.68-.65 1.37.41 1.4.39 1.4-1.03 0-1.22.44-1.84 1.61-2.27.66-.04 1.06.35 1.41.83.14.19.31.39.58.33.33-.08.21-.37.23-.59.1-1.27.22-1.42 1.44-1.71.46-.11.88-.26 1.3-.52 1.2-.73.81-1.73.57-2.73.1-.48.46-.76.82-1.03.62-.71 1.19-1.53 2.45-.86-.07-.66-.43-1.14-.09-1.6.3-.4.74-.57 1.19-.72.23-.08.39-.26.59-.38.09-.05.18-.09.28-.12 1.3.04 2.43-.68 3.7-.86.65-.09 1.35-.03 1.98-.31.99-.15 1.59.56 2.3 1.04.75.79.99 1.89 1.66 2.72.31.39.41.86-.02 1.27-.41.21.23.66-.3.88-.14-.86-.76-1.1-1.54-1.09-.28-1.33-1.53-1.34-2.45-1.81-1.23-.63-2.56-.8-3.91-.89-.25-.02-.54-.29-.72.05-.14.28-.11.6.1.86.42.53.84 1.05 1.26 1.58.06.14.04.32-.08.36-.96.33-1.73 1.22-2.87.99-.64-.13-.77.21-.75.74.01.3.05.61.05.91.04 1.71.89 2.28 2.58 1.75.36-.11.74-.09 1.11-.13.98-.11 1.06-.23.9-1.23-.09-.56-.28-1.22.7-1.15v.2c.18.29.42.53.61.82.71 1.59.73 3.21.18 4.85-.13.38-.37.63-.79.66.11-.28.44-.46.41-.82.14-.19.15-.39-.07-.48-.37-.16-.7-.05-.95.28-.17.14-.36.16-.57.12-1.32-.25-2.34.2-2.85 1.38-.36.84-1.14.82-1.78.93-.88.16-1.74.09-2.5.8-.48.45-1.31.35-1.96.15-1.35-.42-2.69-.12-4.03-.02-.81.06-1.52.21-2.05-.63-.2-.33-.68-.43-1-.68Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M162.93 160.06c-.77.21-.59.75-.44 1.27.28.99.13 1.18-.89 1.33-.61.09-1.23-.04-1.83.4-.52.38-1.06-.36-1.67-.38-.92-.03-.72-.74-.7-1.36.02-.56-.1-1.13-.08-1.7.02-.51.09-.94.88-.76.63.15 1.38.2 1.83-.52.3-.48 1.07.16 1.26-.55.86.52 1.21 1.41 1.63 2.24ZM163.54 161.08c-.33-.18-.6-.4-.61-.82.33.18.6.4.61.82Z"
			style={{
				fill: '#ded9b5',
			}}
		/>
		<path
			d="M145.58 167.6c.6.16 1.26.2 1.5.96.07.22.38.32.62.25.84-.24 1.72-.12 2.55-.26.88-.15 1.66.02 2.49.16.82.14 1.72.4 2.28-.62.37-.68 1.11-.29 1.64-.31.98-.05 1.81.04 2.15-1.22.25-.93 2.04-1.51 2.93-1.11.18.08.39.08.59.12-.53.73-1.51.9-2.04 1.63-.29 0-.5.14-.61.41-1.22-.15-2.22.57-3.27.97-2.85 1.07-5.8.92-8.73.83-.99-.03-1.45-1.11-2.09-1.79ZM162.32 165.56c.03-.8.64-.54 1-.45.43.11.23.42.02.65-.19-.81-.69-.11-1.02-.2Z"
			style={{
				fill: '#e3daba',
			}}
		/>
		<path
			d="M143.13 162.1c.97.71 1.35 1.67 1.23 2.85-.1.24.25.76-.42.65-.32-.05-.35.2-.41.45-.1.42-.38.76-.58 1.12-.37.67-.76.41-.94.08-.28-.53-.52-.28-.76-.08-.43.37-.86.75-1.24 1.18-.48.55-.95 1.09-1.78.85-.36-.1-.38.12-.46.35-.1.32.08.44.34.48.33.05.68.03.99.13.42.13.82.34.76.91-1.49.15-2.65-.41-3.18-1.38-.34-.63.11-1.03.37-1.3.2-.2.71-.85 1.25-.15.29.38.83.18.92-.17.16-.67.56-1.37.31-2.03-.24-.64-.15-1.23-.12-1.84.04-.8-.44-1.53-1.29-1.62-.85-.09-.7-.76-.41-.95.7-.48.76-1.08.73-1.78.71.05.86.6.69 1.08-.29.85.18 1.11.78 1.45.82.45 1.55.61 2.28-.15.25-.26.59-.3.94-.14Z"
			style={{
				fill: '#d0c499',
			}}
		/>
		<path
			d="M143.13 162.1c-.25.08-.53.11-.74.24-1.25.82-2.58.68-3.58-.38-.19-.2-.37-.32-.08-.65.5-.56.27-1.07-.3-1.46-.25-.84-1.51-.67-1.63-1.63 1.74.45 3.27 1.35 4.71 2.38.59.42 1.08.99 1.62 1.49Z"
			style={{
				fill: '#cec59d',
			}}
		/>
		<path
			d="M175.17 163.11c-.76-.07-1.52-.06-2.29 0-.79.05-.86-.58-.99-1.16-.1-.46.13-1.13.31-1.1.79.11 1.39-.45 2.09-.44 1.13.01 2.31-.12 3.22.86.34.37.6.55.05.96-.72.52-1.37 1.14-2.38.89Z"
			style={{
				fill: '#e0d9b3',
			}}
		/>
		<path
			d="M168.85 158.22c.18-.67-.17-1.14-.52-1.66-.46-.68-.86-1.42-1.11-2.21.55-.11.77.35 1.05.64.44.46.89.58 1.41.17.58-.64 1.27-1.2 1.57-2.05.09-.05.17-.05.25.02.11.64-.07 1.2-.58 1.62.32.28.54-.05.79.01.11.22-.02.38-.13.54-.88.67-1.47 1.54-1.84 2.58-.24.66-.06.96.63.95.61-.01 1.19-.2 1.78-.35 1.07-.28 2.14-.55 3.06-1.2.6-.5 1.11-1.14 2.01-1.08-.72.91-1.55 1.71-2.62 2.2-1.21.54-2.57.59-3.78 1.17-.86.41-1.25.09-1.97-1.33Z"
			style={{
				fill: '#e2dbbc',
			}}
		/>
		<path
			d="M177.22 156.18c-.64.36-1.31.68-1.84 1.22a.421.421 0 0 1-.32-.27c-.05-.43.12-.76.55-.84.75-.15 1.06-.8 1.54-1.26.23-.23.31-.53.16-.84-.16-.31-.47-.27-.72-.23-1.4.23-2.77.62-4.12 1.06-.28.09-.53.32-.86.23-.04-.03-.08-.06-.11-.09l.21-.41c.75-.29 1.4-.75 2.12-1.1 1.06-.51 2.14-.58 3.25-.52.83.05 1.38 1.29.89 1.98-.25.36-.51.71-.76 1.07Z"
			style={{
				fill: '#eae3c4',
			}}
		/>
		<path
			d="M168.44 150.27c-.15-.37-.52-.44-.82-.61.28-.65.58-.89 1.13-.18.21.27.32.66.71.79.84.24 1.34.98 2.04 1.43.06.76.7.6 1.15.69.28.06.6-.05.89-.08l-.61.41c-.48.62-.95.24-1.43 0l-.12-.06c-.22-.22-.42-.46-.7-.62-.62-.49-1.22-1.01-1.95-1.34-.17-.08-.38-.17-.29-.43Z"
			style={{
				fill: '#ceca9f',
			}}
		/>
		<path
			d="M173.22 147.4c-.43 0-.67-.18-.69-.6-.02-.34.04-.6.47-.61.44-.02.75.26.83.59.09.38-.29.54-.61.62Z"
			style={{
				fill: '#d8cd9e',
			}}
		/>
		<path
			d="M171.51 151.69c-.03-.36-.25-.6-.45-.88-.41-.59.09-.99.38-1.43.28-.43.6-.1.89-.02.19.06.44 2.11.26 2.34-.35.47-.71-.07-1.08-.01Z"
			style={{
				fill: '#cec892',
			}}
		/>
		<path
			d="M189.88 150.06c.41.02.64.29.82.61-.41-.02-.64-.28-.82-.61Z"
			style={{
				fill: '#d1c897',
			}}
		/>
		<path
			d="M171.51 153.12h-.21c-.51 0-.6-.38-.66-.77.06-.08.13-.13.23-.16.34.01.46.31.64.52v.41Z"
			style={{
				fill: '#e2d9b8',
			}}
		/>
		<path
			d="M130.06 170.05c-1.05.48-2.33.35-3.27 1.17-.16.14-.46.18-.68.17-1.09-.08-2.12.29-3.13.54-1.52.38-3.08-.07-4.56.44-.25.08-.45-.08-.6-.28-.5-.2-.88-.48-.88-1.09 0-.75-.47-1.09-1.13-1.19-.47-.07-.83-.27-1.13-.6-.14-.15-.23-.36-.11-.56.12-.2.38-.25.54-.14.69.45 1.21.11 1.85-.2.63-.31 1.39-.21 2.1-.18.93.04 1.71-.11 2.28-.97.5-.75 1.35-1.1 2.15-1.47.09-.04.18-.06.27-.09.41-.06.8-.17 1.16-.37.09-.04.18-.06.27-.08.94 0 1.81-.24 2.56-.85.42-.35.91-.4 1.45-.32.42.06.71-.17.91-.53.21-.37-.09-.55-.31-.76-.31-.32-.36-.72-.34-1.14.05-.79-.15-1.42-.84-1.94-.51-.38-1.05-.92-.44-1.68-1.42.8-2.68.03-3.98-.44.09-.64.28-.86.92-.76.76.12 1.39-.02 1.99-.5.3-.24.7-.22 1.08-.21 1.22.03 2.44-.06 3.65-.07.23-.03.46-.12.68 0-.17.49-.01.9.13 1.41.32 1.11 1.4 2.09.71 3.42-.11.22-.06.57.17.75 1.15.88.82 2.11.77 3.25-.06 1.21-.23 2.41-.35 3.61-1.07-.61-1.53.46-2.25.82-.59.19-1.25.22-1.63.82Z"
			style={{
				fill: '#ded7b6',
			}}
		/>
		<path
			d="M124.14 157.41c.99-.16 1.72.82 2.73.62.29-.06.63.09.88-.15.22-.21.52-.15.64 0 .18.21-.25.23-.27.42-.06.55.28.94.67 1.17.93.54 1.02 1.34.9 2.25-.05.37.04.82.33.89.71.15.58.63.38.96-.24.41-.6.95-1.2.71-.58-.23-1-.06-1.4.29-.83.72-1.8.88-2.84.8-.03-.45.37-.43.62-.52.87-.3 1.66-.76 2.45-1.21 1.29-.73 1.45-2.14.61-3.36-1.36-1.98-3.34-2.03-5.4-2-.43-.02-.84.02-1.2.28-.12.08-.25.14-.38.19-.94.29-1.94.38-2.74 1.12-.42.38-1.11.46-1.72.19-.24.13-.47.23-.64.47-.91 1.26-2.25 1.53-3.55.73-.61-.38-1.53-.47-1.38-1.56.03-.23-.31-.3-.47-.17-.75.64-.89 0-1.11-.49.81-.1 1.47-.62 2.25-.82.9-.06 1.7-.31 2.5-.81 1.3-.82 2.82-1.22 4.26-1.74 1.36-.71 2.71-1.43 4.26-.5.36.27.72.53 1.12.06 1.02-1.19 2.3-1.48 3.78-1.08.86-.22 1.73-.04 2.6-.05.65 0 1.17-.22 1.67-.6.45-.34.68-.75.45-1.31-.33-.8 0-1.24.79-1.35.44-.06.79-.4 1.25-.33 1.17.55 1.24 1.79.14 2.62-.55.42-1.1.81-.78 1.63.1 1.02.65 1.55 1.68 1.55.87 0 1.15 1.05 1.99 1.1v.2c-1.5-.54-2.99-1.09-4.49-1.63-.34-.2-.68-.63-1.02 0l-.61.2c-.43-.73-1.16-.91-1.92-.95-.87-.05-1.75-.09-2.62.07-.17.03-.38.12-.5.03-.94-.71-1.45.07-2.02.58-.45.4-.84.75-1.52.47-.35-.15-.82-.11-.88.38-.08.59.41.59.83.59.29 0 .6-.18.87.07ZM159.05 154.55c-.2.4-.53.53-.95.65-.92.26-.98.59-.47 1.45.29.49-.3.8-.48.7-1.16-.68-1.57.32-2.18.87-.51-1.44-.51-1.42-2.21-1.37-1.06.03-1.96.5-2.86.96-.58.63-1.29 1.1-1.93 1.65-.9.76-1.35 1.68-1 2.87.1.21.26.39.31.63 0 .1-.04.18-.12.24-.14.06-.28.06-.42.03-1.09-.18-1.58-.42-2.61-1.32-.23-.2-.49-.36-.79-.43l-.41-.81c.49 0 1.25.42 1.41.11.33-.66 1.02-1.08 1.15-1.87.31-1.94 1.49-3.42 2.76-4.82.56-.62.96-.41 1.42.66 1.77.19 3.55.1 5.33.14.93.02 1.81-.05 2.62-.55.5-.06 1.01-.18 1.44.21Z"
			style={{
				fill: '#e1dab9',
			}}
		/>
		<path
			d="M131.7 169.23c.29-.31.6-.61.87-.93.52-.62.97-.53 1.37.12.02.06.08.17.07.18-1.08.93-1.82 2.28-3.33 2.67.87-.83 1.9-1.52 2.35-2.73-.37.41-.8.64-1.33.69Z"
			style={{
				fill: '#e3dbba',
			}}
		/>
		<path
			d="M132.51 155.98c.02-.19-.05-.48.16-.51.38-.06.68.16.86.51-.34-.03-.68-.29-1.02 0Z"
			style={{
				fill: '#ded7b6',
			}}
		/>
		<path
			d="M143.34 161.48c.97-.4 1.14.55 1.59.99.31.3.35.93 1 .37.21-.18.63.03.88.28.46.37 1.06 0 1.53.3.03.04.07.07.1.11-1.03.61-1.52 1.41-1.29 2.69.18.99-.44 1.28-1.42.92-.26-.1-.96-.91-.97.26l-.82.61c.39-.97.9-1.83.9-3 0-1.49-.47-2.58-1.51-3.52Z"
			style={{
				fill: '#e0d9b3',
			}}
		/>
		<path
			d="M123.73 165.77c-1.01.59-2.07 1.09-2.71 2.17-.36.6-1.09.44-1.65.46-1.12.05-2.29-.25-3.21.71-.18.19-.42.11-.62-.09-.21-.22-.45-.42-.86-.31.09.55.5.83.93.86 1.03.07 1.71.33 1.52 1.58-.06.38.41.66.68.95h-.61a1.29 1.29 0 0 0-.61-.61c-1.18-1.4-2.73-2.46-3.68-4.08.14-.57 1.03-1.19-.1-1.7-.03-.01 0-.25.06-.35.1-.15.26-.15.44-.1.33.1.45.52.83.51.57-.11.7.44 1.02.69.43.34.82.55 1.37.28.76-.37 1.61-.09 2.39-.31.1-.03.2-.05.3-.07 1.02-.16 2.15.24 3.06-.57.48-.21.96-.44 1.45-.03Z"
			style={{
				fill: '#ded7ba',
			}}
		/>
		<path
			d="M130.06 170.05c.13-1.09 1.01-.71 1.63-.82-.47.43-1.08.55-1.63.82Z"
			style={{
				fill: '#e3dbba',
			}}
		/>
		<path
			d="M83.93 165.15c.23-.3-.08-.43-.2-.61h.82c.34-.27.78-.43 1.07-.77.24-.28.49-.48.87-.27.32.18.48.47.48.84 0 .24-.08.47-.07.71.06 1.06.66 1.64 1.74 1.67h.1c2.22.04 3.22-.7 3.99-2.85.33-.93.57-1.87.76-2.83.19-.97.88-1.31 1.88-.99.2.24.41-.07.61 0-.56.61-.97 1.36-1.8 1.69-.1.04-.22.2-.21.3.08 1.25-.61 2.24-1.1 3.3-.03.06-.04.13-.02.19.19.64.57 1.37-.41 1.68-.61.19-1.07.62-1.82.67-.81.06-1.69-.11-2.48.2-.3.12-.43-.13-.62-.24-.37-.23-.74-.33-1.13-.05-.47-1.21-1.22-2.15-2.45-2.65Z"
			style={{
				fill: '#eae4d3',
			}}
		/>
		<path
			d="M83.93 165.15c.57.3 1.33.2 1.79.69.48.53.45 1.3.66 1.96-1.44.21-2.87.04-4.29-.2.4-.56.95-1.04.82-1.84.41-.02.41-.31.41-.61h.61Z"
			style={{
				fill: '#e6e4cf',
			}}
		/>
		<path
			d="M117.2 160.06c.88-.14 1.69-.31 2.42-.99.47-.43 1.33-.49 2.07-.44.09.23-.03.38-.19.52-.83.43-1.81.51-2.59 1.08-.36.26-.7.51-.95.88-.49.43-1.01.84-1.43 1.35-.71.35-.89 1.33-1.78 1.47l.41-1.02c.83-.84 1.64-1.71 2.04-2.85Z"
			style={{
				fill: '#e4ddc0',
			}}
		/>
		<path
			d="M106.59 159.65c.66-.24 1.35-.21 2.04-.2.33.14.39.37.16.63-.48.55-1.81.29-2.2-.43Z"
			style={{
				fill: '#e1dab9',
			}}
		/>
		<path
			d="M106.18 159.44c-.97.05-1.85.63-2.86.41-.75-.45-.8-1.01-.29-1.68.45-.59.88-1.19 1.32-1.78.84-.78 1.99-.99 2.95-1.55.77-.55 1.63-.83 2.58-.75.89.07 1.75-.2 2.63-.15.53.03.94.17 1.13.68.18.5-.16.81-.49 1.12-1.71 1.66-3.8 2.65-6.07 3.28-.34.09-.62.25-.9.43Z"
			style={{
				fill: '#f4efd8',
			}}
		/>
		<path
			d="M95.56 153.73c.83-.96 1.94-.72 2.78-.29.82.43 1.55.24 2.33.29.95.22 1.59 1.12 2.7 1.12.67 0 .42.67.12 1.17l.85-.04c.05.07.05.14 0 .2-.36.26-.73.48-1.27.54.18-.99-.59-.75-1.17-1.01-.93-.43-2.02-.14-2.87-.9-.83-.74-1.87-1.21-3.06-1.08h-.41Z"
			style={{
				fill: '#e9e5cb',
			}}
		/>
		<path
			d="M104.34 156.18v-.2c.34-.68 1.24-.25 1.63-.82.36-.13.7-.35 1.11-.29l.12.09c-.78.81-1.92.93-2.86 1.43v-.2Z"
			style={{
				fill: '#ebe7cc',
			}}
		/>
		<path
			d="M114.75 163.93c.6-.49.92-1.25 1.64-1.63.28.42-.06.7-.24 1-.19.32-.46.59-.66.9-.67 1.08-.25 1.86 1.05 1.94.2.01.41 0 .61-.02 2.02-.32 4.09-.26 6.05-1.13.99-.44 2.11-.68 3.16-1.04.81-.28 1.44-.74 2.02-1.31.41-.4.52-.9.21-1.39-.9-1.43-1.99-2.61-3.87-2.57-.84-.22-1.64-.05-2.41.28-.27.11-.53.3-.83.08l.2-.41.21-.2c.38-.22.83-.24 1.22-.41 1.45-.01 2.89 0 4.26.61 1.48.66 2.41 2.93 1.79 4.41-.11.26-.32.38-.55.54-1.15.75-2.39 1.31-3.66 1.79-.38.22-.83.24-1.22.41-.5-.06-.96.09-1.43.2-.65.49-1.4.55-2.19.52-.36-.01-.74-.12-1.08.09-.98.24-1.99.13-2.99.31-1.16.21-2.1-1.67-1.5-2.76l.2-.2Z"
			style={{
				fill: '#e6e1c5',
			}}
		/>
		<path
			d="M114.55 164.13c-.44 1.64.6 2.7 2.36 2.48.7-.09 1.42-.02 2.13-.03-1 .39-2.09.28-3.14.53-.77.19-1.16-.89-1.76-1.35-.36-.67-.2-1.2.41-1.63Z"
			style={{
				fill: '#e4ddc0',
			}}
		/>
		<path
			d="M87.19 163.73c.24-.27.48-.55.72-.82-.04-.05-.07-.12-.12-.15-.48-.21-1.5.12-1.43-.24.13-.74.52-1.59 1.45-1.86.88.92 1.93 1.05 3.02.29 1.38-.96 2.85-1.74 4.36-2.47.35-.17.71-.37.68-.79-.03-.48-.51-.53-.85-.55-1.01-.06-2.02-.2-3.03.02-.33.07-.71.32-1.01-.09.34-1.07 1.39-1.05 2.13-1.06.98 0 1.99.18 2.99.16.35 0 .64.18.89.41l.2.61c-.28.87-.51 1.77-1.43 2.24h-.2c-.13.11-.25.26-.41.29-1.76.32-2.02 1.69-2.2 3.11-.11.86-.34 1.65-.99 2.27-.15.14-.29.29-.41.45-.96 1.29-2.74 1.62-4.07.76-.77-.5-.89-1.49-.29-2.6Z"
			style={{
				fill: '#f5eedf',
			}}
		/>
		<path
			d="M96.99 156.59c-1.29-.37-2.64-.02-3.97-.3-.42-.09-1.64-.09-1.95.91.08.18.03.35-.09.47-.82.85-1.8 1.53-2.43 2.56-.1.16-.35.2-.54.03l-1.02.41c.05-.47.33-.69.77-.82.67-.2.58-.54.1-.88-.25-.17-.5-.4-.77-.46-1.12-.24-.95-1.21-1.06-1.93-.09-.58.52-.67.98-.79.56-.15 1.23-.01 1.63-.61 1.56.25 2.98-.47 4.49-.61h1.5c.77 0 1.5.02 1.61 1.05.05.45.73.48.76.99ZM95.77 159.44c.74-.58.85-1.56 1.43-2.24.2.8-.41 1.36-.61 2.04l-.82.2Z"
			style={{
				fill: '#eee9d9',
			}}
		/>
		<path
			d="M87.19 163.73c-.02.46-.35.85-.24 1.37.24 1.15 1.17 1.32 2.05 1.46.85.13 1.79.17 2.2-.89.12-.3.3-.51.55-.69.61-.46 1-1.18.9-1.84-.16-1.06.45-1.82.76-2.66.3-.82 1.37-.8 2.15-1.02l-.2.61c-.9.04-1.61.18-1.69 1.38-.13 1.97-1.22 3.59-2.28 5.18-.2.3-.64.35-1.01.37-.51.02-1.02 0-1.52 0-1.7 0-2.41-.81-2.14-2.49.06-.36-.03-.59-.28-.8-.36-.29-.55.02-.76.23-.32.32-.67.57-1.13.62.26-.57.86-.82 1.26-1.25.5-.53 1.02-.04 1.39.44Z"
			style={{
				fill: '#efe9da',
			}}
		/>
		<path
			d="M88.01 160.26c.1-.02.26-.01.29-.07.65-1.26 1.94-1.92 2.78-2.99 1.39-.59 2.82-.43 4.26-.25.43.05.89.16.89.65 0 .48-.31.87-.77 1.08-1.6.72-3.14 1.51-4.54 2.59-.66.51-1.58.46-2.38.5-.43.02-.65-.62-.73-1.11.16-.09.2-.24.2-.41Z"
			style={{
				fill: '#f7f1e4',
			}}
		/>
		<path
			d="M134.55 149.45v-.2c.09-.66-.47-.65-.85-.79-.4-.16-.39-.34-.07-.55.71-.46 1.65-.33 2.24.33.58.64 1.13.74 1.97.36.85-.38 1.87-.21 2.8-.27.62-.04 1.33.06 1.98.03.98-.05 1.55.23 1.52 1.3-1.82.82-3.8.58-5.71.81-.54.07-1.05-.28-1.45-.65-.38-.36-.71-.29-1.08-.01-.37.13-.74.14-1.11.03-.16-.08-.29-.17-.24-.38Z"
			style={{
				fill: '#ddd9b8',
			}}
		/>
		<path
			d="M129.45 146.39v-.41c1.9.67 2.28 1.34 1.84 3.26-.54.05-.86.62-1.43.61-.48-.2-.95-.13-1.43 0h-.2c-.45-.27-.98.06-1.43-.2-.06-.14-.08-.3-.2-.41.69-1.3.68-1.33-.41-1.43.43-.35.87-.24 1.31-.01.69.36 1.35.36 1.96-.19.15-.14.26-.31.31-.51 0-.24-.15-.41-.26-.59a.495.495 0 0 1-.04-.13Z"
			style={{
				fill: '#e1dab9',
			}}
		/>
		<path
			d="M146.6 148.43c-.35.3-.78.39-1.22.41.32-.4.77-.42 1.22-.41Z"
			style={{
				fill: '#dfd9bc',
			}}
		/>
		<path
			d="M134.76 149.66h1.22a.53.53 0 0 1 .58 0c.83.58 1.75.83 2.76.83.19 0 .39.12.33.4-.95.22-1.8.81-2.82.79-.15 0-.41.08-.45.18-.43 1.14-1.85 1.6-2.04 2.9-1.06-.7-.09-1.33.28-1.48.88-.36.56-1.33 1.16-1.81.18-.15-.43-.49-.62-.78.12-.17.31-.23.49-.32-.15-.46-.92-.06-.89-.7Z"
			style={{
				fill: '#e1dcc0',
			}}
		/>
		<path
			d="M143.94 152.51c-.14-.78.48-1.11.98-1.38 1.15-.62 2.37-1.09 3.72-1.07-.36.79-1.22.55-1.83.81-.82.36-1.7.61-2.51 1.14.78 1.39.61 2.76-.24 4.1-.52.81-1.93 1.32-3.19 1.04-.62-.14-1.23-.38-1.84-.57-.34-.19-.8-.09-1.07-.46.08-.33.34-.33.6-.32.85.21 1.68.48 2.55.64 1.03.19 1.87 0 2.5-.88.65-.92.96-1.86.34-2.91 0-.05-.01-.1-.02-.15Z"
			style={{
				fill: '#eae4cc',
			}}
		/>
		<path
			d="M138.03 156.18c.36.09.74.13 1.02.41-1.06-.15-2.11-.34-3.08-.83-.53-.27-1.05-.78-1.01-1.29.05-.53.53-1.06 1.23-1.14.07.13.06.27-.02.37-.5.66-.17.96.44 1.28.54.29 1.13.59 1.42 1.2Z"
			style={{
				fill: '#e2dac6',
			}}
		/>
		<path
			d="M138.03 156.18c-.69-.32-1.23-.86-1.92-1.19-1.15-.55-.22-1.11.08-1.66.36-.25.53-.74 1.02-.82l-.2.61c.09.18.02.33-.09.45-.61.64-.26.98.38 1.23.52.31 1.27.35 1.34 1.17-.22 0-.46-.04-.61.2ZM139.25 151.69c-.66.33-1.21.92-2.04.82.66-.33 1.21-.92 2.04-.82Z"
			style={{
				fill: '#e9e1cf',
			}}
		/>
		<path
			d="M157.62 154.55c-.57.48-1.21.65-1.97.63-1.42-.05-2.84-.03-4.26 0-.63.01-1.21-.08-1.74-.42.72-1.16 1.82-1.88 3.02-2.39 1.92-.81 4-1.08 6-1.62.83-.22 1.59.17 2.4.16.76 0 1.29-.19 1.63-.85.19.17.21.39.17.62-.17.53-.55.72-1.09.69-.68-.04-1.35 0-2.03-.02-.52-.01-.99.06-1.4.44-.37.34-.86.4-1.34.37-1.39-.09-2.67.39-3.96.78-.8.24-1.19 1.06-1.91 1.49 1.63 0 3.23.05 4.83.17.1-.03.19-.05.29-.07.43-.03.8-.42 1.27-.24.08.07.1.16.07.26Z"
			style={{
				fill: '#eae3c6',
			}}
		/>
		<path
			d="M162.73 150.68v-.61c.62-.4 1.33-.25 1.96-.15.64.11 1.27.14 1.91.15 1.2-.12 2.12.58 3.06 1.14.41.25.98.47 1.02 1.1l.61.82c.16 1.15-1.04 1.44-1.43 2.24-.53.18-1.04.21-1.47-.25.07-.49.5-.34.79-.43.84-.25.94-.48.47-1.2-.36-.55-.95-.98-.89-1.76.02-.21-.26-.28-.45-.36-1.57-.65-3.14-1.17-4.84-.45-.32.13-.6.11-.76-.25Z"
			style={{
				fill: '#eee8c9',
			}}
		/>
		<path
			d="M170.69 152.31c-1.12-1.18-2.5-1.91-4.09-2.25v-.2c.67-.14 1.22.27 1.84.41.9.41 1.71.97 2.45 1.63.11.13.13.27 0 .41h-.2Z"
			style={{
				fill: '#e1d9b5',
			}}
		/>
		<path
			d="M137.21 154.96c-1.21-.44-1.23-.62-.2-1.84 1.2-.42 2.27-1.33 3.67-1.02.15.48-.39 1.27.32 1.42.68.15 1.37-.28 1.86-.85.2-.23.22-.57.48-.77.27.14.17.65.61.61.75 1.16.74 1.42-.12 2.51-.21.27-.36.58-.57.84-.22.28-.62.4-.75.06-.32-.9-1.07-.57-1.6-.59-1.24-.05-2.49 0-3.7-.36Z"
			style={{
				fill: '#f0e9d8',
			}}
		/>
		<path
			d="M143.33 151.9c-.18 1.1-1.28 2.06-2.32 2.03-.2 0-.41 0-.49-.25-.18-.55-.35-1.1.16-1.58.88-.18 1.75-.39 2.65-.2Z"
			style={{
				fill: '#f7f0df',
			}}
		/>
		<path
			d="M139.66 150.88c-.14-.08-.28-.22-.42-.22-1.19 0-2.24-.44-3.25-1.01.22-.55.45-.79.97-.2.56.63 1.29.92 2.18.77 1.66-.28 3.37-.16 5.02-.57-.87.81-1.92.96-3.05.85-.54-.05-.98.2-1.45.38Z"
			style={{
				fill: '#dfd9bc',
			}}
		/>
		<path
			d="M137.62 139.46c-.26.32-.73.15-1.02.41.13-.65.66-.32 1.02-.41Z"
			style={{
				fill: '#f3ecdc',
			}}
		/>
		<path
			d="M106.18 159.44c.17-.31.4-.5.76-.62 1.58-.49 3.1-1.11 4.51-1.99.69-.43 1.1-1.17 1.83-1.56.21-.11.3-.38.17-.63-.17-.32-.45-.59-.81-.5-1.66.41-3.48-.25-5.04.76-.1.06-.27.03-.4.04-.07-.05-.09-.09-.07-.14.02-.05.05-.07.07-.07.26-.82 1.08-.79 1.66-.96 1.33-.37 2.73-.33 4.1-.17.49.06 1.19.41 1.24 1.02.04.53-.19 1.04-.82 1.38-.72.39-1.37.93-2.02 1.48-.7.6-1.64.97-2.53 1.29-.85.31-1.77.43-2.66.64Z"
			style={{
				fill: '#ebe7cc',
			}}
		/>
		<path
			d="M112.37 152.1c-.31 0-.69.03-.75-.25-.18-.89-.88-1.41-1.36-2.09-.26-.37-.11-.57.21-.71.27-.12.7-.65.82-.2.27 1 1.4 1.13 1.75 2.01.11.28.39.49.16.82-.21.3-.49.46-.83.43Z"
			style={{
				fill: '#f2edd3',
			}}
		/>
		<path
			d="M119.24 155.77c-1.34.55-2.72 1.04-4.02 1.67-.94.46-1.8 1.07-2.92.77 1.31-.18 2.26-.98 3.18-1.84.37-.35.93-.09 1.31-.41.83-.24 1.74-.23 2.45-.82.18.2.14.41 0 .61Z"
			style={{
				fill: '#e4debf',
			}}
		/>
		<path
			d="M107.2 154.75v.2l-1.22.2c.32-.4.77-.42 1.22-.41Z"
			style={{
				fill: '#e9e5cb',
			}}
		/>
		<path
			d="M126.18 150.06c1.22.24 2.44.35 3.67.2.15-.12.3-.11.44 0-.22.7-.91.33-1.33.58-.93.29-1.92.47-2.57 1.32-.12.15-.38.24-.27.48.09.21.33.2.53.22.45.04.88-.03 1.31-.14.63-.07 1.26-.12 1.9-.14 1.12-.04 1.63-.85 1.1-1.63-.13-.06-.26-.12-.38-.21-.14-.15-.25-.31-.12-.52.53-.28 1.2.37 1.74-.31.09-.12.46.57.25.94-.27.49-.39.93-.03 1.41.29.58.08 1.03-.39 1.4-.1.05-.21.09-.32.11-1.39.13-2.77 0-4.15-.16a4.87 4.87 0 0 0-1.01 0c-.7.07-1.33.08-1.51-.89-.09-.47-.62-.77-1.05-1.05-.6-.39-.61-.81-.09-1.3.78-.73 1.42-.81 2.26-.32Z"
			style={{
				fill: '#f1ead1',
			}}
		/>
		<path
			d="M119.24 155.77v-.61c.99-.84 2.42-.95 3.33-1.95.17-.19.5-.25.53-.57.06-.67.44-.58.84-.33.45.28.67.69.33 1.17-.19.26-.51.43-.79.62-.45.3-.54.64-.15 1.06-1.45-.39-2.79-.05-4.08.61Z"
			style={{
				fill: '#e1dabd',
			}}
		/>
		<path
			d="M126.18 150.06c-.57-.25-1.12-.14-1.65.12-.37.18-.74.38-.78.85-.04.5.44.43.69.62.44.33.87.66.93 1.27.05.55.42.62.87.61h5.66c.04.18-.01.34-.16.44-.54.36-2.75.2-3.31-.23-1.24.12-2.58-.38-3.67.61-.15-.09-.2-.24-.2-.41.66-.83.49-1.36-.63-2.05-1.03-.63-1.03-1.03-.04-1.71.2-.13.43-.23.58-.4.73-.81 1.26-.51 1.72.28Z"
			style={{
				fill: '#ede7cb',
			}}
		/>
		<path
			d="M128.43 153.74c1.17.19 2.36.58 3.47-.2h.2c.47-.48.75-.96.06-1.49-.45-.84.17-1.17.75-1.43.55-.24 1.16-.31 1.78-.36-.26-.21-.67-.33-.55-.8h.41l.21.2c.14.07.28.17.43.19.34.06.87-.1.89.38.02.59-.55.4-.91.45-.65 0-1.15.49-1.81.52-.37.02-.38.32-.26.68.41 1.18-.37 2.37-1.67 2.44-1.06.06-2.15.17-3.2-.18l.2-.41Z"
			style={{
				fill: '#e7e2c5',
			}}
		/>
		<path
			d="M134.15 149.45c.25.52.69.71 1.3.59v.28c-.69.12-1.36.24-2.04.37-1.1.22-1.35.54-1.1 1.41.06.05.08.09.06.14-.02.05-.04.07-.06.07-.58-.35-.54-.85-.19-1.29.27-.35.35-.62.07-1.02-.45.91-1.14.11-1.71.28-.07.09-.14.08-.2 0h-.41c.2-.3.55-.21.82-.29.4-.11 1.24-.37 1.43-.53.68-.16 1.36-.16 2.04 0Z"
			style={{
				fill: '#eee9cd',
			}}
		/>
		<path
			d="M122.16 152.63c-.55.85-1.38 1.18-2.34 1.37-.52.1-.54-.08-.59-.48-.1-.76.4-1.27.84-1.62.37-.29.98 0 1.42.31.22.15.44.28.67.42Z"
			style={{
				fill: '#eae3ca',
			}}
		/>
		<path
			d="M124.55 153.94c.16.09.2.24.2.41-.01.25-.1.47-.35.55-.26.09-.56.13-.71-.16-.14-.28.15-.4.33-.53.16-.12.35-.19.53-.28Z"
			style={{
				fill: '#efe9cc',
			}}
		/>
		<path
			d="M134.15 149.45h-2.04c.68-.32 1.36-.32 2.04 0Z"
			style={{
				fill: '#e7e2c5',
			}}
		/>
		<path
			d="M128.43 149.86c.48-.32.95-.32 1.43 0h-1.43ZM126.8 149.66c.47.08 1-.19 1.43.2-.47-.08-1 .19-1.43-.2ZM126.59 149.25c.36-.01.31.19.2.41-.21-.06-.57.03-.41-.41h.2Z"
			style={{
				fill: '#dfd9bc',
			}}
		/>
		<path
			d="M129.45 147.41h-.9c-.42-.01-.8-.13-1.04-.5-.1-.16 0-.35.16-.42.41-.19.76-.6 1.28-.43.18.06.34.21.5.33.19.22.37.44.31.76-.06.15-.16.24-.31.26Z"
			style={{
				fill: '#d6d1a9',
			}}
		/>
		<path
			d="m129.45 147.41.2-.2c.14-.12.27-.12.41 0-.11.27-.32.41-.61.41v-.2Z"
			style={{
				fill: '#e0d8b4',
			}}
		/>
		<path
			d="M193.55 148.84c.25.3.68.41.82.81-.8.45-1.22 1.64-2.45 1.22-.49-.4-.6-1.06-.44-1.5.19-.54.88-.6 1.48-.55.2.02.4 0 .6 0Z"
			style={{
				fill: '#c2ba81',
			}}
		/>
		<path
			d="M190.49 142.11c.4.5.92-.13 1.36.21-1 1.63 1.24 2.05 1.26 3.4-.85.54-1.94.35-2.84.14-.71-.17-.98-1.25-1.05-2-.06-.61.16-1.3.63-1.84.31-.35.44-.06.64.08Z"
			style={{
				fill: '#f1ead2',
			}}
		/>
		<path
			d="M187.98 155.09c0 .24-.12.37-.28.4-.22.04-.38-.09-.4-.32-.02-.19.11-.32.27-.35.23-.05.35.11.41.27Z"
			style={{
				fill: '#e8debb',
			}}
		/>
		<path
			d="M154.15 159.04c.05.16.08.33.14.49.47 1.44-.26 2.66-1.79 2.96q-1.57.31-1.46 1.96c.01.22.03.43-.24.47-.37.06-.75.13-.99-.29-.31-.55-.72-.97-1.37-1.1-.34-.34-.99.24-1.22-.41.05-.05.1-.12.16-.12 2.68-.18 4.48-1.84 6.21-3.64.15-.16.28-.41.58-.31Z"
			style={{
				fill: '#e1dab9',
			}}
		/>
		<path
			d="M154.15 159.04c-1.02 1.43-2.48 2.39-3.85 3.42-.88.66-2.01.68-3.09.66l-.41-.61a.47.47 0 0 1 .39-.13c.09 0 .19.02.28.04 1.1.17 1.95-.11 2.83-.91 1.2-1.08 2.63-1.9 3.61-3.24.17-.23.54-.41.39-.76-.14-.34-.53-.23-.81-.28-1.06-.18-1.98.41-2.98.54-.1.03-.2.04-.3.05-.21 0-.41-.04-.56-.21 1.38-.96 2.99-1.03 4.58-1.13.57-.04.78.43.79.95 0 .26-.05.53-.07.8-.35.2-.62.47-.82.82Z"
			style={{
				fill: '#e6dfbe',
			}}
		/>
		<path
			d="M168.44 154.96c.38.47.91.41 1.43.41-.65.44-1.24.47-1.77-.22-.24-.31-.58-.53-.88-.8-.83-.15-1.31-1.09-2.25-1.02-.63.31-1.32.1-1.98.18-1.37.18-2.58.88-3.94 1.04h-1.43v-.2c.03-.03.06-.07.1-.1.55-.23 1.19-.15 1.72-.47.12-.08.24-.14.37-.2.31-.12.61-.27.92-.4.1-.04.2-.07.3-.09 1.25-.25 2.49-.51 3.77-.45.68.03 1.33.11 1.93.45.81.41 1.54.9 1.71 1.88Z"
			style={{
				fill: '#e7e0bf',
			}}
		/>
		<path
			d="M159.05 154.55c1.87-.92 3.82-1.43 5.92-1.22-.54.65-1.33.28-1.97.4-1.33.24-2.53 1.09-3.95.83Z"
			style={{
				fill: '#e1dab9',
			}}
		/>
		<path
			d="M172.12 158.63c-.61.44-1.35.42-2.03.47-.6.05-.94-.48-.73-1 .48-1.13.91-2.34 2.14-2.94.25.33 0 .56-.17.8-.16.21-.38.38-.54.6-.35.49-.85 1.03-.63 1.62.22.59.91.12 1.37.22.16.04.33.04.48.13.03.03.06.07.1.11Z"
			style={{
				fill: '#eae3c4',
			}}
		/>
		<path
			d="m175.18 157.2.2.21c-.96.74-2.08 1.09-3.27 1.22s-.02-.09-.01-.1c.92-.69 1.82-1.41 3.08-1.33Z"
			style={{
				fill: '#eae3c4',
			}}
		/>
		<path
			d="M175.18 157.2c-1.02.48-2.04.95-3.06 1.43-.5.03-1 .01-1.51.11-.69.13-.91-.38-.73-1.06.27-1.05 1.3-1.54 1.63-2.51 1.21-.77 2.68-.74 3.96-1.32.51-.23 1.16-.18 1.74-.16.45.02.65 1.02.22 1.4-.6.52-.83 1.51-1.91 1.46-.24-.01-.32.39-.34.66Z"
			style={{
				fill: '#f1e9cf',
			}}
		/>
		<path
			d="M170.9 152.31v-.41c.33.18.59.4.61.81l-.61-.41Z"
			style={{
				fill: '#d8d3ab',
			}}
		/>
		<path
			d="M124.14 157.41c-.36.07-.73.16-1.09.2-.53.05-.92-.07-.96-.74-.04-.76.64-.99.98-.83 1.37.63 1.79-.57 2.47-1.18.39-.35.59-.37.88 0 .19.24.43.39.71.29 1.44-.52 2.89-.02 4.34-.02.62 0 0 .82.43 1.07-1.25.09-2.57-.14-3.72.15-1.34.34-2.74.54-4.03 1.07Z"
			style={{
				fill: '#ded8b4',
			}}
		/>
		<path
			d="M123.73 165.77c.35-.3.78-.39 1.22-.41-.32.4-.77.42-1.22.41Z"
			style={{
				fill: '#ded7ba',
			}}
		/>
		<path
			d="M123.12 158.02c-.35.3-.78.39-1.22.41.32-.4.77-.42 1.22-.41Z"
			style={{
				fill: '#e4ddc0',
			}}
		/>
		<path
			d="M147.21 162.5h-.41c-.61-1.34.12-2.52.99-3.25.63-.53 1.42-.9 1.87-1.64h.61c.09.4-.26.6-.43.87-.2.31-.26.54-.01.9.68.98.68 1 1.76.41.6-.33 1.15-.71 1.6-1.23.15-.17.37-.35.22-.62-.12-.2-.36-.17-.56-.16-.54.02-1.08.07-1.62.13-.29.03-.7.26-.76-.31 1.15-.46 2.32-.82 3.59-.62.28.05.54.08.64.39.1.29-.08.46-.25.7-1.3 1.81-3.25 2.9-4.88 4.34-.65.58-1.57.4-2.38.08.4-.37.94-.36 1.42-.47.53-.12.83-.46.93-.96.1-.52-.37-.67-.67-.92-.38-.33-.68-.12-.95.19-.57.62-.58 1.41-.73 2.17Z"
			style={{
				fill: '#eee8c8',
			}}
		/>
		<path
			d="M147.21 163.12c.31.43.92-.02 1.22.41-.55-.11-1.23.29-1.63-.41h.41Z"
			style={{
				fill: '#e1d9b6',
			}}
		/>
		<path
			d="M119.04 166.58c.15-.07.3-.2.44-.19.98.09 1.91-.11 2.83-.42-.42.7-1.11.61-1.77.61h-1.49Z"
			style={{
				fill: '#e4ddc0',
			}}
		/>
		<path
			d="M124.76 158.43c2.11-.1 3.21 1.35 4.2 2.84.29.44.17 1.09-.33 1.57-.79.75-1.74 1.13-2.73 1.56-1.38.59-2.83.96-4.24 1.35-1.69.47-3.5.55-5.26.69-.69.05-1.35-.46-1.63-1.04-.28-.58.37-1.09.66-1.57.3-.51.81-.89.96-1.51.4-.49.78-1.01 1.43-1.22.95-1 2.01-1.76 3.5-1.59.17.02.4.09.5-.01.8-.89 1.95-.75 2.95-1.04Z"
			style={{
				fill: '#ede8cf',
			}}
		/>
		<path
			d="M124.76 158.43c-1.02.53-2.21 1.25-3.16 1.23-1.59-.03-2.64.66-3.79 1.42.17-1.03 1.19-1.1 1.84-1.56.49-.34 1.21-.33 1.83-.48 1.05-.44 2.07-1 3.27-.61Z"
			style={{
				fill: '#ebe6c9',
			}}
		/>
		<path
			d="M89.5 161.09c-.63 0-.87-.28-.54-.82.9-1.45 2.13-2.5 3.77-3.06.5-.17.68.12.87.43.21.34.5.7.1 1.1-.21.22-.41.48-.67.61-1.18.59-2.12 1.66-3.54 1.75Z"
			style={{
				fill: '#faf4eb',
			}}
		/>
		<path
			d="M130.06 147.21h-.41l-.2-.82c.48.06.54.44.61.82Z"
			style={{
				fill: '#dcd6b0',
			}}
		/>
		<path
			d="M137.21 154.96c1.72.05 3.44.12 5.17.14.36 0 .55-.02.32.39-.08.14-.22.31 0 .42.24.11.35-.06.43-.27.09-.22.16-.49.34-.61 1-.7.98-1.56.47-2.52.49.24.62.64.62 1.16.01 2.1-1.62 3.42-3.65 2.97-.78-.17-1.57-.27-2.28-.66-.32-.55-.97-.66-1.43-1.02Z"
			style={{
				fill: '#efe9d4',
			}}
		/>
		<path
			d="m159.87 153.73-.21.2c-.67.2-1.37.24-2.04.41l-1.23.41c-.23-.58.25-.67.59-.83.55-.25 1.17-.3 1.72-.54.72-.29 1.39-.69 2.2-.76.38-.04.83-.23.79-.64-.04-.48-.58-.34-.91-.41-.3-.06-.6.06-.9.12-1.08.4-2.14.84-3.04 1.58-.18.15-.35.3-.56.42-.28.15-.78 0-.8.45-.02.39.54.33.73.62-.51.49-1.02-.01-1.54 0-1.12.02-2.24 0-3.36.04-.24 0-.51.11-.64-.13-.13-.25.13-.4.3-.56 1.71-1.58 3.76-2.23 6.05-2.2.57 0 1.08-.04 1.46-.53.23-.3.59-.3.93-.29.82.01 1.64-.05 2.44.04.47.06.7-.08.89-.45.21.09.4.21.66.08 2-1.07 3.8 0 5.64.58.08.02.2.18.19.2-.62.97.44 1.32.75 1.93.43.87.19 1.41-.81 1.5-.23.02-.47 0-.71 0-.49-.6-.96-1.22-1.63-1.63-1.21-1.12-2.59-.9-3.98-.48-.7.21-1.44.25-2.14.48-.27.14-.59.18-.82.41Z"
			style={{
				fill: '#f0e9d0',
			}}
		/>
		<path
			d="M158.85 153.53c-.47.42-1.12.35-1.66.59-.33.14-.74.16-.79.64h-.2c-.3-.01-.62.05-.87-.18-.18-.16-.36-.32-.32-.6.04-.3.26-.32.52-.36.57-.08 1.17-.16 1.33-.88 0-.03.03-.09.04-.09 1.14-.03 1.82-1.2 2.98-1.17.03.74-.56.92-1.06 1.16-.39.18-.86.19-1.2.63.41.18.92-.13 1.24.25Z"
			style={{
				fill: '#f6eed6',
			}}
		/>
		<path
			d="M128.02 152.92c-.57.32-1.19.21-1.79.17-.22-.01-.5-.1-.56-.36-.06-.25.11-.44.29-.6.84-.71 1.71-1.39 2.88-1.46.61-.14 1.22-.17 1.84 0h.41c.36.81.3.93-.59 1.1-.9-.87-1.79-.85-2.76.07.2.33.64.16.88.4.18.55-.42.43-.59.68Z"
			style={{
				fill: '#f7f0da',
			}}
		/>
		<path
			d="m128.02 152.92.61-.61c.49-.56 1.12-.73 1.84-.61.65-.07.79-.45.61-1.02.63.44.61 1.1.09 1.62-.93.92-2.11.4-3.15.63Z"
			style={{
				fill: '#f1ead6',
			}}
		/>
		<path
			d="M132.31 152.31v-.2c1.08.64.33 1.02-.2 1.43.05-.41.47-.76.2-1.22Z"
			style={{
				fill: '#ede7cb',
			}}
		/>
		<path
			d="M130.68 150.67h-1.84c.38-.46 1.05.06 1.43-.41h.2l.2.41Z"
			style={{
				fill: '#f1ead6',
			}}
		/>
		<path
			d="M150.48 157.61c.58.4 1.15-.17 1.74-.03.28.07.59-.04.89-.05.3-.01.65-.02.79.3.13.3-.18.47-.33.68-.65.95-1.73 1.35-2.62 1.99-.31.22-.5 0-.71-.15-1.12-.87-1.18-1.39-.25-2.47.09-.1.19-.18.29-.28h.2Z"
			style={{
				fill: '#f2eacf',
			}}
		/>
		<path
			d="M160.69 153.33c1.18-.56 2.49-.69 3.72-1.11.79-.27 1.87.17 2.41 1.11-1.66-.69-3.35-.47-5.03-.12-.37.08-.73.11-1.09.11Z"
			style={{
				fill: '#ede6ca',
			}}
		/>
		<path
			d="M157.62 154.35c.65-.31 1.33-.42 2.04-.41-.63.39-1.33.43-2.04.41Z"
			style={{
				fill: '#eae3c6',
			}}
		/>
		<path
			d="M159.87 153.73c.15-.37.47-.43.82-.41-.21.26-.49.38-.82.41Z"
			style={{
				fill: '#ede6ca',
			}}
		/>
		<path
			d="M147.21 162.5c-.32-1 .26-2.53 1.1-2.88.19-.08 1.62.79 1.6 1.03-.06.63-.16 1.32-.9 1.53-.58.17-1.19.21-1.79.31Z"
			style={{
				fill: '#f1e9ce',
			}}
		/>
		<path
			d="M158.85 153.53c-.24 0-.48-.02-.71.02-.35.06-.84.31-.94-.16-.07-.32.4-.61.76-.72.75-.23 1.52-.39 1.92-1.18.48-.26.97-.28 1.47-.08.27.11.69-.03.71.51.02.54-.34.79-.71.84-.88.13-1.67.48-2.49.77Z"
			style={{
				fill: '#f7f0de',
			}}
		/>
		<path
			d="M168.17 152.59c-.68-.08-1.22-.08-1.73-.22-.44-.12-1.04-.37-.86-.9.16-.47.71-.67 1.28-.41.64.29 1.11.71 1.3 1.53Z"
			style={{
				fill: '#efe7d5',
			}}
		/>
		<path
			d="M130.47 151.69c-.61.2-1.23.41-1.84.61-.45-.1-1.18.29-1.26-.44-.07-.6.64-.67 1.1-.82 1.2-.4 1.73-.22 2 .65Z"
			style={{
				fill: '#f8f1e2',
			}}
		/>
	</svg>
);

export default Beras;
